import React from 'react'
import Icon from '@mdi/react'
import {mdiAbTesting} from '@mdi/js'
import {mdiAbacus} from '@mdi/js'
import {mdiAbjadArabic} from '@mdi/js'
import {mdiAbjadHebrew} from '@mdi/js'
import {mdiAbugidaDevanagari} from '@mdi/js'
import {mdiAbugidaThai} from '@mdi/js'
import {mdiAccessPoint} from '@mdi/js'
import {mdiAccessPointCheck} from '@mdi/js'
import {mdiAccessPointMinus} from '@mdi/js'
import {mdiAccessPointNetwork} from '@mdi/js'
import {mdiAccessPointNetworkOff} from '@mdi/js'
import {mdiAccessPointOff} from '@mdi/js'
import {mdiAccessPointPlus} from '@mdi/js'
import {mdiAccessPointRemove} from '@mdi/js'
import {mdiAccount} from '@mdi/js'
import {mdiAccountAlert} from '@mdi/js'
import {mdiAccountAlertOutline} from '@mdi/js'
import {mdiAccountArrowDown} from '@mdi/js'
import {mdiAccountArrowDownOutline} from '@mdi/js'
import {mdiAccountArrowLeft} from '@mdi/js'
import {mdiAccountArrowLeftOutline} from '@mdi/js'
import {mdiAccountArrowRight} from '@mdi/js'
import {mdiAccountArrowRightOutline} from '@mdi/js'
import {mdiAccountArrowUp} from '@mdi/js'
import {mdiAccountArrowUpOutline} from '@mdi/js'
import {mdiAccountBadge} from '@mdi/js'
import {mdiAccountBadgeOutline} from '@mdi/js'
import {mdiAccountBox} from '@mdi/js'
import {mdiAccountBoxMultiple} from '@mdi/js'
import {mdiAccountBoxMultipleOutline} from '@mdi/js'
import {mdiAccountBoxOutline} from '@mdi/js'
import {mdiAccountCancel} from '@mdi/js'
import {mdiAccountCancelOutline} from '@mdi/js'
import {mdiAccountCard} from '@mdi/js'
import {mdiAccountCardOutline} from '@mdi/js'
import {mdiAccountCash} from '@mdi/js'
import {mdiAccountCashOutline} from '@mdi/js'
import {mdiAccountCheck} from '@mdi/js'
import {mdiAccountCheckOutline} from '@mdi/js'
import {mdiAccountChild} from '@mdi/js'
import {mdiAccountChildCircle} from '@mdi/js'
import {mdiAccountChildOutline} from '@mdi/js'
import {mdiAccountCircle} from '@mdi/js'
import {mdiAccountCircleOutline} from '@mdi/js'
import {mdiAccountClock} from '@mdi/js'
import {mdiAccountClockOutline} from '@mdi/js'
import {mdiAccountCog} from '@mdi/js'
import {mdiAccountCogOutline} from '@mdi/js'
import {mdiAccountConvert} from '@mdi/js'
import {mdiAccountConvertOutline} from '@mdi/js'
import {mdiAccountCowboyHat} from '@mdi/js'
import {mdiAccountCowboyHatOutline} from '@mdi/js'
import {mdiAccountCreditCard} from '@mdi/js'
import {mdiAccountCreditCardOutline} from '@mdi/js'
import {mdiAccountDetails} from '@mdi/js'
import {mdiAccountDetailsOutline} from '@mdi/js'
import {mdiAccountEdit} from '@mdi/js'
import {mdiAccountEditOutline} from '@mdi/js'
import {mdiAccountEye} from '@mdi/js'
import {mdiAccountEyeOutline} from '@mdi/js'
import {mdiAccountFilter} from '@mdi/js'
import {mdiAccountFilterOutline} from '@mdi/js'
import {mdiAccountGroup} from '@mdi/js'
import {mdiAccountGroupOutline} from '@mdi/js'
import {mdiAccountHardHat} from '@mdi/js'
import {mdiAccountHardHatOutline} from '@mdi/js'
import {mdiAccountHeart} from '@mdi/js'
import {mdiAccountHeartOutline} from '@mdi/js'
import {mdiAccountInjury} from '@mdi/js'
import {mdiAccountInjuryOutline} from '@mdi/js'
import {mdiAccountKey} from '@mdi/js'
import {mdiAccountKeyOutline} from '@mdi/js'
import {mdiAccountLock} from '@mdi/js'
import {mdiAccountLockOpen} from '@mdi/js'
import {mdiAccountLockOpenOutline} from '@mdi/js'
import {mdiAccountLockOutline} from '@mdi/js'
import {mdiAccountMinus} from '@mdi/js'
import {mdiAccountMinusOutline} from '@mdi/js'
import {mdiAccountMultiple} from '@mdi/js'
import {mdiAccountMultipleCheck} from '@mdi/js'
import {mdiAccountMultipleCheckOutline} from '@mdi/js'
import {mdiAccountMultipleMinus} from '@mdi/js'
import {mdiAccountMultipleMinusOutline} from '@mdi/js'
import {mdiAccountMultipleOutline} from '@mdi/js'
import {mdiAccountMultiplePlus} from '@mdi/js'
import {mdiAccountMultiplePlusOutline} from '@mdi/js'
import {mdiAccountMultipleRemove} from '@mdi/js'
import {mdiAccountMultipleRemoveOutline} from '@mdi/js'
import {mdiAccountMusic} from '@mdi/js'
import {mdiAccountMusicOutline} from '@mdi/js'
import {mdiAccountNetwork} from '@mdi/js'
import {mdiAccountNetworkOff} from '@mdi/js'
import {mdiAccountNetworkOffOutline} from '@mdi/js'
import {mdiAccountNetworkOutline} from '@mdi/js'
import {mdiAccountOff} from '@mdi/js'
import {mdiAccountOffOutline} from '@mdi/js'
import {mdiAccountOutline} from '@mdi/js'
import {mdiAccountPlus} from '@mdi/js'
import {mdiAccountPlusOutline} from '@mdi/js'
import {mdiAccountQuestion} from '@mdi/js'
import {mdiAccountQuestionOutline} from '@mdi/js'
import {mdiAccountReactivate} from '@mdi/js'
import {mdiAccountReactivateOutline} from '@mdi/js'
import {mdiAccountRemove} from '@mdi/js'
import {mdiAccountRemoveOutline} from '@mdi/js'
import {mdiAccountSchool} from '@mdi/js'
import {mdiAccountSchoolOutline} from '@mdi/js'
import {mdiAccountSearch} from '@mdi/js'
import {mdiAccountSearchOutline} from '@mdi/js'
import {mdiAccountSettings} from '@mdi/js'
import {mdiAccountSettingsOutline} from '@mdi/js'
import {mdiAccountStar} from '@mdi/js'
import {mdiAccountStarOutline} from '@mdi/js'
import {mdiAccountSupervisor} from '@mdi/js'
import {mdiAccountSupervisorCircle} from '@mdi/js'
import {mdiAccountSupervisorCircleOutline} from '@mdi/js'
import {mdiAccountSupervisorOutline} from '@mdi/js'
import {mdiAccountSwitch} from '@mdi/js'
import {mdiAccountSwitchOutline} from '@mdi/js'
import {mdiAccountSync} from '@mdi/js'
import {mdiAccountSyncOutline} from '@mdi/js'
import {mdiAccountTie} from '@mdi/js'
import {mdiAccountTieHat} from '@mdi/js'
import {mdiAccountTieHatOutline} from '@mdi/js'
import {mdiAccountTieOutline} from '@mdi/js'
import {mdiAccountTieVoice} from '@mdi/js'
import {mdiAccountTieVoiceOff} from '@mdi/js'
import {mdiAccountTieVoiceOffOutline} from '@mdi/js'
import {mdiAccountTieVoiceOutline} from '@mdi/js'
import {mdiAccountTieWoman} from '@mdi/js'
import {mdiAccountVoice} from '@mdi/js'
import {mdiAccountVoiceOff} from '@mdi/js'
import {mdiAccountWrench} from '@mdi/js'
import {mdiAccountWrenchOutline} from '@mdi/js'
import {mdiAdjust} from '@mdi/js'
import {mdiAdvertisements} from '@mdi/js'
import {mdiAdvertisementsOff} from '@mdi/js'
import {mdiAirConditioner} from '@mdi/js'
import {mdiAirFilter} from '@mdi/js'
import {mdiAirHorn} from '@mdi/js'
import {mdiAirHumidifier} from '@mdi/js'
import {mdiAirHumidifierOff} from '@mdi/js'
import {mdiAirPurifier} from '@mdi/js'
import {mdiAirPurifierOff} from '@mdi/js'
import {mdiAirbag} from '@mdi/js'
import {mdiAirballoon} from '@mdi/js'
import {mdiAirballoonOutline} from '@mdi/js'
import {mdiAirplane} from '@mdi/js'
import {mdiAirplaneAlert} from '@mdi/js'
import {mdiAirplaneCheck} from '@mdi/js'
import {mdiAirplaneClock} from '@mdi/js'
import {mdiAirplaneCog} from '@mdi/js'
import {mdiAirplaneEdit} from '@mdi/js'
import {mdiAirplaneLanding} from '@mdi/js'
import {mdiAirplaneMarker} from '@mdi/js'
import {mdiAirplaneMinus} from '@mdi/js'
import {mdiAirplaneOff} from '@mdi/js'
import {mdiAirplanePlus} from '@mdi/js'
import {mdiAirplaneRemove} from '@mdi/js'
import {mdiAirplaneSearch} from '@mdi/js'
import {mdiAirplaneSettings} from '@mdi/js'
import {mdiAirplaneTakeoff} from '@mdi/js'
import {mdiAirport} from '@mdi/js'
import {mdiAlarm} from '@mdi/js'
import {mdiAlarmBell} from '@mdi/js'
import {mdiAlarmCheck} from '@mdi/js'
import {mdiAlarmLight} from '@mdi/js'
import {mdiAlarmLightOff} from '@mdi/js'
import {mdiAlarmLightOffOutline} from '@mdi/js'
import {mdiAlarmLightOutline} from '@mdi/js'
import {mdiAlarmMultiple} from '@mdi/js'
import {mdiAlarmNote} from '@mdi/js'
import {mdiAlarmNoteOff} from '@mdi/js'
import {mdiAlarmOff} from '@mdi/js'
import {mdiAlarmPanel} from '@mdi/js'
import {mdiAlarmPanelOutline} from '@mdi/js'
import {mdiAlarmPlus} from '@mdi/js'
import {mdiAlarmSnooze} from '@mdi/js'
import {mdiAlbum} from '@mdi/js'
import {mdiAlert} from '@mdi/js'
import {mdiAlertBox} from '@mdi/js'
import {mdiAlertBoxOutline} from '@mdi/js'
import {mdiAlertCircle} from '@mdi/js'
import {mdiAlertCircleCheck} from '@mdi/js'
import {mdiAlertCircleCheckOutline} from '@mdi/js'
import {mdiAlertCircleOutline} from '@mdi/js'
import {mdiAlertDecagram} from '@mdi/js'
import {mdiAlertDecagramOutline} from '@mdi/js'
import {mdiAlertMinus} from '@mdi/js'
import {mdiAlertMinusOutline} from '@mdi/js'
import {mdiAlertOctagon} from '@mdi/js'
import {mdiAlertOctagonOutline} from '@mdi/js'
import {mdiAlertOctagram} from '@mdi/js'
import {mdiAlertOctagramOutline} from '@mdi/js'
import {mdiAlertOutline} from '@mdi/js'
import {mdiAlertPlus} from '@mdi/js'
import {mdiAlertPlusOutline} from '@mdi/js'
import {mdiAlertRemove} from '@mdi/js'
import {mdiAlertRemoveOutline} from '@mdi/js'
import {mdiAlertRhombus} from '@mdi/js'
import {mdiAlertRhombusOutline} from '@mdi/js'
import {mdiAlien} from '@mdi/js'
import {mdiAlienOutline} from '@mdi/js'
import {mdiAlignHorizontalCenter} from '@mdi/js'
import {mdiAlignHorizontalDistribute} from '@mdi/js'
import {mdiAlignHorizontalLeft} from '@mdi/js'
import {mdiAlignHorizontalRight} from '@mdi/js'
import {mdiAlignVerticalBottom} from '@mdi/js'
import {mdiAlignVerticalCenter} from '@mdi/js'
import {mdiAlignVerticalDistribute} from '@mdi/js'
import {mdiAlignVerticalTop} from '@mdi/js'
import {mdiAllInclusive} from '@mdi/js'
import {mdiAllInclusiveBox} from '@mdi/js'
import {mdiAllInclusiveBoxOutline} from '@mdi/js'
import {mdiAllergy} from '@mdi/js'
import {mdiAlpha} from '@mdi/js'
import {mdiAlphaA} from '@mdi/js'
import {mdiAlphaABox} from '@mdi/js'
import {mdiAlphaABoxOutline} from '@mdi/js'
import {mdiAlphaACircle} from '@mdi/js'
import {mdiAlphaACircleOutline} from '@mdi/js'
import {mdiAlphaB} from '@mdi/js'
import {mdiAlphaBBox} from '@mdi/js'
import {mdiAlphaBBoxOutline} from '@mdi/js'
import {mdiAlphaBCircle} from '@mdi/js'
import {mdiAlphaBCircleOutline} from '@mdi/js'
import {mdiAlphaC} from '@mdi/js'
import {mdiAlphaCBox} from '@mdi/js'
import {mdiAlphaCBoxOutline} from '@mdi/js'
import {mdiAlphaCCircle} from '@mdi/js'
import {mdiAlphaCCircleOutline} from '@mdi/js'
import {mdiAlphaD} from '@mdi/js'
import {mdiAlphaDBox} from '@mdi/js'
import {mdiAlphaDBoxOutline} from '@mdi/js'
import {mdiAlphaDCircle} from '@mdi/js'
import {mdiAlphaDCircleOutline} from '@mdi/js'
import {mdiAlphaE} from '@mdi/js'
import {mdiAlphaEBox} from '@mdi/js'
import {mdiAlphaEBoxOutline} from '@mdi/js'
import {mdiAlphaECircle} from '@mdi/js'
import {mdiAlphaECircleOutline} from '@mdi/js'
import {mdiAlphaF} from '@mdi/js'
import {mdiAlphaFBox} from '@mdi/js'
import {mdiAlphaFBoxOutline} from '@mdi/js'
import {mdiAlphaFCircle} from '@mdi/js'
import {mdiAlphaFCircleOutline} from '@mdi/js'
import {mdiAlphaG} from '@mdi/js'
import {mdiAlphaGBox} from '@mdi/js'
import {mdiAlphaGBoxOutline} from '@mdi/js'
import {mdiAlphaGCircle} from '@mdi/js'
import {mdiAlphaGCircleOutline} from '@mdi/js'
import {mdiAlphaH} from '@mdi/js'
import {mdiAlphaHBox} from '@mdi/js'
import {mdiAlphaHBoxOutline} from '@mdi/js'
import {mdiAlphaHCircle} from '@mdi/js'
import {mdiAlphaHCircleOutline} from '@mdi/js'
import {mdiAlphaI} from '@mdi/js'
import {mdiAlphaIBox} from '@mdi/js'
import {mdiAlphaIBoxOutline} from '@mdi/js'
import {mdiAlphaICircle} from '@mdi/js'
import {mdiAlphaICircleOutline} from '@mdi/js'
import {mdiAlphaJ} from '@mdi/js'
import {mdiAlphaJBox} from '@mdi/js'
import {mdiAlphaJBoxOutline} from '@mdi/js'
import {mdiAlphaJCircle} from '@mdi/js'
import {mdiAlphaJCircleOutline} from '@mdi/js'
import {mdiAlphaK} from '@mdi/js'
import {mdiAlphaKBox} from '@mdi/js'
import {mdiAlphaKBoxOutline} from '@mdi/js'
import {mdiAlphaKCircle} from '@mdi/js'
import {mdiAlphaKCircleOutline} from '@mdi/js'
import {mdiAlphaL} from '@mdi/js'
import {mdiAlphaLBox} from '@mdi/js'
import {mdiAlphaLBoxOutline} from '@mdi/js'
import {mdiAlphaLCircle} from '@mdi/js'
import {mdiAlphaLCircleOutline} from '@mdi/js'
import {mdiAlphaM} from '@mdi/js'
import {mdiAlphaMBox} from '@mdi/js'
import {mdiAlphaMBoxOutline} from '@mdi/js'
import {mdiAlphaMCircle} from '@mdi/js'
import {mdiAlphaMCircleOutline} from '@mdi/js'
import {mdiAlphaN} from '@mdi/js'
import {mdiAlphaNBox} from '@mdi/js'
import {mdiAlphaNBoxOutline} from '@mdi/js'
import {mdiAlphaNCircle} from '@mdi/js'
import {mdiAlphaNCircleOutline} from '@mdi/js'
import {mdiAlphaO} from '@mdi/js'
import {mdiAlphaOBox} from '@mdi/js'
import {mdiAlphaOBoxOutline} from '@mdi/js'
import {mdiAlphaOCircle} from '@mdi/js'
import {mdiAlphaOCircleOutline} from '@mdi/js'
import {mdiAlphaP} from '@mdi/js'
import {mdiAlphaPBox} from '@mdi/js'
import {mdiAlphaPBoxOutline} from '@mdi/js'
import {mdiAlphaPCircle} from '@mdi/js'
import {mdiAlphaPCircleOutline} from '@mdi/js'
import {mdiAlphaQ} from '@mdi/js'
import {mdiAlphaQBox} from '@mdi/js'
import {mdiAlphaQBoxOutline} from '@mdi/js'
import {mdiAlphaQCircle} from '@mdi/js'
import {mdiAlphaQCircleOutline} from '@mdi/js'
import {mdiAlphaR} from '@mdi/js'
import {mdiAlphaRBox} from '@mdi/js'
import {mdiAlphaRBoxOutline} from '@mdi/js'
import {mdiAlphaRCircle} from '@mdi/js'
import {mdiAlphaRCircleOutline} from '@mdi/js'
import {mdiAlphaS} from '@mdi/js'
import {mdiAlphaSBox} from '@mdi/js'
import {mdiAlphaSBoxOutline} from '@mdi/js'
import {mdiAlphaSCircle} from '@mdi/js'
import {mdiAlphaSCircleOutline} from '@mdi/js'
import {mdiAlphaT} from '@mdi/js'
import {mdiAlphaTBox} from '@mdi/js'
import {mdiAlphaTBoxOutline} from '@mdi/js'
import {mdiAlphaTCircle} from '@mdi/js'
import {mdiAlphaTCircleOutline} from '@mdi/js'
import {mdiAlphaU} from '@mdi/js'
import {mdiAlphaUBox} from '@mdi/js'
import {mdiAlphaUBoxOutline} from '@mdi/js'
import {mdiAlphaUCircle} from '@mdi/js'
import {mdiAlphaUCircleOutline} from '@mdi/js'
import {mdiAlphaV} from '@mdi/js'
import {mdiAlphaVBox} from '@mdi/js'
import {mdiAlphaVBoxOutline} from '@mdi/js'
import {mdiAlphaVCircle} from '@mdi/js'
import {mdiAlphaVCircleOutline} from '@mdi/js'
import {mdiAlphaW} from '@mdi/js'
import {mdiAlphaWBox} from '@mdi/js'
import {mdiAlphaWBoxOutline} from '@mdi/js'
import {mdiAlphaWCircle} from '@mdi/js'
import {mdiAlphaWCircleOutline} from '@mdi/js'
import {mdiAlphaX} from '@mdi/js'
import {mdiAlphaXBox} from '@mdi/js'
import {mdiAlphaXBoxOutline} from '@mdi/js'
import {mdiAlphaXCircle} from '@mdi/js'
import {mdiAlphaXCircleOutline} from '@mdi/js'
import {mdiAlphaY} from '@mdi/js'
import {mdiAlphaYBox} from '@mdi/js'
import {mdiAlphaYBoxOutline} from '@mdi/js'
import {mdiAlphaYCircle} from '@mdi/js'
import {mdiAlphaYCircleOutline} from '@mdi/js'
import {mdiAlphaZ} from '@mdi/js'
import {mdiAlphaZBox} from '@mdi/js'
import {mdiAlphaZBoxOutline} from '@mdi/js'
import {mdiAlphaZCircle} from '@mdi/js'
import {mdiAlphaZCircleOutline} from '@mdi/js'
import {mdiAlphabetAurebesh} from '@mdi/js'
import {mdiAlphabetCyrillic} from '@mdi/js'
import {mdiAlphabetGreek} from '@mdi/js'
import {mdiAlphabetLatin} from '@mdi/js'
import {mdiAlphabetPiqad} from '@mdi/js'
import {mdiAlphabetTengwar} from '@mdi/js'
import {mdiAlphabetical} from '@mdi/js'
import {mdiAlphabeticalOff} from '@mdi/js'
import {mdiAlphabeticalVariant} from '@mdi/js'
import {mdiAlphabeticalVariantOff} from '@mdi/js'
import {mdiAltimeter} from '@mdi/js'
import {mdiAmbulance} from '@mdi/js'
import {mdiAmmunition} from '@mdi/js'
import {mdiAmpersand} from '@mdi/js'
import {mdiAmplifier} from '@mdi/js'
import {mdiAmplifierOff} from '@mdi/js'
import {mdiAnchor} from '@mdi/js'
import {mdiAndroid} from '@mdi/js'
import {mdiAndroidStudio} from '@mdi/js'
import {mdiAngleAcute} from '@mdi/js'
import {mdiAngleObtuse} from '@mdi/js'
import {mdiAngleRight} from '@mdi/js'
import {mdiAngular} from '@mdi/js'
import {mdiAngularjs} from '@mdi/js'
import {mdiAnimation} from '@mdi/js'
import {mdiAnimationOutline} from '@mdi/js'
import {mdiAnimationPlay} from '@mdi/js'
import {mdiAnimationPlayOutline} from '@mdi/js'
import {mdiAnsible} from '@mdi/js'
import {mdiAntenna} from '@mdi/js'
import {mdiAnvil} from '@mdi/js'
import {mdiApacheKafka} from '@mdi/js'
import {mdiApi} from '@mdi/js'
import {mdiApiOff} from '@mdi/js'
import {mdiApple} from '@mdi/js'
import {mdiAppleFinder} from '@mdi/js'
import {mdiAppleIcloud} from '@mdi/js'
import {mdiAppleIos} from '@mdi/js'
import {mdiAppleKeyboardCaps} from '@mdi/js'
import {mdiAppleKeyboardCommand} from '@mdi/js'
import {mdiAppleKeyboardControl} from '@mdi/js'
import {mdiAppleKeyboardOption} from '@mdi/js'
import {mdiAppleKeyboardShift} from '@mdi/js'
import {mdiAppleSafari} from '@mdi/js'
import {mdiApplication} from '@mdi/js'
import {mdiApplicationArray} from '@mdi/js'
import {mdiApplicationArrayOutline} from '@mdi/js'
import {mdiApplicationBraces} from '@mdi/js'
import {mdiApplicationBracesOutline} from '@mdi/js'
import {mdiApplicationBrackets} from '@mdi/js'
import {mdiApplicationBracketsOutline} from '@mdi/js'
import {mdiApplicationCog} from '@mdi/js'
import {mdiApplicationCogOutline} from '@mdi/js'
import {mdiApplicationEdit} from '@mdi/js'
import {mdiApplicationEditOutline} from '@mdi/js'
import {mdiApplicationOutline} from '@mdi/js'
import {mdiApplicationParentheses} from '@mdi/js'
import {mdiApplicationParenthesesOutline} from '@mdi/js'
import {mdiApplicationSettings} from '@mdi/js'
import {mdiApplicationSettingsOutline} from '@mdi/js'
import {mdiApplicationVariable} from '@mdi/js'
import {mdiApplicationVariableOutline} from '@mdi/js'
import {mdiApproximatelyEqual} from '@mdi/js'
import {mdiApproximatelyEqualBox} from '@mdi/js'
import {mdiApps} from '@mdi/js'
import {mdiAppsBox} from '@mdi/js'
import {mdiArch} from '@mdi/js'
import {mdiArchive} from '@mdi/js'
import {mdiArchiveAlert} from '@mdi/js'
import {mdiArchiveAlertOutline} from '@mdi/js'
import {mdiArchiveArrowDown} from '@mdi/js'
import {mdiArchiveArrowDownOutline} from '@mdi/js'
import {mdiArchiveArrowUp} from '@mdi/js'
import {mdiArchiveArrowUpOutline} from '@mdi/js'
import {mdiArchiveCancel} from '@mdi/js'
import {mdiArchiveCancelOutline} from '@mdi/js'
import {mdiArchiveCheck} from '@mdi/js'
import {mdiArchiveCheckOutline} from '@mdi/js'
import {mdiArchiveClock} from '@mdi/js'
import {mdiArchiveClockOutline} from '@mdi/js'
import {mdiArchiveCog} from '@mdi/js'
import {mdiArchiveCogOutline} from '@mdi/js'
import {mdiArchiveEdit} from '@mdi/js'
import {mdiArchiveEditOutline} from '@mdi/js'
import {mdiArchiveEye} from '@mdi/js'
import {mdiArchiveEyeOutline} from '@mdi/js'
import {mdiArchiveLock} from '@mdi/js'
import {mdiArchiveLockOpen} from '@mdi/js'
import {mdiArchiveLockOpenOutline} from '@mdi/js'
import {mdiArchiveLockOutline} from '@mdi/js'
import {mdiArchiveMarker} from '@mdi/js'
import {mdiArchiveMarkerOutline} from '@mdi/js'
import {mdiArchiveMinus} from '@mdi/js'
import {mdiArchiveMinusOutline} from '@mdi/js'
import {mdiArchiveMusic} from '@mdi/js'
import {mdiArchiveMusicOutline} from '@mdi/js'
import {mdiArchiveOff} from '@mdi/js'
import {mdiArchiveOffOutline} from '@mdi/js'
import {mdiArchiveOutline} from '@mdi/js'
import {mdiArchivePlus} from '@mdi/js'
import {mdiArchivePlusOutline} from '@mdi/js'
import {mdiArchiveRefresh} from '@mdi/js'
import {mdiArchiveRefreshOutline} from '@mdi/js'
import {mdiArchiveRemove} from '@mdi/js'
import {mdiArchiveRemoveOutline} from '@mdi/js'
import {mdiArchiveSearch} from '@mdi/js'
import {mdiArchiveSearchOutline} from '@mdi/js'
import {mdiArchiveSettings} from '@mdi/js'
import {mdiArchiveSettingsOutline} from '@mdi/js'
import {mdiArchiveStar} from '@mdi/js'
import {mdiArchiveStarOutline} from '@mdi/js'
import {mdiArchiveSync} from '@mdi/js'
import {mdiArchiveSyncOutline} from '@mdi/js'
import {mdiArmFlex} from '@mdi/js'
import {mdiArmFlexOutline} from '@mdi/js'
import {mdiArrangeBringForward} from '@mdi/js'
import {mdiArrangeBringToFront} from '@mdi/js'
import {mdiArrangeSendBackward} from '@mdi/js'
import {mdiArrangeSendToBack} from '@mdi/js'
import {mdiArrowAll} from '@mdi/js'
import {mdiArrowBottomLeft} from '@mdi/js'
import {mdiArrowBottomLeftBoldBox} from '@mdi/js'
import {mdiArrowBottomLeftBoldBoxOutline} from '@mdi/js'
import {mdiArrowBottomLeftBoldOutline} from '@mdi/js'
import {mdiArrowBottomLeftThick} from '@mdi/js'
import {mdiArrowBottomLeftThin} from '@mdi/js'
import {mdiArrowBottomLeftThinCircleOutline} from '@mdi/js'
import {mdiArrowBottomRight} from '@mdi/js'
import {mdiArrowBottomRightBoldBox} from '@mdi/js'
import {mdiArrowBottomRightBoldBoxOutline} from '@mdi/js'
import {mdiArrowBottomRightBoldOutline} from '@mdi/js'
import {mdiArrowBottomRightThick} from '@mdi/js'
import {mdiArrowBottomRightThin} from '@mdi/js'
import {mdiArrowBottomRightThinCircleOutline} from '@mdi/js'
import {mdiArrowCollapse} from '@mdi/js'
import {mdiArrowCollapseAll} from '@mdi/js'
import {mdiArrowCollapseDown} from '@mdi/js'
import {mdiArrowCollapseHorizontal} from '@mdi/js'
import {mdiArrowCollapseLeft} from '@mdi/js'
import {mdiArrowCollapseRight} from '@mdi/js'
import {mdiArrowCollapseUp} from '@mdi/js'
import {mdiArrowCollapseVertical} from '@mdi/js'
import {mdiArrowDecision} from '@mdi/js'
import {mdiArrowDecisionAuto} from '@mdi/js'
import {mdiArrowDecisionAutoOutline} from '@mdi/js'
import {mdiArrowDecisionOutline} from '@mdi/js'
import {mdiArrowDown} from '@mdi/js'
import {mdiArrowDownBold} from '@mdi/js'
import {mdiArrowDownBoldBox} from '@mdi/js'
import {mdiArrowDownBoldBoxOutline} from '@mdi/js'
import {mdiArrowDownBoldCircle} from '@mdi/js'
import {mdiArrowDownBoldCircleOutline} from '@mdi/js'
import {mdiArrowDownBoldHexagonOutline} from '@mdi/js'
import {mdiArrowDownBoldOutline} from '@mdi/js'
import {mdiArrowDownBox} from '@mdi/js'
import {mdiArrowDownCircle} from '@mdi/js'
import {mdiArrowDownCircleOutline} from '@mdi/js'
import {mdiArrowDownDropCircle} from '@mdi/js'
import {mdiArrowDownDropCircleOutline} from '@mdi/js'
import {mdiArrowDownLeft} from '@mdi/js'
import {mdiArrowDownLeftBold} from '@mdi/js'
import {mdiArrowDownRight} from '@mdi/js'
import {mdiArrowDownRightBold} from '@mdi/js'
import {mdiArrowDownThick} from '@mdi/js'
import {mdiArrowDownThin} from '@mdi/js'
import {mdiArrowDownThinCircleOutline} from '@mdi/js'
import {mdiArrowExpand} from '@mdi/js'
import {mdiArrowExpandAll} from '@mdi/js'
import {mdiArrowExpandDown} from '@mdi/js'
import {mdiArrowExpandHorizontal} from '@mdi/js'
import {mdiArrowExpandLeft} from '@mdi/js'
import {mdiArrowExpandRight} from '@mdi/js'
import {mdiArrowExpandUp} from '@mdi/js'
import {mdiArrowExpandVertical} from '@mdi/js'
import {mdiArrowHorizontalLock} from '@mdi/js'
import {mdiArrowLeft} from '@mdi/js'
import {mdiArrowLeftBold} from '@mdi/js'
import {mdiArrowLeftBoldBox} from '@mdi/js'
import {mdiArrowLeftBoldBoxOutline} from '@mdi/js'
import {mdiArrowLeftBoldCircle} from '@mdi/js'
import {mdiArrowLeftBoldCircleOutline} from '@mdi/js'
import {mdiArrowLeftBoldHexagonOutline} from '@mdi/js'
import {mdiArrowLeftBoldOutline} from '@mdi/js'
import {mdiArrowLeftBottom} from '@mdi/js'
import {mdiArrowLeftBottomBold} from '@mdi/js'
import {mdiArrowLeftBox} from '@mdi/js'
import {mdiArrowLeftCircle} from '@mdi/js'
import {mdiArrowLeftCircleOutline} from '@mdi/js'
import {mdiArrowLeftDropCircle} from '@mdi/js'
import {mdiArrowLeftDropCircleOutline} from '@mdi/js'
import {mdiArrowLeftRight} from '@mdi/js'
import {mdiArrowLeftRightBold} from '@mdi/js'
import {mdiArrowLeftRightBoldOutline} from '@mdi/js'
import {mdiArrowLeftThick} from '@mdi/js'
import {mdiArrowLeftThin} from '@mdi/js'
import {mdiArrowLeftThinCircleOutline} from '@mdi/js'
import {mdiArrowLeftTop} from '@mdi/js'
import {mdiArrowLeftTopBold} from '@mdi/js'
import {mdiArrowProjectile} from '@mdi/js'
import {mdiArrowProjectileMultiple} from '@mdi/js'
import {mdiArrowRight} from '@mdi/js'
import {mdiArrowRightBold} from '@mdi/js'
import {mdiArrowRightBoldBox} from '@mdi/js'
import {mdiArrowRightBoldBoxOutline} from '@mdi/js'
import {mdiArrowRightBoldCircle} from '@mdi/js'
import {mdiArrowRightBoldCircleOutline} from '@mdi/js'
import {mdiArrowRightBoldHexagonOutline} from '@mdi/js'
import {mdiArrowRightBoldOutline} from '@mdi/js'
import {mdiArrowRightBottom} from '@mdi/js'
import {mdiArrowRightBottomBold} from '@mdi/js'
import {mdiArrowRightBox} from '@mdi/js'
import {mdiArrowRightCircle} from '@mdi/js'
import {mdiArrowRightCircleOutline} from '@mdi/js'
import {mdiArrowRightDropCircle} from '@mdi/js'
import {mdiArrowRightDropCircleOutline} from '@mdi/js'
import {mdiArrowRightThick} from '@mdi/js'
import {mdiArrowRightThin} from '@mdi/js'
import {mdiArrowRightThinCircleOutline} from '@mdi/js'
import {mdiArrowRightTop} from '@mdi/js'
import {mdiArrowRightTopBold} from '@mdi/js'
import {mdiArrowSplitHorizontal} from '@mdi/js'
import {mdiArrowSplitVertical} from '@mdi/js'
import {mdiArrowTopLeft} from '@mdi/js'
import {mdiArrowTopLeftBoldBox} from '@mdi/js'
import {mdiArrowTopLeftBoldBoxOutline} from '@mdi/js'
import {mdiArrowTopLeftBoldOutline} from '@mdi/js'
import {mdiArrowTopLeftBottomRight} from '@mdi/js'
import {mdiArrowTopLeftBottomRightBold} from '@mdi/js'
import {mdiArrowTopLeftThick} from '@mdi/js'
import {mdiArrowTopLeftThin} from '@mdi/js'
import {mdiArrowTopLeftThinCircleOutline} from '@mdi/js'
import {mdiArrowTopRight} from '@mdi/js'
import {mdiArrowTopRightBoldBox} from '@mdi/js'
import {mdiArrowTopRightBoldBoxOutline} from '@mdi/js'
import {mdiArrowTopRightBoldOutline} from '@mdi/js'
import {mdiArrowTopRightBottomLeft} from '@mdi/js'
import {mdiArrowTopRightBottomLeftBold} from '@mdi/js'
import {mdiArrowTopRightThick} from '@mdi/js'
import {mdiArrowTopRightThin} from '@mdi/js'
import {mdiArrowTopRightThinCircleOutline} from '@mdi/js'
import {mdiArrowUDownLeft} from '@mdi/js'
import {mdiArrowUDownLeftBold} from '@mdi/js'
import {mdiArrowUDownRight} from '@mdi/js'
import {mdiArrowUDownRightBold} from '@mdi/js'
import {mdiArrowULeftBottom} from '@mdi/js'
import {mdiArrowULeftBottomBold} from '@mdi/js'
import {mdiArrowULeftTop} from '@mdi/js'
import {mdiArrowULeftTopBold} from '@mdi/js'
import {mdiArrowURightBottom} from '@mdi/js'
import {mdiArrowURightBottomBold} from '@mdi/js'
import {mdiArrowURightTop} from '@mdi/js'
import {mdiArrowURightTopBold} from '@mdi/js'
import {mdiArrowUUpLeft} from '@mdi/js'
import {mdiArrowUUpLeftBold} from '@mdi/js'
import {mdiArrowUUpRight} from '@mdi/js'
import {mdiArrowUUpRightBold} from '@mdi/js'
import {mdiArrowUp} from '@mdi/js'
import {mdiArrowUpBold} from '@mdi/js'
import {mdiArrowUpBoldBox} from '@mdi/js'
import {mdiArrowUpBoldBoxOutline} from '@mdi/js'
import {mdiArrowUpBoldCircle} from '@mdi/js'
import {mdiArrowUpBoldCircleOutline} from '@mdi/js'
import {mdiArrowUpBoldHexagonOutline} from '@mdi/js'
import {mdiArrowUpBoldOutline} from '@mdi/js'
import {mdiArrowUpBox} from '@mdi/js'
import {mdiArrowUpCircle} from '@mdi/js'
import {mdiArrowUpCircleOutline} from '@mdi/js'
import {mdiArrowUpDown} from '@mdi/js'
import {mdiArrowUpDownBold} from '@mdi/js'
import {mdiArrowUpDownBoldOutline} from '@mdi/js'
import {mdiArrowUpDropCircle} from '@mdi/js'
import {mdiArrowUpDropCircleOutline} from '@mdi/js'
import {mdiArrowUpLeft} from '@mdi/js'
import {mdiArrowUpLeftBold} from '@mdi/js'
import {mdiArrowUpRight} from '@mdi/js'
import {mdiArrowUpRightBold} from '@mdi/js'
import {mdiArrowUpThick} from '@mdi/js'
import {mdiArrowUpThin} from '@mdi/js'
import {mdiArrowUpThinCircleOutline} from '@mdi/js'
import {mdiArrowVerticalLock} from '@mdi/js'
import {mdiArtboard} from '@mdi/js'
import {mdiArtstation} from '@mdi/js'
import {mdiAspectRatio} from '@mdi/js'
import {mdiAssistant} from '@mdi/js'
import {mdiAsterisk} from '@mdi/js'
import {mdiAsteriskCircleOutline} from '@mdi/js'
import {mdiAt} from '@mdi/js'
import {mdiAtlassian} from '@mdi/js'
import {mdiAtm} from '@mdi/js'
import {mdiAtom} from '@mdi/js'
import {mdiAtomVariant} from '@mdi/js'
import {mdiAttachment} from '@mdi/js'
import {mdiAttachmentCheck} from '@mdi/js'
import {mdiAttachmentLock} from '@mdi/js'
import {mdiAttachmentMinus} from '@mdi/js'
import {mdiAttachmentOff} from '@mdi/js'
import {mdiAttachmentPlus} from '@mdi/js'
import {mdiAttachmentRemove} from '@mdi/js'
import {mdiAtv} from '@mdi/js'
import {mdiAudioInputRca} from '@mdi/js'
import {mdiAudioInputStereoMinijack} from '@mdi/js'
import {mdiAudioInputXlr} from '@mdi/js'
import {mdiAudioVideo} from '@mdi/js'
import {mdiAudioVideoOff} from '@mdi/js'
import {mdiAugmentedReality} from '@mdi/js'
import {mdiAutoDownload} from '@mdi/js'
import {mdiAutoFix} from '@mdi/js'
import {mdiAutoUpload} from '@mdi/js'
import {mdiAutorenew} from '@mdi/js'
import {mdiAutorenewOff} from '@mdi/js'
import {mdiAvTimer} from '@mdi/js'
import {mdiAwning} from '@mdi/js'
import {mdiAwningOutline} from '@mdi/js'
import {mdiAws} from '@mdi/js'
import {mdiAxe} from '@mdi/js'
import {mdiAxeBattle} from '@mdi/js'
import {mdiAxis} from '@mdi/js'
import {mdiAxisArrow} from '@mdi/js'
import {mdiAxisArrowInfo} from '@mdi/js'
import {mdiAxisArrowLock} from '@mdi/js'
import {mdiAxisLock} from '@mdi/js'
import {mdiAxisXArrow} from '@mdi/js'
import {mdiAxisXArrowLock} from '@mdi/js'
import {mdiAxisXRotateClockwise} from '@mdi/js'
import {mdiAxisXRotateCounterclockwise} from '@mdi/js'
import {mdiAxisXYArrowLock} from '@mdi/js'
import {mdiAxisYArrow} from '@mdi/js'
import {mdiAxisYArrowLock} from '@mdi/js'
import {mdiAxisYRotateClockwise} from '@mdi/js'
import {mdiAxisYRotateCounterclockwise} from '@mdi/js'
import {mdiAxisZArrow} from '@mdi/js'
import {mdiAxisZArrowLock} from '@mdi/js'
import {mdiAxisZRotateClockwise} from '@mdi/js'
import {mdiAxisZRotateCounterclockwise} from '@mdi/js'
import {mdiBabel} from '@mdi/js'
import {mdiBaby} from '@mdi/js'
import {mdiBabyBottle} from '@mdi/js'
import {mdiBabyBottleOutline} from '@mdi/js'
import {mdiBabyBuggy} from '@mdi/js'
import {mdiBabyBuggyOff} from '@mdi/js'
import {mdiBabyCarriage} from '@mdi/js'
import {mdiBabyCarriageOff} from '@mdi/js'
import {mdiBabyFace} from '@mdi/js'
import {mdiBabyFaceOutline} from '@mdi/js'
import {mdiBackburger} from '@mdi/js'
import {mdiBackspace} from '@mdi/js'
import {mdiBackspaceOutline} from '@mdi/js'
import {mdiBackspaceReverse} from '@mdi/js'
import {mdiBackspaceReverseOutline} from '@mdi/js'
import {mdiBackupRestore} from '@mdi/js'
import {mdiBacteria} from '@mdi/js'
import {mdiBacteriaOutline} from '@mdi/js'
import {mdiBadgeAccount} from '@mdi/js'
import {mdiBadgeAccountAlert} from '@mdi/js'
import {mdiBadgeAccountAlertOutline} from '@mdi/js'
import {mdiBadgeAccountHorizontal} from '@mdi/js'
import {mdiBadgeAccountHorizontalOutline} from '@mdi/js'
import {mdiBadgeAccountOutline} from '@mdi/js'
import {mdiBadminton} from '@mdi/js'
import {mdiBagCarryOn} from '@mdi/js'
import {mdiBagCarryOnCheck} from '@mdi/js'
import {mdiBagCarryOnOff} from '@mdi/js'
import {mdiBagChecked} from '@mdi/js'
import {mdiBagPersonal} from '@mdi/js'
import {mdiBagPersonalOff} from '@mdi/js'
import {mdiBagPersonalOffOutline} from '@mdi/js'
import {mdiBagPersonalOutline} from '@mdi/js'
import {mdiBagPersonalTag} from '@mdi/js'
import {mdiBagPersonalTagOutline} from '@mdi/js'
import {mdiBagSuitcase} from '@mdi/js'
import {mdiBagSuitcaseOff} from '@mdi/js'
import {mdiBagSuitcaseOffOutline} from '@mdi/js'
import {mdiBagSuitcaseOutline} from '@mdi/js'
import {mdiBaguette} from '@mdi/js'
import {mdiBalcony} from '@mdi/js'
import {mdiBalloon} from '@mdi/js'
import {mdiBallot} from '@mdi/js'
import {mdiBallotOutline} from '@mdi/js'
import {mdiBallotRecount} from '@mdi/js'
import {mdiBallotRecountOutline} from '@mdi/js'
import {mdiBandage} from '@mdi/js'
import {mdiBank} from '@mdi/js'
import {mdiBankCheck} from '@mdi/js'
import {mdiBankMinus} from '@mdi/js'
import {mdiBankOff} from '@mdi/js'
import {mdiBankOffOutline} from '@mdi/js'
import {mdiBankOutline} from '@mdi/js'
import {mdiBankPlus} from '@mdi/js'
import {mdiBankRemove} from '@mdi/js'
import {mdiBankTransfer} from '@mdi/js'
import {mdiBankTransferIn} from '@mdi/js'
import {mdiBankTransferOut} from '@mdi/js'
import {mdiBarcode} from '@mdi/js'
import {mdiBarcodeOff} from '@mdi/js'
import {mdiBarcodeScan} from '@mdi/js'
import {mdiBarley} from '@mdi/js'
import {mdiBarleyOff} from '@mdi/js'
import {mdiBarn} from '@mdi/js'
import {mdiBarrel} from '@mdi/js'
import {mdiBarrelOutline} from '@mdi/js'
import {mdiBaseball} from '@mdi/js'
import {mdiBaseballBat} from '@mdi/js'
import {mdiBaseballDiamond} from '@mdi/js'
import {mdiBaseballDiamondOutline} from '@mdi/js'
import {mdiBash} from '@mdi/js'
import {mdiBasket} from '@mdi/js'
import {mdiBasketCheck} from '@mdi/js'
import {mdiBasketCheckOutline} from '@mdi/js'
import {mdiBasketFill} from '@mdi/js'
import {mdiBasketMinus} from '@mdi/js'
import {mdiBasketMinusOutline} from '@mdi/js'
import {mdiBasketOff} from '@mdi/js'
import {mdiBasketOffOutline} from '@mdi/js'
import {mdiBasketOutline} from '@mdi/js'
import {mdiBasketPlus} from '@mdi/js'
import {mdiBasketPlusOutline} from '@mdi/js'
import {mdiBasketRemove} from '@mdi/js'
import {mdiBasketRemoveOutline} from '@mdi/js'
import {mdiBasketUnfill} from '@mdi/js'
import {mdiBasketball} from '@mdi/js'
import {mdiBasketballHoop} from '@mdi/js'
import {mdiBasketballHoopOutline} from '@mdi/js'
import {mdiBat} from '@mdi/js'
import {mdiBathtub} from '@mdi/js'
import {mdiBathtubOutline} from '@mdi/js'
import {mdiBattery} from '@mdi/js'
import {mdiBattery10} from '@mdi/js'
import {mdiBattery10Bluetooth} from '@mdi/js'
import {mdiBattery20} from '@mdi/js'
import {mdiBattery20Bluetooth} from '@mdi/js'
import {mdiBattery30} from '@mdi/js'
import {mdiBattery30Bluetooth} from '@mdi/js'
import {mdiBattery40} from '@mdi/js'
import {mdiBattery40Bluetooth} from '@mdi/js'
import {mdiBattery50} from '@mdi/js'
import {mdiBattery50Bluetooth} from '@mdi/js'
import {mdiBattery60} from '@mdi/js'
import {mdiBattery60Bluetooth} from '@mdi/js'
import {mdiBattery70} from '@mdi/js'
import {mdiBattery70Bluetooth} from '@mdi/js'
import {mdiBattery80} from '@mdi/js'
import {mdiBattery80Bluetooth} from '@mdi/js'
import {mdiBattery90} from '@mdi/js'
import {mdiBattery90Bluetooth} from '@mdi/js'
import {mdiBatteryAlert} from '@mdi/js'
import {mdiBatteryAlertBluetooth} from '@mdi/js'
import {mdiBatteryAlertVariant} from '@mdi/js'
import {mdiBatteryAlertVariantOutline} from '@mdi/js'
import {mdiBatteryArrowDown} from '@mdi/js'
import {mdiBatteryArrowDownOutline} from '@mdi/js'
import {mdiBatteryArrowUp} from '@mdi/js'
import {mdiBatteryArrowUpOutline} from '@mdi/js'
import {mdiBatteryBluetooth} from '@mdi/js'
import {mdiBatteryBluetoothVariant} from '@mdi/js'
import {mdiBatteryCharging} from '@mdi/js'
import {mdiBatteryCharging10} from '@mdi/js'
import {mdiBatteryCharging100} from '@mdi/js'
import {mdiBatteryCharging20} from '@mdi/js'
import {mdiBatteryCharging30} from '@mdi/js'
import {mdiBatteryCharging40} from '@mdi/js'
import {mdiBatteryCharging50} from '@mdi/js'
import {mdiBatteryCharging60} from '@mdi/js'
import {mdiBatteryCharging70} from '@mdi/js'
import {mdiBatteryCharging80} from '@mdi/js'
import {mdiBatteryCharging90} from '@mdi/js'
import {mdiBatteryChargingHigh} from '@mdi/js'
import {mdiBatteryChargingLow} from '@mdi/js'
import {mdiBatteryChargingMedium} from '@mdi/js'
import {mdiBatteryChargingOutline} from '@mdi/js'
import {mdiBatteryChargingWireless} from '@mdi/js'
import {mdiBatteryChargingWireless10} from '@mdi/js'
import {mdiBatteryChargingWireless20} from '@mdi/js'
import {mdiBatteryChargingWireless30} from '@mdi/js'
import {mdiBatteryChargingWireless40} from '@mdi/js'
import {mdiBatteryChargingWireless50} from '@mdi/js'
import {mdiBatteryChargingWireless60} from '@mdi/js'
import {mdiBatteryChargingWireless70} from '@mdi/js'
import {mdiBatteryChargingWireless80} from '@mdi/js'
import {mdiBatteryChargingWireless90} from '@mdi/js'
import {mdiBatteryChargingWirelessAlert} from '@mdi/js'
import {mdiBatteryChargingWirelessOutline} from '@mdi/js'
import {mdiBatteryCheck} from '@mdi/js'
import {mdiBatteryCheckOutline} from '@mdi/js'
import {mdiBatteryClock} from '@mdi/js'
import {mdiBatteryClockOutline} from '@mdi/js'
import {mdiBatteryHeart} from '@mdi/js'
import {mdiBatteryHeartOutline} from '@mdi/js'
import {mdiBatteryHeartVariant} from '@mdi/js'
import {mdiBatteryHigh} from '@mdi/js'
import {mdiBatteryLock} from '@mdi/js'
import {mdiBatteryLockOpen} from '@mdi/js'
import {mdiBatteryLow} from '@mdi/js'
import {mdiBatteryMedium} from '@mdi/js'
import {mdiBatteryMinus} from '@mdi/js'
import {mdiBatteryMinusOutline} from '@mdi/js'
import {mdiBatteryMinusVariant} from '@mdi/js'
import {mdiBatteryNegative} from '@mdi/js'
import {mdiBatteryOff} from '@mdi/js'
import {mdiBatteryOffOutline} from '@mdi/js'
import {mdiBatteryOutline} from '@mdi/js'
import {mdiBatteryPlus} from '@mdi/js'
import {mdiBatteryPlusOutline} from '@mdi/js'
import {mdiBatteryPlusVariant} from '@mdi/js'
import {mdiBatteryPositive} from '@mdi/js'
import {mdiBatteryRemove} from '@mdi/js'
import {mdiBatteryRemoveOutline} from '@mdi/js'
import {mdiBatterySync} from '@mdi/js'
import {mdiBatterySyncOutline} from '@mdi/js'
import {mdiBatteryUnknown} from '@mdi/js'
import {mdiBatteryUnknownBluetooth} from '@mdi/js'
import {mdiBeach} from '@mdi/js'
import {mdiBeaker} from '@mdi/js'
import {mdiBeakerAlert} from '@mdi/js'
import {mdiBeakerAlertOutline} from '@mdi/js'
import {mdiBeakerCheck} from '@mdi/js'
import {mdiBeakerCheckOutline} from '@mdi/js'
import {mdiBeakerMinus} from '@mdi/js'
import {mdiBeakerMinusOutline} from '@mdi/js'
import {mdiBeakerOutline} from '@mdi/js'
import {mdiBeakerPlus} from '@mdi/js'
import {mdiBeakerPlusOutline} from '@mdi/js'
import {mdiBeakerQuestion} from '@mdi/js'
import {mdiBeakerQuestionOutline} from '@mdi/js'
import {mdiBeakerRemove} from '@mdi/js'
import {mdiBeakerRemoveOutline} from '@mdi/js'
import {mdiBed} from '@mdi/js'
import {mdiBedClock} from '@mdi/js'
import {mdiBedDouble} from '@mdi/js'
import {mdiBedDoubleOutline} from '@mdi/js'
import {mdiBedEmpty} from '@mdi/js'
import {mdiBedKing} from '@mdi/js'
import {mdiBedKingOutline} from '@mdi/js'
import {mdiBedOutline} from '@mdi/js'
import {mdiBedQueen} from '@mdi/js'
import {mdiBedQueenOutline} from '@mdi/js'
import {mdiBedSingle} from '@mdi/js'
import {mdiBedSingleOutline} from '@mdi/js'
import {mdiBee} from '@mdi/js'
import {mdiBeeFlower} from '@mdi/js'
import {mdiBeehiveOffOutline} from '@mdi/js'
import {mdiBeehiveOutline} from '@mdi/js'
import {mdiBeekeeper} from '@mdi/js'
import {mdiBeer} from '@mdi/js'
import {mdiBeerOutline} from '@mdi/js'
import {mdiBell} from '@mdi/js'
import {mdiBellAlert} from '@mdi/js'
import {mdiBellAlertOutline} from '@mdi/js'
import {mdiBellBadge} from '@mdi/js'
import {mdiBellBadgeOutline} from '@mdi/js'
import {mdiBellCancel} from '@mdi/js'
import {mdiBellCancelOutline} from '@mdi/js'
import {mdiBellCheck} from '@mdi/js'
import {mdiBellCheckOutline} from '@mdi/js'
import {mdiBellCircle} from '@mdi/js'
import {mdiBellCircleOutline} from '@mdi/js'
import {mdiBellCog} from '@mdi/js'
import {mdiBellCogOutline} from '@mdi/js'
import {mdiBellMinus} from '@mdi/js'
import {mdiBellMinusOutline} from '@mdi/js'
import {mdiBellOff} from '@mdi/js'
import {mdiBellOffOutline} from '@mdi/js'
import {mdiBellOutline} from '@mdi/js'
import {mdiBellPlus} from '@mdi/js'
import {mdiBellPlusOutline} from '@mdi/js'
import {mdiBellRemove} from '@mdi/js'
import {mdiBellRemoveOutline} from '@mdi/js'
import {mdiBellRing} from '@mdi/js'
import {mdiBellRingOutline} from '@mdi/js'
import {mdiBellSleep} from '@mdi/js'
import {mdiBellSleepOutline} from '@mdi/js'
import {mdiBeta} from '@mdi/js'
import {mdiBetamax} from '@mdi/js'
import {mdiBiathlon} from '@mdi/js'
import {mdiBicycle} from '@mdi/js'
import {mdiBicycleBasket} from '@mdi/js'
import {mdiBicycleCargo} from '@mdi/js'
import {mdiBicycleElectric} from '@mdi/js'
import {mdiBicyclePennyFarthing} from '@mdi/js'
import {mdiBike} from '@mdi/js'
import {mdiBikeFast} from '@mdi/js'
import {mdiBillboard} from '@mdi/js'
import {mdiBilliards} from '@mdi/js'
import {mdiBilliardsRack} from '@mdi/js'
import {mdiBinoculars} from '@mdi/js'
import {mdiBio} from '@mdi/js'
import {mdiBiohazard} from '@mdi/js'
import {mdiBird} from '@mdi/js'
import {mdiBitbucket} from '@mdi/js'
import {mdiBitcoin} from '@mdi/js'
import {mdiBlackMesa} from '@mdi/js'
import {mdiBlender} from '@mdi/js'
import {mdiBlenderOutline} from '@mdi/js'
import {mdiBlenderSoftware} from '@mdi/js'
import {mdiBlinds} from '@mdi/js'
import {mdiBlindsHorizontal} from '@mdi/js'
import {mdiBlindsHorizontalClosed} from '@mdi/js'
import {mdiBlindsOpen} from '@mdi/js'
import {mdiBlindsVertical} from '@mdi/js'
import {mdiBlindsVerticalClosed} from '@mdi/js'
import {mdiBlockHelper} from '@mdi/js'
import {mdiBloodBag} from '@mdi/js'
import {mdiBluetooth} from '@mdi/js'
import {mdiBluetoothAudio} from '@mdi/js'
import {mdiBluetoothConnect} from '@mdi/js'
import {mdiBluetoothOff} from '@mdi/js'
import {mdiBluetoothSettings} from '@mdi/js'
import {mdiBluetoothTransfer} from '@mdi/js'
import {mdiBlur} from '@mdi/js'
import {mdiBlurLinear} from '@mdi/js'
import {mdiBlurOff} from '@mdi/js'
import {mdiBlurRadial} from '@mdi/js'
import {mdiBolt} from '@mdi/js'
import {mdiBomb} from '@mdi/js'
import {mdiBombOff} from '@mdi/js'
import {mdiBone} from '@mdi/js'
import {mdiBoneOff} from '@mdi/js'
import {mdiBook} from '@mdi/js'
import {mdiBookAccount} from '@mdi/js'
import {mdiBookAccountOutline} from '@mdi/js'
import {mdiBookAlert} from '@mdi/js'
import {mdiBookAlertOutline} from '@mdi/js'
import {mdiBookAlphabet} from '@mdi/js'
import {mdiBookArrowDown} from '@mdi/js'
import {mdiBookArrowDownOutline} from '@mdi/js'
import {mdiBookArrowLeft} from '@mdi/js'
import {mdiBookArrowLeftOutline} from '@mdi/js'
import {mdiBookArrowRight} from '@mdi/js'
import {mdiBookArrowRightOutline} from '@mdi/js'
import {mdiBookArrowUp} from '@mdi/js'
import {mdiBookArrowUpOutline} from '@mdi/js'
import {mdiBookCancel} from '@mdi/js'
import {mdiBookCancelOutline} from '@mdi/js'
import {mdiBookCheck} from '@mdi/js'
import {mdiBookCheckOutline} from '@mdi/js'
import {mdiBookClock} from '@mdi/js'
import {mdiBookClockOutline} from '@mdi/js'
import {mdiBookCog} from '@mdi/js'
import {mdiBookCogOutline} from '@mdi/js'
import {mdiBookCross} from '@mdi/js'
import {mdiBookEdit} from '@mdi/js'
import {mdiBookEditOutline} from '@mdi/js'
import {mdiBookEducation} from '@mdi/js'
import {mdiBookEducationOutline} from '@mdi/js'
import {mdiBookHeart} from '@mdi/js'
import {mdiBookHeartOutline} from '@mdi/js'
import {mdiBookInformationVariant} from '@mdi/js'
import {mdiBookLock} from '@mdi/js'
import {mdiBookLockOpen} from '@mdi/js'
import {mdiBookLockOpenOutline} from '@mdi/js'
import {mdiBookLockOutline} from '@mdi/js'
import {mdiBookMarker} from '@mdi/js'
import {mdiBookMarkerOutline} from '@mdi/js'
import {mdiBookMinus} from '@mdi/js'
import {mdiBookMinusMultiple} from '@mdi/js'
import {mdiBookMinusMultipleOutline} from '@mdi/js'
import {mdiBookMinusOutline} from '@mdi/js'
import {mdiBookMultiple} from '@mdi/js'
import {mdiBookMultipleOutline} from '@mdi/js'
import {mdiBookMusic} from '@mdi/js'
import {mdiBookMusicOutline} from '@mdi/js'
import {mdiBookOff} from '@mdi/js'
import {mdiBookOffOutline} from '@mdi/js'
import {mdiBookOpen} from '@mdi/js'
import {mdiBookOpenBlankVariant} from '@mdi/js'
import {mdiBookOpenOutline} from '@mdi/js'
import {mdiBookOpenPageVariant} from '@mdi/js'
import {mdiBookOpenPageVariantOutline} from '@mdi/js'
import {mdiBookOpenVariant} from '@mdi/js'
import {mdiBookOutline} from '@mdi/js'
import {mdiBookPlay} from '@mdi/js'
import {mdiBookPlayOutline} from '@mdi/js'
import {mdiBookPlus} from '@mdi/js'
import {mdiBookPlusMultiple} from '@mdi/js'
import {mdiBookPlusMultipleOutline} from '@mdi/js'
import {mdiBookPlusOutline} from '@mdi/js'
import {mdiBookRefresh} from '@mdi/js'
import {mdiBookRefreshOutline} from '@mdi/js'
import {mdiBookRemove} from '@mdi/js'
import {mdiBookRemoveMultiple} from '@mdi/js'
import {mdiBookRemoveMultipleOutline} from '@mdi/js'
import {mdiBookRemoveOutline} from '@mdi/js'
import {mdiBookSearch} from '@mdi/js'
import {mdiBookSearchOutline} from '@mdi/js'
import {mdiBookSettings} from '@mdi/js'
import {mdiBookSettingsOutline} from '@mdi/js'
import {mdiBookSync} from '@mdi/js'
import {mdiBookSyncOutline} from '@mdi/js'
import {mdiBookVariant} from '@mdi/js'
import {mdiBookmark} from '@mdi/js'
import {mdiBookmarkBox} from '@mdi/js'
import {mdiBookmarkBoxMultiple} from '@mdi/js'
import {mdiBookmarkBoxMultipleOutline} from '@mdi/js'
import {mdiBookmarkBoxOutline} from '@mdi/js'
import {mdiBookmarkCheck} from '@mdi/js'
import {mdiBookmarkCheckOutline} from '@mdi/js'
import {mdiBookmarkMinus} from '@mdi/js'
import {mdiBookmarkMinusOutline} from '@mdi/js'
import {mdiBookmarkMultiple} from '@mdi/js'
import {mdiBookmarkMultipleOutline} from '@mdi/js'
import {mdiBookmarkMusic} from '@mdi/js'
import {mdiBookmarkMusicOutline} from '@mdi/js'
import {mdiBookmarkOff} from '@mdi/js'
import {mdiBookmarkOffOutline} from '@mdi/js'
import {mdiBookmarkOutline} from '@mdi/js'
import {mdiBookmarkPlus} from '@mdi/js'
import {mdiBookmarkPlusOutline} from '@mdi/js'
import {mdiBookmarkRemove} from '@mdi/js'
import {mdiBookmarkRemoveOutline} from '@mdi/js'
import {mdiBookshelf} from '@mdi/js'
import {mdiBoomGate} from '@mdi/js'
import {mdiBoomGateAlert} from '@mdi/js'
import {mdiBoomGateAlertOutline} from '@mdi/js'
import {mdiBoomGateArrowDown} from '@mdi/js'
import {mdiBoomGateArrowDownOutline} from '@mdi/js'
import {mdiBoomGateArrowUp} from '@mdi/js'
import {mdiBoomGateArrowUpOutline} from '@mdi/js'
import {mdiBoomGateOutline} from '@mdi/js'
import {mdiBoomGateUp} from '@mdi/js'
import {mdiBoomGateUpOutline} from '@mdi/js'
import {mdiBoombox} from '@mdi/js'
import {mdiBoomerang} from '@mdi/js'
import {mdiBootstrap} from '@mdi/js'
import {mdiBorderAll} from '@mdi/js'
import {mdiBorderAllVariant} from '@mdi/js'
import {mdiBorderBottom} from '@mdi/js'
import {mdiBorderBottomVariant} from '@mdi/js'
import {mdiBorderColor} from '@mdi/js'
import {mdiBorderHorizontal} from '@mdi/js'
import {mdiBorderInside} from '@mdi/js'
import {mdiBorderLeft} from '@mdi/js'
import {mdiBorderLeftVariant} from '@mdi/js'
import {mdiBorderNone} from '@mdi/js'
import {mdiBorderNoneVariant} from '@mdi/js'
import {mdiBorderOutside} from '@mdi/js'
import {mdiBorderRadius} from '@mdi/js'
import {mdiBorderRight} from '@mdi/js'
import {mdiBorderRightVariant} from '@mdi/js'
import {mdiBorderStyle} from '@mdi/js'
import {mdiBorderTop} from '@mdi/js'
import {mdiBorderTopVariant} from '@mdi/js'
import {mdiBorderVertical} from '@mdi/js'
import {mdiBottleSoda} from '@mdi/js'
import {mdiBottleSodaClassic} from '@mdi/js'
import {mdiBottleSodaClassicOutline} from '@mdi/js'
import {mdiBottleSodaOutline} from '@mdi/js'
import {mdiBottleTonic} from '@mdi/js'
import {mdiBottleTonicOutline} from '@mdi/js'
import {mdiBottleTonicPlus} from '@mdi/js'
import {mdiBottleTonicPlusOutline} from '@mdi/js'
import {mdiBottleTonicSkull} from '@mdi/js'
import {mdiBottleTonicSkullOutline} from '@mdi/js'
import {mdiBottleWine} from '@mdi/js'
import {mdiBottleWineOutline} from '@mdi/js'
import {mdiBowArrow} from '@mdi/js'
import {mdiBowTie} from '@mdi/js'
import {mdiBowl} from '@mdi/js'
import {mdiBowlMix} from '@mdi/js'
import {mdiBowlMixOutline} from '@mdi/js'
import {mdiBowlOutline} from '@mdi/js'
import {mdiBowling} from '@mdi/js'
import {mdiBox} from '@mdi/js'
import {mdiBoxCutter} from '@mdi/js'
import {mdiBoxCutterOff} from '@mdi/js'
import {mdiBoxShadow} from '@mdi/js'
import {mdiBoxingGlove} from '@mdi/js'
import {mdiBraille} from '@mdi/js'
import {mdiBrain} from '@mdi/js'
import {mdiBreadSlice} from '@mdi/js'
import {mdiBreadSliceOutline} from '@mdi/js'
import {mdiBridge} from '@mdi/js'
import {mdiBriefcase} from '@mdi/js'
import {mdiBriefcaseAccount} from '@mdi/js'
import {mdiBriefcaseAccountOutline} from '@mdi/js'
import {mdiBriefcaseArrowLeftRight} from '@mdi/js'
import {mdiBriefcaseArrowLeftRightOutline} from '@mdi/js'
import {mdiBriefcaseArrowUpDown} from '@mdi/js'
import {mdiBriefcaseArrowUpDownOutline} from '@mdi/js'
import {mdiBriefcaseCheck} from '@mdi/js'
import {mdiBriefcaseCheckOutline} from '@mdi/js'
import {mdiBriefcaseClock} from '@mdi/js'
import {mdiBriefcaseClockOutline} from '@mdi/js'
import {mdiBriefcaseDownload} from '@mdi/js'
import {mdiBriefcaseDownloadOutline} from '@mdi/js'
import {mdiBriefcaseEdit} from '@mdi/js'
import {mdiBriefcaseEditOutline} from '@mdi/js'
import {mdiBriefcaseEye} from '@mdi/js'
import {mdiBriefcaseEyeOutline} from '@mdi/js'
import {mdiBriefcaseMinus} from '@mdi/js'
import {mdiBriefcaseMinusOutline} from '@mdi/js'
import {mdiBriefcaseOff} from '@mdi/js'
import {mdiBriefcaseOffOutline} from '@mdi/js'
import {mdiBriefcaseOutline} from '@mdi/js'
import {mdiBriefcasePlus} from '@mdi/js'
import {mdiBriefcasePlusOutline} from '@mdi/js'
import {mdiBriefcaseRemove} from '@mdi/js'
import {mdiBriefcaseRemoveOutline} from '@mdi/js'
import {mdiBriefcaseSearch} from '@mdi/js'
import {mdiBriefcaseSearchOutline} from '@mdi/js'
import {mdiBriefcaseUpload} from '@mdi/js'
import {mdiBriefcaseUploadOutline} from '@mdi/js'
import {mdiBriefcaseVariant} from '@mdi/js'
import {mdiBriefcaseVariantOff} from '@mdi/js'
import {mdiBriefcaseVariantOffOutline} from '@mdi/js'
import {mdiBriefcaseVariantOutline} from '@mdi/js'
import {mdiBrightness1} from '@mdi/js'
import {mdiBrightness2} from '@mdi/js'
import {mdiBrightness3} from '@mdi/js'
import {mdiBrightness4} from '@mdi/js'
import {mdiBrightness5} from '@mdi/js'
import {mdiBrightness6} from '@mdi/js'
import {mdiBrightness7} from '@mdi/js'
import {mdiBrightnessAuto} from '@mdi/js'
import {mdiBrightnessPercent} from '@mdi/js'
import {mdiBroadcast} from '@mdi/js'
import {mdiBroadcastOff} from '@mdi/js'
import {mdiBroom} from '@mdi/js'
import {mdiBrush} from '@mdi/js'
import {mdiBrushOff} from '@mdi/js'
import {mdiBrushOutline} from '@mdi/js'
import {mdiBrushVariant} from '@mdi/js'
import {mdiBucket} from '@mdi/js'
import {mdiBucketOutline} from '@mdi/js'
import {mdiBuffet} from '@mdi/js'
import {mdiBug} from '@mdi/js'
import {mdiBugCheck} from '@mdi/js'
import {mdiBugCheckOutline} from '@mdi/js'
import {mdiBugOutline} from '@mdi/js'
import {mdiBugPause} from '@mdi/js'
import {mdiBugPauseOutline} from '@mdi/js'
import {mdiBugPlay} from '@mdi/js'
import {mdiBugPlayOutline} from '@mdi/js'
import {mdiBugStop} from '@mdi/js'
import {mdiBugStopOutline} from '@mdi/js'
import {mdiBugle} from '@mdi/js'
import {mdiBulkheadLight} from '@mdi/js'
import {mdiBulldozer} from '@mdi/js'
import {mdiBullet} from '@mdi/js'
import {mdiBulletinBoard} from '@mdi/js'
import {mdiBullhorn} from '@mdi/js'
import {mdiBullhornOutline} from '@mdi/js'
import {mdiBullhornVariant} from '@mdi/js'
import {mdiBullhornVariantOutline} from '@mdi/js'
import {mdiBullseye} from '@mdi/js'
import {mdiBullseyeArrow} from '@mdi/js'
import {mdiBulma} from '@mdi/js'
import {mdiBunkBed} from '@mdi/js'
import {mdiBunkBedOutline} from '@mdi/js'
import {mdiBus} from '@mdi/js'
import {mdiBusAlert} from '@mdi/js'
import {mdiBusArticulatedEnd} from '@mdi/js'
import {mdiBusArticulatedFront} from '@mdi/js'
import {mdiBusClock} from '@mdi/js'
import {mdiBusDoubleDecker} from '@mdi/js'
import {mdiBusElectric} from '@mdi/js'
import {mdiBusMarker} from '@mdi/js'
import {mdiBusMultiple} from '@mdi/js'
import {mdiBusSchool} from '@mdi/js'
import {mdiBusSide} from '@mdi/js'
import {mdiBusStop} from '@mdi/js'
import {mdiBusStopCovered} from '@mdi/js'
import {mdiBusStopUncovered} from '@mdi/js'
import {mdiButterfly} from '@mdi/js'
import {mdiButterflyOutline} from '@mdi/js'
import {mdiButtonCursor} from '@mdi/js'
import {mdiButtonPointer} from '@mdi/js'
import {mdiCabinAFrame} from '@mdi/js'
import {mdiCableData} from '@mdi/js'
import {mdiCached} from '@mdi/js'
import {mdiCactus} from '@mdi/js'
import {mdiCake} from '@mdi/js'
import {mdiCakeLayered} from '@mdi/js'
import {mdiCakeVariant} from '@mdi/js'
import {mdiCakeVariantOutline} from '@mdi/js'
import {mdiCalculator} from '@mdi/js'
import {mdiCalculatorVariant} from '@mdi/js'
import {mdiCalculatorVariantOutline} from '@mdi/js'
import {mdiCalendar} from '@mdi/js'
import {mdiCalendarAccount} from '@mdi/js'
import {mdiCalendarAccountOutline} from '@mdi/js'
import {mdiCalendarAlert} from '@mdi/js'
import {mdiCalendarAlertOutline} from '@mdi/js'
import {mdiCalendarArrowLeft} from '@mdi/js'
import {mdiCalendarArrowRight} from '@mdi/js'
import {mdiCalendarBadge} from '@mdi/js'
import {mdiCalendarBadgeOutline} from '@mdi/js'
import {mdiCalendarBlank} from '@mdi/js'
import {mdiCalendarBlankMultiple} from '@mdi/js'
import {mdiCalendarBlankOutline} from '@mdi/js'
import {mdiCalendarCheck} from '@mdi/js'
import {mdiCalendarCheckOutline} from '@mdi/js'
import {mdiCalendarClock} from '@mdi/js'
import {mdiCalendarClockOutline} from '@mdi/js'
import {mdiCalendarCollapseHorizontal} from '@mdi/js'
import {mdiCalendarCollapseHorizontalOutline} from '@mdi/js'
import {mdiCalendarCursor} from '@mdi/js'
import {mdiCalendarCursorOutline} from '@mdi/js'
import {mdiCalendarEdit} from '@mdi/js'
import {mdiCalendarEditOutline} from '@mdi/js'
import {mdiCalendarEnd} from '@mdi/js'
import {mdiCalendarEndOutline} from '@mdi/js'
import {mdiCalendarExpandHorizontal} from '@mdi/js'
import {mdiCalendarExpandHorizontalOutline} from '@mdi/js'
import {mdiCalendarFilterOutline} from '@mdi/js'
import {mdiCalendarHeart} from '@mdi/js'
import {mdiCalendarHeartOutline} from '@mdi/js'
import {mdiCalendarImport} from '@mdi/js'
import {mdiCalendarImportOutline} from '@mdi/js'
import {mdiCalendarLock} from '@mdi/js'
import {mdiCalendarLockOpen} from '@mdi/js'
import {mdiCalendarLockOpenOutline} from '@mdi/js'
import {mdiCalendarLockOutline} from '@mdi/js'
import {mdiCalendarMinus} from '@mdi/js'
import {mdiCalendarMinusOutline} from '@mdi/js'
import {mdiCalendarMonth} from '@mdi/js'
import {mdiCalendarMonthOutline} from '@mdi/js'
import {mdiCalendarMultiple} from '@mdi/js'
import {mdiCalendarMultipleCheck} from '@mdi/js'
import {mdiCalendarMultiselect} from '@mdi/js'
import {mdiCalendarMultiselectOutline} from '@mdi/js'
import {mdiCalendarOutline} from '@mdi/js'
import {mdiCalendarPlus} from '@mdi/js'
import {mdiCalendarPlusOutline} from '@mdi/js'
import {mdiCalendarQuestion} from '@mdi/js'
import {mdiCalendarQuestionOutline} from '@mdi/js'
import {mdiCalendarRange} from '@mdi/js'
import {mdiCalendarRangeOutline} from '@mdi/js'
import {mdiCalendarRefresh} from '@mdi/js'
import {mdiCalendarRefreshOutline} from '@mdi/js'
import {mdiCalendarRemove} from '@mdi/js'
import {mdiCalendarRemoveOutline} from '@mdi/js'
import {mdiCalendarSearch} from '@mdi/js'
import {mdiCalendarSearchOutline} from '@mdi/js'
import {mdiCalendarStar} from '@mdi/js'
import {mdiCalendarStarOutline} from '@mdi/js'
import {mdiCalendarStart} from '@mdi/js'
import {mdiCalendarStartOutline} from '@mdi/js'
import {mdiCalendarSync} from '@mdi/js'
import {mdiCalendarSyncOutline} from '@mdi/js'
import {mdiCalendarText} from '@mdi/js'
import {mdiCalendarTextOutline} from '@mdi/js'
import {mdiCalendarToday} from '@mdi/js'
import {mdiCalendarTodayOutline} from '@mdi/js'
import {mdiCalendarWeek} from '@mdi/js'
import {mdiCalendarWeekBegin} from '@mdi/js'
import {mdiCalendarWeekBeginOutline} from '@mdi/js'
import {mdiCalendarWeekOutline} from '@mdi/js'
import {mdiCalendarWeekend} from '@mdi/js'
import {mdiCalendarWeekendOutline} from '@mdi/js'
import {mdiCallMade} from '@mdi/js'
import {mdiCallMerge} from '@mdi/js'
import {mdiCallMissed} from '@mdi/js'
import {mdiCallReceived} from '@mdi/js'
import {mdiCallSplit} from '@mdi/js'
import {mdiCamcorder} from '@mdi/js'
import {mdiCamcorderOff} from '@mdi/js'
import {mdiCamera} from '@mdi/js'
import {mdiCameraAccount} from '@mdi/js'
import {mdiCameraBurst} from '@mdi/js'
import {mdiCameraControl} from '@mdi/js'
import {mdiCameraDocument} from '@mdi/js'
import {mdiCameraDocumentOff} from '@mdi/js'
import {mdiCameraEnhance} from '@mdi/js'
import {mdiCameraEnhanceOutline} from '@mdi/js'
import {mdiCameraFlip} from '@mdi/js'
import {mdiCameraFlipOutline} from '@mdi/js'
import {mdiCameraFront} from '@mdi/js'
import {mdiCameraFrontVariant} from '@mdi/js'
import {mdiCameraGopro} from '@mdi/js'
import {mdiCameraImage} from '@mdi/js'
import {mdiCameraIris} from '@mdi/js'
import {mdiCameraLock} from '@mdi/js'
import {mdiCameraLockOutline} from '@mdi/js'
import {mdiCameraMarker} from '@mdi/js'
import {mdiCameraMarkerOutline} from '@mdi/js'
import {mdiCameraMeteringCenter} from '@mdi/js'
import {mdiCameraMeteringMatrix} from '@mdi/js'
import {mdiCameraMeteringPartial} from '@mdi/js'
import {mdiCameraMeteringSpot} from '@mdi/js'
import {mdiCameraOff} from '@mdi/js'
import {mdiCameraOffOutline} from '@mdi/js'
import {mdiCameraOutline} from '@mdi/js'
import {mdiCameraPartyMode} from '@mdi/js'
import {mdiCameraPlus} from '@mdi/js'
import {mdiCameraPlusOutline} from '@mdi/js'
import {mdiCameraRear} from '@mdi/js'
import {mdiCameraRearVariant} from '@mdi/js'
import {mdiCameraRetake} from '@mdi/js'
import {mdiCameraRetakeOutline} from '@mdi/js'
import {mdiCameraSwitch} from '@mdi/js'
import {mdiCameraSwitchOutline} from '@mdi/js'
import {mdiCameraTimer} from '@mdi/js'
import {mdiCameraWireless} from '@mdi/js'
import {mdiCameraWirelessOutline} from '@mdi/js'
import {mdiCampfire} from '@mdi/js'
import {mdiCancel} from '@mdi/js'
import {mdiCandelabra} from '@mdi/js'
import {mdiCandelabraFire} from '@mdi/js'
import {mdiCandle} from '@mdi/js'
import {mdiCandy} from '@mdi/js'
import {mdiCandyOff} from '@mdi/js'
import {mdiCandyOffOutline} from '@mdi/js'
import {mdiCandyOutline} from '@mdi/js'
import {mdiCandycane} from '@mdi/js'
import {mdiCannabis} from '@mdi/js'
import {mdiCannabisOff} from '@mdi/js'
import {mdiCapsLock} from '@mdi/js'
import {mdiCar} from '@mdi/js'
import {mdiCar2Plus} from '@mdi/js'
import {mdiCar3Plus} from '@mdi/js'
import {mdiCarArrowLeft} from '@mdi/js'
import {mdiCarArrowRight} from '@mdi/js'
import {mdiCarBack} from '@mdi/js'
import {mdiCarBattery} from '@mdi/js'
import {mdiCarBrakeAbs} from '@mdi/js'
import {mdiCarBrakeAlert} from '@mdi/js'
import {mdiCarBrakeFluidLevel} from '@mdi/js'
import {mdiCarBrakeHold} from '@mdi/js'
import {mdiCarBrakeLowPressure} from '@mdi/js'
import {mdiCarBrakeParking} from '@mdi/js'
import {mdiCarBrakeRetarder} from '@mdi/js'
import {mdiCarBrakeTemperature} from '@mdi/js'
import {mdiCarBrakeWornLinings} from '@mdi/js'
import {mdiCarChildSeat} from '@mdi/js'
import {mdiCarClock} from '@mdi/js'
import {mdiCarClutch} from '@mdi/js'
import {mdiCarCog} from '@mdi/js'
import {mdiCarConnected} from '@mdi/js'
import {mdiCarConvertible} from '@mdi/js'
import {mdiCarCoolantLevel} from '@mdi/js'
import {mdiCarCruiseControl} from '@mdi/js'
import {mdiCarDefrostFront} from '@mdi/js'
import {mdiCarDefrostRear} from '@mdi/js'
import {mdiCarDoor} from '@mdi/js'
import {mdiCarDoorLock} from '@mdi/js'
import {mdiCarElectric} from '@mdi/js'
import {mdiCarElectricOutline} from '@mdi/js'
import {mdiCarEmergency} from '@mdi/js'
import {mdiCarEsp} from '@mdi/js'
import {mdiCarEstate} from '@mdi/js'
import {mdiCarHatchback} from '@mdi/js'
import {mdiCarInfo} from '@mdi/js'
import {mdiCarKey} from '@mdi/js'
import {mdiCarLiftedPickup} from '@mdi/js'
import {mdiCarLightAlert} from '@mdi/js'
import {mdiCarLightDimmed} from '@mdi/js'
import {mdiCarLightFog} from '@mdi/js'
import {mdiCarLightHigh} from '@mdi/js'
import {mdiCarLimousine} from '@mdi/js'
import {mdiCarMultiple} from '@mdi/js'
import {mdiCarOff} from '@mdi/js'
import {mdiCarOutline} from '@mdi/js'
import {mdiCarParkingLights} from '@mdi/js'
import {mdiCarPickup} from '@mdi/js'
import {mdiCarSearch} from '@mdi/js'
import {mdiCarSearchOutline} from '@mdi/js'
import {mdiCarSeat} from '@mdi/js'
import {mdiCarSeatCooler} from '@mdi/js'
import {mdiCarSeatHeater} from '@mdi/js'
import {mdiCarSelect} from '@mdi/js'
import {mdiCarSettings} from '@mdi/js'
import {mdiCarShiftPattern} from '@mdi/js'
import {mdiCarSide} from '@mdi/js'
import {mdiCarSpeedLimiter} from '@mdi/js'
import {mdiCarSports} from '@mdi/js'
import {mdiCarTireAlert} from '@mdi/js'
import {mdiCarTractionControl} from '@mdi/js'
import {mdiCarTurbocharger} from '@mdi/js'
import {mdiCarWash} from '@mdi/js'
import {mdiCarWindshield} from '@mdi/js'
import {mdiCarWindshieldOutline} from '@mdi/js'
import {mdiCarWireless} from '@mdi/js'
import {mdiCarWrench} from '@mdi/js'
import {mdiCarabiner} from '@mdi/js'
import {mdiCaravan} from '@mdi/js'
import {mdiCard} from '@mdi/js'
import {mdiCardAccountDetails} from '@mdi/js'
import {mdiCardAccountDetailsOutline} from '@mdi/js'
import {mdiCardAccountDetailsStar} from '@mdi/js'
import {mdiCardAccountDetailsStarOutline} from '@mdi/js'
import {mdiCardAccountMail} from '@mdi/js'
import {mdiCardAccountMailOutline} from '@mdi/js'
import {mdiCardAccountPhone} from '@mdi/js'
import {mdiCardAccountPhoneOutline} from '@mdi/js'
import {mdiCardBulleted} from '@mdi/js'
import {mdiCardBulletedOff} from '@mdi/js'
import {mdiCardBulletedOffOutline} from '@mdi/js'
import {mdiCardBulletedOutline} from '@mdi/js'
import {mdiCardBulletedSettings} from '@mdi/js'
import {mdiCardBulletedSettingsOutline} from '@mdi/js'
import {mdiCardMinus} from '@mdi/js'
import {mdiCardMinusOutline} from '@mdi/js'
import {mdiCardMultiple} from '@mdi/js'
import {mdiCardMultipleOutline} from '@mdi/js'
import {mdiCardOff} from '@mdi/js'
import {mdiCardOffOutline} from '@mdi/js'
import {mdiCardOutline} from '@mdi/js'
import {mdiCardPlus} from '@mdi/js'
import {mdiCardPlusOutline} from '@mdi/js'
import {mdiCardRemove} from '@mdi/js'
import {mdiCardRemoveOutline} from '@mdi/js'
import {mdiCardSearch} from '@mdi/js'
import {mdiCardSearchOutline} from '@mdi/js'
import {mdiCardText} from '@mdi/js'
import {mdiCardTextOutline} from '@mdi/js'
import {mdiCards} from '@mdi/js'
import {mdiCardsClub} from '@mdi/js'
import {mdiCardsClubOutline} from '@mdi/js'
import {mdiCardsDiamond} from '@mdi/js'
import {mdiCardsDiamondOutline} from '@mdi/js'
import {mdiCardsHeart} from '@mdi/js'
import {mdiCardsHeartOutline} from '@mdi/js'
import {mdiCardsOutline} from '@mdi/js'
import {mdiCardsPlaying} from '@mdi/js'
import {mdiCardsPlayingClub} from '@mdi/js'
import {mdiCardsPlayingClubMultiple} from '@mdi/js'
import {mdiCardsPlayingClubMultipleOutline} from '@mdi/js'
import {mdiCardsPlayingClubOutline} from '@mdi/js'
import {mdiCardsPlayingDiamond} from '@mdi/js'
import {mdiCardsPlayingDiamondMultiple} from '@mdi/js'
import {mdiCardsPlayingDiamondMultipleOutline} from '@mdi/js'
import {mdiCardsPlayingDiamondOutline} from '@mdi/js'
import {mdiCardsPlayingHeart} from '@mdi/js'
import {mdiCardsPlayingHeartMultiple} from '@mdi/js'
import {mdiCardsPlayingHeartMultipleOutline} from '@mdi/js'
import {mdiCardsPlayingHeartOutline} from '@mdi/js'
import {mdiCardsPlayingOutline} from '@mdi/js'
import {mdiCardsPlayingSpade} from '@mdi/js'
import {mdiCardsPlayingSpadeMultiple} from '@mdi/js'
import {mdiCardsPlayingSpadeMultipleOutline} from '@mdi/js'
import {mdiCardsPlayingSpadeOutline} from '@mdi/js'
import {mdiCardsSpade} from '@mdi/js'
import {mdiCardsSpadeOutline} from '@mdi/js'
import {mdiCardsVariant} from '@mdi/js'
import {mdiCarrot} from '@mdi/js'
import {mdiCart} from '@mdi/js'
import {mdiCartArrowDown} from '@mdi/js'
import {mdiCartArrowRight} from '@mdi/js'
import {mdiCartArrowUp} from '@mdi/js'
import {mdiCartCheck} from '@mdi/js'
import {mdiCartHeart} from '@mdi/js'
import {mdiCartMinus} from '@mdi/js'
import {mdiCartOff} from '@mdi/js'
import {mdiCartOutline} from '@mdi/js'
import {mdiCartPercent} from '@mdi/js'
import {mdiCartPlus} from '@mdi/js'
import {mdiCartRemove} from '@mdi/js'
import {mdiCartVariant} from '@mdi/js'
import {mdiCaseSensitiveAlt} from '@mdi/js'
import {mdiCash} from '@mdi/js'
import {mdiCash100} from '@mdi/js'
import {mdiCashCheck} from '@mdi/js'
import {mdiCashClock} from '@mdi/js'
import {mdiCashFast} from '@mdi/js'
import {mdiCashLock} from '@mdi/js'
import {mdiCashLockOpen} from '@mdi/js'
import {mdiCashMarker} from '@mdi/js'
import {mdiCashMinus} from '@mdi/js'
import {mdiCashMultiple} from '@mdi/js'
import {mdiCashPlus} from '@mdi/js'
import {mdiCashRefund} from '@mdi/js'
import {mdiCashRegister} from '@mdi/js'
import {mdiCashRemove} from '@mdi/js'
import {mdiCashSync} from '@mdi/js'
import {mdiCassette} from '@mdi/js'
import {mdiCast} from '@mdi/js'
import {mdiCastAudio} from '@mdi/js'
import {mdiCastAudioVariant} from '@mdi/js'
import {mdiCastConnected} from '@mdi/js'
import {mdiCastEducation} from '@mdi/js'
import {mdiCastOff} from '@mdi/js'
import {mdiCastVariant} from '@mdi/js'
import {mdiCastle} from '@mdi/js'
import {mdiCat} from '@mdi/js'
import {mdiCctv} from '@mdi/js'
import {mdiCctvOff} from '@mdi/js'
import {mdiCeilingFan} from '@mdi/js'
import {mdiCeilingFanLight} from '@mdi/js'
import {mdiCeilingLight} from '@mdi/js'
import {mdiCeilingLightMultiple} from '@mdi/js'
import {mdiCeilingLightMultipleOutline} from '@mdi/js'
import {mdiCeilingLightOutline} from '@mdi/js'
import {mdiCellphone} from '@mdi/js'
import {mdiCellphoneArrowDown} from '@mdi/js'
import {mdiCellphoneArrowDownVariant} from '@mdi/js'
import {mdiCellphoneBasic} from '@mdi/js'
import {mdiCellphoneCharging} from '@mdi/js'
import {mdiCellphoneCheck} from '@mdi/js'
import {mdiCellphoneCog} from '@mdi/js'
import {mdiCellphoneDock} from '@mdi/js'
import {mdiCellphoneInformation} from '@mdi/js'
import {mdiCellphoneKey} from '@mdi/js'
import {mdiCellphoneLink} from '@mdi/js'
import {mdiCellphoneLinkOff} from '@mdi/js'
import {mdiCellphoneLock} from '@mdi/js'
import {mdiCellphoneMarker} from '@mdi/js'
import {mdiCellphoneMessage} from '@mdi/js'
import {mdiCellphoneMessageOff} from '@mdi/js'
import {mdiCellphoneNfc} from '@mdi/js'
import {mdiCellphoneNfcOff} from '@mdi/js'
import {mdiCellphoneOff} from '@mdi/js'
import {mdiCellphonePlay} from '@mdi/js'
import {mdiCellphoneRemove} from '@mdi/js'
import {mdiCellphoneScreenshot} from '@mdi/js'
import {mdiCellphoneSettings} from '@mdi/js'
import {mdiCellphoneSound} from '@mdi/js'
import {mdiCellphoneText} from '@mdi/js'
import {mdiCellphoneWireless} from '@mdi/js'
import {mdiCentos} from '@mdi/js'
import {mdiCertificate} from '@mdi/js'
import {mdiCertificateOutline} from '@mdi/js'
import {mdiChairRolling} from '@mdi/js'
import {mdiChairSchool} from '@mdi/js'
import {mdiChandelier} from '@mdi/js'
import {mdiCharity} from '@mdi/js'
import {mdiChartArc} from '@mdi/js'
import {mdiChartAreaspline} from '@mdi/js'
import {mdiChartAreasplineVariant} from '@mdi/js'
import {mdiChartBar} from '@mdi/js'
import {mdiChartBarStacked} from '@mdi/js'
import {mdiChartBellCurve} from '@mdi/js'
import {mdiChartBellCurveCumulative} from '@mdi/js'
import {mdiChartBox} from '@mdi/js'
import {mdiChartBoxOutline} from '@mdi/js'
import {mdiChartBoxPlusOutline} from '@mdi/js'
import {mdiChartBubble} from '@mdi/js'
import {mdiChartDonut} from '@mdi/js'
import {mdiChartDonutVariant} from '@mdi/js'
import {mdiChartGantt} from '@mdi/js'
import {mdiChartHistogram} from '@mdi/js'
import {mdiChartLine} from '@mdi/js'
import {mdiChartLineStacked} from '@mdi/js'
import {mdiChartLineVariant} from '@mdi/js'
import {mdiChartMultiline} from '@mdi/js'
import {mdiChartMultiple} from '@mdi/js'
import {mdiChartPie} from '@mdi/js'
import {mdiChartPpf} from '@mdi/js'
import {mdiChartSankey} from '@mdi/js'
import {mdiChartSankeyVariant} from '@mdi/js'
import {mdiChartScatterPlot} from '@mdi/js'
import {mdiChartScatterPlotHexbin} from '@mdi/js'
import {mdiChartTimeline} from '@mdi/js'
import {mdiChartTimelineVariant} from '@mdi/js'
import {mdiChartTimelineVariantShimmer} from '@mdi/js'
import {mdiChartTree} from '@mdi/js'
import {mdiChartWaterfall} from '@mdi/js'
import {mdiChat} from '@mdi/js'
import {mdiChatAlert} from '@mdi/js'
import {mdiChatAlertOutline} from '@mdi/js'
import {mdiChatMinus} from '@mdi/js'
import {mdiChatMinusOutline} from '@mdi/js'
import {mdiChatOutline} from '@mdi/js'
import {mdiChatPlus} from '@mdi/js'
import {mdiChatPlusOutline} from '@mdi/js'
import {mdiChatProcessing} from '@mdi/js'
import {mdiChatProcessingOutline} from '@mdi/js'
import {mdiChatQuestion} from '@mdi/js'
import {mdiChatQuestionOutline} from '@mdi/js'
import {mdiChatRemove} from '@mdi/js'
import {mdiChatRemoveOutline} from '@mdi/js'
import {mdiChatSleep} from '@mdi/js'
import {mdiChatSleepOutline} from '@mdi/js'
import {mdiCheck} from '@mdi/js'
import {mdiCheckAll} from '@mdi/js'
import {mdiCheckBold} from '@mdi/js'
import {mdiCheckCircle} from '@mdi/js'
import {mdiCheckCircleOutline} from '@mdi/js'
import {mdiCheckDecagram} from '@mdi/js'
import {mdiCheckDecagramOutline} from '@mdi/js'
import {mdiCheckNetwork} from '@mdi/js'
import {mdiCheckNetworkOutline} from '@mdi/js'
import {mdiCheckOutline} from '@mdi/js'
import {mdiCheckUnderline} from '@mdi/js'
import {mdiCheckUnderlineCircle} from '@mdi/js'
import {mdiCheckUnderlineCircleOutline} from '@mdi/js'
import {mdiCheckbook} from '@mdi/js'
import {mdiCheckboxBlank} from '@mdi/js'
import {mdiCheckboxBlankBadge} from '@mdi/js'
import {mdiCheckboxBlankBadgeOutline} from '@mdi/js'
import {mdiCheckboxBlankCircle} from '@mdi/js'
import {mdiCheckboxBlankCircleOutline} from '@mdi/js'
import {mdiCheckboxBlankOff} from '@mdi/js'
import {mdiCheckboxBlankOffOutline} from '@mdi/js'
import {mdiCheckboxBlankOutline} from '@mdi/js'
import {mdiCheckboxIntermediate} from '@mdi/js'
import {mdiCheckboxIntermediateVariant} from '@mdi/js'
import {mdiCheckboxMarked} from '@mdi/js'
import {mdiCheckboxMarkedCircle} from '@mdi/js'
import {mdiCheckboxMarkedCircleOutline} from '@mdi/js'
import {mdiCheckboxMarkedCirclePlusOutline} from '@mdi/js'
import {mdiCheckboxMarkedOutline} from '@mdi/js'
import {mdiCheckboxMultipleBlank} from '@mdi/js'
import {mdiCheckboxMultipleBlankCircle} from '@mdi/js'
import {mdiCheckboxMultipleBlankCircleOutline} from '@mdi/js'
import {mdiCheckboxMultipleBlankOutline} from '@mdi/js'
import {mdiCheckboxMultipleMarked} from '@mdi/js'
import {mdiCheckboxMultipleMarkedCircle} from '@mdi/js'
import {mdiCheckboxMultipleMarkedCircleOutline} from '@mdi/js'
import {mdiCheckboxMultipleMarkedOutline} from '@mdi/js'
import {mdiCheckboxMultipleOutline} from '@mdi/js'
import {mdiCheckboxOutline} from '@mdi/js'
import {mdiCheckerboard} from '@mdi/js'
import {mdiCheckerboardMinus} from '@mdi/js'
import {mdiCheckerboardPlus} from '@mdi/js'
import {mdiCheckerboardRemove} from '@mdi/js'
import {mdiCheese} from '@mdi/js'
import {mdiCheeseOff} from '@mdi/js'
import {mdiChefHat} from '@mdi/js'
import {mdiChemicalWeapon} from '@mdi/js'
import {mdiChessBishop} from '@mdi/js'
import {mdiChessKing} from '@mdi/js'
import {mdiChessKnight} from '@mdi/js'
import {mdiChessPawn} from '@mdi/js'
import {mdiChessQueen} from '@mdi/js'
import {mdiChessRook} from '@mdi/js'
import {mdiChevronDoubleDown} from '@mdi/js'
import {mdiChevronDoubleLeft} from '@mdi/js'
import {mdiChevronDoubleRight} from '@mdi/js'
import {mdiChevronDoubleUp} from '@mdi/js'
import {mdiChevronDown} from '@mdi/js'
import {mdiChevronDownBox} from '@mdi/js'
import {mdiChevronDownBoxOutline} from '@mdi/js'
import {mdiChevronDownCircle} from '@mdi/js'
import {mdiChevronDownCircleOutline} from '@mdi/js'
import {mdiChevronLeft} from '@mdi/js'
import {mdiChevronLeftBox} from '@mdi/js'
import {mdiChevronLeftBoxOutline} from '@mdi/js'
import {mdiChevronLeftCircle} from '@mdi/js'
import {mdiChevronLeftCircleOutline} from '@mdi/js'
import {mdiChevronRight} from '@mdi/js'
import {mdiChevronRightBox} from '@mdi/js'
import {mdiChevronRightBoxOutline} from '@mdi/js'
import {mdiChevronRightCircle} from '@mdi/js'
import {mdiChevronRightCircleOutline} from '@mdi/js'
import {mdiChevronTripleDown} from '@mdi/js'
import {mdiChevronTripleLeft} from '@mdi/js'
import {mdiChevronTripleRight} from '@mdi/js'
import {mdiChevronTripleUp} from '@mdi/js'
import {mdiChevronUp} from '@mdi/js'
import {mdiChevronUpBox} from '@mdi/js'
import {mdiChevronUpBoxOutline} from '@mdi/js'
import {mdiChevronUpCircle} from '@mdi/js'
import {mdiChevronUpCircleOutline} from '@mdi/js'
import {mdiChiliAlert} from '@mdi/js'
import {mdiChiliAlertOutline} from '@mdi/js'
import {mdiChiliHot} from '@mdi/js'
import {mdiChiliHotOutline} from '@mdi/js'
import {mdiChiliMedium} from '@mdi/js'
import {mdiChiliMediumOutline} from '@mdi/js'
import {mdiChiliMild} from '@mdi/js'
import {mdiChiliMildOutline} from '@mdi/js'
import {mdiChiliOff} from '@mdi/js'
import {mdiChiliOffOutline} from '@mdi/js'
import {mdiChip} from '@mdi/js'
import {mdiChurch} from '@mdi/js'
import {mdiChurchOutline} from '@mdi/js'
import {mdiCigar} from '@mdi/js'
import {mdiCigarOff} from '@mdi/js'
import {mdiCircle} from '@mdi/js'
import {mdiCircleBox} from '@mdi/js'
import {mdiCircleBoxOutline} from '@mdi/js'
import {mdiCircleDouble} from '@mdi/js'
import {mdiCircleEditOutline} from '@mdi/js'
import {mdiCircleExpand} from '@mdi/js'
import {mdiCircleHalf} from '@mdi/js'
import {mdiCircleHalfFull} from '@mdi/js'
import {mdiCircleMedium} from '@mdi/js'
import {mdiCircleMultiple} from '@mdi/js'
import {mdiCircleMultipleOutline} from '@mdi/js'
import {mdiCircleOffOutline} from '@mdi/js'
import {mdiCircleOpacity} from '@mdi/js'
import {mdiCircleOutline} from '@mdi/js'
import {mdiCircleSlice1} from '@mdi/js'
import {mdiCircleSlice2} from '@mdi/js'
import {mdiCircleSlice3} from '@mdi/js'
import {mdiCircleSlice4} from '@mdi/js'
import {mdiCircleSlice5} from '@mdi/js'
import {mdiCircleSlice6} from '@mdi/js'
import {mdiCircleSlice7} from '@mdi/js'
import {mdiCircleSlice8} from '@mdi/js'
import {mdiCircleSmall} from '@mdi/js'
import {mdiCircularSaw} from '@mdi/js'
import {mdiCity} from '@mdi/js'
import {mdiCityVariant} from '@mdi/js'
import {mdiCityVariantOutline} from '@mdi/js'
import {mdiClipboard} from '@mdi/js'
import {mdiClipboardAccount} from '@mdi/js'
import {mdiClipboardAccountOutline} from '@mdi/js'
import {mdiClipboardAlert} from '@mdi/js'
import {mdiClipboardAlertOutline} from '@mdi/js'
import {mdiClipboardArrowDown} from '@mdi/js'
import {mdiClipboardArrowDownOutline} from '@mdi/js'
import {mdiClipboardArrowLeft} from '@mdi/js'
import {mdiClipboardArrowLeftOutline} from '@mdi/js'
import {mdiClipboardArrowRight} from '@mdi/js'
import {mdiClipboardArrowRightOutline} from '@mdi/js'
import {mdiClipboardArrowUp} from '@mdi/js'
import {mdiClipboardArrowUpOutline} from '@mdi/js'
import {mdiClipboardCheck} from '@mdi/js'
import {mdiClipboardCheckMultiple} from '@mdi/js'
import {mdiClipboardCheckMultipleOutline} from '@mdi/js'
import {mdiClipboardCheckOutline} from '@mdi/js'
import {mdiClipboardClock} from '@mdi/js'
import {mdiClipboardClockOutline} from '@mdi/js'
import {mdiClipboardEdit} from '@mdi/js'
import {mdiClipboardEditOutline} from '@mdi/js'
import {mdiClipboardFile} from '@mdi/js'
import {mdiClipboardFileOutline} from '@mdi/js'
import {mdiClipboardFlow} from '@mdi/js'
import {mdiClipboardFlowOutline} from '@mdi/js'
import {mdiClipboardList} from '@mdi/js'
import {mdiClipboardListOutline} from '@mdi/js'
import {mdiClipboardMinus} from '@mdi/js'
import {mdiClipboardMinusOutline} from '@mdi/js'
import {mdiClipboardMultiple} from '@mdi/js'
import {mdiClipboardMultipleOutline} from '@mdi/js'
import {mdiClipboardOff} from '@mdi/js'
import {mdiClipboardOffOutline} from '@mdi/js'
import {mdiClipboardOutline} from '@mdi/js'
import {mdiClipboardPlay} from '@mdi/js'
import {mdiClipboardPlayMultiple} from '@mdi/js'
import {mdiClipboardPlayMultipleOutline} from '@mdi/js'
import {mdiClipboardPlayOutline} from '@mdi/js'
import {mdiClipboardPlus} from '@mdi/js'
import {mdiClipboardPlusOutline} from '@mdi/js'
import {mdiClipboardPulse} from '@mdi/js'
import {mdiClipboardPulseOutline} from '@mdi/js'
import {mdiClipboardRemove} from '@mdi/js'
import {mdiClipboardRemoveOutline} from '@mdi/js'
import {mdiClipboardSearch} from '@mdi/js'
import {mdiClipboardSearchOutline} from '@mdi/js'
import {mdiClipboardText} from '@mdi/js'
import {mdiClipboardTextClock} from '@mdi/js'
import {mdiClipboardTextClockOutline} from '@mdi/js'
import {mdiClipboardTextMultiple} from '@mdi/js'
import {mdiClipboardTextMultipleOutline} from '@mdi/js'
import {mdiClipboardTextOff} from '@mdi/js'
import {mdiClipboardTextOffOutline} from '@mdi/js'
import {mdiClipboardTextOutline} from '@mdi/js'
import {mdiClipboardTextPlay} from '@mdi/js'
import {mdiClipboardTextPlayOutline} from '@mdi/js'
import {mdiClipboardTextSearch} from '@mdi/js'
import {mdiClipboardTextSearchOutline} from '@mdi/js'
import {mdiClippy} from '@mdi/js'
import {mdiClock} from '@mdi/js'
import {mdiClockAlert} from '@mdi/js'
import {mdiClockAlertOutline} from '@mdi/js'
import {mdiClockCheck} from '@mdi/js'
import {mdiClockCheckOutline} from '@mdi/js'
import {mdiClockDigital} from '@mdi/js'
import {mdiClockEdit} from '@mdi/js'
import {mdiClockEditOutline} from '@mdi/js'
import {mdiClockEnd} from '@mdi/js'
import {mdiClockFast} from '@mdi/js'
import {mdiClockIn} from '@mdi/js'
import {mdiClockMinus} from '@mdi/js'
import {mdiClockMinusOutline} from '@mdi/js'
import {mdiClockOut} from '@mdi/js'
import {mdiClockOutline} from '@mdi/js'
import {mdiClockPlus} from '@mdi/js'
import {mdiClockPlusOutline} from '@mdi/js'
import {mdiClockRemove} from '@mdi/js'
import {mdiClockRemoveOutline} from '@mdi/js'
import {mdiClockStart} from '@mdi/js'
import {mdiClockTimeEight} from '@mdi/js'
import {mdiClockTimeEightOutline} from '@mdi/js'
import {mdiClockTimeEleven} from '@mdi/js'
import {mdiClockTimeElevenOutline} from '@mdi/js'
import {mdiClockTimeFive} from '@mdi/js'
import {mdiClockTimeFiveOutline} from '@mdi/js'
import {mdiClockTimeFour} from '@mdi/js'
import {mdiClockTimeFourOutline} from '@mdi/js'
import {mdiClockTimeNine} from '@mdi/js'
import {mdiClockTimeNineOutline} from '@mdi/js'
import {mdiClockTimeOne} from '@mdi/js'
import {mdiClockTimeOneOutline} from '@mdi/js'
import {mdiClockTimeSeven} from '@mdi/js'
import {mdiClockTimeSevenOutline} from '@mdi/js'
import {mdiClockTimeSix} from '@mdi/js'
import {mdiClockTimeSixOutline} from '@mdi/js'
import {mdiClockTimeTen} from '@mdi/js'
import {mdiClockTimeTenOutline} from '@mdi/js'
import {mdiClockTimeThree} from '@mdi/js'
import {mdiClockTimeThreeOutline} from '@mdi/js'
import {mdiClockTimeTwelve} from '@mdi/js'
import {mdiClockTimeTwelveOutline} from '@mdi/js'
import {mdiClockTimeTwo} from '@mdi/js'
import {mdiClockTimeTwoOutline} from '@mdi/js'
import {mdiClose} from '@mdi/js'
import {mdiCloseBox} from '@mdi/js'
import {mdiCloseBoxMultiple} from '@mdi/js'
import {mdiCloseBoxMultipleOutline} from '@mdi/js'
import {mdiCloseBoxOutline} from '@mdi/js'
import {mdiCloseCircle} from '@mdi/js'
import {mdiCloseCircleMultiple} from '@mdi/js'
import {mdiCloseCircleMultipleOutline} from '@mdi/js'
import {mdiCloseCircleOutline} from '@mdi/js'
import {mdiCloseNetwork} from '@mdi/js'
import {mdiCloseNetworkOutline} from '@mdi/js'
import {mdiCloseOctagon} from '@mdi/js'
import {mdiCloseOctagonOutline} from '@mdi/js'
import {mdiCloseOutline} from '@mdi/js'
import {mdiCloseThick} from '@mdi/js'
import {mdiClosedCaption} from '@mdi/js'
import {mdiClosedCaptionOutline} from '@mdi/js'
import {mdiCloud} from '@mdi/js'
import {mdiCloudAlert} from '@mdi/js'
import {mdiCloudBraces} from '@mdi/js'
import {mdiCloudCheck} from '@mdi/js'
import {mdiCloudCheckOutline} from '@mdi/js'
import {mdiCloudCircle} from '@mdi/js'
import {mdiCloudDownload} from '@mdi/js'
import {mdiCloudDownloadOutline} from '@mdi/js'
import {mdiCloudLock} from '@mdi/js'
import {mdiCloudLockOutline} from '@mdi/js'
import {mdiCloudOffOutline} from '@mdi/js'
import {mdiCloudOutline} from '@mdi/js'
import {mdiCloudPercent} from '@mdi/js'
import {mdiCloudPercentOutline} from '@mdi/js'
import {mdiCloudPrint} from '@mdi/js'
import {mdiCloudPrintOutline} from '@mdi/js'
import {mdiCloudQuestion} from '@mdi/js'
import {mdiCloudRefresh} from '@mdi/js'
import {mdiCloudSearch} from '@mdi/js'
import {mdiCloudSearchOutline} from '@mdi/js'
import {mdiCloudSync} from '@mdi/js'
import {mdiCloudSyncOutline} from '@mdi/js'
import {mdiCloudTags} from '@mdi/js'
import {mdiCloudUpload} from '@mdi/js'
import {mdiCloudUploadOutline} from '@mdi/js'
import {mdiClouds} from '@mdi/js'
import {mdiClover} from '@mdi/js'
import {mdiCoachLamp} from '@mdi/js'
import {mdiCoachLampVariant} from '@mdi/js'
import {mdiCoatRack} from '@mdi/js'
import {mdiCodeArray} from '@mdi/js'
import {mdiCodeBraces} from '@mdi/js'
import {mdiCodeBracesBox} from '@mdi/js'
import {mdiCodeBrackets} from '@mdi/js'
import {mdiCodeEqual} from '@mdi/js'
import {mdiCodeGreaterThan} from '@mdi/js'
import {mdiCodeGreaterThanOrEqual} from '@mdi/js'
import {mdiCodeJson} from '@mdi/js'
import {mdiCodeLessThan} from '@mdi/js'
import {mdiCodeLessThanOrEqual} from '@mdi/js'
import {mdiCodeNotEqual} from '@mdi/js'
import {mdiCodeNotEqualVariant} from '@mdi/js'
import {mdiCodeParentheses} from '@mdi/js'
import {mdiCodeParenthesesBox} from '@mdi/js'
import {mdiCodeString} from '@mdi/js'
import {mdiCodeTags} from '@mdi/js'
import {mdiCodeTagsCheck} from '@mdi/js'
import {mdiCodepen} from '@mdi/js'
import {mdiCoffee} from '@mdi/js'
import {mdiCoffeeMaker} from '@mdi/js'
import {mdiCoffeeMakerCheck} from '@mdi/js'
import {mdiCoffeeMakerCheckOutline} from '@mdi/js'
import {mdiCoffeeMakerOutline} from '@mdi/js'
import {mdiCoffeeOff} from '@mdi/js'
import {mdiCoffeeOffOutline} from '@mdi/js'
import {mdiCoffeeOutline} from '@mdi/js'
import {mdiCoffeeToGo} from '@mdi/js'
import {mdiCoffeeToGoOutline} from '@mdi/js'
import {mdiCoffin} from '@mdi/js'
import {mdiCog} from '@mdi/js'
import {mdiCogBox} from '@mdi/js'
import {mdiCogClockwise} from '@mdi/js'
import {mdiCogCounterclockwise} from '@mdi/js'
import {mdiCogOff} from '@mdi/js'
import {mdiCogOffOutline} from '@mdi/js'
import {mdiCogOutline} from '@mdi/js'
import {mdiCogPause} from '@mdi/js'
import {mdiCogPauseOutline} from '@mdi/js'
import {mdiCogPlay} from '@mdi/js'
import {mdiCogPlayOutline} from '@mdi/js'
import {mdiCogRefresh} from '@mdi/js'
import {mdiCogRefreshOutline} from '@mdi/js'
import {mdiCogStop} from '@mdi/js'
import {mdiCogStopOutline} from '@mdi/js'
import {mdiCogSync} from '@mdi/js'
import {mdiCogSyncOutline} from '@mdi/js'
import {mdiCogTransfer} from '@mdi/js'
import {mdiCogTransferOutline} from '@mdi/js'
import {mdiCogs} from '@mdi/js'
import {mdiCollage} from '@mdi/js'
import {mdiCollapseAll} from '@mdi/js'
import {mdiCollapseAllOutline} from '@mdi/js'
import {mdiColorHelper} from '@mdi/js'
import {mdiComma} from '@mdi/js'
import {mdiCommaBox} from '@mdi/js'
import {mdiCommaBoxOutline} from '@mdi/js'
import {mdiCommaCircle} from '@mdi/js'
import {mdiCommaCircleOutline} from '@mdi/js'
import {mdiComment} from '@mdi/js'
import {mdiCommentAccount} from '@mdi/js'
import {mdiCommentAccountOutline} from '@mdi/js'
import {mdiCommentAlert} from '@mdi/js'
import {mdiCommentAlertOutline} from '@mdi/js'
import {mdiCommentArrowLeft} from '@mdi/js'
import {mdiCommentArrowLeftOutline} from '@mdi/js'
import {mdiCommentArrowRight} from '@mdi/js'
import {mdiCommentArrowRightOutline} from '@mdi/js'
import {mdiCommentBookmark} from '@mdi/js'
import {mdiCommentBookmarkOutline} from '@mdi/js'
import {mdiCommentCheck} from '@mdi/js'
import {mdiCommentCheckOutline} from '@mdi/js'
import {mdiCommentEdit} from '@mdi/js'
import {mdiCommentEditOutline} from '@mdi/js'
import {mdiCommentEye} from '@mdi/js'
import {mdiCommentEyeOutline} from '@mdi/js'
import {mdiCommentFlash} from '@mdi/js'
import {mdiCommentFlashOutline} from '@mdi/js'
import {mdiCommentMinus} from '@mdi/js'
import {mdiCommentMinusOutline} from '@mdi/js'
import {mdiCommentMultiple} from '@mdi/js'
import {mdiCommentMultipleOutline} from '@mdi/js'
import {mdiCommentOff} from '@mdi/js'
import {mdiCommentOffOutline} from '@mdi/js'
import {mdiCommentOutline} from '@mdi/js'
import {mdiCommentPlus} from '@mdi/js'
import {mdiCommentPlusOutline} from '@mdi/js'
import {mdiCommentProcessing} from '@mdi/js'
import {mdiCommentProcessingOutline} from '@mdi/js'
import {mdiCommentQuestion} from '@mdi/js'
import {mdiCommentQuestionOutline} from '@mdi/js'
import {mdiCommentQuote} from '@mdi/js'
import {mdiCommentQuoteOutline} from '@mdi/js'
import {mdiCommentRemove} from '@mdi/js'
import {mdiCommentRemoveOutline} from '@mdi/js'
import {mdiCommentSearch} from '@mdi/js'
import {mdiCommentSearchOutline} from '@mdi/js'
import {mdiCommentText} from '@mdi/js'
import {mdiCommentTextMultiple} from '@mdi/js'
import {mdiCommentTextMultipleOutline} from '@mdi/js'
import {mdiCommentTextOutline} from '@mdi/js'
import {mdiCompare} from '@mdi/js'
import {mdiCompareHorizontal} from '@mdi/js'
import {mdiCompareRemove} from '@mdi/js'
import {mdiCompareVertical} from '@mdi/js'
import {mdiCompass} from '@mdi/js'
import {mdiCompassOff} from '@mdi/js'
import {mdiCompassOffOutline} from '@mdi/js'
import {mdiCompassOutline} from '@mdi/js'
import {mdiCompassRose} from '@mdi/js'
import {mdiCompost} from '@mdi/js'
import {mdiCone} from '@mdi/js'
import {mdiConeOff} from '@mdi/js'
import {mdiConnection} from '@mdi/js'
import {mdiConsole} from '@mdi/js'
import {mdiConsoleLine} from '@mdi/js'
import {mdiConsoleNetwork} from '@mdi/js'
import {mdiConsoleNetworkOutline} from '@mdi/js'
import {mdiConsolidate} from '@mdi/js'
import {mdiContactlessPayment} from '@mdi/js'
import {mdiContactlessPaymentCircle} from '@mdi/js'
import {mdiContactlessPaymentCircleOutline} from '@mdi/js'
import {mdiContacts} from '@mdi/js'
import {mdiContactsOutline} from '@mdi/js'
import {mdiContain} from '@mdi/js'
import {mdiContainEnd} from '@mdi/js'
import {mdiContainStart} from '@mdi/js'
import {mdiContentCopy} from '@mdi/js'
import {mdiContentCut} from '@mdi/js'
import {mdiContentDuplicate} from '@mdi/js'
import {mdiContentPaste} from '@mdi/js'
import {mdiContentSave} from '@mdi/js'
import {mdiContentSaveAlert} from '@mdi/js'
import {mdiContentSaveAlertOutline} from '@mdi/js'
import {mdiContentSaveAll} from '@mdi/js'
import {mdiContentSaveAllOutline} from '@mdi/js'
import {mdiContentSaveCheck} from '@mdi/js'
import {mdiContentSaveCheckOutline} from '@mdi/js'
import {mdiContentSaveCog} from '@mdi/js'
import {mdiContentSaveCogOutline} from '@mdi/js'
import {mdiContentSaveEdit} from '@mdi/js'
import {mdiContentSaveEditOutline} from '@mdi/js'
import {mdiContentSaveMinus} from '@mdi/js'
import {mdiContentSaveMinusOutline} from '@mdi/js'
import {mdiContentSaveMove} from '@mdi/js'
import {mdiContentSaveMoveOutline} from '@mdi/js'
import {mdiContentSaveOff} from '@mdi/js'
import {mdiContentSaveOffOutline} from '@mdi/js'
import {mdiContentSaveOutline} from '@mdi/js'
import {mdiContentSavePlus} from '@mdi/js'
import {mdiContentSavePlusOutline} from '@mdi/js'
import {mdiContentSaveSettings} from '@mdi/js'
import {mdiContentSaveSettingsOutline} from '@mdi/js'
import {mdiContrast} from '@mdi/js'
import {mdiContrastBox} from '@mdi/js'
import {mdiContrastCircle} from '@mdi/js'
import {mdiController} from '@mdi/js'
import {mdiControllerClassic} from '@mdi/js'
import {mdiControllerClassicOutline} from '@mdi/js'
import {mdiControllerOff} from '@mdi/js'
import {mdiCookie} from '@mdi/js'
import {mdiCookieAlert} from '@mdi/js'
import {mdiCookieAlertOutline} from '@mdi/js'
import {mdiCookieCheck} from '@mdi/js'
import {mdiCookieCheckOutline} from '@mdi/js'
import {mdiCookieClock} from '@mdi/js'
import {mdiCookieClockOutline} from '@mdi/js'
import {mdiCookieCog} from '@mdi/js'
import {mdiCookieCogOutline} from '@mdi/js'
import {mdiCookieEdit} from '@mdi/js'
import {mdiCookieEditOutline} from '@mdi/js'
import {mdiCookieLock} from '@mdi/js'
import {mdiCookieLockOutline} from '@mdi/js'
import {mdiCookieMinus} from '@mdi/js'
import {mdiCookieMinusOutline} from '@mdi/js'
import {mdiCookieOff} from '@mdi/js'
import {mdiCookieOffOutline} from '@mdi/js'
import {mdiCookieOutline} from '@mdi/js'
import {mdiCookiePlus} from '@mdi/js'
import {mdiCookiePlusOutline} from '@mdi/js'
import {mdiCookieRefresh} from '@mdi/js'
import {mdiCookieRefreshOutline} from '@mdi/js'
import {mdiCookieRemove} from '@mdi/js'
import {mdiCookieRemoveOutline} from '@mdi/js'
import {mdiCookieSettings} from '@mdi/js'
import {mdiCookieSettingsOutline} from '@mdi/js'
import {mdiCoolantTemperature} from '@mdi/js'
import {mdiCopyleft} from '@mdi/js'
import {mdiCopyright} from '@mdi/js'
import {mdiCordova} from '@mdi/js'
import {mdiCorn} from '@mdi/js'
import {mdiCornOff} from '@mdi/js'
import {mdiCosineWave} from '@mdi/js'
import {mdiCounter} from '@mdi/js'
import {mdiCountertop} from '@mdi/js'
import {mdiCountertopOutline} from '@mdi/js'
import {mdiCow} from '@mdi/js'
import {mdiCowOff} from '@mdi/js'
import {mdiCpu32Bit} from '@mdi/js'
import {mdiCpu64Bit} from '@mdi/js'
import {mdiCradle} from '@mdi/js'
import {mdiCradleOutline} from '@mdi/js'
import {mdiCrane} from '@mdi/js'
import {mdiCreation} from '@mdi/js'
import {mdiCreativeCommons} from '@mdi/js'
import {mdiCreditCard} from '@mdi/js'
import {mdiCreditCardCheck} from '@mdi/js'
import {mdiCreditCardCheckOutline} from '@mdi/js'
import {mdiCreditCardChip} from '@mdi/js'
import {mdiCreditCardChipOutline} from '@mdi/js'
import {mdiCreditCardClock} from '@mdi/js'
import {mdiCreditCardClockOutline} from '@mdi/js'
import {mdiCreditCardEdit} from '@mdi/js'
import {mdiCreditCardEditOutline} from '@mdi/js'
import {mdiCreditCardFast} from '@mdi/js'
import {mdiCreditCardFastOutline} from '@mdi/js'
import {mdiCreditCardLock} from '@mdi/js'
import {mdiCreditCardLockOutline} from '@mdi/js'
import {mdiCreditCardMarker} from '@mdi/js'
import {mdiCreditCardMarkerOutline} from '@mdi/js'
import {mdiCreditCardMinus} from '@mdi/js'
import {mdiCreditCardMinusOutline} from '@mdi/js'
import {mdiCreditCardMultiple} from '@mdi/js'
import {mdiCreditCardMultipleOutline} from '@mdi/js'
import {mdiCreditCardOff} from '@mdi/js'
import {mdiCreditCardOffOutline} from '@mdi/js'
import {mdiCreditCardOutline} from '@mdi/js'
import {mdiCreditCardPlus} from '@mdi/js'
import {mdiCreditCardPlusOutline} from '@mdi/js'
import {mdiCreditCardRefresh} from '@mdi/js'
import {mdiCreditCardRefreshOutline} from '@mdi/js'
import {mdiCreditCardRefund} from '@mdi/js'
import {mdiCreditCardRefundOutline} from '@mdi/js'
import {mdiCreditCardRemove} from '@mdi/js'
import {mdiCreditCardRemoveOutline} from '@mdi/js'
import {mdiCreditCardScan} from '@mdi/js'
import {mdiCreditCardScanOutline} from '@mdi/js'
import {mdiCreditCardSearch} from '@mdi/js'
import {mdiCreditCardSearchOutline} from '@mdi/js'
import {mdiCreditCardSettings} from '@mdi/js'
import {mdiCreditCardSettingsOutline} from '@mdi/js'
import {mdiCreditCardSync} from '@mdi/js'
import {mdiCreditCardSyncOutline} from '@mdi/js'
import {mdiCreditCardWireless} from '@mdi/js'
import {mdiCreditCardWirelessOff} from '@mdi/js'
import {mdiCreditCardWirelessOffOutline} from '@mdi/js'
import {mdiCreditCardWirelessOutline} from '@mdi/js'
import {mdiCricket} from '@mdi/js'
import {mdiCrop} from '@mdi/js'
import {mdiCropFree} from '@mdi/js'
import {mdiCropLandscape} from '@mdi/js'
import {mdiCropPortrait} from '@mdi/js'
import {mdiCropRotate} from '@mdi/js'
import {mdiCropSquare} from '@mdi/js'
import {mdiCross} from '@mdi/js'
import {mdiCrossBolnisi} from '@mdi/js'
import {mdiCrossCeltic} from '@mdi/js'
import {mdiCrossOutline} from '@mdi/js'
import {mdiCrosshairs} from '@mdi/js'
import {mdiCrosshairsGps} from '@mdi/js'
import {mdiCrosshairsOff} from '@mdi/js'
import {mdiCrosshairsQuestion} from '@mdi/js'
import {mdiCrowd} from '@mdi/js'
import {mdiCrown} from '@mdi/js'
import {mdiCrownCircle} from '@mdi/js'
import {mdiCrownCircleOutline} from '@mdi/js'
import {mdiCrownOutline} from '@mdi/js'
import {mdiCryengine} from '@mdi/js'
import {mdiCrystalBall} from '@mdi/js'
import {mdiCube} from '@mdi/js'
import {mdiCubeOff} from '@mdi/js'
import {mdiCubeOffOutline} from '@mdi/js'
import {mdiCubeOutline} from '@mdi/js'
import {mdiCubeScan} from '@mdi/js'
import {mdiCubeSend} from '@mdi/js'
import {mdiCubeUnfolded} from '@mdi/js'
import {mdiCup} from '@mdi/js'
import {mdiCupOff} from '@mdi/js'
import {mdiCupOffOutline} from '@mdi/js'
import {mdiCupOutline} from '@mdi/js'
import {mdiCupWater} from '@mdi/js'
import {mdiCupboard} from '@mdi/js'
import {mdiCupboardOutline} from '@mdi/js'
import {mdiCupcake} from '@mdi/js'
import {mdiCurling} from '@mdi/js'
import {mdiCurrencyBdt} from '@mdi/js'
import {mdiCurrencyBrl} from '@mdi/js'
import {mdiCurrencyBtc} from '@mdi/js'
import {mdiCurrencyCny} from '@mdi/js'
import {mdiCurrencyEth} from '@mdi/js'
import {mdiCurrencyEur} from '@mdi/js'
import {mdiCurrencyEurOff} from '@mdi/js'
import {mdiCurrencyFra} from '@mdi/js'
import {mdiCurrencyGbp} from '@mdi/js'
import {mdiCurrencyIls} from '@mdi/js'
import {mdiCurrencyInr} from '@mdi/js'
import {mdiCurrencyJpy} from '@mdi/js'
import {mdiCurrencyKrw} from '@mdi/js'
import {mdiCurrencyKzt} from '@mdi/js'
import {mdiCurrencyMnt} from '@mdi/js'
import {mdiCurrencyNgn} from '@mdi/js'
import {mdiCurrencyPhp} from '@mdi/js'
import {mdiCurrencyRial} from '@mdi/js'
import {mdiCurrencyRub} from '@mdi/js'
import {mdiCurrencyRupee} from '@mdi/js'
import {mdiCurrencySign} from '@mdi/js'
import {mdiCurrencyTry} from '@mdi/js'
import {mdiCurrencyTwd} from '@mdi/js'
import {mdiCurrencyUah} from '@mdi/js'
import {mdiCurrencyUsd} from '@mdi/js'
import {mdiCurrencyUsdOff} from '@mdi/js'
import {mdiCurrentAc} from '@mdi/js'
import {mdiCurrentDc} from '@mdi/js'
import {mdiCursorDefault} from '@mdi/js'
import {mdiCursorDefaultClick} from '@mdi/js'
import {mdiCursorDefaultClickOutline} from '@mdi/js'
import {mdiCursorDefaultGesture} from '@mdi/js'
import {mdiCursorDefaultGestureOutline} from '@mdi/js'
import {mdiCursorDefaultOutline} from '@mdi/js'
import {mdiCursorMove} from '@mdi/js'
import {mdiCursorPointer} from '@mdi/js'
import {mdiCursorText} from '@mdi/js'
import {mdiCurtains} from '@mdi/js'
import {mdiCurtainsClosed} from '@mdi/js'
import {mdiCylinder} from '@mdi/js'
import {mdiCylinderOff} from '@mdi/js'
import {mdiDanceBallroom} from '@mdi/js'
import {mdiDancePole} from '@mdi/js'
import {mdiDataMatrix} from '@mdi/js'
import {mdiDataMatrixEdit} from '@mdi/js'
import {mdiDataMatrixMinus} from '@mdi/js'
import {mdiDataMatrixPlus} from '@mdi/js'
import {mdiDataMatrixRemove} from '@mdi/js'
import {mdiDataMatrixScan} from '@mdi/js'
import {mdiDatabase} from '@mdi/js'
import {mdiDatabaseAlert} from '@mdi/js'
import {mdiDatabaseAlertOutline} from '@mdi/js'
import {mdiDatabaseArrowDown} from '@mdi/js'
import {mdiDatabaseArrowDownOutline} from '@mdi/js'
import {mdiDatabaseArrowLeft} from '@mdi/js'
import {mdiDatabaseArrowLeftOutline} from '@mdi/js'
import {mdiDatabaseArrowRight} from '@mdi/js'
import {mdiDatabaseArrowRightOutline} from '@mdi/js'
import {mdiDatabaseArrowUp} from '@mdi/js'
import {mdiDatabaseArrowUpOutline} from '@mdi/js'
import {mdiDatabaseCheck} from '@mdi/js'
import {mdiDatabaseCheckOutline} from '@mdi/js'
import {mdiDatabaseClock} from '@mdi/js'
import {mdiDatabaseClockOutline} from '@mdi/js'
import {mdiDatabaseCog} from '@mdi/js'
import {mdiDatabaseCogOutline} from '@mdi/js'
import {mdiDatabaseEdit} from '@mdi/js'
import {mdiDatabaseEditOutline} from '@mdi/js'
import {mdiDatabaseEyeOff} from '@mdi/js'
import {mdiDatabaseEyeOffOutline} from '@mdi/js'
import {mdiDatabaseEyeOutline} from '@mdi/js'
import {mdiDatabaseImport} from '@mdi/js'
import {mdiDatabaseImportOutline} from '@mdi/js'
import {mdiDatabaseLock} from '@mdi/js'
import {mdiDatabaseLockOutline} from '@mdi/js'
import {mdiDatabaseMarker} from '@mdi/js'
import {mdiDatabaseMarkerOutline} from '@mdi/js'
import {mdiDatabaseMinus} from '@mdi/js'
import {mdiDatabaseMinusOutline} from '@mdi/js'
import {mdiDatabaseOff} from '@mdi/js'
import {mdiDatabaseOffOutline} from '@mdi/js'
import {mdiDatabaseOutline} from '@mdi/js'
import {mdiDatabasePlus} from '@mdi/js'
import {mdiDatabasePlusOutline} from '@mdi/js'
import {mdiDatabaseRefresh} from '@mdi/js'
import {mdiDatabaseRefreshOutline} from '@mdi/js'
import {mdiDatabaseRemove} from '@mdi/js'
import {mdiDatabaseRemoveOutline} from '@mdi/js'
import {mdiDatabaseSearch} from '@mdi/js'
import {mdiDatabaseSearchOutline} from '@mdi/js'
import {mdiDatabaseSettings} from '@mdi/js'
import {mdiDatabaseSettingsOutline} from '@mdi/js'
import {mdiDatabaseSync} from '@mdi/js'
import {mdiDatabaseSyncOutline} from '@mdi/js'
import {mdiDeathStar} from '@mdi/js'
import {mdiDeathStarVariant} from '@mdi/js'
import {mdiDeathlyHallows} from '@mdi/js'
import {mdiDebian} from '@mdi/js'
import {mdiDebugStepInto} from '@mdi/js'
import {mdiDebugStepOut} from '@mdi/js'
import {mdiDebugStepOver} from '@mdi/js'
import {mdiDecagram} from '@mdi/js'
import {mdiDecagramOutline} from '@mdi/js'
import {mdiDecimal} from '@mdi/js'
import {mdiDecimalComma} from '@mdi/js'
import {mdiDecimalCommaDecrease} from '@mdi/js'
import {mdiDecimalCommaIncrease} from '@mdi/js'
import {mdiDecimalDecrease} from '@mdi/js'
import {mdiDecimalIncrease} from '@mdi/js'
import {mdiDelete} from '@mdi/js'
import {mdiDeleteAlert} from '@mdi/js'
import {mdiDeleteAlertOutline} from '@mdi/js'
import {mdiDeleteCircle} from '@mdi/js'
import {mdiDeleteCircleOutline} from '@mdi/js'
import {mdiDeleteClock} from '@mdi/js'
import {mdiDeleteClockOutline} from '@mdi/js'
import {mdiDeleteEmpty} from '@mdi/js'
import {mdiDeleteEmptyOutline} from '@mdi/js'
import {mdiDeleteForever} from '@mdi/js'
import {mdiDeleteForeverOutline} from '@mdi/js'
import {mdiDeleteOff} from '@mdi/js'
import {mdiDeleteOffOutline} from '@mdi/js'
import {mdiDeleteOutline} from '@mdi/js'
import {mdiDeleteRestore} from '@mdi/js'
import {mdiDeleteSweep} from '@mdi/js'
import {mdiDeleteSweepOutline} from '@mdi/js'
import {mdiDeleteVariant} from '@mdi/js'
import {mdiDelta} from '@mdi/js'
import {mdiDesk} from '@mdi/js'
import {mdiDeskLamp} from '@mdi/js'
import {mdiDeskLampOff} from '@mdi/js'
import {mdiDeskLampOn} from '@mdi/js'
import {mdiDeskphone} from '@mdi/js'
import {mdiDesktopClassic} from '@mdi/js'
import {mdiDesktopTower} from '@mdi/js'
import {mdiDesktopTowerMonitor} from '@mdi/js'
import {mdiDetails} from '@mdi/js'
import {mdiDevTo} from '@mdi/js'
import {mdiDeveloperBoard} from '@mdi/js'
import {mdiDeviantart} from '@mdi/js'
import {mdiDevices} from '@mdi/js'
import {mdiDharmachakra} from '@mdi/js'
import {mdiDiabetes} from '@mdi/js'
import {mdiDialpad} from '@mdi/js'
import {mdiDiameter} from '@mdi/js'
import {mdiDiameterOutline} from '@mdi/js'
import {mdiDiameterVariant} from '@mdi/js'
import {mdiDiamond} from '@mdi/js'
import {mdiDiamondOutline} from '@mdi/js'
import {mdiDiamondStone} from '@mdi/js'
import {mdiDice1} from '@mdi/js'
import {mdiDice1Outline} from '@mdi/js'
import {mdiDice2} from '@mdi/js'
import {mdiDice2Outline} from '@mdi/js'
import {mdiDice3} from '@mdi/js'
import {mdiDice3Outline} from '@mdi/js'
import {mdiDice4} from '@mdi/js'
import {mdiDice4Outline} from '@mdi/js'
import {mdiDice5} from '@mdi/js'
import {mdiDice5Outline} from '@mdi/js'
import {mdiDice6} from '@mdi/js'
import {mdiDice6Outline} from '@mdi/js'
import {mdiDiceD10} from '@mdi/js'
import {mdiDiceD10Outline} from '@mdi/js'
import {mdiDiceD12} from '@mdi/js'
import {mdiDiceD12Outline} from '@mdi/js'
import {mdiDiceD20} from '@mdi/js'
import {mdiDiceD20Outline} from '@mdi/js'
import {mdiDiceD4} from '@mdi/js'
import {mdiDiceD4Outline} from '@mdi/js'
import {mdiDiceD6} from '@mdi/js'
import {mdiDiceD6Outline} from '@mdi/js'
import {mdiDiceD8} from '@mdi/js'
import {mdiDiceD8Outline} from '@mdi/js'
import {mdiDiceMultiple} from '@mdi/js'
import {mdiDiceMultipleOutline} from '@mdi/js'
import {mdiDigitalOcean} from '@mdi/js'
import {mdiDipSwitch} from '@mdi/js'
import {mdiDirections} from '@mdi/js'
import {mdiDirectionsFork} from '@mdi/js'
import {mdiDisc} from '@mdi/js'
import {mdiDiscAlert} from '@mdi/js'
import {mdiDiscPlayer} from '@mdi/js'
import {mdiDishwasher} from '@mdi/js'
import {mdiDishwasherAlert} from '@mdi/js'
import {mdiDishwasherOff} from '@mdi/js'
import {mdiDisqus} from '@mdi/js'
import {mdiDistributeHorizontalCenter} from '@mdi/js'
import {mdiDistributeHorizontalLeft} from '@mdi/js'
import {mdiDistributeHorizontalRight} from '@mdi/js'
import {mdiDistributeVerticalBottom} from '@mdi/js'
import {mdiDistributeVerticalCenter} from '@mdi/js'
import {mdiDistributeVerticalTop} from '@mdi/js'
import {mdiDiversify} from '@mdi/js'
import {mdiDiving} from '@mdi/js'
import {mdiDivingFlippers} from '@mdi/js'
import {mdiDivingHelmet} from '@mdi/js'
import {mdiDivingScuba} from '@mdi/js'
import {mdiDivingScubaFlag} from '@mdi/js'
import {mdiDivingScubaMask} from '@mdi/js'
import {mdiDivingScubaTank} from '@mdi/js'
import {mdiDivingScubaTankMultiple} from '@mdi/js'
import {mdiDivingSnorkel} from '@mdi/js'
import {mdiDivision} from '@mdi/js'
import {mdiDivisionBox} from '@mdi/js'
import {mdiDlna} from '@mdi/js'
import {mdiDna} from '@mdi/js'
import {mdiDns} from '@mdi/js'
import {mdiDnsOutline} from '@mdi/js'
import {mdiDockBottom} from '@mdi/js'
import {mdiDockLeft} from '@mdi/js'
import {mdiDockRight} from '@mdi/js'
import {mdiDockTop} from '@mdi/js'
import {mdiDockWindow} from '@mdi/js'
import {mdiDocker} from '@mdi/js'
import {mdiDoctor} from '@mdi/js'
import {mdiDog} from '@mdi/js'
import {mdiDogService} from '@mdi/js'
import {mdiDogSide} from '@mdi/js'
import {mdiDogSideOff} from '@mdi/js'
import {mdiDolby} from '@mdi/js'
import {mdiDolly} from '@mdi/js'
import {mdiDolphin} from '@mdi/js'
import {mdiDomain} from '@mdi/js'
import {mdiDomainOff} from '@mdi/js'
import {mdiDomainPlus} from '@mdi/js'
import {mdiDomainRemove} from '@mdi/js'
import {mdiDomeLight} from '@mdi/js'
import {mdiDominoMask} from '@mdi/js'
import {mdiDonkey} from '@mdi/js'
import {mdiDoor} from '@mdi/js'
import {mdiDoorClosed} from '@mdi/js'
import {mdiDoorClosedLock} from '@mdi/js'
import {mdiDoorOpen} from '@mdi/js'
import {mdiDoorSliding} from '@mdi/js'
import {mdiDoorSlidingLock} from '@mdi/js'
import {mdiDoorSlidingOpen} from '@mdi/js'
import {mdiDoorbell} from '@mdi/js'
import {mdiDoorbellVideo} from '@mdi/js'
import {mdiDotNet} from '@mdi/js'
import {mdiDotsCircle} from '@mdi/js'
import {mdiDotsGrid} from '@mdi/js'
import {mdiDotsHexagon} from '@mdi/js'
import {mdiDotsHorizontal} from '@mdi/js'
import {mdiDotsHorizontalCircle} from '@mdi/js'
import {mdiDotsHorizontalCircleOutline} from '@mdi/js'
import {mdiDotsSquare} from '@mdi/js'
import {mdiDotsTriangle} from '@mdi/js'
import {mdiDotsVertical} from '@mdi/js'
import {mdiDotsVerticalCircle} from '@mdi/js'
import {mdiDotsVerticalCircleOutline} from '@mdi/js'
import {mdiDownload} from '@mdi/js'
import {mdiDownloadBox} from '@mdi/js'
import {mdiDownloadBoxOutline} from '@mdi/js'
import {mdiDownloadCircle} from '@mdi/js'
import {mdiDownloadCircleOutline} from '@mdi/js'
import {mdiDownloadLock} from '@mdi/js'
import {mdiDownloadLockOutline} from '@mdi/js'
import {mdiDownloadMultiple} from '@mdi/js'
import {mdiDownloadNetwork} from '@mdi/js'
import {mdiDownloadNetworkOutline} from '@mdi/js'
import {mdiDownloadOff} from '@mdi/js'
import {mdiDownloadOffOutline} from '@mdi/js'
import {mdiDownloadOutline} from '@mdi/js'
import {mdiDrag} from '@mdi/js'
import {mdiDragHorizontal} from '@mdi/js'
import {mdiDragHorizontalVariant} from '@mdi/js'
import {mdiDragVariant} from '@mdi/js'
import {mdiDragVertical} from '@mdi/js'
import {mdiDragVerticalVariant} from '@mdi/js'
import {mdiDramaMasks} from '@mdi/js'
import {mdiDraw} from '@mdi/js'
import {mdiDrawPen} from '@mdi/js'
import {mdiDrawing} from '@mdi/js'
import {mdiDrawingBox} from '@mdi/js'
import {mdiDresser} from '@mdi/js'
import {mdiDresserOutline} from '@mdi/js'
import {mdiDrone} from '@mdi/js'
import {mdiDropbox} from '@mdi/js'
import {mdiDrupal} from '@mdi/js'
import {mdiDuck} from '@mdi/js'
import {mdiDumbbell} from '@mdi/js'
import {mdiDumpTruck} from '@mdi/js'
import {mdiEarHearing} from '@mdi/js'
import {mdiEarHearingLoop} from '@mdi/js'
import {mdiEarHearingOff} from '@mdi/js'
import {mdiEarbuds} from '@mdi/js'
import {mdiEarbudsOff} from '@mdi/js'
import {mdiEarbudsOffOutline} from '@mdi/js'
import {mdiEarbudsOutline} from '@mdi/js'
import {mdiEarth} from '@mdi/js'
import {mdiEarthArrowRight} from '@mdi/js'
import {mdiEarthBox} from '@mdi/js'
import {mdiEarthBoxMinus} from '@mdi/js'
import {mdiEarthBoxOff} from '@mdi/js'
import {mdiEarthBoxPlus} from '@mdi/js'
import {mdiEarthBoxRemove} from '@mdi/js'
import {mdiEarthMinus} from '@mdi/js'
import {mdiEarthOff} from '@mdi/js'
import {mdiEarthPlus} from '@mdi/js'
import {mdiEarthRemove} from '@mdi/js'
import {mdiEgg} from '@mdi/js'
import {mdiEggEaster} from '@mdi/js'
import {mdiEggFried} from '@mdi/js'
import {mdiEggOff} from '@mdi/js'
import {mdiEggOffOutline} from '@mdi/js'
import {mdiEggOutline} from '@mdi/js'
import {mdiEiffelTower} from '@mdi/js'
import {mdiEightTrack} from '@mdi/js'
import {mdiEject} from '@mdi/js'
import {mdiEjectCircle} from '@mdi/js'
import {mdiEjectCircleOutline} from '@mdi/js'
import {mdiEjectOutline} from '@mdi/js'
import {mdiElectricSwitch} from '@mdi/js'
import {mdiElectricSwitchClosed} from '@mdi/js'
import {mdiElectronFramework} from '@mdi/js'
import {mdiElephant} from '@mdi/js'
import {mdiElevationDecline} from '@mdi/js'
import {mdiElevationRise} from '@mdi/js'
import {mdiElevator} from '@mdi/js'
import {mdiElevatorDown} from '@mdi/js'
import {mdiElevatorPassenger} from '@mdi/js'
import {mdiElevatorPassengerOff} from '@mdi/js'
import {mdiElevatorPassengerOffOutline} from '@mdi/js'
import {mdiElevatorPassengerOutline} from '@mdi/js'
import {mdiElevatorUp} from '@mdi/js'
import {mdiEllipse} from '@mdi/js'
import {mdiEllipseOutline} from '@mdi/js'
import {mdiEmail} from '@mdi/js'
import {mdiEmailAlert} from '@mdi/js'
import {mdiEmailAlertOutline} from '@mdi/js'
import {mdiEmailArrowLeft} from '@mdi/js'
import {mdiEmailArrowLeftOutline} from '@mdi/js'
import {mdiEmailArrowRight} from '@mdi/js'
import {mdiEmailArrowRightOutline} from '@mdi/js'
import {mdiEmailBox} from '@mdi/js'
import {mdiEmailCheck} from '@mdi/js'
import {mdiEmailCheckOutline} from '@mdi/js'
import {mdiEmailEdit} from '@mdi/js'
import {mdiEmailEditOutline} from '@mdi/js'
import {mdiEmailFast} from '@mdi/js'
import {mdiEmailFastOutline} from '@mdi/js'
import {mdiEmailLock} from '@mdi/js'
import {mdiEmailLockOutline} from '@mdi/js'
import {mdiEmailMarkAsUnread} from '@mdi/js'
import {mdiEmailMinus} from '@mdi/js'
import {mdiEmailMinusOutline} from '@mdi/js'
import {mdiEmailMultiple} from '@mdi/js'
import {mdiEmailMultipleOutline} from '@mdi/js'
import {mdiEmailNewsletter} from '@mdi/js'
import {mdiEmailOff} from '@mdi/js'
import {mdiEmailOffOutline} from '@mdi/js'
import {mdiEmailOpen} from '@mdi/js'
import {mdiEmailOpenMultiple} from '@mdi/js'
import {mdiEmailOpenMultipleOutline} from '@mdi/js'
import {mdiEmailOpenOutline} from '@mdi/js'
import {mdiEmailOutline} from '@mdi/js'
import {mdiEmailPlus} from '@mdi/js'
import {mdiEmailPlusOutline} from '@mdi/js'
import {mdiEmailRemove} from '@mdi/js'
import {mdiEmailRemoveOutline} from '@mdi/js'
import {mdiEmailSeal} from '@mdi/js'
import {mdiEmailSealOutline} from '@mdi/js'
import {mdiEmailSearch} from '@mdi/js'
import {mdiEmailSearchOutline} from '@mdi/js'
import {mdiEmailSync} from '@mdi/js'
import {mdiEmailSyncOutline} from '@mdi/js'
import {mdiEmailVariant} from '@mdi/js'
import {mdiEmber} from '@mdi/js'
import {mdiEmby} from '@mdi/js'
import {mdiEmoticon} from '@mdi/js'
import {mdiEmoticonAngry} from '@mdi/js'
import {mdiEmoticonAngryOutline} from '@mdi/js'
import {mdiEmoticonConfused} from '@mdi/js'
import {mdiEmoticonConfusedOutline} from '@mdi/js'
import {mdiEmoticonCool} from '@mdi/js'
import {mdiEmoticonCoolOutline} from '@mdi/js'
import {mdiEmoticonCry} from '@mdi/js'
import {mdiEmoticonCryOutline} from '@mdi/js'
import {mdiEmoticonDead} from '@mdi/js'
import {mdiEmoticonDeadOutline} from '@mdi/js'
import {mdiEmoticonDevil} from '@mdi/js'
import {mdiEmoticonDevilOutline} from '@mdi/js'
import {mdiEmoticonExcited} from '@mdi/js'
import {mdiEmoticonExcitedOutline} from '@mdi/js'
import {mdiEmoticonFrown} from '@mdi/js'
import {mdiEmoticonFrownOutline} from '@mdi/js'
import {mdiEmoticonHappy} from '@mdi/js'
import {mdiEmoticonHappyOutline} from '@mdi/js'
import {mdiEmoticonKiss} from '@mdi/js'
import {mdiEmoticonKissOutline} from '@mdi/js'
import {mdiEmoticonLol} from '@mdi/js'
import {mdiEmoticonLolOutline} from '@mdi/js'
import {mdiEmoticonNeutral} from '@mdi/js'
import {mdiEmoticonNeutralOutline} from '@mdi/js'
import {mdiEmoticonOutline} from '@mdi/js'
import {mdiEmoticonPoop} from '@mdi/js'
import {mdiEmoticonPoopOutline} from '@mdi/js'
import {mdiEmoticonSad} from '@mdi/js'
import {mdiEmoticonSadOutline} from '@mdi/js'
import {mdiEmoticonSick} from '@mdi/js'
import {mdiEmoticonSickOutline} from '@mdi/js'
import {mdiEmoticonTongue} from '@mdi/js'
import {mdiEmoticonTongueOutline} from '@mdi/js'
import {mdiEmoticonWink} from '@mdi/js'
import {mdiEmoticonWinkOutline} from '@mdi/js'
import {mdiEngine} from '@mdi/js'
import {mdiEngineOff} from '@mdi/js'
import {mdiEngineOffOutline} from '@mdi/js'
import {mdiEngineOutline} from '@mdi/js'
import {mdiEpsilon} from '@mdi/js'
import {mdiEqual} from '@mdi/js'
import {mdiEqualBox} from '@mdi/js'
import {mdiEqualizer} from '@mdi/js'
import {mdiEqualizerOutline} from '@mdi/js'
import {mdiEraser} from '@mdi/js'
import {mdiEraserVariant} from '@mdi/js'
import {mdiEscalator} from '@mdi/js'
import {mdiEscalatorBox} from '@mdi/js'
import {mdiEscalatorDown} from '@mdi/js'
import {mdiEscalatorUp} from '@mdi/js'
import {mdiEslint} from '@mdi/js'
import {mdiEt} from '@mdi/js'
import {mdiEthereum} from '@mdi/js'
import {mdiEthernet} from '@mdi/js'
import {mdiEthernetCable} from '@mdi/js'
import {mdiEthernetCableOff} from '@mdi/js'
import {mdiEvPlugCcs1} from '@mdi/js'
import {mdiEvPlugCcs2} from '@mdi/js'
import {mdiEvPlugChademo} from '@mdi/js'
import {mdiEvPlugTesla} from '@mdi/js'
import {mdiEvPlugType1} from '@mdi/js'
import {mdiEvPlugType2} from '@mdi/js'
import {mdiEvStation} from '@mdi/js'
import {mdiEvernote} from '@mdi/js'
import {mdiExcavator} from '@mdi/js'
import {mdiExclamation} from '@mdi/js'
import {mdiExclamationThick} from '@mdi/js'
import {mdiExitRun} from '@mdi/js'
import {mdiExitToApp} from '@mdi/js'
import {mdiExpandAll} from '@mdi/js'
import {mdiExpandAllOutline} from '@mdi/js'
import {mdiExpansionCard} from '@mdi/js'
import {mdiExpansionCardVariant} from '@mdi/js'
import {mdiExponent} from '@mdi/js'
import {mdiExponentBox} from '@mdi/js'
import {mdiEyeArrowLeft} from '@mdi/js'
import {mdiEyeArrowLeftOutline} from '@mdi/js'
import {mdiEyeArrowRight} from '@mdi/js'
import {mdiEyeArrowRightOutline} from '@mdi/js'
import {mdiEyeCheck} from '@mdi/js'
import {mdiEyeCheckOutline} from '@mdi/js'
import {mdiEyeCircle} from '@mdi/js'
import {mdiEyeCircleOutline} from '@mdi/js'
import {mdiEyeMinus} from '@mdi/js'
import {mdiEyeMinusOutline} from '@mdi/js'
import {mdiEyeOff} from '@mdi/js'
import {mdiEyeOffOutline} from '@mdi/js'
import {mdiEyeOutline} from '@mdi/js'
import {mdiEyePlus} from '@mdi/js'
import {mdiEyePlusOutline} from '@mdi/js'
import {mdiEyeRefresh} from '@mdi/js'
import {mdiEyeRefreshOutline} from '@mdi/js'
import {mdiEyeRemove} from '@mdi/js'
import {mdiEyeRemoveOutline} from '@mdi/js'
import {mdiEyeSettings} from '@mdi/js'
import {mdiEyeSettingsOutline} from '@mdi/js'
import {mdiEyedropper} from '@mdi/js'
import {mdiEyedropperMinus} from '@mdi/js'
import {mdiEyedropperOff} from '@mdi/js'
import {mdiEyedropperPlus} from '@mdi/js'
import {mdiEyedropperRemove} from '@mdi/js'
import {mdiEyedropperVariant} from '@mdi/js'
import {mdiFaceAgent} from '@mdi/js'
import {mdiFaceMan} from '@mdi/js'
import {mdiFaceManOutline} from '@mdi/js'
import {mdiFaceManProfile} from '@mdi/js'
import {mdiFaceManShimmer} from '@mdi/js'
import {mdiFaceManShimmerOutline} from '@mdi/js'
import {mdiFaceMask} from '@mdi/js'
import {mdiFaceMaskOutline} from '@mdi/js'
import {mdiFaceRecognition} from '@mdi/js'
import {mdiFaceWoman} from '@mdi/js'
import {mdiFaceWomanOutline} from '@mdi/js'
import {mdiFaceWomanProfile} from '@mdi/js'
import {mdiFaceWomanShimmer} from '@mdi/js'
import {mdiFaceWomanShimmerOutline} from '@mdi/js'
import {mdiFacebook} from '@mdi/js'
import {mdiFacebookGaming} from '@mdi/js'
import {mdiFacebookMessenger} from '@mdi/js'
import {mdiFacebookWorkplace} from '@mdi/js'
import {mdiFactory} from '@mdi/js'
import {mdiFamilyTree} from '@mdi/js'
import {mdiFan} from '@mdi/js'
import {mdiFanAlert} from '@mdi/js'
import {mdiFanAuto} from '@mdi/js'
import {mdiFanChevronDown} from '@mdi/js'
import {mdiFanChevronUp} from '@mdi/js'
import {mdiFanClock} from '@mdi/js'
import {mdiFanMinus} from '@mdi/js'
import {mdiFanOff} from '@mdi/js'
import {mdiFanPlus} from '@mdi/js'
import {mdiFanRemove} from '@mdi/js'
import {mdiFanSpeed1} from '@mdi/js'
import {mdiFanSpeed2} from '@mdi/js'
import {mdiFanSpeed3} from '@mdi/js'
import {mdiFastForward} from '@mdi/js'
import {mdiFastForward10} from '@mdi/js'
import {mdiFastForward15} from '@mdi/js'
import {mdiFastForward30} from '@mdi/js'
import {mdiFastForward45} from '@mdi/js'
import {mdiFastForward5} from '@mdi/js'
import {mdiFastForward60} from '@mdi/js'
import {mdiFastForwardOutline} from '@mdi/js'
import {mdiFaucet} from '@mdi/js'
import {mdiFaucetVariant} from '@mdi/js'
import {mdiFax} from '@mdi/js'
import {mdiFeather} from '@mdi/js'
import {mdiFeatureSearch} from '@mdi/js'
import {mdiFeatureSearchOutline} from '@mdi/js'
import {mdiFedora} from '@mdi/js'
import {mdiFence} from '@mdi/js'
import {mdiFenceElectric} from '@mdi/js'
import {mdiFencing} from '@mdi/js'
import {mdiFerrisWheel} from '@mdi/js'
import {mdiFerry} from '@mdi/js'
import {mdiFile} from '@mdi/js'
import {mdiFileAccount} from '@mdi/js'
import {mdiFileAccountOutline} from '@mdi/js'
import {mdiFileAlert} from '@mdi/js'
import {mdiFileAlertOutline} from '@mdi/js'
import {mdiFileArrowLeftRight} from '@mdi/js'
import {mdiFileArrowLeftRightOutline} from '@mdi/js'
import {mdiFileArrowUpDown} from '@mdi/js'
import {mdiFileArrowUpDownOutline} from '@mdi/js'
import {mdiFileCabinet} from '@mdi/js'
import {mdiFileCad} from '@mdi/js'
import {mdiFileCadBox} from '@mdi/js'
import {mdiFileCancel} from '@mdi/js'
import {mdiFileCancelOutline} from '@mdi/js'
import {mdiFileCertificate} from '@mdi/js'
import {mdiFileCertificateOutline} from '@mdi/js'
import {mdiFileChart} from '@mdi/js'
import {mdiFileChartCheck} from '@mdi/js'
import {mdiFileChartCheckOutline} from '@mdi/js'
import {mdiFileChartOutline} from '@mdi/js'
import {mdiFileCheck} from '@mdi/js'
import {mdiFileCheckOutline} from '@mdi/js'
import {mdiFileClock} from '@mdi/js'
import {mdiFileClockOutline} from '@mdi/js'
import {mdiFileCloud} from '@mdi/js'
import {mdiFileCloudOutline} from '@mdi/js'
import {mdiFileCode} from '@mdi/js'
import {mdiFileCodeOutline} from '@mdi/js'
import {mdiFileCog} from '@mdi/js'
import {mdiFileCogOutline} from '@mdi/js'
import {mdiFileCompare} from '@mdi/js'
import {mdiFileDelimited} from '@mdi/js'
import {mdiFileDelimitedOutline} from '@mdi/js'
import {mdiFileDocument} from '@mdi/js'
import {mdiFileDocumentAlert} from '@mdi/js'
import {mdiFileDocumentAlertOutline} from '@mdi/js'
import {mdiFileDocumentCheck} from '@mdi/js'
import {mdiFileDocumentCheckOutline} from '@mdi/js'
import {mdiFileDocumentEdit} from '@mdi/js'
import {mdiFileDocumentEditOutline} from '@mdi/js'
import {mdiFileDocumentMinus} from '@mdi/js'
import {mdiFileDocumentMinusOutline} from '@mdi/js'
import {mdiFileDocumentMultiple} from '@mdi/js'
import {mdiFileDocumentMultipleOutline} from '@mdi/js'
import {mdiFileDocumentOutline} from '@mdi/js'
import {mdiFileDocumentPlus} from '@mdi/js'
import {mdiFileDocumentPlusOutline} from '@mdi/js'
import {mdiFileDocumentRemove} from '@mdi/js'
import {mdiFileDocumentRemoveOutline} from '@mdi/js'
import {mdiFileDownload} from '@mdi/js'
import {mdiFileDownloadOutline} from '@mdi/js'
import {mdiFileEdit} from '@mdi/js'
import {mdiFileEditOutline} from '@mdi/js'
import {mdiFileExcel} from '@mdi/js'
import {mdiFileExcelBox} from '@mdi/js'
import {mdiFileExcelBoxOutline} from '@mdi/js'
import {mdiFileExcelOutline} from '@mdi/js'
import {mdiFileEyeOutline} from '@mdi/js'
import {mdiFileFind} from '@mdi/js'
import {mdiFileFindOutline} from '@mdi/js'
import {mdiFileGifBox} from '@mdi/js'
import {mdiFileHidden} from '@mdi/js'
import {mdiFileImage} from '@mdi/js'
import {mdiFileImageMarker} from '@mdi/js'
import {mdiFileImageMarkerOutline} from '@mdi/js'
import {mdiFileImageMinus} from '@mdi/js'
import {mdiFileImageMinusOutline} from '@mdi/js'
import {mdiFileImageOutline} from '@mdi/js'
import {mdiFileImagePlus} from '@mdi/js'
import {mdiFileImagePlusOutline} from '@mdi/js'
import {mdiFileImageRemove} from '@mdi/js'
import {mdiFileImageRemoveOutline} from '@mdi/js'
import {mdiFileImport} from '@mdi/js'
import {mdiFileImportOutline} from '@mdi/js'
import {mdiFileJpgBox} from '@mdi/js'
import {mdiFileKey} from '@mdi/js'
import {mdiFileKeyOutline} from '@mdi/js'
import {mdiFileLink} from '@mdi/js'
import {mdiFileLinkOutline} from '@mdi/js'
import {mdiFileLock} from '@mdi/js'
import {mdiFileLockOpen} from '@mdi/js'
import {mdiFileLockOpenOutline} from '@mdi/js'
import {mdiFileLockOutline} from '@mdi/js'
import {mdiFileMarker} from '@mdi/js'
import {mdiFileMarkerOutline} from '@mdi/js'
import {mdiFileMinus} from '@mdi/js'
import {mdiFileMinusOutline} from '@mdi/js'
import {mdiFileMove} from '@mdi/js'
import {mdiFileMoveOutline} from '@mdi/js'
import {mdiFileMultiple} from '@mdi/js'
import {mdiFileMultipleOutline} from '@mdi/js'
import {mdiFileMusic} from '@mdi/js'
import {mdiFileMusicOutline} from '@mdi/js'
import {mdiFileOutline} from '@mdi/js'
import {mdiFilePdfBox} from '@mdi/js'
import {mdiFilePercent} from '@mdi/js'
import {mdiFilePercentOutline} from '@mdi/js'
import {mdiFilePhone} from '@mdi/js'
import {mdiFilePhoneOutline} from '@mdi/js'
import {mdiFilePlus} from '@mdi/js'
import {mdiFilePlusOutline} from '@mdi/js'
import {mdiFilePngBox} from '@mdi/js'
import {mdiFilePowerpoint} from '@mdi/js'
import {mdiFilePowerpointBox} from '@mdi/js'
import {mdiFilePowerpointBoxOutline} from '@mdi/js'
import {mdiFilePowerpointOutline} from '@mdi/js'
import {mdiFilePresentationBox} from '@mdi/js'
import {mdiFileQuestion} from '@mdi/js'
import {mdiFileQuestionOutline} from '@mdi/js'
import {mdiFileRefresh} from '@mdi/js'
import {mdiFileRefreshOutline} from '@mdi/js'
import {mdiFileRemove} from '@mdi/js'
import {mdiFileRemoveOutline} from '@mdi/js'
import {mdiFileReplace} from '@mdi/js'
import {mdiFileReplaceOutline} from '@mdi/js'
import {mdiFileRestore} from '@mdi/js'
import {mdiFileRestoreOutline} from '@mdi/js'
import {mdiFileRotateLeft} from '@mdi/js'
import {mdiFileRotateLeftOutline} from '@mdi/js'
import {mdiFileRotateRight} from '@mdi/js'
import {mdiFileRotateRightOutline} from '@mdi/js'
import {mdiFileSearch} from '@mdi/js'
import {mdiFileSearchOutline} from '@mdi/js'
import {mdiFileSend} from '@mdi/js'
import {mdiFileSendOutline} from '@mdi/js'
import {mdiFileSettings} from '@mdi/js'
import {mdiFileSettingsOutline} from '@mdi/js'
import {mdiFileSign} from '@mdi/js'
import {mdiFileStar} from '@mdi/js'
import {mdiFileStarOutline} from '@mdi/js'
import {mdiFileSwap} from '@mdi/js'
import {mdiFileSwapOutline} from '@mdi/js'
import {mdiFileSync} from '@mdi/js'
import {mdiFileSyncOutline} from '@mdi/js'
import {mdiFileTable} from '@mdi/js'
import {mdiFileTableBox} from '@mdi/js'
import {mdiFileTableBoxMultiple} from '@mdi/js'
import {mdiFileTableBoxMultipleOutline} from '@mdi/js'
import {mdiFileTableBoxOutline} from '@mdi/js'
import {mdiFileTableOutline} from '@mdi/js'
import {mdiFileTree} from '@mdi/js'
import {mdiFileTreeOutline} from '@mdi/js'
import {mdiFileUndo} from '@mdi/js'
import {mdiFileUndoOutline} from '@mdi/js'
import {mdiFileUpload} from '@mdi/js'
import {mdiFileUploadOutline} from '@mdi/js'
import {mdiFileVideo} from '@mdi/js'
import {mdiFileVideoOutline} from '@mdi/js'
import {mdiFileWord} from '@mdi/js'
import {mdiFileWordBox} from '@mdi/js'
import {mdiFileWordBoxOutline} from '@mdi/js'
import {mdiFileWordOutline} from '@mdi/js'
import {mdiFileXmlBox} from '@mdi/js'
import {mdiFilm} from '@mdi/js'
import {mdiFilmstrip} from '@mdi/js'
import {mdiFilmstripBox} from '@mdi/js'
import {mdiFilmstripBoxMultiple} from '@mdi/js'
import {mdiFilmstripOff} from '@mdi/js'
import {mdiFilter} from '@mdi/js'
import {mdiFilterCheck} from '@mdi/js'
import {mdiFilterCheckOutline} from '@mdi/js'
import {mdiFilterCog} from '@mdi/js'
import {mdiFilterCogOutline} from '@mdi/js'
import {mdiFilterMenu} from '@mdi/js'
import {mdiFilterMenuOutline} from '@mdi/js'
import {mdiFilterMinus} from '@mdi/js'
import {mdiFilterMinusOutline} from '@mdi/js'
import {mdiFilterMultiple} from '@mdi/js'
import {mdiFilterMultipleOutline} from '@mdi/js'
import {mdiFilterOff} from '@mdi/js'
import {mdiFilterOffOutline} from '@mdi/js'
import {mdiFilterOutline} from '@mdi/js'
import {mdiFilterPlus} from '@mdi/js'
import {mdiFilterPlusOutline} from '@mdi/js'
import {mdiFilterRemove} from '@mdi/js'
import {mdiFilterRemoveOutline} from '@mdi/js'
import {mdiFilterSettings} from '@mdi/js'
import {mdiFilterSettingsOutline} from '@mdi/js'
import {mdiFilterVariant} from '@mdi/js'
import {mdiFilterVariantMinus} from '@mdi/js'
import {mdiFilterVariantPlus} from '@mdi/js'
import {mdiFilterVariantRemove} from '@mdi/js'
import {mdiFinance} from '@mdi/js'
import {mdiFindReplace} from '@mdi/js'
import {mdiFingerprint} from '@mdi/js'
import {mdiFingerprintOff} from '@mdi/js'
import {mdiFire} from '@mdi/js'
import {mdiFireAlert} from '@mdi/js'
import {mdiFireCircle} from '@mdi/js'
import {mdiFireExtinguisher} from '@mdi/js'
import {mdiFireHydrant} from '@mdi/js'
import {mdiFireHydrantAlert} from '@mdi/js'
import {mdiFireHydrantOff} from '@mdi/js'
import {mdiFireOff} from '@mdi/js'
import {mdiFireTruck} from '@mdi/js'
import {mdiFirebase} from '@mdi/js'
import {mdiFirefox} from '@mdi/js'
import {mdiFireplace} from '@mdi/js'
import {mdiFireplaceOff} from '@mdi/js'
import {mdiFirewire} from '@mdi/js'
import {mdiFirework} from '@mdi/js'
import {mdiFireworkOff} from '@mdi/js'
import {mdiFish} from '@mdi/js'
import {mdiFishOff} from '@mdi/js'
import {mdiFishbowl} from '@mdi/js'
import {mdiFishbowlOutline} from '@mdi/js'
import {mdiFitToPage} from '@mdi/js'
import {mdiFitToPageOutline} from '@mdi/js'
import {mdiFitToScreen} from '@mdi/js'
import {mdiFitToScreenOutline} from '@mdi/js'
import {mdiFlag} from '@mdi/js'
import {mdiFlagCheckered} from '@mdi/js'
import {mdiFlagMinus} from '@mdi/js'
import {mdiFlagMinusOutline} from '@mdi/js'
import {mdiFlagOff} from '@mdi/js'
import {mdiFlagOffOutline} from '@mdi/js'
import {mdiFlagOutline} from '@mdi/js'
import {mdiFlagPlus} from '@mdi/js'
import {mdiFlagPlusOutline} from '@mdi/js'
import {mdiFlagRemove} from '@mdi/js'
import {mdiFlagRemoveOutline} from '@mdi/js'
import {mdiFlagTriangle} from '@mdi/js'
import {mdiFlagVariant} from '@mdi/js'
import {mdiFlagVariantMinus} from '@mdi/js'
import {mdiFlagVariantMinusOutline} from '@mdi/js'
import {mdiFlagVariantOff} from '@mdi/js'
import {mdiFlagVariantOffOutline} from '@mdi/js'
import {mdiFlagVariantOutline} from '@mdi/js'
import {mdiFlagVariantPlus} from '@mdi/js'
import {mdiFlagVariantPlusOutline} from '@mdi/js'
import {mdiFlagVariantRemove} from '@mdi/js'
import {mdiFlagVariantRemoveOutline} from '@mdi/js'
import {mdiFlare} from '@mdi/js'
import {mdiFlash} from '@mdi/js'
import {mdiFlashAlert} from '@mdi/js'
import {mdiFlashAlertOutline} from '@mdi/js'
import {mdiFlashAuto} from '@mdi/js'
import {mdiFlashOff} from '@mdi/js'
import {mdiFlashOffOutline} from '@mdi/js'
import {mdiFlashOutline} from '@mdi/js'
import {mdiFlashRedEye} from '@mdi/js'
import {mdiFlashTriangle} from '@mdi/js'
import {mdiFlashTriangleOutline} from '@mdi/js'
import {mdiFlashlight} from '@mdi/js'
import {mdiFlashlightOff} from '@mdi/js'
import {mdiFlask} from '@mdi/js'
import {mdiFlaskEmpty} from '@mdi/js'
import {mdiFlaskEmptyMinus} from '@mdi/js'
import {mdiFlaskEmptyMinusOutline} from '@mdi/js'
import {mdiFlaskEmptyOff} from '@mdi/js'
import {mdiFlaskEmptyOffOutline} from '@mdi/js'
import {mdiFlaskEmptyOutline} from '@mdi/js'
import {mdiFlaskEmptyPlus} from '@mdi/js'
import {mdiFlaskEmptyPlusOutline} from '@mdi/js'
import {mdiFlaskEmptyRemove} from '@mdi/js'
import {mdiFlaskEmptyRemoveOutline} from '@mdi/js'
import {mdiFlaskMinus} from '@mdi/js'
import {mdiFlaskMinusOutline} from '@mdi/js'
import {mdiFlaskOff} from '@mdi/js'
import {mdiFlaskOffOutline} from '@mdi/js'
import {mdiFlaskOutline} from '@mdi/js'
import {mdiFlaskPlus} from '@mdi/js'
import {mdiFlaskPlusOutline} from '@mdi/js'
import {mdiFlaskRemove} from '@mdi/js'
import {mdiFlaskRemoveOutline} from '@mdi/js'
import {mdiFlaskRoundBottom} from '@mdi/js'
import {mdiFlaskRoundBottomEmpty} from '@mdi/js'
import {mdiFlaskRoundBottomEmptyOutline} from '@mdi/js'
import {mdiFlaskRoundBottomOutline} from '@mdi/js'
import {mdiFleurDeLis} from '@mdi/js'
import {mdiFlipHorizontal} from '@mdi/js'
import {mdiFlipToBack} from '@mdi/js'
import {mdiFlipToFront} from '@mdi/js'
import {mdiFlipVertical} from '@mdi/js'
import {mdiFloorLamp} from '@mdi/js'
import {mdiFloorLampDual} from '@mdi/js'
import {mdiFloorLampDualOutline} from '@mdi/js'
import {mdiFloorLampOutline} from '@mdi/js'
import {mdiFloorLampTorchiere} from '@mdi/js'
import {mdiFloorLampTorchiereOutline} from '@mdi/js'
import {mdiFloorLampTorchiereVariant} from '@mdi/js'
import {mdiFloorLampTorchiereVariantOutline} from '@mdi/js'
import {mdiFloorPlan} from '@mdi/js'
import {mdiFloppy} from '@mdi/js'
import {mdiFloppyVariant} from '@mdi/js'
import {mdiFlower} from '@mdi/js'
import {mdiFlowerOutline} from '@mdi/js'
import {mdiFlowerPollen} from '@mdi/js'
import {mdiFlowerPollenOutline} from '@mdi/js'
import {mdiFlowerPoppy} from '@mdi/js'
import {mdiFlowerTulip} from '@mdi/js'
import {mdiFlowerTulipOutline} from '@mdi/js'
import {mdiFocusAuto} from '@mdi/js'
import {mdiFocusField} from '@mdi/js'
import {mdiFocusFieldHorizontal} from '@mdi/js'
import {mdiFocusFieldVertical} from '@mdi/js'
import {mdiFolder} from '@mdi/js'
import {mdiFolderAccount} from '@mdi/js'
import {mdiFolderAccountOutline} from '@mdi/js'
import {mdiFolderAlert} from '@mdi/js'
import {mdiFolderAlertOutline} from '@mdi/js'
import {mdiFolderArrowDown} from '@mdi/js'
import {mdiFolderArrowDownOutline} from '@mdi/js'
import {mdiFolderArrowLeft} from '@mdi/js'
import {mdiFolderArrowLeftOutline} from '@mdi/js'
import {mdiFolderArrowLeftRight} from '@mdi/js'
import {mdiFolderArrowLeftRightOutline} from '@mdi/js'
import {mdiFolderArrowRight} from '@mdi/js'
import {mdiFolderArrowRightOutline} from '@mdi/js'
import {mdiFolderArrowUp} from '@mdi/js'
import {mdiFolderArrowUpDown} from '@mdi/js'
import {mdiFolderArrowUpDownOutline} from '@mdi/js'
import {mdiFolderArrowUpOutline} from '@mdi/js'
import {mdiFolderCancel} from '@mdi/js'
import {mdiFolderCancelOutline} from '@mdi/js'
import {mdiFolderCheck} from '@mdi/js'
import {mdiFolderCheckOutline} from '@mdi/js'
import {mdiFolderClock} from '@mdi/js'
import {mdiFolderClockOutline} from '@mdi/js'
import {mdiFolderCog} from '@mdi/js'
import {mdiFolderCogOutline} from '@mdi/js'
import {mdiFolderDownload} from '@mdi/js'
import {mdiFolderDownloadOutline} from '@mdi/js'
import {mdiFolderEdit} from '@mdi/js'
import {mdiFolderEditOutline} from '@mdi/js'
import {mdiFolderEye} from '@mdi/js'
import {mdiFolderEyeOutline} from '@mdi/js'
import {mdiFolderFile} from '@mdi/js'
import {mdiFolderFileOutline} from '@mdi/js'
import {mdiFolderGoogleDrive} from '@mdi/js'
import {mdiFolderHeart} from '@mdi/js'
import {mdiFolderHeartOutline} from '@mdi/js'
import {mdiFolderHidden} from '@mdi/js'
import {mdiFolderHome} from '@mdi/js'
import {mdiFolderHomeOutline} from '@mdi/js'
import {mdiFolderImage} from '@mdi/js'
import {mdiFolderInformation} from '@mdi/js'
import {mdiFolderInformationOutline} from '@mdi/js'
import {mdiFolderKey} from '@mdi/js'
import {mdiFolderKeyNetwork} from '@mdi/js'
import {mdiFolderKeyNetworkOutline} from '@mdi/js'
import {mdiFolderKeyOutline} from '@mdi/js'
import {mdiFolderLock} from '@mdi/js'
import {mdiFolderLockOpen} from '@mdi/js'
import {mdiFolderLockOpenOutline} from '@mdi/js'
import {mdiFolderLockOutline} from '@mdi/js'
import {mdiFolderMarker} from '@mdi/js'
import {mdiFolderMarkerOutline} from '@mdi/js'
import {mdiFolderMinus} from '@mdi/js'
import {mdiFolderMinusOutline} from '@mdi/js'
import {mdiFolderMove} from '@mdi/js'
import {mdiFolderMoveOutline} from '@mdi/js'
import {mdiFolderMultiple} from '@mdi/js'
import {mdiFolderMultipleImage} from '@mdi/js'
import {mdiFolderMultipleOutline} from '@mdi/js'
import {mdiFolderMultiplePlus} from '@mdi/js'
import {mdiFolderMultiplePlusOutline} from '@mdi/js'
import {mdiFolderMusic} from '@mdi/js'
import {mdiFolderMusicOutline} from '@mdi/js'
import {mdiFolderNetwork} from '@mdi/js'
import {mdiFolderNetworkOutline} from '@mdi/js'
import {mdiFolderOff} from '@mdi/js'
import {mdiFolderOffOutline} from '@mdi/js'
import {mdiFolderOpen} from '@mdi/js'
import {mdiFolderOpenOutline} from '@mdi/js'
import {mdiFolderOutline} from '@mdi/js'
import {mdiFolderPlay} from '@mdi/js'
import {mdiFolderPlayOutline} from '@mdi/js'
import {mdiFolderPlus} from '@mdi/js'
import {mdiFolderPlusOutline} from '@mdi/js'
import {mdiFolderPound} from '@mdi/js'
import {mdiFolderPoundOutline} from '@mdi/js'
import {mdiFolderQuestion} from '@mdi/js'
import {mdiFolderQuestionOutline} from '@mdi/js'
import {mdiFolderRefresh} from '@mdi/js'
import {mdiFolderRefreshOutline} from '@mdi/js'
import {mdiFolderRemove} from '@mdi/js'
import {mdiFolderRemoveOutline} from '@mdi/js'
import {mdiFolderSearch} from '@mdi/js'
import {mdiFolderSearchOutline} from '@mdi/js'
import {mdiFolderSettings} from '@mdi/js'
import {mdiFolderSettingsOutline} from '@mdi/js'
import {mdiFolderStar} from '@mdi/js'
import {mdiFolderStarMultiple} from '@mdi/js'
import {mdiFolderStarMultipleOutline} from '@mdi/js'
import {mdiFolderStarOutline} from '@mdi/js'
import {mdiFolderSwap} from '@mdi/js'
import {mdiFolderSwapOutline} from '@mdi/js'
import {mdiFolderSync} from '@mdi/js'
import {mdiFolderSyncOutline} from '@mdi/js'
import {mdiFolderTable} from '@mdi/js'
import {mdiFolderTableOutline} from '@mdi/js'
import {mdiFolderText} from '@mdi/js'
import {mdiFolderTextOutline} from '@mdi/js'
import {mdiFolderUpload} from '@mdi/js'
import {mdiFolderUploadOutline} from '@mdi/js'
import {mdiFolderWrench} from '@mdi/js'
import {mdiFolderWrenchOutline} from '@mdi/js'
import {mdiFolderZip} from '@mdi/js'
import {mdiFolderZipOutline} from '@mdi/js'
import {mdiFontAwesome} from '@mdi/js'
import {mdiFood} from '@mdi/js'
import {mdiFoodApple} from '@mdi/js'
import {mdiFoodAppleOutline} from '@mdi/js'
import {mdiFoodCroissant} from '@mdi/js'
import {mdiFoodDrumstick} from '@mdi/js'
import {mdiFoodDrumstickOff} from '@mdi/js'
import {mdiFoodDrumstickOffOutline} from '@mdi/js'
import {mdiFoodDrumstickOutline} from '@mdi/js'
import {mdiFoodForkDrink} from '@mdi/js'
import {mdiFoodHalal} from '@mdi/js'
import {mdiFoodHotDog} from '@mdi/js'
import {mdiFoodKosher} from '@mdi/js'
import {mdiFoodOff} from '@mdi/js'
import {mdiFoodOffOutline} from '@mdi/js'
import {mdiFoodOutline} from '@mdi/js'
import {mdiFoodSteak} from '@mdi/js'
import {mdiFoodSteakOff} from '@mdi/js'
import {mdiFoodTakeoutBox} from '@mdi/js'
import {mdiFoodTakeoutBoxOutline} from '@mdi/js'
import {mdiFoodTurkey} from '@mdi/js'
import {mdiFoodVariant} from '@mdi/js'
import {mdiFoodVariantOff} from '@mdi/js'
import {mdiFootPrint} from '@mdi/js'
import {mdiFootball} from '@mdi/js'
import {mdiFootballAustralian} from '@mdi/js'
import {mdiFootballHelmet} from '@mdi/js'
import {mdiForest} from '@mdi/js'
import {mdiForklift} from '@mdi/js'
import {mdiFormDropdown} from '@mdi/js'
import {mdiFormSelect} from '@mdi/js'
import {mdiFormTextarea} from '@mdi/js'
import {mdiFormTextbox} from '@mdi/js'
import {mdiFormTextboxLock} from '@mdi/js'
import {mdiFormTextboxPassword} from '@mdi/js'
import {mdiFormatAlignBottom} from '@mdi/js'
import {mdiFormatAlignCenter} from '@mdi/js'
import {mdiFormatAlignJustify} from '@mdi/js'
import {mdiFormatAlignLeft} from '@mdi/js'
import {mdiFormatAlignMiddle} from '@mdi/js'
import {mdiFormatAlignRight} from '@mdi/js'
import {mdiFormatAlignTop} from '@mdi/js'
import {mdiFormatAnnotationMinus} from '@mdi/js'
import {mdiFormatAnnotationPlus} from '@mdi/js'
import {mdiFormatBold} from '@mdi/js'
import {mdiFormatClear} from '@mdi/js'
import {mdiFormatColorFill} from '@mdi/js'
import {mdiFormatColorHighlight} from '@mdi/js'
import {mdiFormatColorMarkerCancel} from '@mdi/js'
import {mdiFormatColorText} from '@mdi/js'
import {mdiFormatColumns} from '@mdi/js'
import {mdiFormatFloatCenter} from '@mdi/js'
import {mdiFormatFloatLeft} from '@mdi/js'
import {mdiFormatFloatNone} from '@mdi/js'
import {mdiFormatFloatRight} from '@mdi/js'
import {mdiFormatFont} from '@mdi/js'
import {mdiFormatFontSizeDecrease} from '@mdi/js'
import {mdiFormatFontSizeIncrease} from '@mdi/js'
import {mdiFormatHeader1} from '@mdi/js'
import {mdiFormatHeader2} from '@mdi/js'
import {mdiFormatHeader3} from '@mdi/js'
import {mdiFormatHeader4} from '@mdi/js'
import {mdiFormatHeader5} from '@mdi/js'
import {mdiFormatHeader6} from '@mdi/js'
import {mdiFormatHeaderDecrease} from '@mdi/js'
import {mdiFormatHeaderEqual} from '@mdi/js'
import {mdiFormatHeaderIncrease} from '@mdi/js'
import {mdiFormatHeaderPound} from '@mdi/js'
import {mdiFormatHorizontalAlignCenter} from '@mdi/js'
import {mdiFormatHorizontalAlignLeft} from '@mdi/js'
import {mdiFormatHorizontalAlignRight} from '@mdi/js'
import {mdiFormatIndentDecrease} from '@mdi/js'
import {mdiFormatIndentIncrease} from '@mdi/js'
import {mdiFormatItalic} from '@mdi/js'
import {mdiFormatLetterCase} from '@mdi/js'
import {mdiFormatLetterCaseLower} from '@mdi/js'
import {mdiFormatLetterCaseUpper} from '@mdi/js'
import {mdiFormatLetterEndsWith} from '@mdi/js'
import {mdiFormatLetterMatches} from '@mdi/js'
import {mdiFormatLetterSpacing} from '@mdi/js'
import {mdiFormatLetterSpacingVariant} from '@mdi/js'
import {mdiFormatLetterStartsWith} from '@mdi/js'
import {mdiFormatLineHeight} from '@mdi/js'
import {mdiFormatLineSpacing} from '@mdi/js'
import {mdiFormatLineStyle} from '@mdi/js'
import {mdiFormatLineWeight} from '@mdi/js'
import {mdiFormatListBulleted} from '@mdi/js'
import {mdiFormatListBulletedSquare} from '@mdi/js'
import {mdiFormatListBulletedTriangle} from '@mdi/js'
import {mdiFormatListBulletedType} from '@mdi/js'
import {mdiFormatListCheckbox} from '@mdi/js'
import {mdiFormatListChecks} from '@mdi/js'
import {mdiFormatListGroup} from '@mdi/js'
import {mdiFormatListGroupPlus} from '@mdi/js'
import {mdiFormatListNumbered} from '@mdi/js'
import {mdiFormatListNumberedRtl} from '@mdi/js'
import {mdiFormatListText} from '@mdi/js'
import {mdiFormatOverline} from '@mdi/js'
import {mdiFormatPageBreak} from '@mdi/js'
import {mdiFormatPageSplit} from '@mdi/js'
import {mdiFormatPaint} from '@mdi/js'
import {mdiFormatParagraph} from '@mdi/js'
import {mdiFormatParagraphSpacing} from '@mdi/js'
import {mdiFormatPilcrow} from '@mdi/js'
import {mdiFormatPilcrowArrowLeft} from '@mdi/js'
import {mdiFormatPilcrowArrowRight} from '@mdi/js'
import {mdiFormatQuoteClose} from '@mdi/js'
import {mdiFormatQuoteCloseOutline} from '@mdi/js'
import {mdiFormatQuoteOpen} from '@mdi/js'
import {mdiFormatQuoteOpenOutline} from '@mdi/js'
import {mdiFormatRotate90} from '@mdi/js'
import {mdiFormatSection} from '@mdi/js'
import {mdiFormatSize} from '@mdi/js'
import {mdiFormatStrikethrough} from '@mdi/js'
import {mdiFormatStrikethroughVariant} from '@mdi/js'
import {mdiFormatSubscript} from '@mdi/js'
import {mdiFormatSuperscript} from '@mdi/js'
import {mdiFormatText} from '@mdi/js'
import {mdiFormatTextRotationAngleDown} from '@mdi/js'
import {mdiFormatTextRotationAngleUp} from '@mdi/js'
import {mdiFormatTextRotationDown} from '@mdi/js'
import {mdiFormatTextRotationDownVertical} from '@mdi/js'
import {mdiFormatTextRotationNone} from '@mdi/js'
import {mdiFormatTextRotationUp} from '@mdi/js'
import {mdiFormatTextRotationVertical} from '@mdi/js'
import {mdiFormatTextVariant} from '@mdi/js'
import {mdiFormatTextVariantOutline} from '@mdi/js'
import {mdiFormatTextWrappingClip} from '@mdi/js'
import {mdiFormatTextWrappingOverflow} from '@mdi/js'
import {mdiFormatTextWrappingWrap} from '@mdi/js'
import {mdiFormatTextbox} from '@mdi/js'
import {mdiFormatTitle} from '@mdi/js'
import {mdiFormatUnderline} from '@mdi/js'
import {mdiFormatUnderlineWavy} from '@mdi/js'
import {mdiFormatVerticalAlignBottom} from '@mdi/js'
import {mdiFormatVerticalAlignCenter} from '@mdi/js'
import {mdiFormatVerticalAlignTop} from '@mdi/js'
import {mdiFormatWrapInline} from '@mdi/js'
import {mdiFormatWrapSquare} from '@mdi/js'
import {mdiFormatWrapTight} from '@mdi/js'
import {mdiFormatWrapTopBottom} from '@mdi/js'
import {mdiForum} from '@mdi/js'
import {mdiForumMinus} from '@mdi/js'
import {mdiForumMinusOutline} from '@mdi/js'
import {mdiForumOutline} from '@mdi/js'
import {mdiForumPlus} from '@mdi/js'
import {mdiForumPlusOutline} from '@mdi/js'
import {mdiForumRemove} from '@mdi/js'
import {mdiForumRemoveOutline} from '@mdi/js'
import {mdiForward} from '@mdi/js'
import {mdiForwardburger} from '@mdi/js'
import {mdiFountain} from '@mdi/js'
import {mdiFountainPen} from '@mdi/js'
import {mdiFountainPenTip} from '@mdi/js'
import {mdiFractionOneHalf} from '@mdi/js'
import {mdiFreebsd} from '@mdi/js'
import {mdiFrenchFries} from '@mdi/js'
import {mdiFrequentlyAskedQuestions} from '@mdi/js'
import {mdiFridge} from '@mdi/js'
import {mdiFridgeAlert} from '@mdi/js'
import {mdiFridgeAlertOutline} from '@mdi/js'
import {mdiFridgeBottom} from '@mdi/js'
import {mdiFridgeIndustrial} from '@mdi/js'
import {mdiFridgeIndustrialAlert} from '@mdi/js'
import {mdiFridgeIndustrialAlertOutline} from '@mdi/js'
import {mdiFridgeIndustrialOff} from '@mdi/js'
import {mdiFridgeIndustrialOffOutline} from '@mdi/js'
import {mdiFridgeIndustrialOutline} from '@mdi/js'
import {mdiFridgeOff} from '@mdi/js'
import {mdiFridgeOffOutline} from '@mdi/js'
import {mdiFridgeOutline} from '@mdi/js'
import {mdiFridgeTop} from '@mdi/js'
import {mdiFridgeVariant} from '@mdi/js'
import {mdiFridgeVariantAlert} from '@mdi/js'
import {mdiFridgeVariantAlertOutline} from '@mdi/js'
import {mdiFridgeVariantOff} from '@mdi/js'
import {mdiFridgeVariantOffOutline} from '@mdi/js'
import {mdiFridgeVariantOutline} from '@mdi/js'
import {mdiFruitCherries} from '@mdi/js'
import {mdiFruitCherriesOff} from '@mdi/js'
import {mdiFruitCitrus} from '@mdi/js'
import {mdiFruitCitrusOff} from '@mdi/js'
import {mdiFruitGrapes} from '@mdi/js'
import {mdiFruitGrapesOutline} from '@mdi/js'
import {mdiFruitPear} from '@mdi/js'
import {mdiFruitPineapple} from '@mdi/js'
import {mdiFruitWatermelon} from '@mdi/js'
import {mdiFuel} from '@mdi/js'
import {mdiFuelCell} from '@mdi/js'
import {mdiFullscreen} from '@mdi/js'
import {mdiFullscreenExit} from '@mdi/js'
import {mdiFunction} from '@mdi/js'
import {mdiFunctionVariant} from '@mdi/js'
import {mdiFuriganaHorizontal} from '@mdi/js'
import {mdiFuriganaVertical} from '@mdi/js'
import {mdiFuse} from '@mdi/js'
import {mdiFuseAlert} from '@mdi/js'
import {mdiFuseBlade} from '@mdi/js'
import {mdiFuseOff} from '@mdi/js'
import {mdiGamepad} from '@mdi/js'
import {mdiGamepadCircle} from '@mdi/js'
import {mdiGamepadCircleDown} from '@mdi/js'
import {mdiGamepadCircleLeft} from '@mdi/js'
import {mdiGamepadCircleOutline} from '@mdi/js'
import {mdiGamepadCircleRight} from '@mdi/js'
import {mdiGamepadCircleUp} from '@mdi/js'
import {mdiGamepadDown} from '@mdi/js'
import {mdiGamepadLeft} from '@mdi/js'
import {mdiGamepadOutline} from '@mdi/js'
import {mdiGamepadRight} from '@mdi/js'
import {mdiGamepadRound} from '@mdi/js'
import {mdiGamepadRoundDown} from '@mdi/js'
import {mdiGamepadRoundLeft} from '@mdi/js'
import {mdiGamepadRoundOutline} from '@mdi/js'
import {mdiGamepadRoundRight} from '@mdi/js'
import {mdiGamepadRoundUp} from '@mdi/js'
import {mdiGamepadSquare} from '@mdi/js'
import {mdiGamepadSquareOutline} from '@mdi/js'
import {mdiGamepadUp} from '@mdi/js'
import {mdiGamepadVariant} from '@mdi/js'
import {mdiGamepadVariantOutline} from '@mdi/js'
import {mdiGamma} from '@mdi/js'
import {mdiGantryCrane} from '@mdi/js'
import {mdiGarage} from '@mdi/js'
import {mdiGarageAlert} from '@mdi/js'
import {mdiGarageAlertVariant} from '@mdi/js'
import {mdiGarageLock} from '@mdi/js'
import {mdiGarageOpen} from '@mdi/js'
import {mdiGarageOpenVariant} from '@mdi/js'
import {mdiGarageVariant} from '@mdi/js'
import {mdiGarageVariantLock} from '@mdi/js'
import {mdiGasBurner} from '@mdi/js'
import {mdiGasCylinder} from '@mdi/js'
import {mdiGasStation} from '@mdi/js'
import {mdiGasStationOff} from '@mdi/js'
import {mdiGasStationOffOutline} from '@mdi/js'
import {mdiGasStationOutline} from '@mdi/js'
import {mdiGate} from '@mdi/js'
import {mdiGateAlert} from '@mdi/js'
import {mdiGateAnd} from '@mdi/js'
import {mdiGateArrowLeft} from '@mdi/js'
import {mdiGateArrowRight} from '@mdi/js'
import {mdiGateBuffer} from '@mdi/js'
import {mdiGateNand} from '@mdi/js'
import {mdiGateNor} from '@mdi/js'
import {mdiGateNot} from '@mdi/js'
import {mdiGateOpen} from '@mdi/js'
import {mdiGateOr} from '@mdi/js'
import {mdiGateXnor} from '@mdi/js'
import {mdiGateXor} from '@mdi/js'
import {mdiGatsby} from '@mdi/js'
import {mdiGauge} from '@mdi/js'
import {mdiGaugeEmpty} from '@mdi/js'
import {mdiGaugeFull} from '@mdi/js'
import {mdiGaugeLow} from '@mdi/js'
import {mdiGavel} from '@mdi/js'
import {mdiGenderFemale} from '@mdi/js'
import {mdiGenderMale} from '@mdi/js'
import {mdiGenderMaleFemale} from '@mdi/js'
import {mdiGenderMaleFemaleVariant} from '@mdi/js'
import {mdiGenderNonBinary} from '@mdi/js'
import {mdiGenderTransgender} from '@mdi/js'
import {mdiGentoo} from '@mdi/js'
import {mdiGesture} from '@mdi/js'
import {mdiGestureDoubleTap} from '@mdi/js'
import {mdiGesturePinch} from '@mdi/js'
import {mdiGestureSpread} from '@mdi/js'
import {mdiGestureSwipe} from '@mdi/js'
import {mdiGestureSwipeDown} from '@mdi/js'
import {mdiGestureSwipeHorizontal} from '@mdi/js'
import {mdiGestureSwipeLeft} from '@mdi/js'
import {mdiGestureSwipeRight} from '@mdi/js'
import {mdiGestureSwipeUp} from '@mdi/js'
import {mdiGestureSwipeVertical} from '@mdi/js'
import {mdiGestureTap} from '@mdi/js'
import {mdiGestureTapBox} from '@mdi/js'
import {mdiGestureTapButton} from '@mdi/js'
import {mdiGestureTapHold} from '@mdi/js'
import {mdiGestureTwoDoubleTap} from '@mdi/js'
import {mdiGestureTwoTap} from '@mdi/js'
import {mdiGhost} from '@mdi/js'
import {mdiGhostOff} from '@mdi/js'
import {mdiGhostOffOutline} from '@mdi/js'
import {mdiGhostOutline} from '@mdi/js'
import {mdiGift} from '@mdi/js'
import {mdiGiftOff} from '@mdi/js'
import {mdiGiftOffOutline} from '@mdi/js'
import {mdiGiftOpen} from '@mdi/js'
import {mdiGiftOpenOutline} from '@mdi/js'
import {mdiGiftOutline} from '@mdi/js'
import {mdiGit} from '@mdi/js'
import {mdiGithub} from '@mdi/js'
import {mdiGitlab} from '@mdi/js'
import {mdiGlassCocktail} from '@mdi/js'
import {mdiGlassCocktailOff} from '@mdi/js'
import {mdiGlassFlute} from '@mdi/js'
import {mdiGlassFragile} from '@mdi/js'
import {mdiGlassMug} from '@mdi/js'
import {mdiGlassMugOff} from '@mdi/js'
import {mdiGlassMugVariant} from '@mdi/js'
import {mdiGlassMugVariantOff} from '@mdi/js'
import {mdiGlassPintOutline} from '@mdi/js'
import {mdiGlassStange} from '@mdi/js'
import {mdiGlassTulip} from '@mdi/js'
import {mdiGlassWine} from '@mdi/js'
import {mdiGlasses} from '@mdi/js'
import {mdiGlobeLight} from '@mdi/js'
import {mdiGlobeLightOutline} from '@mdi/js'
import {mdiGlobeModel} from '@mdi/js'
import {mdiGmail} from '@mdi/js'
import {mdiGnome} from '@mdi/js'
import {mdiGoKart} from '@mdi/js'
import {mdiGoKartTrack} from '@mdi/js'
import {mdiGog} from '@mdi/js'
import {mdiGold} from '@mdi/js'
import {mdiGolf} from '@mdi/js'
import {mdiGolfCart} from '@mdi/js'
import {mdiGolfTee} from '@mdi/js'
import {mdiGondola} from '@mdi/js'
import {mdiGoodreads} from '@mdi/js'
import {mdiGoogle} from '@mdi/js'
import {mdiGoogleAds} from '@mdi/js'
import {mdiGoogleAnalytics} from '@mdi/js'
import {mdiGoogleAssistant} from '@mdi/js'
import {mdiGoogleCardboard} from '@mdi/js'
import {mdiGoogleChrome} from '@mdi/js'
import {mdiGoogleCircles} from '@mdi/js'
import {mdiGoogleCirclesCommunities} from '@mdi/js'
import {mdiGoogleCirclesExtended} from '@mdi/js'
import {mdiGoogleCirclesGroup} from '@mdi/js'
import {mdiGoogleClassroom} from '@mdi/js'
import {mdiGoogleCloud} from '@mdi/js'
import {mdiGoogleDownasaur} from '@mdi/js'
import {mdiGoogleDrive} from '@mdi/js'
import {mdiGoogleEarth} from '@mdi/js'
import {mdiGoogleFit} from '@mdi/js'
import {mdiGoogleGlass} from '@mdi/js'
import {mdiGoogleHangouts} from '@mdi/js'
import {mdiGoogleKeep} from '@mdi/js'
import {mdiGoogleLens} from '@mdi/js'
import {mdiGoogleMaps} from '@mdi/js'
import {mdiGoogleMyBusiness} from '@mdi/js'
import {mdiGoogleNearby} from '@mdi/js'
import {mdiGooglePlay} from '@mdi/js'
import {mdiGooglePlus} from '@mdi/js'
import {mdiGooglePodcast} from '@mdi/js'
import {mdiGoogleSpreadsheet} from '@mdi/js'
import {mdiGoogleStreetView} from '@mdi/js'
import {mdiGoogleTranslate} from '@mdi/js'
import {mdiGradientHorizontal} from '@mdi/js'
import {mdiGradientVertical} from '@mdi/js'
import {mdiGrain} from '@mdi/js'
import {mdiGraph} from '@mdi/js'
import {mdiGraphOutline} from '@mdi/js'
import {mdiGraphql} from '@mdi/js'
import {mdiGrass} from '@mdi/js'
import {mdiGraveStone} from '@mdi/js'
import {mdiGreasePencil} from '@mdi/js'
import {mdiGreaterThan} from '@mdi/js'
import {mdiGreaterThanOrEqual} from '@mdi/js'
import {mdiGreenhouse} from '@mdi/js'
import {mdiGrid} from '@mdi/js'
import {mdiGridLarge} from '@mdi/js'
import {mdiGridOff} from '@mdi/js'
import {mdiGrill} from '@mdi/js'
import {mdiGrillOutline} from '@mdi/js'
import {mdiGroup} from '@mdi/js'
import {mdiGuitarAcoustic} from '@mdi/js'
import {mdiGuitarElectric} from '@mdi/js'
import {mdiGuitarPick} from '@mdi/js'
import {mdiGuitarPickOutline} from '@mdi/js'
import {mdiGuyFawkesMask} from '@mdi/js'
import {mdiGymnastics} from '@mdi/js'
import {mdiHail} from '@mdi/js'
import {mdiHairDryer} from '@mdi/js'
import {mdiHairDryerOutline} from '@mdi/js'
import {mdiHalloween} from '@mdi/js'
import {mdiHamburger} from '@mdi/js'
import {mdiHamburgerCheck} from '@mdi/js'
import {mdiHamburgerMinus} from '@mdi/js'
import {mdiHamburgerOff} from '@mdi/js'
import {mdiHamburgerPlus} from '@mdi/js'
import {mdiHamburgerRemove} from '@mdi/js'
import {mdiHammer} from '@mdi/js'
import {mdiHammerScrewdriver} from '@mdi/js'
import {mdiHammerSickle} from '@mdi/js'
import {mdiHammerWrench} from '@mdi/js'
import {mdiHandBackLeft} from '@mdi/js'
import {mdiHandBackLeftOff} from '@mdi/js'
import {mdiHandBackLeftOffOutline} from '@mdi/js'
import {mdiHandBackLeftOutline} from '@mdi/js'
import {mdiHandBackRight} from '@mdi/js'
import {mdiHandBackRightOff} from '@mdi/js'
import {mdiHandBackRightOffOutline} from '@mdi/js'
import {mdiHandBackRightOutline} from '@mdi/js'
import {mdiHandClap} from '@mdi/js'
import {mdiHandClapOff} from '@mdi/js'
import {mdiHandCoin} from '@mdi/js'
import {mdiHandCoinOutline} from '@mdi/js'
import {mdiHandCycle} from '@mdi/js'
import {mdiHandExtended} from '@mdi/js'
import {mdiHandExtendedOutline} from '@mdi/js'
import {mdiHandFrontLeft} from '@mdi/js'
import {mdiHandFrontLeftOutline} from '@mdi/js'
import {mdiHandFrontRight} from '@mdi/js'
import {mdiHandFrontRightOutline} from '@mdi/js'
import {mdiHandHeart} from '@mdi/js'
import {mdiHandHeartOutline} from '@mdi/js'
import {mdiHandOkay} from '@mdi/js'
import {mdiHandPeace} from '@mdi/js'
import {mdiHandPeaceVariant} from '@mdi/js'
import {mdiHandPointingDown} from '@mdi/js'
import {mdiHandPointingLeft} from '@mdi/js'
import {mdiHandPointingRight} from '@mdi/js'
import {mdiHandPointingUp} from '@mdi/js'
import {mdiHandSaw} from '@mdi/js'
import {mdiHandWash} from '@mdi/js'
import {mdiHandWashOutline} from '@mdi/js'
import {mdiHandWater} from '@mdi/js'
import {mdiHandWave} from '@mdi/js'
import {mdiHandWaveOutline} from '@mdi/js'
import {mdiHandball} from '@mdi/js'
import {mdiHandcuffs} from '@mdi/js'
import {mdiHandsPray} from '@mdi/js'
import {mdiHandshake} from '@mdi/js'
import {mdiHandshakeOutline} from '@mdi/js'
import {mdiHanger} from '@mdi/js'
import {mdiHardHat} from '@mdi/js'
import {mdiHarddisk} from '@mdi/js'
import {mdiHarddiskPlus} from '@mdi/js'
import {mdiHarddiskRemove} from '@mdi/js'
import {mdiHatFedora} from '@mdi/js'
import {mdiHazardLights} from '@mdi/js'
import {mdiHdmiPort} from '@mdi/js'
import {mdiHdr} from '@mdi/js'
import {mdiHdrOff} from '@mdi/js'
import {mdiHead} from '@mdi/js'
import {mdiHeadAlert} from '@mdi/js'
import {mdiHeadAlertOutline} from '@mdi/js'
import {mdiHeadCheck} from '@mdi/js'
import {mdiHeadCheckOutline} from '@mdi/js'
import {mdiHeadCog} from '@mdi/js'
import {mdiHeadCogOutline} from '@mdi/js'
import {mdiHeadDotsHorizontal} from '@mdi/js'
import {mdiHeadDotsHorizontalOutline} from '@mdi/js'
import {mdiHeadFlash} from '@mdi/js'
import {mdiHeadFlashOutline} from '@mdi/js'
import {mdiHeadHeart} from '@mdi/js'
import {mdiHeadHeartOutline} from '@mdi/js'
import {mdiHeadLightbulb} from '@mdi/js'
import {mdiHeadLightbulbOutline} from '@mdi/js'
import {mdiHeadMinus} from '@mdi/js'
import {mdiHeadMinusOutline} from '@mdi/js'
import {mdiHeadOutline} from '@mdi/js'
import {mdiHeadPlus} from '@mdi/js'
import {mdiHeadPlusOutline} from '@mdi/js'
import {mdiHeadQuestion} from '@mdi/js'
import {mdiHeadQuestionOutline} from '@mdi/js'
import {mdiHeadRemove} from '@mdi/js'
import {mdiHeadRemoveOutline} from '@mdi/js'
import {mdiHeadSnowflake} from '@mdi/js'
import {mdiHeadSnowflakeOutline} from '@mdi/js'
import {mdiHeadSync} from '@mdi/js'
import {mdiHeadSyncOutline} from '@mdi/js'
import {mdiHeadphones} from '@mdi/js'
import {mdiHeadphonesBluetooth} from '@mdi/js'
import {mdiHeadphonesBox} from '@mdi/js'
import {mdiHeadphonesOff} from '@mdi/js'
import {mdiHeadphonesSettings} from '@mdi/js'
import {mdiHeadset} from '@mdi/js'
import {mdiHeadsetDock} from '@mdi/js'
import {mdiHeadsetOff} from '@mdi/js'
import {mdiHeart} from '@mdi/js'
import {mdiHeartBox} from '@mdi/js'
import {mdiHeartBoxOutline} from '@mdi/js'
import {mdiHeartBroken} from '@mdi/js'
import {mdiHeartBrokenOutline} from '@mdi/js'
import {mdiHeartCircle} from '@mdi/js'
import {mdiHeartCircleOutline} from '@mdi/js'
import {mdiHeartCog} from '@mdi/js'
import {mdiHeartCogOutline} from '@mdi/js'
import {mdiHeartFlash} from '@mdi/js'
import {mdiHeartHalf} from '@mdi/js'
import {mdiHeartHalfFull} from '@mdi/js'
import {mdiHeartHalfOutline} from '@mdi/js'
import {mdiHeartMinus} from '@mdi/js'
import {mdiHeartMinusOutline} from '@mdi/js'
import {mdiHeartMultiple} from '@mdi/js'
import {mdiHeartMultipleOutline} from '@mdi/js'
import {mdiHeartOff} from '@mdi/js'
import {mdiHeartOffOutline} from '@mdi/js'
import {mdiHeartOutline} from '@mdi/js'
import {mdiHeartPlus} from '@mdi/js'
import {mdiHeartPlusOutline} from '@mdi/js'
import {mdiHeartPulse} from '@mdi/js'
import {mdiHeartRemove} from '@mdi/js'
import {mdiHeartRemoveOutline} from '@mdi/js'
import {mdiHeartSettings} from '@mdi/js'
import {mdiHeartSettingsOutline} from '@mdi/js'
import {mdiHeatPump} from '@mdi/js'
import {mdiHeatPumpOutline} from '@mdi/js'
import {mdiHeatWave} from '@mdi/js'
import {mdiHeatingCoil} from '@mdi/js'
import {mdiHelicopter} from '@mdi/js'
import {mdiHelp} from '@mdi/js'
import {mdiHelpBox} from '@mdi/js'
import {mdiHelpCircle} from '@mdi/js'
import {mdiHelpCircleOutline} from '@mdi/js'
import {mdiHelpNetwork} from '@mdi/js'
import {mdiHelpNetworkOutline} from '@mdi/js'
import {mdiHelpRhombus} from '@mdi/js'
import {mdiHelpRhombusOutline} from '@mdi/js'
import {mdiHexadecimal} from '@mdi/js'
import {mdiHexagon} from '@mdi/js'
import {mdiHexagonMultiple} from '@mdi/js'
import {mdiHexagonMultipleOutline} from '@mdi/js'
import {mdiHexagonOutline} from '@mdi/js'
import {mdiHexagonSlice1} from '@mdi/js'
import {mdiHexagonSlice2} from '@mdi/js'
import {mdiHexagonSlice3} from '@mdi/js'
import {mdiHexagonSlice4} from '@mdi/js'
import {mdiHexagonSlice5} from '@mdi/js'
import {mdiHexagonSlice6} from '@mdi/js'
import {mdiHexagram} from '@mdi/js'
import {mdiHexagramOutline} from '@mdi/js'
import {mdiHighDefinition} from '@mdi/js'
import {mdiHighDefinitionBox} from '@mdi/js'
import {mdiHighway} from '@mdi/js'
import {mdiHiking} from '@mdi/js'
import {mdiHistory} from '@mdi/js'
import {mdiHockeyPuck} from '@mdi/js'
import {mdiHockeySticks} from '@mdi/js'
import {mdiHololens} from '@mdi/js'
import {mdiHome} from '@mdi/js'
import {mdiHomeAccount} from '@mdi/js'
import {mdiHomeAlert} from '@mdi/js'
import {mdiHomeAlertOutline} from '@mdi/js'
import {mdiHomeAnalytics} from '@mdi/js'
import {mdiHomeAssistant} from '@mdi/js'
import {mdiHomeAutomation} from '@mdi/js'
import {mdiHomeBattery} from '@mdi/js'
import {mdiHomeBatteryOutline} from '@mdi/js'
import {mdiHomeCircle} from '@mdi/js'
import {mdiHomeCircleOutline} from '@mdi/js'
import {mdiHomeCity} from '@mdi/js'
import {mdiHomeCityOutline} from '@mdi/js'
import {mdiHomeClock} from '@mdi/js'
import {mdiHomeClockOutline} from '@mdi/js'
import {mdiHomeEdit} from '@mdi/js'
import {mdiHomeEditOutline} from '@mdi/js'
import {mdiHomeFloor0} from '@mdi/js'
import {mdiHomeFloor1} from '@mdi/js'
import {mdiHomeFloor2} from '@mdi/js'
import {mdiHomeFloor3} from '@mdi/js'
import {mdiHomeFloorA} from '@mdi/js'
import {mdiHomeFloorB} from '@mdi/js'
import {mdiHomeFloorG} from '@mdi/js'
import {mdiHomeFloorL} from '@mdi/js'
import {mdiHomeFloorNegative1} from '@mdi/js'
import {mdiHomeGroup} from '@mdi/js'
import {mdiHomeGroupMinus} from '@mdi/js'
import {mdiHomeGroupPlus} from '@mdi/js'
import {mdiHomeGroupRemove} from '@mdi/js'
import {mdiHomeHeart} from '@mdi/js'
import {mdiHomeImportOutline} from '@mdi/js'
import {mdiHomeLightbulb} from '@mdi/js'
import {mdiHomeLightbulbOutline} from '@mdi/js'
import {mdiHomeLightningBolt} from '@mdi/js'
import {mdiHomeLightningBoltOutline} from '@mdi/js'
import {mdiHomeLock} from '@mdi/js'
import {mdiHomeLockOpen} from '@mdi/js'
import {mdiHomeMapMarker} from '@mdi/js'
import {mdiHomeMinus} from '@mdi/js'
import {mdiHomeMinusOutline} from '@mdi/js'
import {mdiHomeModern} from '@mdi/js'
import {mdiHomeOff} from '@mdi/js'
import {mdiHomeOffOutline} from '@mdi/js'
import {mdiHomeOutline} from '@mdi/js'
import {mdiHomePlus} from '@mdi/js'
import {mdiHomePlusOutline} from '@mdi/js'
import {mdiHomeRemove} from '@mdi/js'
import {mdiHomeRemoveOutline} from '@mdi/js'
import {mdiHomeRoof} from '@mdi/js'
import {mdiHomeSearch} from '@mdi/js'
import {mdiHomeSearchOutline} from '@mdi/js'
import {mdiHomeSilo} from '@mdi/js'
import {mdiHomeSiloOutline} from '@mdi/js'
import {mdiHomeSwitch} from '@mdi/js'
import {mdiHomeSwitchOutline} from '@mdi/js'
import {mdiHomeThermometer} from '@mdi/js'
import {mdiHomeThermometerOutline} from '@mdi/js'
import {mdiHomeVariant} from '@mdi/js'
import {mdiHomeVariantOutline} from '@mdi/js'
import {mdiHook} from '@mdi/js'
import {mdiHookOff} from '@mdi/js'
import {mdiHoopHouse} from '@mdi/js'
import {mdiHops} from '@mdi/js'
import {mdiHorizontalRotateClockwise} from '@mdi/js'
import {mdiHorizontalRotateCounterclockwise} from '@mdi/js'
import {mdiHorse} from '@mdi/js'
import {mdiHorseHuman} from '@mdi/js'
import {mdiHorseVariant} from '@mdi/js'
import {mdiHorseVariantFast} from '@mdi/js'
import {mdiHorseshoe} from '@mdi/js'
import {mdiHospital} from '@mdi/js'
import {mdiHospitalBox} from '@mdi/js'
import {mdiHospitalBoxOutline} from '@mdi/js'
import {mdiHospitalBuilding} from '@mdi/js'
import {mdiHospitalMarker} from '@mdi/js'
import {mdiHotTub} from '@mdi/js'
import {mdiHours24} from '@mdi/js'
import {mdiHubspot} from '@mdi/js'
import {mdiHulu} from '@mdi/js'
import {mdiHuman} from '@mdi/js'
import {mdiHumanBabyChangingTable} from '@mdi/js'
import {mdiHumanCane} from '@mdi/js'
import {mdiHumanCapacityDecrease} from '@mdi/js'
import {mdiHumanCapacityIncrease} from '@mdi/js'
import {mdiHumanChild} from '@mdi/js'
import {mdiHumanDolly} from '@mdi/js'
import {mdiHumanEdit} from '@mdi/js'
import {mdiHumanFemale} from '@mdi/js'
import {mdiHumanFemaleBoy} from '@mdi/js'
import {mdiHumanFemaleDance} from '@mdi/js'
import {mdiHumanFemaleFemale} from '@mdi/js'
import {mdiHumanFemaleGirl} from '@mdi/js'
import {mdiHumanGreeting} from '@mdi/js'
import {mdiHumanGreetingProximity} from '@mdi/js'
import {mdiHumanGreetingVariant} from '@mdi/js'
import {mdiHumanHandsdown} from '@mdi/js'
import {mdiHumanHandsup} from '@mdi/js'
import {mdiHumanMale} from '@mdi/js'
import {mdiHumanMaleBoard} from '@mdi/js'
import {mdiHumanMaleBoardPoll} from '@mdi/js'
import {mdiHumanMaleBoy} from '@mdi/js'
import {mdiHumanMaleChild} from '@mdi/js'
import {mdiHumanMaleFemale} from '@mdi/js'
import {mdiHumanMaleFemaleChild} from '@mdi/js'
import {mdiHumanMaleGirl} from '@mdi/js'
import {mdiHumanMaleHeight} from '@mdi/js'
import {mdiHumanMaleHeightVariant} from '@mdi/js'
import {mdiHumanMaleMale} from '@mdi/js'
import {mdiHumanNonBinary} from '@mdi/js'
import {mdiHumanPregnant} from '@mdi/js'
import {mdiHumanQueue} from '@mdi/js'
import {mdiHumanScooter} from '@mdi/js'
import {mdiHumanWalker} from '@mdi/js'
import {mdiHumanWheelchair} from '@mdi/js'
import {mdiHumanWhiteCane} from '@mdi/js'
import {mdiHumbleBundle} from '@mdi/js'
import {mdiHvac} from '@mdi/js'
import {mdiHvacOff} from '@mdi/js'
import {mdiHydraulicOilLevel} from '@mdi/js'
import {mdiHydraulicOilTemperature} from '@mdi/js'
import {mdiHydroPower} from '@mdi/js'
import {mdiHydrogenStation} from '@mdi/js'
import {mdiIceCream} from '@mdi/js'
import {mdiIceCreamOff} from '@mdi/js'
import {mdiIcePop} from '@mdi/js'
import {mdiIdCard} from '@mdi/js'
import {mdiIdentifier} from '@mdi/js'
import {mdiIdeogramCjk} from '@mdi/js'
import {mdiIdeogramCjkVariant} from '@mdi/js'
import {mdiImage} from '@mdi/js'
import {mdiImageAlbum} from '@mdi/js'
import {mdiImageArea} from '@mdi/js'
import {mdiImageAreaClose} from '@mdi/js'
import {mdiImageAutoAdjust} from '@mdi/js'
import {mdiImageBroken} from '@mdi/js'
import {mdiImageBrokenVariant} from '@mdi/js'
import {mdiImageCheck} from '@mdi/js'
import {mdiImageCheckOutline} from '@mdi/js'
import {mdiImageEdit} from '@mdi/js'
import {mdiImageEditOutline} from '@mdi/js'
import {mdiImageFilterBlackWhite} from '@mdi/js'
import {mdiImageFilterCenterFocus} from '@mdi/js'
import {mdiImageFilterCenterFocusStrong} from '@mdi/js'
import {mdiImageFilterCenterFocusStrongOutline} from '@mdi/js'
import {mdiImageFilterCenterFocusWeak} from '@mdi/js'
import {mdiImageFilterDrama} from '@mdi/js'
import {mdiImageFilterFrames} from '@mdi/js'
import {mdiImageFilterHdr} from '@mdi/js'
import {mdiImageFilterNone} from '@mdi/js'
import {mdiImageFilterTiltShift} from '@mdi/js'
import {mdiImageFilterVintage} from '@mdi/js'
import {mdiImageFrame} from '@mdi/js'
import {mdiImageLock} from '@mdi/js'
import {mdiImageLockOutline} from '@mdi/js'
import {mdiImageMarker} from '@mdi/js'
import {mdiImageMarkerOutline} from '@mdi/js'
import {mdiImageMinus} from '@mdi/js'
import {mdiImageMinusOutline} from '@mdi/js'
import {mdiImageMove} from '@mdi/js'
import {mdiImageMultiple} from '@mdi/js'
import {mdiImageMultipleOutline} from '@mdi/js'
import {mdiImageOff} from '@mdi/js'
import {mdiImageOffOutline} from '@mdi/js'
import {mdiImageOutline} from '@mdi/js'
import {mdiImagePlus} from '@mdi/js'
import {mdiImagePlusOutline} from '@mdi/js'
import {mdiImageRefresh} from '@mdi/js'
import {mdiImageRefreshOutline} from '@mdi/js'
import {mdiImageRemove} from '@mdi/js'
import {mdiImageRemoveOutline} from '@mdi/js'
import {mdiImageSearch} from '@mdi/js'
import {mdiImageSearchOutline} from '@mdi/js'
import {mdiImageSizeSelectActual} from '@mdi/js'
import {mdiImageSizeSelectLarge} from '@mdi/js'
import {mdiImageSizeSelectSmall} from '@mdi/js'
import {mdiImageSync} from '@mdi/js'
import {mdiImageSyncOutline} from '@mdi/js'
import {mdiImageText} from '@mdi/js'
import {mdiImport} from '@mdi/js'
import {mdiInbox} from '@mdi/js'
import {mdiInboxArrowDown} from '@mdi/js'
import {mdiInboxArrowDownOutline} from '@mdi/js'
import {mdiInboxArrowUp} from '@mdi/js'
import {mdiInboxArrowUpOutline} from '@mdi/js'
import {mdiInboxFull} from '@mdi/js'
import {mdiInboxFullOutline} from '@mdi/js'
import {mdiInboxMultiple} from '@mdi/js'
import {mdiInboxMultipleOutline} from '@mdi/js'
import {mdiInboxOutline} from '@mdi/js'
import {mdiInboxRemove} from '@mdi/js'
import {mdiInboxRemoveOutline} from '@mdi/js'
import {mdiIncognito} from '@mdi/js'
import {mdiIncognitoCircle} from '@mdi/js'
import {mdiIncognitoCircleOff} from '@mdi/js'
import {mdiIncognitoOff} from '@mdi/js'
import {mdiInduction} from '@mdi/js'
import {mdiInfinity} from '@mdi/js'
import {mdiInformation} from '@mdi/js'
import {mdiInformationOff} from '@mdi/js'
import {mdiInformationOffOutline} from '@mdi/js'
import {mdiInformationOutline} from '@mdi/js'
import {mdiInformationVariant} from '@mdi/js'
import {mdiInstagram} from '@mdi/js'
import {mdiInstrumentTriangle} from '@mdi/js'
import {mdiIntegratedCircuitChip} from '@mdi/js'
import {mdiInvertColors} from '@mdi/js'
import {mdiInvertColorsOff} from '@mdi/js'
import {mdiIobroker} from '@mdi/js'
import {mdiIp} from '@mdi/js'
import {mdiIpNetwork} from '@mdi/js'
import {mdiIpNetworkOutline} from '@mdi/js'
import {mdiIpOutline} from '@mdi/js'
import {mdiIpod} from '@mdi/js'
import {mdiIron} from '@mdi/js'
import {mdiIronBoard} from '@mdi/js'
import {mdiIronOutline} from '@mdi/js'
import {mdiIsland} from '@mdi/js'
import {mdiIvBag} from '@mdi/js'
import {mdiJabber} from '@mdi/js'
import {mdiJeepney} from '@mdi/js'
import {mdiJellyfish} from '@mdi/js'
import {mdiJellyfishOutline} from '@mdi/js'
import {mdiJira} from '@mdi/js'
import {mdiJquery} from '@mdi/js'
import {mdiJsfiddle} from '@mdi/js'
import {mdiJumpRope} from '@mdi/js'
import {mdiKabaddi} from '@mdi/js'
import {mdiKangaroo} from '@mdi/js'
import {mdiKarate} from '@mdi/js'
import {mdiKayaking} from '@mdi/js'
import {mdiKeg} from '@mdi/js'
import {mdiKettle} from '@mdi/js'
import {mdiKettleAlert} from '@mdi/js'
import {mdiKettleAlertOutline} from '@mdi/js'
import {mdiKettleOff} from '@mdi/js'
import {mdiKettleOffOutline} from '@mdi/js'
import {mdiKettleOutline} from '@mdi/js'
import {mdiKettlePourOver} from '@mdi/js'
import {mdiKettleSteam} from '@mdi/js'
import {mdiKettleSteamOutline} from '@mdi/js'
import {mdiKettlebell} from '@mdi/js'
import {mdiKey} from '@mdi/js'
import {mdiKeyAlert} from '@mdi/js'
import {mdiKeyAlertOutline} from '@mdi/js'
import {mdiKeyArrowRight} from '@mdi/js'
import {mdiKeyChain} from '@mdi/js'
import {mdiKeyChainVariant} from '@mdi/js'
import {mdiKeyChange} from '@mdi/js'
import {mdiKeyLink} from '@mdi/js'
import {mdiKeyMinus} from '@mdi/js'
import {mdiKeyOutline} from '@mdi/js'
import {mdiKeyPlus} from '@mdi/js'
import {mdiKeyRemove} from '@mdi/js'
import {mdiKeyStar} from '@mdi/js'
import {mdiKeyVariant} from '@mdi/js'
import {mdiKeyWireless} from '@mdi/js'
import {mdiKeyboard} from '@mdi/js'
import {mdiKeyboardBackspace} from '@mdi/js'
import {mdiKeyboardCaps} from '@mdi/js'
import {mdiKeyboardClose} from '@mdi/js'
import {mdiKeyboardEsc} from '@mdi/js'
import {mdiKeyboardF1} from '@mdi/js'
import {mdiKeyboardF10} from '@mdi/js'
import {mdiKeyboardF11} from '@mdi/js'
import {mdiKeyboardF12} from '@mdi/js'
import {mdiKeyboardF2} from '@mdi/js'
import {mdiKeyboardF3} from '@mdi/js'
import {mdiKeyboardF4} from '@mdi/js'
import {mdiKeyboardF5} from '@mdi/js'
import {mdiKeyboardF6} from '@mdi/js'
import {mdiKeyboardF7} from '@mdi/js'
import {mdiKeyboardF8} from '@mdi/js'
import {mdiKeyboardF9} from '@mdi/js'
import {mdiKeyboardOff} from '@mdi/js'
import {mdiKeyboardOffOutline} from '@mdi/js'
import {mdiKeyboardOutline} from '@mdi/js'
import {mdiKeyboardReturn} from '@mdi/js'
import {mdiKeyboardSettings} from '@mdi/js'
import {mdiKeyboardSettingsOutline} from '@mdi/js'
import {mdiKeyboardSpace} from '@mdi/js'
import {mdiKeyboardTab} from '@mdi/js'
import {mdiKeyboardTabReverse} from '@mdi/js'
import {mdiKeyboardVariant} from '@mdi/js'
import {mdiKhanda} from '@mdi/js'
import {mdiKickstarter} from '@mdi/js'
import {mdiKite} from '@mdi/js'
import {mdiKiteOutline} from '@mdi/js'
import {mdiKitesurfing} from '@mdi/js'
import {mdiKlingon} from '@mdi/js'
import {mdiKnife} from '@mdi/js'
import {mdiKnifeMilitary} from '@mdi/js'
import {mdiKnob} from '@mdi/js'
import {mdiKoala} from '@mdi/js'
import {mdiKodi} from '@mdi/js'
import {mdiKubernetes} from '@mdi/js'
import {mdiLabel} from '@mdi/js'
import {mdiLabelMultiple} from '@mdi/js'
import {mdiLabelMultipleOutline} from '@mdi/js'
import {mdiLabelOff} from '@mdi/js'
import {mdiLabelOffOutline} from '@mdi/js'
import {mdiLabelOutline} from '@mdi/js'
import {mdiLabelPercent} from '@mdi/js'
import {mdiLabelPercentOutline} from '@mdi/js'
import {mdiLabelVariant} from '@mdi/js'
import {mdiLabelVariantOutline} from '@mdi/js'
import {mdiLadder} from '@mdi/js'
import {mdiLadybug} from '@mdi/js'
import {mdiLambda} from '@mdi/js'
import {mdiLamp} from '@mdi/js'
import {mdiLampOutline} from '@mdi/js'
import {mdiLamps} from '@mdi/js'
import {mdiLampsOutline} from '@mdi/js'
import {mdiLan} from '@mdi/js'
import {mdiLanCheck} from '@mdi/js'
import {mdiLanConnect} from '@mdi/js'
import {mdiLanDisconnect} from '@mdi/js'
import {mdiLanPending} from '@mdi/js'
import {mdiLandFields} from '@mdi/js'
import {mdiLandPlots} from '@mdi/js'
import {mdiLandPlotsCircle} from '@mdi/js'
import {mdiLandPlotsCircleVariant} from '@mdi/js'
import {mdiLandRowsHorizontal} from '@mdi/js'
import {mdiLandRowsVertical} from '@mdi/js'
import {mdiLandslide} from '@mdi/js'
import {mdiLandslideOutline} from '@mdi/js'
import {mdiLanguageC} from '@mdi/js'
import {mdiLanguageCpp} from '@mdi/js'
import {mdiLanguageCsharp} from '@mdi/js'
import {mdiLanguageCss3} from '@mdi/js'
import {mdiLanguageFortran} from '@mdi/js'
import {mdiLanguageGo} from '@mdi/js'
import {mdiLanguageHaskell} from '@mdi/js'
import {mdiLanguageHtml5} from '@mdi/js'
import {mdiLanguageJava} from '@mdi/js'
import {mdiLanguageJavascript} from '@mdi/js'
import {mdiLanguageKotlin} from '@mdi/js'
import {mdiLanguageLua} from '@mdi/js'
import {mdiLanguageMarkdown} from '@mdi/js'
import {mdiLanguageMarkdownOutline} from '@mdi/js'
import {mdiLanguagePhp} from '@mdi/js'
import {mdiLanguagePython} from '@mdi/js'
import {mdiLanguageR} from '@mdi/js'
import {mdiLanguageRuby} from '@mdi/js'
import {mdiLanguageRubyOnRails} from '@mdi/js'
import {mdiLanguageRust} from '@mdi/js'
import {mdiLanguageSwift} from '@mdi/js'
import {mdiLanguageTypescript} from '@mdi/js'
import {mdiLanguageXaml} from '@mdi/js'
import {mdiLaptop} from '@mdi/js'
import {mdiLaptopAccount} from '@mdi/js'
import {mdiLaptopOff} from '@mdi/js'
import {mdiLaravel} from '@mdi/js'
import {mdiLaserPointer} from '@mdi/js'
import {mdiLasso} from '@mdi/js'
import {mdiLastpass} from '@mdi/js'
import {mdiLatitude} from '@mdi/js'
import {mdiLaunch} from '@mdi/js'
import {mdiLavaLamp} from '@mdi/js'
import {mdiLayers} from '@mdi/js'
import {mdiLayersEdit} from '@mdi/js'
import {mdiLayersMinus} from '@mdi/js'
import {mdiLayersOff} from '@mdi/js'
import {mdiLayersOffOutline} from '@mdi/js'
import {mdiLayersOutline} from '@mdi/js'
import {mdiLayersPlus} from '@mdi/js'
import {mdiLayersRemove} from '@mdi/js'
import {mdiLayersSearch} from '@mdi/js'
import {mdiLayersSearchOutline} from '@mdi/js'
import {mdiLayersTriple} from '@mdi/js'
import {mdiLayersTripleOutline} from '@mdi/js'
import {mdiLeadPencil} from '@mdi/js'
import {mdiLeaf} from '@mdi/js'
import {mdiLeafCircle} from '@mdi/js'
import {mdiLeafCircleOutline} from '@mdi/js'
import {mdiLeafMaple} from '@mdi/js'
import {mdiLeafMapleOff} from '@mdi/js'
import {mdiLeafOff} from '@mdi/js'
import {mdiLeak} from '@mdi/js'
import {mdiLeakOff} from '@mdi/js'
import {mdiLectern} from '@mdi/js'
import {mdiLedOff} from '@mdi/js'
import {mdiLedOn} from '@mdi/js'
import {mdiLedOutline} from '@mdi/js'
import {mdiLedStrip} from '@mdi/js'
import {mdiLedStripVariant} from '@mdi/js'
import {mdiLedStripVariantOff} from '@mdi/js'
import {mdiLedVariantOff} from '@mdi/js'
import {mdiLedVariantOn} from '@mdi/js'
import {mdiLedVariantOutline} from '@mdi/js'
import {mdiLeek} from '@mdi/js'
import {mdiLessThan} from '@mdi/js'
import {mdiLessThanOrEqual} from '@mdi/js'
import {mdiLibrary} from '@mdi/js'
import {mdiLibraryOutline} from '@mdi/js'
import {mdiLibraryShelves} from '@mdi/js'
import {mdiLicense} from '@mdi/js'
import {mdiLifebuoy} from '@mdi/js'
import {mdiLightFloodDown} from '@mdi/js'
import {mdiLightFloodUp} from '@mdi/js'
import {mdiLightRecessed} from '@mdi/js'
import {mdiLightSwitch} from '@mdi/js'
import {mdiLightSwitchOff} from '@mdi/js'
import {mdiLightbulb} from '@mdi/js'
import {mdiLightbulbAlert} from '@mdi/js'
import {mdiLightbulbAlertOutline} from '@mdi/js'
import {mdiLightbulbAuto} from '@mdi/js'
import {mdiLightbulbAutoOutline} from '@mdi/js'
import {mdiLightbulbCfl} from '@mdi/js'
import {mdiLightbulbCflOff} from '@mdi/js'
import {mdiLightbulbCflSpiral} from '@mdi/js'
import {mdiLightbulbCflSpiralOff} from '@mdi/js'
import {mdiLightbulbFluorescentTube} from '@mdi/js'
import {mdiLightbulbFluorescentTubeOutline} from '@mdi/js'
import {mdiLightbulbGroup} from '@mdi/js'
import {mdiLightbulbGroupOff} from '@mdi/js'
import {mdiLightbulbGroupOffOutline} from '@mdi/js'
import {mdiLightbulbGroupOutline} from '@mdi/js'
import {mdiLightbulbMultiple} from '@mdi/js'
import {mdiLightbulbMultipleOff} from '@mdi/js'
import {mdiLightbulbMultipleOffOutline} from '@mdi/js'
import {mdiLightbulbMultipleOutline} from '@mdi/js'
import {mdiLightbulbNight} from '@mdi/js'
import {mdiLightbulbNightOutline} from '@mdi/js'
import {mdiLightbulbOff} from '@mdi/js'
import {mdiLightbulbOffOutline} from '@mdi/js'
import {mdiLightbulbOn} from '@mdi/js'
import {mdiLightbulbOn10} from '@mdi/js'
import {mdiLightbulbOn20} from '@mdi/js'
import {mdiLightbulbOn30} from '@mdi/js'
import {mdiLightbulbOn40} from '@mdi/js'
import {mdiLightbulbOn50} from '@mdi/js'
import {mdiLightbulbOn60} from '@mdi/js'
import {mdiLightbulbOn70} from '@mdi/js'
import {mdiLightbulbOn80} from '@mdi/js'
import {mdiLightbulbOn90} from '@mdi/js'
import {mdiLightbulbOnOutline} from '@mdi/js'
import {mdiLightbulbOutline} from '@mdi/js'
import {mdiLightbulbQuestion} from '@mdi/js'
import {mdiLightbulbQuestionOutline} from '@mdi/js'
import {mdiLightbulbSpot} from '@mdi/js'
import {mdiLightbulbSpotOff} from '@mdi/js'
import {mdiLightbulbVariant} from '@mdi/js'
import {mdiLightbulbVariantOutline} from '@mdi/js'
import {mdiLighthouse} from '@mdi/js'
import {mdiLighthouseOn} from '@mdi/js'
import {mdiLightningBolt} from '@mdi/js'
import {mdiLightningBoltCircle} from '@mdi/js'
import {mdiLightningBoltOutline} from '@mdi/js'
import {mdiLineScan} from '@mdi/js'
import {mdiLingerie} from '@mdi/js'
import {mdiLink} from '@mdi/js'
import {mdiLinkBox} from '@mdi/js'
import {mdiLinkBoxOutline} from '@mdi/js'
import {mdiLinkBoxVariant} from '@mdi/js'
import {mdiLinkBoxVariantOutline} from '@mdi/js'
import {mdiLinkLock} from '@mdi/js'
import {mdiLinkOff} from '@mdi/js'
import {mdiLinkPlus} from '@mdi/js'
import {mdiLinkVariant} from '@mdi/js'
import {mdiLinkVariantMinus} from '@mdi/js'
import {mdiLinkVariantOff} from '@mdi/js'
import {mdiLinkVariantPlus} from '@mdi/js'
import {mdiLinkVariantRemove} from '@mdi/js'
import {mdiLinkedin} from '@mdi/js'
import {mdiLinux} from '@mdi/js'
import {mdiLinuxMint} from '@mdi/js'
import {mdiLipstick} from '@mdi/js'
import {mdiLiquidSpot} from '@mdi/js'
import {mdiLiquor} from '@mdi/js'
import {mdiListBox} from '@mdi/js'
import {mdiListBoxOutline} from '@mdi/js'
import {mdiListStatus} from '@mdi/js'
import {mdiLitecoin} from '@mdi/js'
import {mdiLoading} from '@mdi/js'
import {mdiLocationEnter} from '@mdi/js'
import {mdiLocationExit} from '@mdi/js'
import {mdiLock} from '@mdi/js'
import {mdiLockAlert} from '@mdi/js'
import {mdiLockAlertOutline} from '@mdi/js'
import {mdiLockCheck} from '@mdi/js'
import {mdiLockCheckOutline} from '@mdi/js'
import {mdiLockClock} from '@mdi/js'
import {mdiLockMinus} from '@mdi/js'
import {mdiLockMinusOutline} from '@mdi/js'
import {mdiLockOff} from '@mdi/js'
import {mdiLockOffOutline} from '@mdi/js'
import {mdiLockOpen} from '@mdi/js'
import {mdiLockOpenAlert} from '@mdi/js'
import {mdiLockOpenAlertOutline} from '@mdi/js'
import {mdiLockOpenCheck} from '@mdi/js'
import {mdiLockOpenCheckOutline} from '@mdi/js'
import {mdiLockOpenMinus} from '@mdi/js'
import {mdiLockOpenMinusOutline} from '@mdi/js'
import {mdiLockOpenOutline} from '@mdi/js'
import {mdiLockOpenPlus} from '@mdi/js'
import {mdiLockOpenPlusOutline} from '@mdi/js'
import {mdiLockOpenRemove} from '@mdi/js'
import {mdiLockOpenRemoveOutline} from '@mdi/js'
import {mdiLockOpenVariant} from '@mdi/js'
import {mdiLockOpenVariantOutline} from '@mdi/js'
import {mdiLockOutline} from '@mdi/js'
import {mdiLockPattern} from '@mdi/js'
import {mdiLockPlus} from '@mdi/js'
import {mdiLockPlusOutline} from '@mdi/js'
import {mdiLockQuestion} from '@mdi/js'
import {mdiLockRemove} from '@mdi/js'
import {mdiLockRemoveOutline} from '@mdi/js'
import {mdiLockReset} from '@mdi/js'
import {mdiLockSmart} from '@mdi/js'
import {mdiLocker} from '@mdi/js'
import {mdiLockerMultiple} from '@mdi/js'
import {mdiLogin} from '@mdi/js'
import {mdiLoginVariant} from '@mdi/js'
import {mdiLogout} from '@mdi/js'
import {mdiLogoutVariant} from '@mdi/js'
import {mdiLongitude} from '@mdi/js'
import {mdiLooks} from '@mdi/js'
import {mdiLotion} from '@mdi/js'
import {mdiLotionOutline} from '@mdi/js'
import {mdiLotionPlus} from '@mdi/js'
import {mdiLotionPlusOutline} from '@mdi/js'
import {mdiLoupe} from '@mdi/js'
import {mdiLumx} from '@mdi/js'
import {mdiLungs} from '@mdi/js'
import {mdiMace} from '@mdi/js'
import {mdiMagazinePistol} from '@mdi/js'
import {mdiMagazineRifle} from '@mdi/js'
import {mdiMagicStaff} from '@mdi/js'
import {mdiMagnet} from '@mdi/js'
import {mdiMagnetOn} from '@mdi/js'
import {mdiMagnify} from '@mdi/js'
import {mdiMagnifyClose} from '@mdi/js'
import {mdiMagnifyExpand} from '@mdi/js'
import {mdiMagnifyMinus} from '@mdi/js'
import {mdiMagnifyMinusCursor} from '@mdi/js'
import {mdiMagnifyMinusOutline} from '@mdi/js'
import {mdiMagnifyPlus} from '@mdi/js'
import {mdiMagnifyPlusCursor} from '@mdi/js'
import {mdiMagnifyPlusOutline} from '@mdi/js'
import {mdiMagnifyRemoveCursor} from '@mdi/js'
import {mdiMagnifyRemoveOutline} from '@mdi/js'
import {mdiMagnifyScan} from '@mdi/js'
import {mdiMail} from '@mdi/js'
import {mdiMailbox} from '@mdi/js'
import {mdiMailboxOpen} from '@mdi/js'
import {mdiMailboxOpenOutline} from '@mdi/js'
import {mdiMailboxOpenUp} from '@mdi/js'
import {mdiMailboxOpenUpOutline} from '@mdi/js'
import {mdiMailboxOutline} from '@mdi/js'
import {mdiMailboxUp} from '@mdi/js'
import {mdiMailboxUpOutline} from '@mdi/js'
import {mdiManjaro} from '@mdi/js'
import {mdiMap} from '@mdi/js'
import {mdiMapCheck} from '@mdi/js'
import {mdiMapCheckOutline} from '@mdi/js'
import {mdiMapClock} from '@mdi/js'
import {mdiMapClockOutline} from '@mdi/js'
import {mdiMapLegend} from '@mdi/js'
import {mdiMapMarker} from '@mdi/js'
import {mdiMapMarkerAccount} from '@mdi/js'
import {mdiMapMarkerAccountOutline} from '@mdi/js'
import {mdiMapMarkerAlert} from '@mdi/js'
import {mdiMapMarkerAlertOutline} from '@mdi/js'
import {mdiMapMarkerCheck} from '@mdi/js'
import {mdiMapMarkerCheckOutline} from '@mdi/js'
import {mdiMapMarkerCircle} from '@mdi/js'
import {mdiMapMarkerDistance} from '@mdi/js'
import {mdiMapMarkerDown} from '@mdi/js'
import {mdiMapMarkerLeft} from '@mdi/js'
import {mdiMapMarkerLeftOutline} from '@mdi/js'
import {mdiMapMarkerMinus} from '@mdi/js'
import {mdiMapMarkerMinusOutline} from '@mdi/js'
import {mdiMapMarkerMultiple} from '@mdi/js'
import {mdiMapMarkerMultipleOutline} from '@mdi/js'
import {mdiMapMarkerOff} from '@mdi/js'
import {mdiMapMarkerOffOutline} from '@mdi/js'
import {mdiMapMarkerOutline} from '@mdi/js'
import {mdiMapMarkerPath} from '@mdi/js'
import {mdiMapMarkerPlus} from '@mdi/js'
import {mdiMapMarkerPlusOutline} from '@mdi/js'
import {mdiMapMarkerQuestion} from '@mdi/js'
import {mdiMapMarkerQuestionOutline} from '@mdi/js'
import {mdiMapMarkerRadius} from '@mdi/js'
import {mdiMapMarkerRadiusOutline} from '@mdi/js'
import {mdiMapMarkerRemove} from '@mdi/js'
import {mdiMapMarkerRemoveOutline} from '@mdi/js'
import {mdiMapMarkerRemoveVariant} from '@mdi/js'
import {mdiMapMarkerRight} from '@mdi/js'
import {mdiMapMarkerRightOutline} from '@mdi/js'
import {mdiMapMarkerStar} from '@mdi/js'
import {mdiMapMarkerStarOutline} from '@mdi/js'
import {mdiMapMarkerUp} from '@mdi/js'
import {mdiMapMinus} from '@mdi/js'
import {mdiMapOutline} from '@mdi/js'
import {mdiMapPlus} from '@mdi/js'
import {mdiMapSearch} from '@mdi/js'
import {mdiMapSearchOutline} from '@mdi/js'
import {mdiMapbox} from '@mdi/js'
import {mdiMargin} from '@mdi/js'
import {mdiMarker} from '@mdi/js'
import {mdiMarkerCancel} from '@mdi/js'
import {mdiMarkerCheck} from '@mdi/js'
import {mdiMastodon} from '@mdi/js'
import {mdiMaterialDesign} from '@mdi/js'
import {mdiMaterialUi} from '@mdi/js'
import {mdiMathCompass} from '@mdi/js'
import {mdiMathCos} from '@mdi/js'
import {mdiMathIntegral} from '@mdi/js'
import {mdiMathIntegralBox} from '@mdi/js'
import {mdiMathLog} from '@mdi/js'
import {mdiMathNorm} from '@mdi/js'
import {mdiMathNormBox} from '@mdi/js'
import {mdiMathSin} from '@mdi/js'
import {mdiMathTan} from '@mdi/js'
import {mdiMatrix} from '@mdi/js'
import {mdiMedal} from '@mdi/js'
import {mdiMedalOutline} from '@mdi/js'
import {mdiMedicalBag} from '@mdi/js'
import {mdiMedicalCottonSwab} from '@mdi/js'
import {mdiMedication} from '@mdi/js'
import {mdiMedicationOutline} from '@mdi/js'
import {mdiMeditation} from '@mdi/js'
import {mdiMemory} from '@mdi/js'
import {mdiMenorah} from '@mdi/js'
import {mdiMenorahFire} from '@mdi/js'
import {mdiMenu} from '@mdi/js'
import {mdiMenuDown} from '@mdi/js'
import {mdiMenuDownOutline} from '@mdi/js'
import {mdiMenuLeft} from '@mdi/js'
import {mdiMenuLeftOutline} from '@mdi/js'
import {mdiMenuOpen} from '@mdi/js'
import {mdiMenuRight} from '@mdi/js'
import {mdiMenuRightOutline} from '@mdi/js'
import {mdiMenuSwap} from '@mdi/js'
import {mdiMenuSwapOutline} from '@mdi/js'
import {mdiMenuUp} from '@mdi/js'
import {mdiMenuUpOutline} from '@mdi/js'
import {mdiMerge} from '@mdi/js'
import {mdiMessage} from '@mdi/js'
import {mdiMessageAlert} from '@mdi/js'
import {mdiMessageAlertOutline} from '@mdi/js'
import {mdiMessageArrowLeft} from '@mdi/js'
import {mdiMessageArrowLeftOutline} from '@mdi/js'
import {mdiMessageArrowRight} from '@mdi/js'
import {mdiMessageArrowRightOutline} from '@mdi/js'
import {mdiMessageBadge} from '@mdi/js'
import {mdiMessageBadgeOutline} from '@mdi/js'
import {mdiMessageBookmark} from '@mdi/js'
import {mdiMessageBookmarkOutline} from '@mdi/js'
import {mdiMessageBulleted} from '@mdi/js'
import {mdiMessageBulletedOff} from '@mdi/js'
import {mdiMessageCheck} from '@mdi/js'
import {mdiMessageCheckOutline} from '@mdi/js'
import {mdiMessageCog} from '@mdi/js'
import {mdiMessageCogOutline} from '@mdi/js'
import {mdiMessageDraw} from '@mdi/js'
import {mdiMessageFast} from '@mdi/js'
import {mdiMessageFastOutline} from '@mdi/js'
import {mdiMessageFlash} from '@mdi/js'
import {mdiMessageFlashOutline} from '@mdi/js'
import {mdiMessageImage} from '@mdi/js'
import {mdiMessageImageOutline} from '@mdi/js'
import {mdiMessageLock} from '@mdi/js'
import {mdiMessageLockOutline} from '@mdi/js'
import {mdiMessageMinus} from '@mdi/js'
import {mdiMessageMinusOutline} from '@mdi/js'
import {mdiMessageOff} from '@mdi/js'
import {mdiMessageOffOutline} from '@mdi/js'
import {mdiMessageOutline} from '@mdi/js'
import {mdiMessagePlus} from '@mdi/js'
import {mdiMessagePlusOutline} from '@mdi/js'
import {mdiMessageProcessing} from '@mdi/js'
import {mdiMessageProcessingOutline} from '@mdi/js'
import {mdiMessageQuestion} from '@mdi/js'
import {mdiMessageQuestionOutline} from '@mdi/js'
import {mdiMessageReply} from '@mdi/js'
import {mdiMessageReplyOutline} from '@mdi/js'
import {mdiMessageReplyText} from '@mdi/js'
import {mdiMessageReplyTextOutline} from '@mdi/js'
import {mdiMessageSettings} from '@mdi/js'
import {mdiMessageSettingsOutline} from '@mdi/js'
import {mdiMessageStar} from '@mdi/js'
import {mdiMessageStarOutline} from '@mdi/js'
import {mdiMessageText} from '@mdi/js'
import {mdiMessageTextClock} from '@mdi/js'
import {mdiMessageTextClockOutline} from '@mdi/js'
import {mdiMessageTextFast} from '@mdi/js'
import {mdiMessageTextFastOutline} from '@mdi/js'
import {mdiMessageTextLock} from '@mdi/js'
import {mdiMessageTextLockOutline} from '@mdi/js'
import {mdiMessageTextOutline} from '@mdi/js'
import {mdiMessageVideo} from '@mdi/js'
import {mdiMeteor} from '@mdi/js'
import {mdiMeterElectric} from '@mdi/js'
import {mdiMeterElectricOutline} from '@mdi/js'
import {mdiMeterGas} from '@mdi/js'
import {mdiMeterGasOutline} from '@mdi/js'
import {mdiMetronome} from '@mdi/js'
import {mdiMetronomeTick} from '@mdi/js'
import {mdiMicroSd} from '@mdi/js'
import {mdiMicrophone} from '@mdi/js'
import {mdiMicrophoneMessage} from '@mdi/js'
import {mdiMicrophoneMessageOff} from '@mdi/js'
import {mdiMicrophoneMinus} from '@mdi/js'
import {mdiMicrophoneOff} from '@mdi/js'
import {mdiMicrophoneOutline} from '@mdi/js'
import {mdiMicrophonePlus} from '@mdi/js'
import {mdiMicrophoneQuestion} from '@mdi/js'
import {mdiMicrophoneQuestionOutline} from '@mdi/js'
import {mdiMicrophoneSettings} from '@mdi/js'
import {mdiMicrophoneVariant} from '@mdi/js'
import {mdiMicrophoneVariantOff} from '@mdi/js'
import {mdiMicroscope} from '@mdi/js'
import {mdiMicrosoft} from '@mdi/js'
import {mdiMicrosoftAccess} from '@mdi/js'
import {mdiMicrosoftAzure} from '@mdi/js'
import {mdiMicrosoftAzureDevops} from '@mdi/js'
import {mdiMicrosoftBing} from '@mdi/js'
import {mdiMicrosoftDynamics365} from '@mdi/js'
import {mdiMicrosoftEdge} from '@mdi/js'
import {mdiMicrosoftExcel} from '@mdi/js'
import {mdiMicrosoftInternetExplorer} from '@mdi/js'
import {mdiMicrosoftOffice} from '@mdi/js'
import {mdiMicrosoftOnedrive} from '@mdi/js'
import {mdiMicrosoftOnenote} from '@mdi/js'
import {mdiMicrosoftOutlook} from '@mdi/js'
import {mdiMicrosoftPowerpoint} from '@mdi/js'
import {mdiMicrosoftSharepoint} from '@mdi/js'
import {mdiMicrosoftTeams} from '@mdi/js'
import {mdiMicrosoftVisualStudio} from '@mdi/js'
import {mdiMicrosoftVisualStudioCode} from '@mdi/js'
import {mdiMicrosoftWindows} from '@mdi/js'
import {mdiMicrosoftWindowsClassic} from '@mdi/js'
import {mdiMicrosoftWord} from '@mdi/js'
import {mdiMicrosoftXbox} from '@mdi/js'
import {mdiMicrosoftXboxController} from '@mdi/js'
import {mdiMicrosoftXboxControllerBatteryAlert} from '@mdi/js'
import {mdiMicrosoftXboxControllerBatteryCharging} from '@mdi/js'
import {mdiMicrosoftXboxControllerBatteryEmpty} from '@mdi/js'
import {mdiMicrosoftXboxControllerBatteryFull} from '@mdi/js'
import {mdiMicrosoftXboxControllerBatteryLow} from '@mdi/js'
import {mdiMicrosoftXboxControllerBatteryMedium} from '@mdi/js'
import {mdiMicrosoftXboxControllerBatteryUnknown} from '@mdi/js'
import {mdiMicrosoftXboxControllerMenu} from '@mdi/js'
import {mdiMicrosoftXboxControllerOff} from '@mdi/js'
import {mdiMicrosoftXboxControllerView} from '@mdi/js'
import {mdiMicrowave} from '@mdi/js'
import {mdiMicrowaveOff} from '@mdi/js'
import {mdiMiddleware} from '@mdi/js'
import {mdiMiddlewareOutline} from '@mdi/js'
import {mdiMidi} from '@mdi/js'
import {mdiMidiPort} from '@mdi/js'
import {mdiMine} from '@mdi/js'
import {mdiMinecraft} from '@mdi/js'
import {mdiMiniSd} from '@mdi/js'
import {mdiMinidisc} from '@mdi/js'
import {mdiMinus} from '@mdi/js'
import {mdiMinusBox} from '@mdi/js'
import {mdiMinusBoxMultiple} from '@mdi/js'
import {mdiMinusBoxMultipleOutline} from '@mdi/js'
import {mdiMinusBoxOutline} from '@mdi/js'
import {mdiMinusCircle} from '@mdi/js'
import {mdiMinusCircleMultiple} from '@mdi/js'
import {mdiMinusCircleMultipleOutline} from '@mdi/js'
import {mdiMinusCircleOff} from '@mdi/js'
import {mdiMinusCircleOffOutline} from '@mdi/js'
import {mdiMinusCircleOutline} from '@mdi/js'
import {mdiMinusNetwork} from '@mdi/js'
import {mdiMinusNetworkOutline} from '@mdi/js'
import {mdiMinusThick} from '@mdi/js'
import {mdiMirror} from '@mdi/js'
import {mdiMirrorRectangle} from '@mdi/js'
import {mdiMirrorVariant} from '@mdi/js'
import {mdiMixedMartialArts} from '@mdi/js'
import {mdiMixedReality} from '@mdi/js'
import {mdiMolecule} from '@mdi/js'
import {mdiMoleculeCo} from '@mdi/js'
import {mdiMoleculeCo2} from '@mdi/js'
import {mdiMonitor} from '@mdi/js'
import {mdiMonitorAccount} from '@mdi/js'
import {mdiMonitorArrowDown} from '@mdi/js'
import {mdiMonitorArrowDownVariant} from '@mdi/js'
import {mdiMonitorCellphone} from '@mdi/js'
import {mdiMonitorCellphoneStar} from '@mdi/js'
import {mdiMonitorDashboard} from '@mdi/js'
import {mdiMonitorEdit} from '@mdi/js'
import {mdiMonitorEye} from '@mdi/js'
import {mdiMonitorLock} from '@mdi/js'
import {mdiMonitorMultiple} from '@mdi/js'
import {mdiMonitorOff} from '@mdi/js'
import {mdiMonitorScreenshot} from '@mdi/js'
import {mdiMonitorShare} from '@mdi/js'
import {mdiMonitorShimmer} from '@mdi/js'
import {mdiMonitorSmall} from '@mdi/js'
import {mdiMonitorSpeaker} from '@mdi/js'
import {mdiMonitorSpeakerOff} from '@mdi/js'
import {mdiMonitorStar} from '@mdi/js'
import {mdiMoonFirstQuarter} from '@mdi/js'
import {mdiMoonFull} from '@mdi/js'
import {mdiMoonLastQuarter} from '@mdi/js'
import {mdiMoonNew} from '@mdi/js'
import {mdiMoonWaningCrescent} from '@mdi/js'
import {mdiMoonWaningGibbous} from '@mdi/js'
import {mdiMoonWaxingCrescent} from '@mdi/js'
import {mdiMoonWaxingGibbous} from '@mdi/js'
import {mdiMoped} from '@mdi/js'
import {mdiMopedElectric} from '@mdi/js'
import {mdiMopedElectricOutline} from '@mdi/js'
import {mdiMopedOutline} from '@mdi/js'
import {mdiMore} from '@mdi/js'
import {mdiMortarPestle} from '@mdi/js'
import {mdiMortarPestlePlus} from '@mdi/js'
import {mdiMosque} from '@mdi/js'
import {mdiMosqueOutline} from '@mdi/js'
import {mdiMotherHeart} from '@mdi/js'
import {mdiMotherNurse} from '@mdi/js'
import {mdiMotion} from '@mdi/js'
import {mdiMotionOutline} from '@mdi/js'
import {mdiMotionPause} from '@mdi/js'
import {mdiMotionPauseOutline} from '@mdi/js'
import {mdiMotionPlay} from '@mdi/js'
import {mdiMotionPlayOutline} from '@mdi/js'
import {mdiMotionSensor} from '@mdi/js'
import {mdiMotionSensorOff} from '@mdi/js'
import {mdiMotorbike} from '@mdi/js'
import {mdiMotorbikeElectric} from '@mdi/js'
import {mdiMotorbikeOff} from '@mdi/js'
import {mdiMouse} from '@mdi/js'
import {mdiMouseBluetooth} from '@mdi/js'
import {mdiMouseMoveDown} from '@mdi/js'
import {mdiMouseMoveUp} from '@mdi/js'
import {mdiMouseMoveVertical} from '@mdi/js'
import {mdiMouseOff} from '@mdi/js'
import {mdiMouseVariant} from '@mdi/js'
import {mdiMouseVariantOff} from '@mdi/js'
import {mdiMoveResize} from '@mdi/js'
import {mdiMoveResizeVariant} from '@mdi/js'
import {mdiMovie} from '@mdi/js'
import {mdiMovieCheck} from '@mdi/js'
import {mdiMovieCheckOutline} from '@mdi/js'
import {mdiMovieCog} from '@mdi/js'
import {mdiMovieCogOutline} from '@mdi/js'
import {mdiMovieEdit} from '@mdi/js'
import {mdiMovieEditOutline} from '@mdi/js'
import {mdiMovieFilter} from '@mdi/js'
import {mdiMovieFilterOutline} from '@mdi/js'
import {mdiMovieMinus} from '@mdi/js'
import {mdiMovieMinusOutline} from '@mdi/js'
import {mdiMovieOff} from '@mdi/js'
import {mdiMovieOffOutline} from '@mdi/js'
import {mdiMovieOpen} from '@mdi/js'
import {mdiMovieOpenCheck} from '@mdi/js'
import {mdiMovieOpenCheckOutline} from '@mdi/js'
import {mdiMovieOpenCog} from '@mdi/js'
import {mdiMovieOpenCogOutline} from '@mdi/js'
import {mdiMovieOpenEdit} from '@mdi/js'
import {mdiMovieOpenEditOutline} from '@mdi/js'
import {mdiMovieOpenMinus} from '@mdi/js'
import {mdiMovieOpenMinusOutline} from '@mdi/js'
import {mdiMovieOpenOff} from '@mdi/js'
import {mdiMovieOpenOffOutline} from '@mdi/js'
import {mdiMovieOpenOutline} from '@mdi/js'
import {mdiMovieOpenPlay} from '@mdi/js'
import {mdiMovieOpenPlayOutline} from '@mdi/js'
import {mdiMovieOpenPlus} from '@mdi/js'
import {mdiMovieOpenPlusOutline} from '@mdi/js'
import {mdiMovieOpenRemove} from '@mdi/js'
import {mdiMovieOpenRemoveOutline} from '@mdi/js'
import {mdiMovieOpenSettings} from '@mdi/js'
import {mdiMovieOpenSettingsOutline} from '@mdi/js'
import {mdiMovieOpenStar} from '@mdi/js'
import {mdiMovieOpenStarOutline} from '@mdi/js'
import {mdiMovieOutline} from '@mdi/js'
import {mdiMoviePlay} from '@mdi/js'
import {mdiMoviePlayOutline} from '@mdi/js'
import {mdiMoviePlus} from '@mdi/js'
import {mdiMoviePlusOutline} from '@mdi/js'
import {mdiMovieRemove} from '@mdi/js'
import {mdiMovieRemoveOutline} from '@mdi/js'
import {mdiMovieRoll} from '@mdi/js'
import {mdiMovieSearch} from '@mdi/js'
import {mdiMovieSearchOutline} from '@mdi/js'
import {mdiMovieSettings} from '@mdi/js'
import {mdiMovieSettingsOutline} from '@mdi/js'
import {mdiMovieStar} from '@mdi/js'
import {mdiMovieStarOutline} from '@mdi/js'
import {mdiMower} from '@mdi/js'
import {mdiMowerBag} from '@mdi/js'
import {mdiMowerBagOn} from '@mdi/js'
import {mdiMowerOn} from '@mdi/js'
import {mdiMuffin} from '@mdi/js'
import {mdiMulticast} from '@mdi/js'
import {mdiMultimedia} from '@mdi/js'
import {mdiMultiplication} from '@mdi/js'
import {mdiMultiplicationBox} from '@mdi/js'
import {mdiMushroom} from '@mdi/js'
import {mdiMushroomOff} from '@mdi/js'
import {mdiMushroomOffOutline} from '@mdi/js'
import {mdiMushroomOutline} from '@mdi/js'
import {mdiMusic} from '@mdi/js'
import {mdiMusicAccidentalDoubleFlat} from '@mdi/js'
import {mdiMusicAccidentalDoubleSharp} from '@mdi/js'
import {mdiMusicAccidentalFlat} from '@mdi/js'
import {mdiMusicAccidentalNatural} from '@mdi/js'
import {mdiMusicAccidentalSharp} from '@mdi/js'
import {mdiMusicBox} from '@mdi/js'
import {mdiMusicBoxMultiple} from '@mdi/js'
import {mdiMusicBoxMultipleOutline} from '@mdi/js'
import {mdiMusicBoxOutline} from '@mdi/js'
import {mdiMusicCircle} from '@mdi/js'
import {mdiMusicCircleOutline} from '@mdi/js'
import {mdiMusicClefAlto} from '@mdi/js'
import {mdiMusicClefBass} from '@mdi/js'
import {mdiMusicClefTreble} from '@mdi/js'
import {mdiMusicNote} from '@mdi/js'
import {mdiMusicNoteBluetooth} from '@mdi/js'
import {mdiMusicNoteBluetoothOff} from '@mdi/js'
import {mdiMusicNoteEighth} from '@mdi/js'
import {mdiMusicNoteEighthDotted} from '@mdi/js'
import {mdiMusicNoteHalf} from '@mdi/js'
import {mdiMusicNoteHalfDotted} from '@mdi/js'
import {mdiMusicNoteMinus} from '@mdi/js'
import {mdiMusicNoteOff} from '@mdi/js'
import {mdiMusicNoteOffOutline} from '@mdi/js'
import {mdiMusicNoteOutline} from '@mdi/js'
import {mdiMusicNotePlus} from '@mdi/js'
import {mdiMusicNoteQuarter} from '@mdi/js'
import {mdiMusicNoteQuarterDotted} from '@mdi/js'
import {mdiMusicNoteSixteenth} from '@mdi/js'
import {mdiMusicNoteSixteenthDotted} from '@mdi/js'
import {mdiMusicNoteWhole} from '@mdi/js'
import {mdiMusicNoteWholeDotted} from '@mdi/js'
import {mdiMusicOff} from '@mdi/js'
import {mdiMusicRestEighth} from '@mdi/js'
import {mdiMusicRestHalf} from '@mdi/js'
import {mdiMusicRestQuarter} from '@mdi/js'
import {mdiMusicRestSixteenth} from '@mdi/js'
import {mdiMusicRestWhole} from '@mdi/js'
import {mdiMustache} from '@mdi/js'
import {mdiNail} from '@mdi/js'
import {mdiNas} from '@mdi/js'
import {mdiNativescript} from '@mdi/js'
import {mdiNature} from '@mdi/js'
import {mdiNaturePeople} from '@mdi/js'
import {mdiNavigation} from '@mdi/js'
import {mdiNavigationOutline} from '@mdi/js'
import {mdiNavigationVariant} from '@mdi/js'
import {mdiNavigationVariantOutline} from '@mdi/js'
import {mdiNearMe} from '@mdi/js'
import {mdiNecklace} from '@mdi/js'
import {mdiNeedle} from '@mdi/js'
import {mdiNeedleOff} from '@mdi/js'
import {mdiNetflix} from '@mdi/js'
import {mdiNetwork} from '@mdi/js'
import {mdiNetworkOff} from '@mdi/js'
import {mdiNetworkOffOutline} from '@mdi/js'
import {mdiNetworkOutline} from '@mdi/js'
import {mdiNetworkPos} from '@mdi/js'
import {mdiNetworkStrength1} from '@mdi/js'
import {mdiNetworkStrength1Alert} from '@mdi/js'
import {mdiNetworkStrength2} from '@mdi/js'
import {mdiNetworkStrength2Alert} from '@mdi/js'
import {mdiNetworkStrength3} from '@mdi/js'
import {mdiNetworkStrength3Alert} from '@mdi/js'
import {mdiNetworkStrength4} from '@mdi/js'
import {mdiNetworkStrength4Alert} from '@mdi/js'
import {mdiNetworkStrength4Cog} from '@mdi/js'
import {mdiNetworkStrengthOff} from '@mdi/js'
import {mdiNetworkStrengthOffOutline} from '@mdi/js'
import {mdiNetworkStrengthOutline} from '@mdi/js'
import {mdiNewBox} from '@mdi/js'
import {mdiNewspaper} from '@mdi/js'
import {mdiNewspaperCheck} from '@mdi/js'
import {mdiNewspaperMinus} from '@mdi/js'
import {mdiNewspaperPlus} from '@mdi/js'
import {mdiNewspaperRemove} from '@mdi/js'
import {mdiNewspaperVariant} from '@mdi/js'
import {mdiNewspaperVariantMultiple} from '@mdi/js'
import {mdiNewspaperVariantMultipleOutline} from '@mdi/js'
import {mdiNewspaperVariantOutline} from '@mdi/js'
import {mdiNfc} from '@mdi/js'
import {mdiNfcSearchVariant} from '@mdi/js'
import {mdiNfcTap} from '@mdi/js'
import {mdiNfcVariant} from '@mdi/js'
import {mdiNfcVariantOff} from '@mdi/js'
import {mdiNinja} from '@mdi/js'
import {mdiNintendoGameBoy} from '@mdi/js'
import {mdiNintendoSwitch} from '@mdi/js'
import {mdiNintendoWii} from '@mdi/js'
import {mdiNintendoWiiu} from '@mdi/js'
import {mdiNix} from '@mdi/js'
import {mdiNodejs} from '@mdi/js'
import {mdiNoodles} from '@mdi/js'
import {mdiNotEqual} from '@mdi/js'
import {mdiNotEqualVariant} from '@mdi/js'
import {mdiNote} from '@mdi/js'
import {mdiNoteAlert} from '@mdi/js'
import {mdiNoteAlertOutline} from '@mdi/js'
import {mdiNoteCheck} from '@mdi/js'
import {mdiNoteCheckOutline} from '@mdi/js'
import {mdiNoteEdit} from '@mdi/js'
import {mdiNoteEditOutline} from '@mdi/js'
import {mdiNoteMinus} from '@mdi/js'
import {mdiNoteMinusOutline} from '@mdi/js'
import {mdiNoteMultiple} from '@mdi/js'
import {mdiNoteMultipleOutline} from '@mdi/js'
import {mdiNoteOff} from '@mdi/js'
import {mdiNoteOffOutline} from '@mdi/js'
import {mdiNoteOutline} from '@mdi/js'
import {mdiNotePlus} from '@mdi/js'
import {mdiNotePlusOutline} from '@mdi/js'
import {mdiNoteRemove} from '@mdi/js'
import {mdiNoteRemoveOutline} from '@mdi/js'
import {mdiNoteSearch} from '@mdi/js'
import {mdiNoteSearchOutline} from '@mdi/js'
import {mdiNoteText} from '@mdi/js'
import {mdiNoteTextOutline} from '@mdi/js'
import {mdiNotebook} from '@mdi/js'
import {mdiNotebookCheck} from '@mdi/js'
import {mdiNotebookCheckOutline} from '@mdi/js'
import {mdiNotebookEdit} from '@mdi/js'
import {mdiNotebookEditOutline} from '@mdi/js'
import {mdiNotebookHeart} from '@mdi/js'
import {mdiNotebookHeartOutline} from '@mdi/js'
import {mdiNotebookMinus} from '@mdi/js'
import {mdiNotebookMinusOutline} from '@mdi/js'
import {mdiNotebookMultiple} from '@mdi/js'
import {mdiNotebookOutline} from '@mdi/js'
import {mdiNotebookPlus} from '@mdi/js'
import {mdiNotebookPlusOutline} from '@mdi/js'
import {mdiNotebookRemove} from '@mdi/js'
import {mdiNotebookRemoveOutline} from '@mdi/js'
import {mdiNotificationClearAll} from '@mdi/js'
import {mdiNpm} from '@mdi/js'
import {mdiNuke} from '@mdi/js'
import {mdiNull} from '@mdi/js'
import {mdiNumeric} from '@mdi/js'
import {mdiNumeric0} from '@mdi/js'
import {mdiNumeric0Box} from '@mdi/js'
import {mdiNumeric0BoxMultiple} from '@mdi/js'
import {mdiNumeric0BoxMultipleOutline} from '@mdi/js'
import {mdiNumeric0BoxOutline} from '@mdi/js'
import {mdiNumeric0Circle} from '@mdi/js'
import {mdiNumeric0CircleOutline} from '@mdi/js'
import {mdiNumeric1} from '@mdi/js'
import {mdiNumeric1Box} from '@mdi/js'
import {mdiNumeric1BoxMultiple} from '@mdi/js'
import {mdiNumeric1BoxMultipleOutline} from '@mdi/js'
import {mdiNumeric1BoxOutline} from '@mdi/js'
import {mdiNumeric1Circle} from '@mdi/js'
import {mdiNumeric1CircleOutline} from '@mdi/js'
import {mdiNumeric10} from '@mdi/js'
import {mdiNumeric10Box} from '@mdi/js'
import {mdiNumeric10BoxMultiple} from '@mdi/js'
import {mdiNumeric10BoxMultipleOutline} from '@mdi/js'
import {mdiNumeric10BoxOutline} from '@mdi/js'
import {mdiNumeric10Circle} from '@mdi/js'
import {mdiNumeric10CircleOutline} from '@mdi/js'
import {mdiNumeric2} from '@mdi/js'
import {mdiNumeric2Box} from '@mdi/js'
import {mdiNumeric2BoxMultiple} from '@mdi/js'
import {mdiNumeric2BoxMultipleOutline} from '@mdi/js'
import {mdiNumeric2BoxOutline} from '@mdi/js'
import {mdiNumeric2Circle} from '@mdi/js'
import {mdiNumeric2CircleOutline} from '@mdi/js'
import {mdiNumeric3} from '@mdi/js'
import {mdiNumeric3Box} from '@mdi/js'
import {mdiNumeric3BoxMultiple} from '@mdi/js'
import {mdiNumeric3BoxMultipleOutline} from '@mdi/js'
import {mdiNumeric3BoxOutline} from '@mdi/js'
import {mdiNumeric3Circle} from '@mdi/js'
import {mdiNumeric3CircleOutline} from '@mdi/js'
import {mdiNumeric4} from '@mdi/js'
import {mdiNumeric4Box} from '@mdi/js'
import {mdiNumeric4BoxMultiple} from '@mdi/js'
import {mdiNumeric4BoxMultipleOutline} from '@mdi/js'
import {mdiNumeric4BoxOutline} from '@mdi/js'
import {mdiNumeric4Circle} from '@mdi/js'
import {mdiNumeric4CircleOutline} from '@mdi/js'
import {mdiNumeric5} from '@mdi/js'
import {mdiNumeric5Box} from '@mdi/js'
import {mdiNumeric5BoxMultiple} from '@mdi/js'
import {mdiNumeric5BoxMultipleOutline} from '@mdi/js'
import {mdiNumeric5BoxOutline} from '@mdi/js'
import {mdiNumeric5Circle} from '@mdi/js'
import {mdiNumeric5CircleOutline} from '@mdi/js'
import {mdiNumeric6} from '@mdi/js'
import {mdiNumeric6Box} from '@mdi/js'
import {mdiNumeric6BoxMultiple} from '@mdi/js'
import {mdiNumeric6BoxMultipleOutline} from '@mdi/js'
import {mdiNumeric6BoxOutline} from '@mdi/js'
import {mdiNumeric6Circle} from '@mdi/js'
import {mdiNumeric6CircleOutline} from '@mdi/js'
import {mdiNumeric7} from '@mdi/js'
import {mdiNumeric7Box} from '@mdi/js'
import {mdiNumeric7BoxMultiple} from '@mdi/js'
import {mdiNumeric7BoxMultipleOutline} from '@mdi/js'
import {mdiNumeric7BoxOutline} from '@mdi/js'
import {mdiNumeric7Circle} from '@mdi/js'
import {mdiNumeric7CircleOutline} from '@mdi/js'
import {mdiNumeric8} from '@mdi/js'
import {mdiNumeric8Box} from '@mdi/js'
import {mdiNumeric8BoxMultiple} from '@mdi/js'
import {mdiNumeric8BoxMultipleOutline} from '@mdi/js'
import {mdiNumeric8BoxOutline} from '@mdi/js'
import {mdiNumeric8Circle} from '@mdi/js'
import {mdiNumeric8CircleOutline} from '@mdi/js'
import {mdiNumeric9} from '@mdi/js'
import {mdiNumeric9Box} from '@mdi/js'
import {mdiNumeric9BoxMultiple} from '@mdi/js'
import {mdiNumeric9BoxMultipleOutline} from '@mdi/js'
import {mdiNumeric9BoxOutline} from '@mdi/js'
import {mdiNumeric9Circle} from '@mdi/js'
import {mdiNumeric9CircleOutline} from '@mdi/js'
import {mdiNumeric9Plus} from '@mdi/js'
import {mdiNumeric9PlusBox} from '@mdi/js'
import {mdiNumeric9PlusBoxMultiple} from '@mdi/js'
import {mdiNumeric9PlusBoxMultipleOutline} from '@mdi/js'
import {mdiNumeric9PlusBoxOutline} from '@mdi/js'
import {mdiNumeric9PlusCircle} from '@mdi/js'
import {mdiNumeric9PlusCircleOutline} from '@mdi/js'
import {mdiNumericNegative1} from '@mdi/js'
import {mdiNumericOff} from '@mdi/js'
import {mdiNumericPositive1} from '@mdi/js'
import {mdiNut} from '@mdi/js'
import {mdiNutrition} from '@mdi/js'
import {mdiNuxt} from '@mdi/js'
import {mdiOar} from '@mdi/js'
import {mdiOcarina} from '@mdi/js'
import {mdiOci} from '@mdi/js'
import {mdiOcr} from '@mdi/js'
import {mdiOctagon} from '@mdi/js'
import {mdiOctagonOutline} from '@mdi/js'
import {mdiOctagram} from '@mdi/js'
import {mdiOctagramOutline} from '@mdi/js'
import {mdiOctahedron} from '@mdi/js'
import {mdiOctahedronOff} from '@mdi/js'
import {mdiOdnoklassniki} from '@mdi/js'
import {mdiOffer} from '@mdi/js'
import {mdiOfficeBuilding} from '@mdi/js'
import {mdiOfficeBuildingCog} from '@mdi/js'
import {mdiOfficeBuildingCogOutline} from '@mdi/js'
import {mdiOfficeBuildingMarker} from '@mdi/js'
import {mdiOfficeBuildingMarkerOutline} from '@mdi/js'
import {mdiOfficeBuildingMinus} from '@mdi/js'
import {mdiOfficeBuildingMinusOutline} from '@mdi/js'
import {mdiOfficeBuildingOutline} from '@mdi/js'
import {mdiOfficeBuildingPlus} from '@mdi/js'
import {mdiOfficeBuildingPlusOutline} from '@mdi/js'
import {mdiOfficeBuildingRemove} from '@mdi/js'
import {mdiOfficeBuildingRemoveOutline} from '@mdi/js'
import {mdiOil} from '@mdi/js'
import {mdiOilLamp} from '@mdi/js'
import {mdiOilLevel} from '@mdi/js'
import {mdiOilTemperature} from '@mdi/js'
import {mdiOm} from '@mdi/js'
import {mdiOmega} from '@mdi/js'
import {mdiOneUp} from '@mdi/js'
import {mdiOnepassword} from '@mdi/js'
import {mdiOpacity} from '@mdi/js'
import {mdiOpenInApp} from '@mdi/js'
import {mdiOpenInNew} from '@mdi/js'
import {mdiOpenSourceInitiative} from '@mdi/js'
import {mdiOpenid} from '@mdi/js'
import {mdiOpera} from '@mdi/js'
import {mdiOrbit} from '@mdi/js'
import {mdiOrbitVariant} from '@mdi/js'
import {mdiOrderAlphabeticalAscending} from '@mdi/js'
import {mdiOrderAlphabeticalDescending} from '@mdi/js'
import {mdiOrderBoolAscending} from '@mdi/js'
import {mdiOrderBoolAscendingVariant} from '@mdi/js'
import {mdiOrderBoolDescending} from '@mdi/js'
import {mdiOrderBoolDescendingVariant} from '@mdi/js'
import {mdiOrderNumericAscending} from '@mdi/js'
import {mdiOrderNumericDescending} from '@mdi/js'
import {mdiOrigin} from '@mdi/js'
import {mdiOrnament} from '@mdi/js'
import {mdiOrnamentVariant} from '@mdi/js'
import {mdiOutdoorLamp} from '@mdi/js'
import {mdiOverscan} from '@mdi/js'
import {mdiOwl} from '@mdi/js'
import {mdiPacMan} from '@mdi/js'
import {mdiPackage} from '@mdi/js'
import {mdiPackageCheck} from '@mdi/js'
import {mdiPackageDown} from '@mdi/js'
import {mdiPackageUp} from '@mdi/js'
import {mdiPackageVariant} from '@mdi/js'
import {mdiPackageVariantClosed} from '@mdi/js'
import {mdiPackageVariantClosedCheck} from '@mdi/js'
import {mdiPackageVariantClosedMinus} from '@mdi/js'
import {mdiPackageVariantClosedPlus} from '@mdi/js'
import {mdiPackageVariantClosedRemove} from '@mdi/js'
import {mdiPackageVariantMinus} from '@mdi/js'
import {mdiPackageVariantPlus} from '@mdi/js'
import {mdiPackageVariantRemove} from '@mdi/js'
import {mdiPageFirst} from '@mdi/js'
import {mdiPageLast} from '@mdi/js'
import {mdiPageLayoutBody} from '@mdi/js'
import {mdiPageLayoutFooter} from '@mdi/js'
import {mdiPageLayoutHeader} from '@mdi/js'
import {mdiPageLayoutHeaderFooter} from '@mdi/js'
import {mdiPageLayoutSidebarLeft} from '@mdi/js'
import {mdiPageLayoutSidebarRight} from '@mdi/js'
import {mdiPageNext} from '@mdi/js'
import {mdiPageNextOutline} from '@mdi/js'
import {mdiPagePrevious} from '@mdi/js'
import {mdiPagePreviousOutline} from '@mdi/js'
import {mdiPail} from '@mdi/js'
import {mdiPailMinus} from '@mdi/js'
import {mdiPailMinusOutline} from '@mdi/js'
import {mdiPailOff} from '@mdi/js'
import {mdiPailOffOutline} from '@mdi/js'
import {mdiPailOutline} from '@mdi/js'
import {mdiPailPlus} from '@mdi/js'
import {mdiPailPlusOutline} from '@mdi/js'
import {mdiPailRemove} from '@mdi/js'
import {mdiPailRemoveOutline} from '@mdi/js'
import {mdiPalette} from '@mdi/js'
import {mdiPaletteAdvanced} from '@mdi/js'
import {mdiPaletteOutline} from '@mdi/js'
import {mdiPaletteSwatch} from '@mdi/js'
import {mdiPaletteSwatchOutline} from '@mdi/js'
import {mdiPaletteSwatchVariant} from '@mdi/js'
import {mdiPalmTree} from '@mdi/js'
import {mdiPan} from '@mdi/js'
import {mdiPanBottomLeft} from '@mdi/js'
import {mdiPanBottomRight} from '@mdi/js'
import {mdiPanDown} from '@mdi/js'
import {mdiPanHorizontal} from '@mdi/js'
import {mdiPanLeft} from '@mdi/js'
import {mdiPanRight} from '@mdi/js'
import {mdiPanTopLeft} from '@mdi/js'
import {mdiPanTopRight} from '@mdi/js'
import {mdiPanUp} from '@mdi/js'
import {mdiPanVertical} from '@mdi/js'
import {mdiPanda} from '@mdi/js'
import {mdiPandora} from '@mdi/js'
import {mdiPanorama} from '@mdi/js'
import {mdiPanoramaFisheye} from '@mdi/js'
import {mdiPanoramaHorizontal} from '@mdi/js'
import {mdiPanoramaHorizontalOutline} from '@mdi/js'
import {mdiPanoramaOutline} from '@mdi/js'
import {mdiPanoramaSphere} from '@mdi/js'
import {mdiPanoramaSphereOutline} from '@mdi/js'
import {mdiPanoramaVariant} from '@mdi/js'
import {mdiPanoramaVariantOutline} from '@mdi/js'
import {mdiPanoramaVertical} from '@mdi/js'
import {mdiPanoramaVerticalOutline} from '@mdi/js'
import {mdiPanoramaWideAngle} from '@mdi/js'
import {mdiPanoramaWideAngleOutline} from '@mdi/js'
import {mdiPaperCutVertical} from '@mdi/js'
import {mdiPaperRoll} from '@mdi/js'
import {mdiPaperRollOutline} from '@mdi/js'
import {mdiPaperclip} from '@mdi/js'
import {mdiPaperclipCheck} from '@mdi/js'
import {mdiPaperclipLock} from '@mdi/js'
import {mdiPaperclipMinus} from '@mdi/js'
import {mdiPaperclipOff} from '@mdi/js'
import {mdiPaperclipPlus} from '@mdi/js'
import {mdiPaperclipRemove} from '@mdi/js'
import {mdiParachute} from '@mdi/js'
import {mdiParachuteOutline} from '@mdi/js'
import {mdiParagliding} from '@mdi/js'
import {mdiParking} from '@mdi/js'
import {mdiPartyPopper} from '@mdi/js'
import {mdiPassport} from '@mdi/js'
import {mdiPassportBiometric} from '@mdi/js'
import {mdiPasta} from '@mdi/js'
import {mdiPatioHeater} from '@mdi/js'
import {mdiPatreon} from '@mdi/js'
import {mdiPause} from '@mdi/js'
import {mdiPauseBox} from '@mdi/js'
import {mdiPauseBoxOutline} from '@mdi/js'
import {mdiPauseCircle} from '@mdi/js'
import {mdiPauseCircleOutline} from '@mdi/js'
import {mdiPauseOctagon} from '@mdi/js'
import {mdiPauseOctagonOutline} from '@mdi/js'
import {mdiPaw} from '@mdi/js'
import {mdiPawOff} from '@mdi/js'
import {mdiPawOffOutline} from '@mdi/js'
import {mdiPawOutline} from '@mdi/js'
import {mdiPeace} from '@mdi/js'
import {mdiPeanut} from '@mdi/js'
import {mdiPeanutOff} from '@mdi/js'
import {mdiPeanutOffOutline} from '@mdi/js'
import {mdiPeanutOutline} from '@mdi/js'
import {mdiPen} from '@mdi/js'
import {mdiPenLock} from '@mdi/js'
import {mdiPenMinus} from '@mdi/js'
import {mdiPenOff} from '@mdi/js'
import {mdiPenPlus} from '@mdi/js'
import {mdiPenRemove} from '@mdi/js'
import {mdiPencil} from '@mdi/js'
import {mdiPencilBox} from '@mdi/js'
import {mdiPencilBoxMultiple} from '@mdi/js'
import {mdiPencilBoxMultipleOutline} from '@mdi/js'
import {mdiPencilBoxOutline} from '@mdi/js'
import {mdiPencilCircle} from '@mdi/js'
import {mdiPencilCircleOutline} from '@mdi/js'
import {mdiPencilLock} from '@mdi/js'
import {mdiPencilLockOutline} from '@mdi/js'
import {mdiPencilMinus} from '@mdi/js'
import {mdiPencilMinusOutline} from '@mdi/js'
import {mdiPencilOff} from '@mdi/js'
import {mdiPencilOffOutline} from '@mdi/js'
import {mdiPencilOutline} from '@mdi/js'
import {mdiPencilPlus} from '@mdi/js'
import {mdiPencilPlusOutline} from '@mdi/js'
import {mdiPencilRemove} from '@mdi/js'
import {mdiPencilRemoveOutline} from '@mdi/js'
import {mdiPencilRuler} from '@mdi/js'
import {mdiPenguin} from '@mdi/js'
import {mdiPentagon} from '@mdi/js'
import {mdiPentagonOutline} from '@mdi/js'
import {mdiPentagram} from '@mdi/js'
import {mdiPercent} from '@mdi/js'
import {mdiPercentBox} from '@mdi/js'
import {mdiPercentBoxOutline} from '@mdi/js'
import {mdiPercentCircle} from '@mdi/js'
import {mdiPercentCircleOutline} from '@mdi/js'
import {mdiPercentOutline} from '@mdi/js'
import {mdiPeriodicTable} from '@mdi/js'
import {mdiPerspectiveLess} from '@mdi/js'
import {mdiPerspectiveMore} from '@mdi/js'
import {mdiPh} from '@mdi/js'
import {mdiPhone} from '@mdi/js'
import {mdiPhoneAlert} from '@mdi/js'
import {mdiPhoneAlertOutline} from '@mdi/js'
import {mdiPhoneBluetooth} from '@mdi/js'
import {mdiPhoneBluetoothOutline} from '@mdi/js'
import {mdiPhoneCancel} from '@mdi/js'
import {mdiPhoneCancelOutline} from '@mdi/js'
import {mdiPhoneCheck} from '@mdi/js'
import {mdiPhoneCheckOutline} from '@mdi/js'
import {mdiPhoneClassic} from '@mdi/js'
import {mdiPhoneClassicOff} from '@mdi/js'
import {mdiPhoneClock} from '@mdi/js'
import {mdiPhoneDial} from '@mdi/js'
import {mdiPhoneDialOutline} from '@mdi/js'
import {mdiPhoneForward} from '@mdi/js'
import {mdiPhoneForwardOutline} from '@mdi/js'
import {mdiPhoneHangup} from '@mdi/js'
import {mdiPhoneHangupOutline} from '@mdi/js'
import {mdiPhoneInTalk} from '@mdi/js'
import {mdiPhoneInTalkOutline} from '@mdi/js'
import {mdiPhoneIncoming} from '@mdi/js'
import {mdiPhoneIncomingOutgoing} from '@mdi/js'
import {mdiPhoneIncomingOutgoingOutline} from '@mdi/js'
import {mdiPhoneIncomingOutline} from '@mdi/js'
import {mdiPhoneLock} from '@mdi/js'
import {mdiPhoneLockOutline} from '@mdi/js'
import {mdiPhoneLog} from '@mdi/js'
import {mdiPhoneLogOutline} from '@mdi/js'
import {mdiPhoneMessage} from '@mdi/js'
import {mdiPhoneMessageOutline} from '@mdi/js'
import {mdiPhoneMinus} from '@mdi/js'
import {mdiPhoneMinusOutline} from '@mdi/js'
import {mdiPhoneMissed} from '@mdi/js'
import {mdiPhoneMissedOutline} from '@mdi/js'
import {mdiPhoneOff} from '@mdi/js'
import {mdiPhoneOffOutline} from '@mdi/js'
import {mdiPhoneOutgoing} from '@mdi/js'
import {mdiPhoneOutgoingOutline} from '@mdi/js'
import {mdiPhoneOutline} from '@mdi/js'
import {mdiPhonePaused} from '@mdi/js'
import {mdiPhonePausedOutline} from '@mdi/js'
import {mdiPhonePlus} from '@mdi/js'
import {mdiPhonePlusOutline} from '@mdi/js'
import {mdiPhoneRefresh} from '@mdi/js'
import {mdiPhoneRefreshOutline} from '@mdi/js'
import {mdiPhoneRemove} from '@mdi/js'
import {mdiPhoneRemoveOutline} from '@mdi/js'
import {mdiPhoneReturn} from '@mdi/js'
import {mdiPhoneReturnOutline} from '@mdi/js'
import {mdiPhoneRing} from '@mdi/js'
import {mdiPhoneRingOutline} from '@mdi/js'
import {mdiPhoneRotateLandscape} from '@mdi/js'
import {mdiPhoneRotatePortrait} from '@mdi/js'
import {mdiPhoneSettings} from '@mdi/js'
import {mdiPhoneSettingsOutline} from '@mdi/js'
import {mdiPhoneSync} from '@mdi/js'
import {mdiPhoneSyncOutline} from '@mdi/js'
import {mdiPhoneVoip} from '@mdi/js'
import {mdiPi} from '@mdi/js'
import {mdiPiBox} from '@mdi/js'
import {mdiPiHole} from '@mdi/js'
import {mdiPiano} from '@mdi/js'
import {mdiPianoOff} from '@mdi/js'
import {mdiPickaxe} from '@mdi/js'
import {mdiPictureInPictureBottomRight} from '@mdi/js'
import {mdiPictureInPictureBottomRightOutline} from '@mdi/js'
import {mdiPictureInPictureTopRight} from '@mdi/js'
import {mdiPictureInPictureTopRightOutline} from '@mdi/js'
import {mdiPier} from '@mdi/js'
import {mdiPierCrane} from '@mdi/js'
import {mdiPig} from '@mdi/js'
import {mdiPigVariant} from '@mdi/js'
import {mdiPigVariantOutline} from '@mdi/js'
import {mdiPiggyBank} from '@mdi/js'
import {mdiPiggyBankOutline} from '@mdi/js'
import {mdiPill} from '@mdi/js'
import {mdiPillMultiple} from '@mdi/js'
import {mdiPillOff} from '@mdi/js'
import {mdiPillar} from '@mdi/js'
import {mdiPin} from '@mdi/js'
import {mdiPinOff} from '@mdi/js'
import {mdiPinOffOutline} from '@mdi/js'
import {mdiPinOutline} from '@mdi/js'
import {mdiPineTree} from '@mdi/js'
import {mdiPineTreeBox} from '@mdi/js'
import {mdiPineTreeFire} from '@mdi/js'
import {mdiPinterest} from '@mdi/js'
import {mdiPinwheel} from '@mdi/js'
import {mdiPinwheelOutline} from '@mdi/js'
import {mdiPipe} from '@mdi/js'
import {mdiPipeDisconnected} from '@mdi/js'
import {mdiPipeLeak} from '@mdi/js'
import {mdiPipeValve} from '@mdi/js'
import {mdiPipeWrench} from '@mdi/js'
import {mdiPirate} from '@mdi/js'
import {mdiPistol} from '@mdi/js'
import {mdiPiston} from '@mdi/js'
import {mdiPitchfork} from '@mdi/js'
import {mdiPizza} from '@mdi/js'
import {mdiPlaneCar} from '@mdi/js'
import {mdiPlaneTrain} from '@mdi/js'
import {mdiPlay} from '@mdi/js'
import {mdiPlayBox} from '@mdi/js'
import {mdiPlayBoxLock} from '@mdi/js'
import {mdiPlayBoxLockOpen} from '@mdi/js'
import {mdiPlayBoxLockOpenOutline} from '@mdi/js'
import {mdiPlayBoxLockOutline} from '@mdi/js'
import {mdiPlayBoxMultiple} from '@mdi/js'
import {mdiPlayBoxMultipleOutline} from '@mdi/js'
import {mdiPlayBoxOutline} from '@mdi/js'
import {mdiPlayCircle} from '@mdi/js'
import {mdiPlayCircleOutline} from '@mdi/js'
import {mdiPlayNetwork} from '@mdi/js'
import {mdiPlayNetworkOutline} from '@mdi/js'
import {mdiPlayOutline} from '@mdi/js'
import {mdiPlayPause} from '@mdi/js'
import {mdiPlayProtectedContent} from '@mdi/js'
import {mdiPlaySpeed} from '@mdi/js'
import {mdiPlaylistCheck} from '@mdi/js'
import {mdiPlaylistEdit} from '@mdi/js'
import {mdiPlaylistMinus} from '@mdi/js'
import {mdiPlaylistMusic} from '@mdi/js'
import {mdiPlaylistMusicOutline} from '@mdi/js'
import {mdiPlaylistPlay} from '@mdi/js'
import {mdiPlaylistPlus} from '@mdi/js'
import {mdiPlaylistRemove} from '@mdi/js'
import {mdiPlaylistStar} from '@mdi/js'
import {mdiPlex} from '@mdi/js'
import {mdiPliers} from '@mdi/js'
import {mdiPlus} from '@mdi/js'
import {mdiPlusBox} from '@mdi/js'
import {mdiPlusBoxMultiple} from '@mdi/js'
import {mdiPlusBoxMultipleOutline} from '@mdi/js'
import {mdiPlusBoxOutline} from '@mdi/js'
import {mdiPlusCircle} from '@mdi/js'
import {mdiPlusCircleMultiple} from '@mdi/js'
import {mdiPlusCircleMultipleOutline} from '@mdi/js'
import {mdiPlusCircleOutline} from '@mdi/js'
import {mdiPlusLock} from '@mdi/js'
import {mdiPlusLockOpen} from '@mdi/js'
import {mdiPlusMinus} from '@mdi/js'
import {mdiPlusMinusBox} from '@mdi/js'
import {mdiPlusMinusVariant} from '@mdi/js'
import {mdiPlusNetwork} from '@mdi/js'
import {mdiPlusNetworkOutline} from '@mdi/js'
import {mdiPlusOutline} from '@mdi/js'
import {mdiPlusThick} from '@mdi/js'
import {mdiPodcast} from '@mdi/js'
import {mdiPodium} from '@mdi/js'
import {mdiPodiumBronze} from '@mdi/js'
import {mdiPodiumGold} from '@mdi/js'
import {mdiPodiumSilver} from '@mdi/js'
import {mdiPointOfSale} from '@mdi/js'
import {mdiPokeball} from '@mdi/js'
import {mdiPokemonGo} from '@mdi/js'
import {mdiPokerChip} from '@mdi/js'
import {mdiPolaroid} from '@mdi/js'
import {mdiPoliceBadge} from '@mdi/js'
import {mdiPoliceBadgeOutline} from '@mdi/js'
import {mdiPoliceStation} from '@mdi/js'
import {mdiPoll} from '@mdi/js'
import {mdiPolo} from '@mdi/js'
import {mdiPolymer} from '@mdi/js'
import {mdiPool} from '@mdi/js'
import {mdiPoolThermometer} from '@mdi/js'
import {mdiPopcorn} from '@mdi/js'
import {mdiPost} from '@mdi/js'
import {mdiPostLamp} from '@mdi/js'
import {mdiPostOutline} from '@mdi/js'
import {mdiPostageStamp} from '@mdi/js'
import {mdiPot} from '@mdi/js'
import {mdiPotMix} from '@mdi/js'
import {mdiPotMixOutline} from '@mdi/js'
import {mdiPotOutline} from '@mdi/js'
import {mdiPotSteam} from '@mdi/js'
import {mdiPotSteamOutline} from '@mdi/js'
import {mdiPound} from '@mdi/js'
import {mdiPoundBox} from '@mdi/js'
import {mdiPoundBoxOutline} from '@mdi/js'
import {mdiPower} from '@mdi/js'
import {mdiPowerCycle} from '@mdi/js'
import {mdiPowerOff} from '@mdi/js'
import {mdiPowerOn} from '@mdi/js'
import {mdiPowerPlug} from '@mdi/js'
import {mdiPowerPlugOff} from '@mdi/js'
import {mdiPowerPlugOffOutline} from '@mdi/js'
import {mdiPowerPlugOutline} from '@mdi/js'
import {mdiPowerSettings} from '@mdi/js'
import {mdiPowerSleep} from '@mdi/js'
import {mdiPowerSocket} from '@mdi/js'
import {mdiPowerSocketAu} from '@mdi/js'
import {mdiPowerSocketCh} from '@mdi/js'
import {mdiPowerSocketDe} from '@mdi/js'
import {mdiPowerSocketEu} from '@mdi/js'
import {mdiPowerSocketFr} from '@mdi/js'
import {mdiPowerSocketIt} from '@mdi/js'
import {mdiPowerSocketJp} from '@mdi/js'
import {mdiPowerSocketUk} from '@mdi/js'
import {mdiPowerSocketUs} from '@mdi/js'
import {mdiPowerStandby} from '@mdi/js'
import {mdiPowershell} from '@mdi/js'
import {mdiPrescription} from '@mdi/js'
import {mdiPresentation} from '@mdi/js'
import {mdiPresentationPlay} from '@mdi/js'
import {mdiPretzel} from '@mdi/js'
import {mdiPrinter} from '@mdi/js'
import {mdiPrinter3d} from '@mdi/js'
import {mdiPrinter3dNozzle} from '@mdi/js'
import {mdiPrinter3dNozzleAlert} from '@mdi/js'
import {mdiPrinter3dNozzleAlertOutline} from '@mdi/js'
import {mdiPrinter3dNozzleHeat} from '@mdi/js'
import {mdiPrinter3dNozzleHeatOutline} from '@mdi/js'
import {mdiPrinter3dNozzleOff} from '@mdi/js'
import {mdiPrinter3dNozzleOffOutline} from '@mdi/js'
import {mdiPrinter3dNozzleOutline} from '@mdi/js'
import {mdiPrinter3dOff} from '@mdi/js'
import {mdiPrinterAlert} from '@mdi/js'
import {mdiPrinterCheck} from '@mdi/js'
import {mdiPrinterEye} from '@mdi/js'
import {mdiPrinterOff} from '@mdi/js'
import {mdiPrinterOffOutline} from '@mdi/js'
import {mdiPrinterOutline} from '@mdi/js'
import {mdiPrinterPos} from '@mdi/js'
import {mdiPrinterSearch} from '@mdi/js'
import {mdiPrinterSettings} from '@mdi/js'
import {mdiPrinterWireless} from '@mdi/js'
import {mdiPriorityHigh} from '@mdi/js'
import {mdiPriorityLow} from '@mdi/js'
import {mdiProfessionalHexagon} from '@mdi/js'
import {mdiProgressAlert} from '@mdi/js'
import {mdiProgressCheck} from '@mdi/js'
import {mdiProgressClock} from '@mdi/js'
import {mdiProgressClose} from '@mdi/js'
import {mdiProgressDownload} from '@mdi/js'
import {mdiProgressHelper} from '@mdi/js'
import {mdiProgressPencil} from '@mdi/js'
import {mdiProgressQuestion} from '@mdi/js'
import {mdiProgressStar} from '@mdi/js'
import {mdiProgressUpload} from '@mdi/js'
import {mdiProgressWrench} from '@mdi/js'
import {mdiProjector} from '@mdi/js'
import {mdiProjectorOff} from '@mdi/js'
import {mdiProjectorScreen} from '@mdi/js'
import {mdiProjectorScreenOff} from '@mdi/js'
import {mdiProjectorScreenOffOutline} from '@mdi/js'
import {mdiProjectorScreenOutline} from '@mdi/js'
import {mdiProjectorScreenVariant} from '@mdi/js'
import {mdiProjectorScreenVariantOff} from '@mdi/js'
import {mdiProjectorScreenVariantOffOutline} from '@mdi/js'
import {mdiProjectorScreenVariantOutline} from '@mdi/js'
import {mdiPropaneTank} from '@mdi/js'
import {mdiPropaneTankOutline} from '@mdi/js'
import {mdiProtocol} from '@mdi/js'
import {mdiPublish} from '@mdi/js'
import {mdiPublishOff} from '@mdi/js'
import {mdiPulse} from '@mdi/js'
import {mdiPump} from '@mdi/js'
import {mdiPumpOff} from '@mdi/js'
import {mdiPumpkin} from '@mdi/js'
import {mdiPurse} from '@mdi/js'
import {mdiPurseOutline} from '@mdi/js'
import {mdiPuzzle} from '@mdi/js'
import {mdiPuzzleCheck} from '@mdi/js'
import {mdiPuzzleCheckOutline} from '@mdi/js'
import {mdiPuzzleEdit} from '@mdi/js'
import {mdiPuzzleEditOutline} from '@mdi/js'
import {mdiPuzzleHeart} from '@mdi/js'
import {mdiPuzzleHeartOutline} from '@mdi/js'
import {mdiPuzzleMinus} from '@mdi/js'
import {mdiPuzzleMinusOutline} from '@mdi/js'
import {mdiPuzzleOutline} from '@mdi/js'
import {mdiPuzzlePlus} from '@mdi/js'
import {mdiPuzzlePlusOutline} from '@mdi/js'
import {mdiPuzzleRemove} from '@mdi/js'
import {mdiPuzzleRemoveOutline} from '@mdi/js'
import {mdiPuzzleStar} from '@mdi/js'
import {mdiPuzzleStarOutline} from '@mdi/js'
import {mdiPyramid} from '@mdi/js'
import {mdiPyramidOff} from '@mdi/js'
import {mdiQi} from '@mdi/js'
import {mdiQqchat} from '@mdi/js'
import {mdiQrcode} from '@mdi/js'
import {mdiQrcodeEdit} from '@mdi/js'
import {mdiQrcodeMinus} from '@mdi/js'
import {mdiQrcodePlus} from '@mdi/js'
import {mdiQrcodeRemove} from '@mdi/js'
import {mdiQrcodeScan} from '@mdi/js'
import {mdiQuadcopter} from '@mdi/js'
import {mdiQualityHigh} from '@mdi/js'
import {mdiQualityLow} from '@mdi/js'
import {mdiQualityMedium} from '@mdi/js'
import {mdiQuora} from '@mdi/js'
import {mdiRabbit} from '@mdi/js'
import {mdiRabbitVariant} from '@mdi/js'
import {mdiRabbitVariantOutline} from '@mdi/js'
import {mdiRacingHelmet} from '@mdi/js'
import {mdiRacquetball} from '@mdi/js'
import {mdiRadar} from '@mdi/js'
import {mdiRadiator} from '@mdi/js'
import {mdiRadiatorDisabled} from '@mdi/js'
import {mdiRadiatorOff} from '@mdi/js'
import {mdiRadio} from '@mdi/js'
import {mdiRadioAm} from '@mdi/js'
import {mdiRadioFm} from '@mdi/js'
import {mdiRadioHandheld} from '@mdi/js'
import {mdiRadioOff} from '@mdi/js'
import {mdiRadioTower} from '@mdi/js'
import {mdiRadioactive} from '@mdi/js'
import {mdiRadioactiveCircle} from '@mdi/js'
import {mdiRadioactiveCircleOutline} from '@mdi/js'
import {mdiRadioactiveOff} from '@mdi/js'
import {mdiRadioboxBlank} from '@mdi/js'
import {mdiRadioboxMarked} from '@mdi/js'
import {mdiRadiologyBox} from '@mdi/js'
import {mdiRadiologyBoxOutline} from '@mdi/js'
import {mdiRadius} from '@mdi/js'
import {mdiRadiusOutline} from '@mdi/js'
import {mdiRailroadLight} from '@mdi/js'
import {mdiRake} from '@mdi/js'
import {mdiRaspberryPi} from '@mdi/js'
import {mdiRaw} from '@mdi/js'
import {mdiRawOff} from '@mdi/js'
import {mdiRayEnd} from '@mdi/js'
import {mdiRayEndArrow} from '@mdi/js'
import {mdiRayStart} from '@mdi/js'
import {mdiRayStartArrow} from '@mdi/js'
import {mdiRayStartEnd} from '@mdi/js'
import {mdiRayStartVertexEnd} from '@mdi/js'
import {mdiRayVertex} from '@mdi/js'
import {mdiRazorDoubleEdge} from '@mdi/js'
import {mdiRazorSingleEdge} from '@mdi/js'
import {mdiReact} from '@mdi/js'
import {mdiRead} from '@mdi/js'
import {mdiReceipt} from '@mdi/js'
import {mdiReceiptOutline} from '@mdi/js'
import {mdiReceiptText} from '@mdi/js'
import {mdiReceiptTextCheck} from '@mdi/js'
import {mdiReceiptTextCheckOutline} from '@mdi/js'
import {mdiReceiptTextMinus} from '@mdi/js'
import {mdiReceiptTextMinusOutline} from '@mdi/js'
import {mdiReceiptTextOutline} from '@mdi/js'
import {mdiReceiptTextPlus} from '@mdi/js'
import {mdiReceiptTextPlusOutline} from '@mdi/js'
import {mdiReceiptTextRemove} from '@mdi/js'
import {mdiReceiptTextRemoveOutline} from '@mdi/js'
import {mdiRecord} from '@mdi/js'
import {mdiRecordCircle} from '@mdi/js'
import {mdiRecordCircleOutline} from '@mdi/js'
import {mdiRecordPlayer} from '@mdi/js'
import {mdiRecordRec} from '@mdi/js'
import {mdiRectangle} from '@mdi/js'
import {mdiRectangleOutline} from '@mdi/js'
import {mdiRecycle} from '@mdi/js'
import {mdiRecycleVariant} from '@mdi/js'
import {mdiReddit} from '@mdi/js'
import {mdiRedhat} from '@mdi/js'
import {mdiRedo} from '@mdi/js'
import {mdiRedoVariant} from '@mdi/js'
import {mdiReflectHorizontal} from '@mdi/js'
import {mdiReflectVertical} from '@mdi/js'
import {mdiRefresh} from '@mdi/js'
import {mdiRefreshAuto} from '@mdi/js'
import {mdiRefreshCircle} from '@mdi/js'
import {mdiRegex} from '@mdi/js'
import {mdiRegisteredTrademark} from '@mdi/js'
import {mdiReiterate} from '@mdi/js'
import {mdiRelationManyToMany} from '@mdi/js'
import {mdiRelationManyToOne} from '@mdi/js'
import {mdiRelationManyToOneOrMany} from '@mdi/js'
import {mdiRelationManyToOnlyOne} from '@mdi/js'
import {mdiRelationManyToZeroOrMany} from '@mdi/js'
import {mdiRelationManyToZeroOrOne} from '@mdi/js'
import {mdiRelationOneOrManyToMany} from '@mdi/js'
import {mdiRelationOneOrManyToOne} from '@mdi/js'
import {mdiRelationOneOrManyToOneOrMany} from '@mdi/js'
import {mdiRelationOneOrManyToOnlyOne} from '@mdi/js'
import {mdiRelationOneOrManyToZeroOrMany} from '@mdi/js'
import {mdiRelationOneOrManyToZeroOrOne} from '@mdi/js'
import {mdiRelationOneToMany} from '@mdi/js'
import {mdiRelationOneToOne} from '@mdi/js'
import {mdiRelationOneToOneOrMany} from '@mdi/js'
import {mdiRelationOneToOnlyOne} from '@mdi/js'
import {mdiRelationOneToZeroOrMany} from '@mdi/js'
import {mdiRelationOneToZeroOrOne} from '@mdi/js'
import {mdiRelationOnlyOneToMany} from '@mdi/js'
import {mdiRelationOnlyOneToOne} from '@mdi/js'
import {mdiRelationOnlyOneToOneOrMany} from '@mdi/js'
import {mdiRelationOnlyOneToOnlyOne} from '@mdi/js'
import {mdiRelationOnlyOneToZeroOrMany} from '@mdi/js'
import {mdiRelationOnlyOneToZeroOrOne} from '@mdi/js'
import {mdiRelationZeroOrManyToMany} from '@mdi/js'
import {mdiRelationZeroOrManyToOne} from '@mdi/js'
import {mdiRelationZeroOrManyToOneOrMany} from '@mdi/js'
import {mdiRelationZeroOrManyToOnlyOne} from '@mdi/js'
import {mdiRelationZeroOrManyToZeroOrMany} from '@mdi/js'
import {mdiRelationZeroOrManyToZeroOrOne} from '@mdi/js'
import {mdiRelationZeroOrOneToMany} from '@mdi/js'
import {mdiRelationZeroOrOneToOne} from '@mdi/js'
import {mdiRelationZeroOrOneToOneOrMany} from '@mdi/js'
import {mdiRelationZeroOrOneToOnlyOne} from '@mdi/js'
import {mdiRelationZeroOrOneToZeroOrMany} from '@mdi/js'
import {mdiRelationZeroOrOneToZeroOrOne} from '@mdi/js'
import {mdiRelativeScale} from '@mdi/js'
import {mdiReload} from '@mdi/js'
import {mdiReloadAlert} from '@mdi/js'
import {mdiReminder} from '@mdi/js'
import {mdiRemote} from '@mdi/js'
import {mdiRemoteDesktop} from '@mdi/js'
import {mdiRemoteOff} from '@mdi/js'
import {mdiRemoteTv} from '@mdi/js'
import {mdiRemoteTvOff} from '@mdi/js'
import {mdiRenameBox} from '@mdi/js'
import {mdiReorderHorizontal} from '@mdi/js'
import {mdiReorderVertical} from '@mdi/js'
import {mdiRepeat} from '@mdi/js'
import {mdiRepeatOff} from '@mdi/js'
import {mdiRepeatOnce} from '@mdi/js'
import {mdiRepeatVariant} from '@mdi/js'
import {mdiReplay} from '@mdi/js'
import {mdiReply} from '@mdi/js'
import {mdiReplyAll} from '@mdi/js'
import {mdiReplyAllOutline} from '@mdi/js'
import {mdiReplyCircle} from '@mdi/js'
import {mdiReplyOutline} from '@mdi/js'
import {mdiReproduction} from '@mdi/js'
import {mdiResistor} from '@mdi/js'
import {mdiResistorNodes} from '@mdi/js'
import {mdiResize} from '@mdi/js'
import {mdiResizeBottomRight} from '@mdi/js'
import {mdiResponsive} from '@mdi/js'
import {mdiRestart} from '@mdi/js'
import {mdiRestartAlert} from '@mdi/js'
import {mdiRestartOff} from '@mdi/js'
import {mdiRestore} from '@mdi/js'
import {mdiRestoreAlert} from '@mdi/js'
import {mdiRewind} from '@mdi/js'
import {mdiRewind10} from '@mdi/js'
import {mdiRewind15} from '@mdi/js'
import {mdiRewind30} from '@mdi/js'
import {mdiRewind45} from '@mdi/js'
import {mdiRewind5} from '@mdi/js'
import {mdiRewind60} from '@mdi/js'
import {mdiRewindOutline} from '@mdi/js'
import {mdiRhombus} from '@mdi/js'
import {mdiRhombusMedium} from '@mdi/js'
import {mdiRhombusMediumOutline} from '@mdi/js'
import {mdiRhombusOutline} from '@mdi/js'
import {mdiRhombusSplit} from '@mdi/js'
import {mdiRhombusSplitOutline} from '@mdi/js'
import {mdiRibbon} from '@mdi/js'
import {mdiRice} from '@mdi/js'
import {mdiRickshaw} from '@mdi/js'
import {mdiRickshawElectric} from '@mdi/js'
import {mdiRing} from '@mdi/js'
import {mdiRivet} from '@mdi/js'
import {mdiRoad} from '@mdi/js'
import {mdiRoadVariant} from '@mdi/js'
import {mdiRobber} from '@mdi/js'
import {mdiRobot} from '@mdi/js'
import {mdiRobotAngry} from '@mdi/js'
import {mdiRobotAngryOutline} from '@mdi/js'
import {mdiRobotConfused} from '@mdi/js'
import {mdiRobotConfusedOutline} from '@mdi/js'
import {mdiRobotDead} from '@mdi/js'
import {mdiRobotDeadOutline} from '@mdi/js'
import {mdiRobotExcited} from '@mdi/js'
import {mdiRobotExcitedOutline} from '@mdi/js'
import {mdiRobotHappy} from '@mdi/js'
import {mdiRobotHappyOutline} from '@mdi/js'
import {mdiRobotIndustrial} from '@mdi/js'
import {mdiRobotIndustrialOutline} from '@mdi/js'
import {mdiRobotLove} from '@mdi/js'
import {mdiRobotLoveOutline} from '@mdi/js'
import {mdiRobotMower} from '@mdi/js'
import {mdiRobotMowerOutline} from '@mdi/js'
import {mdiRobotOff} from '@mdi/js'
import {mdiRobotOffOutline} from '@mdi/js'
import {mdiRobotOutline} from '@mdi/js'
import {mdiRobotVacuum} from '@mdi/js'
import {mdiRobotVacuumAlert} from '@mdi/js'
import {mdiRobotVacuumVariant} from '@mdi/js'
import {mdiRobotVacuumVariantAlert} from '@mdi/js'
import {mdiRocket} from '@mdi/js'
import {mdiRocketLaunch} from '@mdi/js'
import {mdiRocketLaunchOutline} from '@mdi/js'
import {mdiRocketOutline} from '@mdi/js'
import {mdiRodent} from '@mdi/js'
import {mdiRollerShade} from '@mdi/js'
import {mdiRollerShadeClosed} from '@mdi/js'
import {mdiRollerSkate} from '@mdi/js'
import {mdiRollerSkateOff} from '@mdi/js'
import {mdiRollerblade} from '@mdi/js'
import {mdiRollerbladeOff} from '@mdi/js'
import {mdiRollupjs} from '@mdi/js'
import {mdiRolodex} from '@mdi/js'
import {mdiRolodexOutline} from '@mdi/js'
import {mdiRomanNumeral1} from '@mdi/js'
import {mdiRomanNumeral10} from '@mdi/js'
import {mdiRomanNumeral2} from '@mdi/js'
import {mdiRomanNumeral3} from '@mdi/js'
import {mdiRomanNumeral4} from '@mdi/js'
import {mdiRomanNumeral5} from '@mdi/js'
import {mdiRomanNumeral6} from '@mdi/js'
import {mdiRomanNumeral7} from '@mdi/js'
import {mdiRomanNumeral8} from '@mdi/js'
import {mdiRomanNumeral9} from '@mdi/js'
import {mdiRoomService} from '@mdi/js'
import {mdiRoomServiceOutline} from '@mdi/js'
import {mdiRotate360} from '@mdi/js'
import {mdiRotate3d} from '@mdi/js'
import {mdiRotate3dVariant} from '@mdi/js'
import {mdiRotateLeft} from '@mdi/js'
import {mdiRotateLeftVariant} from '@mdi/js'
import {mdiRotateOrbit} from '@mdi/js'
import {mdiRotateRight} from '@mdi/js'
import {mdiRotateRightVariant} from '@mdi/js'
import {mdiRoundedCorner} from '@mdi/js'
import {mdiRouter} from '@mdi/js'
import {mdiRouterNetwork} from '@mdi/js'
import {mdiRouterWireless} from '@mdi/js'
import {mdiRouterWirelessOff} from '@mdi/js'
import {mdiRouterWirelessSettings} from '@mdi/js'
import {mdiRoutes} from '@mdi/js'
import {mdiRoutesClock} from '@mdi/js'
import {mdiRowing} from '@mdi/js'
import {mdiRss} from '@mdi/js'
import {mdiRssBox} from '@mdi/js'
import {mdiRssOff} from '@mdi/js'
import {mdiRug} from '@mdi/js'
import {mdiRugby} from '@mdi/js'
import {mdiRuler} from '@mdi/js'
import {mdiRulerSquare} from '@mdi/js'
import {mdiRulerSquareCompass} from '@mdi/js'
import {mdiRun} from '@mdi/js'
import {mdiRunFast} from '@mdi/js'
import {mdiRvTruck} from '@mdi/js'
import {mdiSack} from '@mdi/js'
import {mdiSackPercent} from '@mdi/js'
import {mdiSafe} from '@mdi/js'
import {mdiSafeSquare} from '@mdi/js'
import {mdiSafeSquareOutline} from '@mdi/js'
import {mdiSafetyGoggles} from '@mdi/js'
import {mdiSailBoat} from '@mdi/js'
import {mdiSailBoatSink} from '@mdi/js'
import {mdiSale} from '@mdi/js'
import {mdiSaleOutline} from '@mdi/js'
import {mdiSalesforce} from '@mdi/js'
import {mdiSass} from '@mdi/js'
import {mdiSatellite} from '@mdi/js'
import {mdiSatelliteUplink} from '@mdi/js'
import {mdiSatelliteVariant} from '@mdi/js'
import {mdiSausage} from '@mdi/js'
import {mdiSausageOff} from '@mdi/js'
import {mdiSawBlade} from '@mdi/js'
import {mdiSawtoothWave} from '@mdi/js'
import {mdiSaxophone} from '@mdi/js'
import {mdiScale} from '@mdi/js'
import {mdiScaleBalance} from '@mdi/js'
import {mdiScaleBathroom} from '@mdi/js'
import {mdiScaleOff} from '@mdi/js'
import {mdiScaleUnbalanced} from '@mdi/js'
import {mdiScanHelper} from '@mdi/js'
import {mdiScanner} from '@mdi/js'
import {mdiScannerOff} from '@mdi/js'
import {mdiScatterPlot} from '@mdi/js'
import {mdiScatterPlotOutline} from '@mdi/js'
import {mdiScent} from '@mdi/js'
import {mdiScentOff} from '@mdi/js'
import {mdiSchool} from '@mdi/js'
import {mdiSchoolOutline} from '@mdi/js'
import {mdiScissorsCutting} from '@mdi/js'
import {mdiScooter} from '@mdi/js'
import {mdiScooterElectric} from '@mdi/js'
import {mdiScoreboard} from '@mdi/js'
import {mdiScoreboardOutline} from '@mdi/js'
import {mdiScreenRotation} from '@mdi/js'
import {mdiScreenRotationLock} from '@mdi/js'
import {mdiScrewFlatTop} from '@mdi/js'
import {mdiScrewLag} from '@mdi/js'
import {mdiScrewMachineFlatTop} from '@mdi/js'
import {mdiScrewMachineRoundTop} from '@mdi/js'
import {mdiScrewRoundTop} from '@mdi/js'
import {mdiScrewdriver} from '@mdi/js'
import {mdiScript} from '@mdi/js'
import {mdiScriptOutline} from '@mdi/js'
import {mdiScriptText} from '@mdi/js'
import {mdiScriptTextKey} from '@mdi/js'
import {mdiScriptTextKeyOutline} from '@mdi/js'
import {mdiScriptTextOutline} from '@mdi/js'
import {mdiScriptTextPlay} from '@mdi/js'
import {mdiScriptTextPlayOutline} from '@mdi/js'
import {mdiSd} from '@mdi/js'
import {mdiSeal} from '@mdi/js'
import {mdiSealVariant} from '@mdi/js'
import {mdiSearchWeb} from '@mdi/js'
import {mdiSeat} from '@mdi/js'
import {mdiSeatFlat} from '@mdi/js'
import {mdiSeatFlatAngled} from '@mdi/js'
import {mdiSeatIndividualSuite} from '@mdi/js'
import {mdiSeatLegroomExtra} from '@mdi/js'
import {mdiSeatLegroomNormal} from '@mdi/js'
import {mdiSeatLegroomReduced} from '@mdi/js'
import {mdiSeatOutline} from '@mdi/js'
import {mdiSeatPassenger} from '@mdi/js'
import {mdiSeatReclineExtra} from '@mdi/js'
import {mdiSeatReclineNormal} from '@mdi/js'
import {mdiSeatbelt} from '@mdi/js'
import {mdiSecurity} from '@mdi/js'
import {mdiSecurityNetwork} from '@mdi/js'
import {mdiSeed} from '@mdi/js'
import {mdiSeedOff} from '@mdi/js'
import {mdiSeedOffOutline} from '@mdi/js'
import {mdiSeedOutline} from '@mdi/js'
import {mdiSeedPlus} from '@mdi/js'
import {mdiSeedPlusOutline} from '@mdi/js'
import {mdiSeesaw} from '@mdi/js'
import {mdiSegment} from '@mdi/js'
import {mdiSelect} from '@mdi/js'
import {mdiSelectAll} from '@mdi/js'
import {mdiSelectArrowDown} from '@mdi/js'
import {mdiSelectArrowUp} from '@mdi/js'
import {mdiSelectColor} from '@mdi/js'
import {mdiSelectCompare} from '@mdi/js'
import {mdiSelectDrag} from '@mdi/js'
import {mdiSelectGroup} from '@mdi/js'
import {mdiSelectInverse} from '@mdi/js'
import {mdiSelectMarker} from '@mdi/js'
import {mdiSelectMultiple} from '@mdi/js'
import {mdiSelectMultipleMarker} from '@mdi/js'
import {mdiSelectOff} from '@mdi/js'
import {mdiSelectPlace} from '@mdi/js'
import {mdiSelectRemove} from '@mdi/js'
import {mdiSelectSearch} from '@mdi/js'
import {mdiSelection} from '@mdi/js'
import {mdiSelectionDrag} from '@mdi/js'
import {mdiSelectionEllipse} from '@mdi/js'
import {mdiSelectionEllipseArrowInside} from '@mdi/js'
import {mdiSelectionEllipseRemove} from '@mdi/js'
import {mdiSelectionMarker} from '@mdi/js'
import {mdiSelectionMultiple} from '@mdi/js'
import {mdiSelectionMultipleMarker} from '@mdi/js'
import {mdiSelectionOff} from '@mdi/js'
import {mdiSelectionRemove} from '@mdi/js'
import {mdiSelectionSearch} from '@mdi/js'
import {mdiSemanticWeb} from '@mdi/js'
import {mdiSend} from '@mdi/js'
import {mdiSendCheck} from '@mdi/js'
import {mdiSendCheckOutline} from '@mdi/js'
import {mdiSendCircle} from '@mdi/js'
import {mdiSendCircleOutline} from '@mdi/js'
import {mdiSendClock} from '@mdi/js'
import {mdiSendClockOutline} from '@mdi/js'
import {mdiSendLock} from '@mdi/js'
import {mdiSendLockOutline} from '@mdi/js'
import {mdiSendOutline} from '@mdi/js'
import {mdiSerialPort} from '@mdi/js'
import {mdiServer} from '@mdi/js'
import {mdiServerMinus} from '@mdi/js'
import {mdiServerNetwork} from '@mdi/js'
import {mdiServerNetworkOff} from '@mdi/js'
import {mdiServerOff} from '@mdi/js'
import {mdiServerPlus} from '@mdi/js'
import {mdiServerRemove} from '@mdi/js'
import {mdiServerSecurity} from '@mdi/js'
import {mdiSetAll} from '@mdi/js'
import {mdiSetCenter} from '@mdi/js'
import {mdiSetCenterRight} from '@mdi/js'
import {mdiSetLeft} from '@mdi/js'
import {mdiSetLeftCenter} from '@mdi/js'
import {mdiSetLeftRight} from '@mdi/js'
import {mdiSetMerge} from '@mdi/js'
import {mdiSetNone} from '@mdi/js'
import {mdiSetRight} from '@mdi/js'
import {mdiSetSplit} from '@mdi/js'
import {mdiSetSquare} from '@mdi/js'
import {mdiSetTopBox} from '@mdi/js'
import {mdiSettingsHelper} from '@mdi/js'
import {mdiShaker} from '@mdi/js'
import {mdiShakerOutline} from '@mdi/js'
import {mdiShape} from '@mdi/js'
import {mdiShapeCirclePlus} from '@mdi/js'
import {mdiShapeOutline} from '@mdi/js'
import {mdiShapeOvalPlus} from '@mdi/js'
import {mdiShapePlus} from '@mdi/js'
import {mdiShapePolygonPlus} from '@mdi/js'
import {mdiShapeRectanglePlus} from '@mdi/js'
import {mdiShapeSquarePlus} from '@mdi/js'
import {mdiShapeSquareRoundedPlus} from '@mdi/js'
import {mdiShare} from '@mdi/js'
import {mdiShareAll} from '@mdi/js'
import {mdiShareAllOutline} from '@mdi/js'
import {mdiShareCircle} from '@mdi/js'
import {mdiShareOff} from '@mdi/js'
import {mdiShareOffOutline} from '@mdi/js'
import {mdiShareOutline} from '@mdi/js'
import {mdiShareVariant} from '@mdi/js'
import {mdiShareVariantOutline} from '@mdi/js'
import {mdiShark} from '@mdi/js'
import {mdiSharkFin} from '@mdi/js'
import {mdiSharkFinOutline} from '@mdi/js'
import {mdiSharkOff} from '@mdi/js'
import {mdiSheep} from '@mdi/js'
import {mdiShield} from '@mdi/js'
import {mdiShieldAccount} from '@mdi/js'
import {mdiShieldAccountOutline} from '@mdi/js'
import {mdiShieldAccountVariant} from '@mdi/js'
import {mdiShieldAccountVariantOutline} from '@mdi/js'
import {mdiShieldAirplane} from '@mdi/js'
import {mdiShieldAirplaneOutline} from '@mdi/js'
import {mdiShieldAlert} from '@mdi/js'
import {mdiShieldAlertOutline} from '@mdi/js'
import {mdiShieldBug} from '@mdi/js'
import {mdiShieldBugOutline} from '@mdi/js'
import {mdiShieldCar} from '@mdi/js'
import {mdiShieldCheck} from '@mdi/js'
import {mdiShieldCheckOutline} from '@mdi/js'
import {mdiShieldCross} from '@mdi/js'
import {mdiShieldCrossOutline} from '@mdi/js'
import {mdiShieldCrown} from '@mdi/js'
import {mdiShieldCrownOutline} from '@mdi/js'
import {mdiShieldEdit} from '@mdi/js'
import {mdiShieldEditOutline} from '@mdi/js'
import {mdiShieldHalf} from '@mdi/js'
import {mdiShieldHalfFull} from '@mdi/js'
import {mdiShieldHome} from '@mdi/js'
import {mdiShieldHomeOutline} from '@mdi/js'
import {mdiShieldKey} from '@mdi/js'
import {mdiShieldKeyOutline} from '@mdi/js'
import {mdiShieldLinkVariant} from '@mdi/js'
import {mdiShieldLinkVariantOutline} from '@mdi/js'
import {mdiShieldLock} from '@mdi/js'
import {mdiShieldLockOpen} from '@mdi/js'
import {mdiShieldLockOpenOutline} from '@mdi/js'
import {mdiShieldLockOutline} from '@mdi/js'
import {mdiShieldMoon} from '@mdi/js'
import {mdiShieldMoonOutline} from '@mdi/js'
import {mdiShieldOff} from '@mdi/js'
import {mdiShieldOffOutline} from '@mdi/js'
import {mdiShieldOutline} from '@mdi/js'
import {mdiShieldPlus} from '@mdi/js'
import {mdiShieldPlusOutline} from '@mdi/js'
import {mdiShieldRefresh} from '@mdi/js'
import {mdiShieldRefreshOutline} from '@mdi/js'
import {mdiShieldRemove} from '@mdi/js'
import {mdiShieldRemoveOutline} from '@mdi/js'
import {mdiShieldSearch} from '@mdi/js'
import {mdiShieldStar} from '@mdi/js'
import {mdiShieldStarOutline} from '@mdi/js'
import {mdiShieldSun} from '@mdi/js'
import {mdiShieldSunOutline} from '@mdi/js'
import {mdiShieldSword} from '@mdi/js'
import {mdiShieldSwordOutline} from '@mdi/js'
import {mdiShieldSync} from '@mdi/js'
import {mdiShieldSyncOutline} from '@mdi/js'
import {mdiShimmer} from '@mdi/js'
import {mdiShipWheel} from '@mdi/js'
import {mdiShippingPallet} from '@mdi/js'
import {mdiShoeBallet} from '@mdi/js'
import {mdiShoeCleat} from '@mdi/js'
import {mdiShoeFormal} from '@mdi/js'
import {mdiShoeHeel} from '@mdi/js'
import {mdiShoePrint} from '@mdi/js'
import {mdiShoeSneaker} from '@mdi/js'
import {mdiShopping} from '@mdi/js'
import {mdiShoppingMusic} from '@mdi/js'
import {mdiShoppingOutline} from '@mdi/js'
import {mdiShoppingSearch} from '@mdi/js'
import {mdiShoppingSearchOutline} from '@mdi/js'
import {mdiShore} from '@mdi/js'
import {mdiShovel} from '@mdi/js'
import {mdiShovelOff} from '@mdi/js'
import {mdiShower} from '@mdi/js'
import {mdiShowerHead} from '@mdi/js'
import {mdiShredder} from '@mdi/js'
import {mdiShuffle} from '@mdi/js'
import {mdiShuffleDisabled} from '@mdi/js'
import {mdiShuffleVariant} from '@mdi/js'
import {mdiShuriken} from '@mdi/js'
import {mdiSickle} from '@mdi/js'
import {mdiSigma} from '@mdi/js'
import {mdiSigmaLower} from '@mdi/js'
import {mdiSignCaution} from '@mdi/js'
import {mdiSignDirection} from '@mdi/js'
import {mdiSignDirectionMinus} from '@mdi/js'
import {mdiSignDirectionPlus} from '@mdi/js'
import {mdiSignDirectionRemove} from '@mdi/js'
import {mdiSignLanguage} from '@mdi/js'
import {mdiSignLanguageOutline} from '@mdi/js'
import {mdiSignPole} from '@mdi/js'
import {mdiSignRealEstate} from '@mdi/js'
import {mdiSignText} from '@mdi/js'
import {mdiSignYield} from '@mdi/js'
import {mdiSignal} from '@mdi/js'
import {mdiSignal2g} from '@mdi/js'
import {mdiSignal3g} from '@mdi/js'
import {mdiSignal4g} from '@mdi/js'
import {mdiSignal5g} from '@mdi/js'
import {mdiSignalCellular1} from '@mdi/js'
import {mdiSignalCellular2} from '@mdi/js'
import {mdiSignalCellular3} from '@mdi/js'
import {mdiSignalCellularOutline} from '@mdi/js'
import {mdiSignalDistanceVariant} from '@mdi/js'
import {mdiSignalHspa} from '@mdi/js'
import {mdiSignalHspaPlus} from '@mdi/js'
import {mdiSignalOff} from '@mdi/js'
import {mdiSignalVariant} from '@mdi/js'
import {mdiSignature} from '@mdi/js'
import {mdiSignatureFreehand} from '@mdi/js'
import {mdiSignatureImage} from '@mdi/js'
import {mdiSignatureText} from '@mdi/js'
import {mdiSilo} from '@mdi/js'
import {mdiSiloOutline} from '@mdi/js'
import {mdiSilverware} from '@mdi/js'
import {mdiSilverwareClean} from '@mdi/js'
import {mdiSilverwareFork} from '@mdi/js'
import {mdiSilverwareForkKnife} from '@mdi/js'
import {mdiSilverwareSpoon} from '@mdi/js'
import {mdiSilverwareVariant} from '@mdi/js'
import {mdiSim} from '@mdi/js'
import {mdiSimAlert} from '@mdi/js'
import {mdiSimAlertOutline} from '@mdi/js'
import {mdiSimOff} from '@mdi/js'
import {mdiSimOffOutline} from '@mdi/js'
import {mdiSimOutline} from '@mdi/js'
import {mdiSimpleIcons} from '@mdi/js'
import {mdiSinaWeibo} from '@mdi/js'
import {mdiSineWave} from '@mdi/js'
import {mdiSitemap} from '@mdi/js'
import {mdiSitemapOutline} from '@mdi/js'
import {mdiSizeL} from '@mdi/js'
import {mdiSizeM} from '@mdi/js'
import {mdiSizeS} from '@mdi/js'
import {mdiSizeXl} from '@mdi/js'
import {mdiSizeXs} from '@mdi/js'
import {mdiSizeXxl} from '@mdi/js'
import {mdiSizeXxs} from '@mdi/js'
import {mdiSizeXxxl} from '@mdi/js'
import {mdiSkate} from '@mdi/js'
import {mdiSkateOff} from '@mdi/js'
import {mdiSkateboard} from '@mdi/js'
import {mdiSkateboarding} from '@mdi/js'
import {mdiSkewLess} from '@mdi/js'
import {mdiSkewMore} from '@mdi/js'
import {mdiSki} from '@mdi/js'
import {mdiSkiCrossCountry} from '@mdi/js'
import {mdiSkiWater} from '@mdi/js'
import {mdiSkipBackward} from '@mdi/js'
import {mdiSkipBackwardOutline} from '@mdi/js'
import {mdiSkipForward} from '@mdi/js'
import {mdiSkipForwardOutline} from '@mdi/js'
import {mdiSkipNext} from '@mdi/js'
import {mdiSkipNextCircle} from '@mdi/js'
import {mdiSkipNextCircleOutline} from '@mdi/js'
import {mdiSkipNextOutline} from '@mdi/js'
import {mdiSkipPrevious} from '@mdi/js'
import {mdiSkipPreviousCircle} from '@mdi/js'
import {mdiSkipPreviousCircleOutline} from '@mdi/js'
import {mdiSkipPreviousOutline} from '@mdi/js'
import {mdiSkull} from '@mdi/js'
import {mdiSkullCrossbones} from '@mdi/js'
import {mdiSkullCrossbonesOutline} from '@mdi/js'
import {mdiSkullOutline} from '@mdi/js'
import {mdiSkullScan} from '@mdi/js'
import {mdiSkullScanOutline} from '@mdi/js'
import {mdiSkype} from '@mdi/js'
import {mdiSkypeBusiness} from '@mdi/js'
import {mdiSlack} from '@mdi/js'
import {mdiSlashForward} from '@mdi/js'
import {mdiSlashForwardBox} from '@mdi/js'
import {mdiSledding} from '@mdi/js'
import {mdiSleep} from '@mdi/js'
import {mdiSleepOff} from '@mdi/js'
import {mdiSlide} from '@mdi/js'
import {mdiSlopeDownhill} from '@mdi/js'
import {mdiSlopeUphill} from '@mdi/js'
import {mdiSlotMachine} from '@mdi/js'
import {mdiSlotMachineOutline} from '@mdi/js'
import {mdiSmartCard} from '@mdi/js'
import {mdiSmartCardOff} from '@mdi/js'
import {mdiSmartCardOffOutline} from '@mdi/js'
import {mdiSmartCardOutline} from '@mdi/js'
import {mdiSmartCardReader} from '@mdi/js'
import {mdiSmartCardReaderOutline} from '@mdi/js'
import {mdiSmog} from '@mdi/js'
import {mdiSmoke} from '@mdi/js'
import {mdiSmokeDetector} from '@mdi/js'
import {mdiSmokeDetectorAlert} from '@mdi/js'
import {mdiSmokeDetectorAlertOutline} from '@mdi/js'
import {mdiSmokeDetectorOff} from '@mdi/js'
import {mdiSmokeDetectorOffOutline} from '@mdi/js'
import {mdiSmokeDetectorOutline} from '@mdi/js'
import {mdiSmokeDetectorVariant} from '@mdi/js'
import {mdiSmokeDetectorVariantAlert} from '@mdi/js'
import {mdiSmokeDetectorVariantOff} from '@mdi/js'
import {mdiSmoking} from '@mdi/js'
import {mdiSmokingOff} from '@mdi/js'
import {mdiSmokingPipe} from '@mdi/js'
import {mdiSmokingPipeOff} from '@mdi/js'
import {mdiSnail} from '@mdi/js'
import {mdiSnake} from '@mdi/js'
import {mdiSnapchat} from '@mdi/js'
import {mdiSnowboard} from '@mdi/js'
import {mdiSnowflake} from '@mdi/js'
import {mdiSnowflakeAlert} from '@mdi/js'
import {mdiSnowflakeCheck} from '@mdi/js'
import {mdiSnowflakeMelt} from '@mdi/js'
import {mdiSnowflakeOff} from '@mdi/js'
import {mdiSnowflakeThermometer} from '@mdi/js'
import {mdiSnowflakeVariant} from '@mdi/js'
import {mdiSnowman} from '@mdi/js'
import {mdiSnowmobile} from '@mdi/js'
import {mdiSnowshoeing} from '@mdi/js'
import {mdiSoccer} from '@mdi/js'
import {mdiSoccerField} from '@mdi/js'
import {mdiSocialDistance2Meters} from '@mdi/js'
import {mdiSocialDistance6Feet} from '@mdi/js'
import {mdiSofa} from '@mdi/js'
import {mdiSofaOutline} from '@mdi/js'
import {mdiSofaSingle} from '@mdi/js'
import {mdiSofaSingleOutline} from '@mdi/js'
import {mdiSolarPanel} from '@mdi/js'
import {mdiSolarPanelLarge} from '@mdi/js'
import {mdiSolarPower} from '@mdi/js'
import {mdiSolarPowerVariant} from '@mdi/js'
import {mdiSolarPowerVariantOutline} from '@mdi/js'
import {mdiSolderingIron} from '@mdi/js'
import {mdiSolid} from '@mdi/js'
import {mdiSonyPlaystation} from '@mdi/js'
import {mdiSort} from '@mdi/js'
import {mdiSortAlphabeticalAscending} from '@mdi/js'
import {mdiSortAlphabeticalAscendingVariant} from '@mdi/js'
import {mdiSortAlphabeticalDescending} from '@mdi/js'
import {mdiSortAlphabeticalDescendingVariant} from '@mdi/js'
import {mdiSortAlphabeticalVariant} from '@mdi/js'
import {mdiSortAscending} from '@mdi/js'
import {mdiSortBoolAscending} from '@mdi/js'
import {mdiSortBoolAscendingVariant} from '@mdi/js'
import {mdiSortBoolDescending} from '@mdi/js'
import {mdiSortBoolDescendingVariant} from '@mdi/js'
import {mdiSortCalendarAscending} from '@mdi/js'
import {mdiSortCalendarDescending} from '@mdi/js'
import {mdiSortClockAscending} from '@mdi/js'
import {mdiSortClockAscendingOutline} from '@mdi/js'
import {mdiSortClockDescending} from '@mdi/js'
import {mdiSortClockDescendingOutline} from '@mdi/js'
import {mdiSortDescending} from '@mdi/js'
import {mdiSortNumericAscending} from '@mdi/js'
import {mdiSortNumericAscendingVariant} from '@mdi/js'
import {mdiSortNumericDescending} from '@mdi/js'
import {mdiSortNumericDescendingVariant} from '@mdi/js'
import {mdiSortNumericVariant} from '@mdi/js'
import {mdiSortReverseVariant} from '@mdi/js'
import {mdiSortVariant} from '@mdi/js'
import {mdiSortVariantLock} from '@mdi/js'
import {mdiSortVariantLockOpen} from '@mdi/js'
import {mdiSortVariantOff} from '@mdi/js'
import {mdiSortVariantRemove} from '@mdi/js'
import {mdiSoundbar} from '@mdi/js'
import {mdiSoundcloud} from '@mdi/js'
import {mdiSourceBranch} from '@mdi/js'
import {mdiSourceBranchCheck} from '@mdi/js'
import {mdiSourceBranchMinus} from '@mdi/js'
import {mdiSourceBranchPlus} from '@mdi/js'
import {mdiSourceBranchRefresh} from '@mdi/js'
import {mdiSourceBranchRemove} from '@mdi/js'
import {mdiSourceBranchSync} from '@mdi/js'
import {mdiSourceCommit} from '@mdi/js'
import {mdiSourceCommitEnd} from '@mdi/js'
import {mdiSourceCommitEndLocal} from '@mdi/js'
import {mdiSourceCommitLocal} from '@mdi/js'
import {mdiSourceCommitNextLocal} from '@mdi/js'
import {mdiSourceCommitStart} from '@mdi/js'
import {mdiSourceCommitStartNextLocal} from '@mdi/js'
import {mdiSourceFork} from '@mdi/js'
import {mdiSourceMerge} from '@mdi/js'
import {mdiSourcePull} from '@mdi/js'
import {mdiSourceRepository} from '@mdi/js'
import {mdiSourceRepositoryMultiple} from '@mdi/js'
import {mdiSoySauce} from '@mdi/js'
import {mdiSoySauceOff} from '@mdi/js'
import {mdiSpa} from '@mdi/js'
import {mdiSpaOutline} from '@mdi/js'
import {mdiSpaceInvaders} from '@mdi/js'
import {mdiSpaceStation} from '@mdi/js'
import {mdiSpade} from '@mdi/js'
import {mdiSpeaker} from '@mdi/js'
import {mdiSpeakerBluetooth} from '@mdi/js'
import {mdiSpeakerMessage} from '@mdi/js'
import {mdiSpeakerMultiple} from '@mdi/js'
import {mdiSpeakerOff} from '@mdi/js'
import {mdiSpeakerPause} from '@mdi/js'
import {mdiSpeakerPlay} from '@mdi/js'
import {mdiSpeakerStop} from '@mdi/js'
import {mdiSpeakerWireless} from '@mdi/js'
import {mdiSpear} from '@mdi/js'
import {mdiSpeedometer} from '@mdi/js'
import {mdiSpeedometerMedium} from '@mdi/js'
import {mdiSpeedometerSlow} from '@mdi/js'
import {mdiSpellcheck} from '@mdi/js'
import {mdiSphere} from '@mdi/js'
import {mdiSphereOff} from '@mdi/js'
import {mdiSpider} from '@mdi/js'
import {mdiSpiderThread} from '@mdi/js'
import {mdiSpiderWeb} from '@mdi/js'
import {mdiSpiritLevel} from '@mdi/js'
import {mdiSpoonSugar} from '@mdi/js'
import {mdiSpotify} from '@mdi/js'
import {mdiSpotlight} from '@mdi/js'
import {mdiSpotlightBeam} from '@mdi/js'
import {mdiSpray} from '@mdi/js'
import {mdiSprayBottle} from '@mdi/js'
import {mdiSprinkler} from '@mdi/js'
import {mdiSprinklerFire} from '@mdi/js'
import {mdiSprinklerVariant} from '@mdi/js'
import {mdiSprout} from '@mdi/js'
import {mdiSproutOutline} from '@mdi/js'
import {mdiSquare} from '@mdi/js'
import {mdiSquareCircle} from '@mdi/js'
import {mdiSquareEditOutline} from '@mdi/js'
import {mdiSquareMedium} from '@mdi/js'
import {mdiSquareMediumOutline} from '@mdi/js'
import {mdiSquareOff} from '@mdi/js'
import {mdiSquareOffOutline} from '@mdi/js'
import {mdiSquareOpacity} from '@mdi/js'
import {mdiSquareOutline} from '@mdi/js'
import {mdiSquareRoot} from '@mdi/js'
import {mdiSquareRootBox} from '@mdi/js'
import {mdiSquareRounded} from '@mdi/js'
import {mdiSquareRoundedBadge} from '@mdi/js'
import {mdiSquareRoundedBadgeOutline} from '@mdi/js'
import {mdiSquareRoundedOutline} from '@mdi/js'
import {mdiSquareSmall} from '@mdi/js'
import {mdiSquareWave} from '@mdi/js'
import {mdiSqueegee} from '@mdi/js'
import {mdiSsh} from '@mdi/js'
import {mdiStackExchange} from '@mdi/js'
import {mdiStackOverflow} from '@mdi/js'
import {mdiStackpath} from '@mdi/js'
import {mdiStadium} from '@mdi/js'
import {mdiStadiumOutline} from '@mdi/js'
import {mdiStadiumVariant} from '@mdi/js'
import {mdiStairs} from '@mdi/js'
import {mdiStairsBox} from '@mdi/js'
import {mdiStairsDown} from '@mdi/js'
import {mdiStairsUp} from '@mdi/js'
import {mdiStamper} from '@mdi/js'
import {mdiStandardDefinition} from '@mdi/js'
import {mdiStar} from '@mdi/js'
import {mdiStarBox} from '@mdi/js'
import {mdiStarBoxMultiple} from '@mdi/js'
import {mdiStarBoxMultipleOutline} from '@mdi/js'
import {mdiStarBoxOutline} from '@mdi/js'
import {mdiStarCheck} from '@mdi/js'
import {mdiStarCheckOutline} from '@mdi/js'
import {mdiStarCircle} from '@mdi/js'
import {mdiStarCircleOutline} from '@mdi/js'
import {mdiStarCog} from '@mdi/js'
import {mdiStarCogOutline} from '@mdi/js'
import {mdiStarCrescent} from '@mdi/js'
import {mdiStarDavid} from '@mdi/js'
import {mdiStarFace} from '@mdi/js'
import {mdiStarFourPoints} from '@mdi/js'
import {mdiStarFourPointsOutline} from '@mdi/js'
import {mdiStarHalf} from '@mdi/js'
import {mdiStarHalfFull} from '@mdi/js'
import {mdiStarMinus} from '@mdi/js'
import {mdiStarMinusOutline} from '@mdi/js'
import {mdiStarOff} from '@mdi/js'
import {mdiStarOffOutline} from '@mdi/js'
import {mdiStarOutline} from '@mdi/js'
import {mdiStarPlus} from '@mdi/js'
import {mdiStarPlusOutline} from '@mdi/js'
import {mdiStarRemove} from '@mdi/js'
import {mdiStarRemoveOutline} from '@mdi/js'
import {mdiStarSettings} from '@mdi/js'
import {mdiStarSettingsOutline} from '@mdi/js'
import {mdiStarShooting} from '@mdi/js'
import {mdiStarShootingOutline} from '@mdi/js'
import {mdiStarThreePoints} from '@mdi/js'
import {mdiStarThreePointsOutline} from '@mdi/js'
import {mdiStateMachine} from '@mdi/js'
import {mdiSteam} from '@mdi/js'
import {mdiSteering} from '@mdi/js'
import {mdiSteeringOff} from '@mdi/js'
import {mdiStepBackward} from '@mdi/js'
import {mdiStepBackward2} from '@mdi/js'
import {mdiStepForward} from '@mdi/js'
import {mdiStepForward2} from '@mdi/js'
import {mdiStethoscope} from '@mdi/js'
import {mdiSticker} from '@mdi/js'
import {mdiStickerAlert} from '@mdi/js'
import {mdiStickerAlertOutline} from '@mdi/js'
import {mdiStickerCheck} from '@mdi/js'
import {mdiStickerCheckOutline} from '@mdi/js'
import {mdiStickerCircleOutline} from '@mdi/js'
import {mdiStickerEmoji} from '@mdi/js'
import {mdiStickerMinus} from '@mdi/js'
import {mdiStickerMinusOutline} from '@mdi/js'
import {mdiStickerOutline} from '@mdi/js'
import {mdiStickerPlus} from '@mdi/js'
import {mdiStickerPlusOutline} from '@mdi/js'
import {mdiStickerRemove} from '@mdi/js'
import {mdiStickerRemoveOutline} from '@mdi/js'
import {mdiStickerText} from '@mdi/js'
import {mdiStickerTextOutline} from '@mdi/js'
import {mdiStocking} from '@mdi/js'
import {mdiStomach} from '@mdi/js'
import {mdiStool} from '@mdi/js'
import {mdiStoolOutline} from '@mdi/js'
import {mdiStop} from '@mdi/js'
import {mdiStopCircle} from '@mdi/js'
import {mdiStopCircleOutline} from '@mdi/js'
import {mdiStorageTank} from '@mdi/js'
import {mdiStorageTankOutline} from '@mdi/js'
import {mdiStore} from '@mdi/js'
import {mdiStore24Hour} from '@mdi/js'
import {mdiStoreAlert} from '@mdi/js'
import {mdiStoreAlertOutline} from '@mdi/js'
import {mdiStoreCheck} from '@mdi/js'
import {mdiStoreCheckOutline} from '@mdi/js'
import {mdiStoreClock} from '@mdi/js'
import {mdiStoreClockOutline} from '@mdi/js'
import {mdiStoreCog} from '@mdi/js'
import {mdiStoreCogOutline} from '@mdi/js'
import {mdiStoreEdit} from '@mdi/js'
import {mdiStoreEditOutline} from '@mdi/js'
import {mdiStoreMarker} from '@mdi/js'
import {mdiStoreMarkerOutline} from '@mdi/js'
import {mdiStoreMinus} from '@mdi/js'
import {mdiStoreMinusOutline} from '@mdi/js'
import {mdiStoreOff} from '@mdi/js'
import {mdiStoreOffOutline} from '@mdi/js'
import {mdiStoreOutline} from '@mdi/js'
import {mdiStorePlus} from '@mdi/js'
import {mdiStorePlusOutline} from '@mdi/js'
import {mdiStoreRemove} from '@mdi/js'
import {mdiStoreRemoveOutline} from '@mdi/js'
import {mdiStoreSearch} from '@mdi/js'
import {mdiStoreSearchOutline} from '@mdi/js'
import {mdiStoreSettings} from '@mdi/js'
import {mdiStoreSettingsOutline} from '@mdi/js'
import {mdiStorefront} from '@mdi/js'
import {mdiStorefrontCheck} from '@mdi/js'
import {mdiStorefrontCheckOutline} from '@mdi/js'
import {mdiStorefrontEdit} from '@mdi/js'
import {mdiStorefrontEditOutline} from '@mdi/js'
import {mdiStorefrontMinus} from '@mdi/js'
import {mdiStorefrontMinusOutline} from '@mdi/js'
import {mdiStorefrontOutline} from '@mdi/js'
import {mdiStorefrontPlus} from '@mdi/js'
import {mdiStorefrontPlusOutline} from '@mdi/js'
import {mdiStorefrontRemove} from '@mdi/js'
import {mdiStorefrontRemoveOutline} from '@mdi/js'
import {mdiStove} from '@mdi/js'
import {mdiStrategy} from '@mdi/js'
import {mdiStretchToPage} from '@mdi/js'
import {mdiStretchToPageOutline} from '@mdi/js'
import {mdiStringLights} from '@mdi/js'
import {mdiStringLightsOff} from '@mdi/js'
import {mdiSubdirectoryArrowLeft} from '@mdi/js'
import {mdiSubdirectoryArrowRight} from '@mdi/js'
import {mdiSubmarine} from '@mdi/js'
import {mdiSubtitles} from '@mdi/js'
import {mdiSubtitlesOutline} from '@mdi/js'
import {mdiSubway} from '@mdi/js'
import {mdiSubwayAlertVariant} from '@mdi/js'
import {mdiSubwayVariant} from '@mdi/js'
import {mdiSummit} from '@mdi/js'
import {mdiSunAngle} from '@mdi/js'
import {mdiSunAngleOutline} from '@mdi/js'
import {mdiSunClock} from '@mdi/js'
import {mdiSunClockOutline} from '@mdi/js'
import {mdiSunCompass} from '@mdi/js'
import {mdiSunSnowflake} from '@mdi/js'
import {mdiSunSnowflakeVariant} from '@mdi/js'
import {mdiSunThermometer} from '@mdi/js'
import {mdiSunThermometerOutline} from '@mdi/js'
import {mdiSunWireless} from '@mdi/js'
import {mdiSunWirelessOutline} from '@mdi/js'
import {mdiSunglasses} from '@mdi/js'
import {mdiSurfing} from '@mdi/js'
import {mdiSurroundSound} from '@mdi/js'
import {mdiSurroundSound20} from '@mdi/js'
import {mdiSurroundSound21} from '@mdi/js'
import {mdiSurroundSound31} from '@mdi/js'
import {mdiSurroundSound51} from '@mdi/js'
import {mdiSurroundSound512} from '@mdi/js'
import {mdiSurroundSound71} from '@mdi/js'
import {mdiSvg} from '@mdi/js'
import {mdiSwapHorizontal} from '@mdi/js'
import {mdiSwapHorizontalBold} from '@mdi/js'
import {mdiSwapHorizontalCircle} from '@mdi/js'
import {mdiSwapHorizontalCircleOutline} from '@mdi/js'
import {mdiSwapHorizontalVariant} from '@mdi/js'
import {mdiSwapVertical} from '@mdi/js'
import {mdiSwapVerticalBold} from '@mdi/js'
import {mdiSwapVerticalCircle} from '@mdi/js'
import {mdiSwapVerticalCircleOutline} from '@mdi/js'
import {mdiSwapVerticalVariant} from '@mdi/js'
import {mdiSwim} from '@mdi/js'
import {mdiSwitch} from '@mdi/js'
import {mdiSword} from '@mdi/js'
import {mdiSwordCross} from '@mdi/js'
import {mdiSyllabaryHangul} from '@mdi/js'
import {mdiSyllabaryHiragana} from '@mdi/js'
import {mdiSyllabaryKatakana} from '@mdi/js'
import {mdiSyllabaryKatakanaHalfwidth} from '@mdi/js'
import {mdiSymbol} from '@mdi/js'
import {mdiSymfony} from '@mdi/js'
import {mdiSynagogue} from '@mdi/js'
import {mdiSynagogueOutline} from '@mdi/js'
import {mdiSync} from '@mdi/js'
import {mdiSyncAlert} from '@mdi/js'
import {mdiSyncCircle} from '@mdi/js'
import {mdiSyncOff} from '@mdi/js'
import {mdiTab} from '@mdi/js'
import {mdiTabMinus} from '@mdi/js'
import {mdiTabPlus} from '@mdi/js'
import {mdiTabRemove} from '@mdi/js'
import {mdiTabSearch} from '@mdi/js'
import {mdiTabUnselected} from '@mdi/js'
import {mdiTable} from '@mdi/js'
import {mdiTableAccount} from '@mdi/js'
import {mdiTableAlert} from '@mdi/js'
import {mdiTableArrowDown} from '@mdi/js'
import {mdiTableArrowLeft} from '@mdi/js'
import {mdiTableArrowRight} from '@mdi/js'
import {mdiTableArrowUp} from '@mdi/js'
import {mdiTableBorder} from '@mdi/js'
import {mdiTableCancel} from '@mdi/js'
import {mdiTableChair} from '@mdi/js'
import {mdiTableCheck} from '@mdi/js'
import {mdiTableClock} from '@mdi/js'
import {mdiTableCog} from '@mdi/js'
import {mdiTableColumn} from '@mdi/js'
import {mdiTableColumnPlusAfter} from '@mdi/js'
import {mdiTableColumnPlusBefore} from '@mdi/js'
import {mdiTableColumnRemove} from '@mdi/js'
import {mdiTableColumnWidth} from '@mdi/js'
import {mdiTableEdit} from '@mdi/js'
import {mdiTableEye} from '@mdi/js'
import {mdiTableEyeOff} from '@mdi/js'
import {mdiTableFilter} from '@mdi/js'
import {mdiTableFurniture} from '@mdi/js'
import {mdiTableHeadersEye} from '@mdi/js'
import {mdiTableHeadersEyeOff} from '@mdi/js'
import {mdiTableHeart} from '@mdi/js'
import {mdiTableKey} from '@mdi/js'
import {mdiTableLarge} from '@mdi/js'
import {mdiTableLargePlus} from '@mdi/js'
import {mdiTableLargeRemove} from '@mdi/js'
import {mdiTableLock} from '@mdi/js'
import {mdiTableMergeCells} from '@mdi/js'
import {mdiTableMinus} from '@mdi/js'
import {mdiTableMultiple} from '@mdi/js'
import {mdiTableNetwork} from '@mdi/js'
import {mdiTableOfContents} from '@mdi/js'
import {mdiTableOff} from '@mdi/js'
import {mdiTablePicnic} from '@mdi/js'
import {mdiTablePivot} from '@mdi/js'
import {mdiTablePlus} from '@mdi/js'
import {mdiTableQuestion} from '@mdi/js'
import {mdiTableRefresh} from '@mdi/js'
import {mdiTableRemove} from '@mdi/js'
import {mdiTableRow} from '@mdi/js'
import {mdiTableRowHeight} from '@mdi/js'
import {mdiTableRowPlusAfter} from '@mdi/js'
import {mdiTableRowPlusBefore} from '@mdi/js'
import {mdiTableRowRemove} from '@mdi/js'
import {mdiTableSearch} from '@mdi/js'
import {mdiTableSettings} from '@mdi/js'
import {mdiTableSplitCell} from '@mdi/js'
import {mdiTableStar} from '@mdi/js'
import {mdiTableSync} from '@mdi/js'
import {mdiTableTennis} from '@mdi/js'
import {mdiTablet} from '@mdi/js'
import {mdiTabletCellphone} from '@mdi/js'
import {mdiTabletDashboard} from '@mdi/js'
import {mdiTaco} from '@mdi/js'
import {mdiTag} from '@mdi/js'
import {mdiTagArrowDown} from '@mdi/js'
import {mdiTagArrowDownOutline} from '@mdi/js'
import {mdiTagArrowLeft} from '@mdi/js'
import {mdiTagArrowLeftOutline} from '@mdi/js'
import {mdiTagArrowRight} from '@mdi/js'
import {mdiTagArrowRightOutline} from '@mdi/js'
import {mdiTagArrowUp} from '@mdi/js'
import {mdiTagArrowUpOutline} from '@mdi/js'
import {mdiTagCheck} from '@mdi/js'
import {mdiTagCheckOutline} from '@mdi/js'
import {mdiTagFaces} from '@mdi/js'
import {mdiTagHeart} from '@mdi/js'
import {mdiTagHeartOutline} from '@mdi/js'
import {mdiTagMinus} from '@mdi/js'
import {mdiTagMinusOutline} from '@mdi/js'
import {mdiTagMultiple} from '@mdi/js'
import {mdiTagMultipleOutline} from '@mdi/js'
import {mdiTagOff} from '@mdi/js'
import {mdiTagOffOutline} from '@mdi/js'
import {mdiTagOutline} from '@mdi/js'
import {mdiTagPlus} from '@mdi/js'
import {mdiTagPlusOutline} from '@mdi/js'
import {mdiTagRemove} from '@mdi/js'
import {mdiTagRemoveOutline} from '@mdi/js'
import {mdiTagSearch} from '@mdi/js'
import {mdiTagSearchOutline} from '@mdi/js'
import {mdiTagText} from '@mdi/js'
import {mdiTagTextOutline} from '@mdi/js'
import {mdiTailwind} from '@mdi/js'
import {mdiTallyMark1} from '@mdi/js'
import {mdiTallyMark2} from '@mdi/js'
import {mdiTallyMark3} from '@mdi/js'
import {mdiTallyMark4} from '@mdi/js'
import {mdiTallyMark5} from '@mdi/js'
import {mdiTangram} from '@mdi/js'
import {mdiTank} from '@mdi/js'
import {mdiTankerTruck} from '@mdi/js'
import {mdiTapeDrive} from '@mdi/js'
import {mdiTapeMeasure} from '@mdi/js'
import {mdiTarget} from '@mdi/js'
import {mdiTargetAccount} from '@mdi/js'
import {mdiTargetVariant} from '@mdi/js'
import {mdiTaxi} from '@mdi/js'
import {mdiTea} from '@mdi/js'
import {mdiTeaOutline} from '@mdi/js'
import {mdiTeamviewer} from '@mdi/js'
import {mdiTeddyBear} from '@mdi/js'
import {mdiTelescope} from '@mdi/js'
import {mdiTelevision} from '@mdi/js'
import {mdiTelevisionAmbientLight} from '@mdi/js'
import {mdiTelevisionBox} from '@mdi/js'
import {mdiTelevisionClassic} from '@mdi/js'
import {mdiTelevisionClassicOff} from '@mdi/js'
import {mdiTelevisionGuide} from '@mdi/js'
import {mdiTelevisionOff} from '@mdi/js'
import {mdiTelevisionPause} from '@mdi/js'
import {mdiTelevisionPlay} from '@mdi/js'
import {mdiTelevisionShimmer} from '@mdi/js'
import {mdiTelevisionSpeaker} from '@mdi/js'
import {mdiTelevisionSpeakerOff} from '@mdi/js'
import {mdiTelevisionStop} from '@mdi/js'
import {mdiTemperatureCelsius} from '@mdi/js'
import {mdiTemperatureFahrenheit} from '@mdi/js'
import {mdiTemperatureKelvin} from '@mdi/js'
import {mdiTempleBuddhist} from '@mdi/js'
import {mdiTempleBuddhistOutline} from '@mdi/js'
import {mdiTempleHindu} from '@mdi/js'
import {mdiTempleHinduOutline} from '@mdi/js'
import {mdiTennis} from '@mdi/js'
import {mdiTennisBall} from '@mdi/js'
import {mdiTent} from '@mdi/js'
import {mdiTerraform} from '@mdi/js'
import {mdiTerrain} from '@mdi/js'
import {mdiTestTube} from '@mdi/js'
import {mdiTestTubeEmpty} from '@mdi/js'
import {mdiTestTubeOff} from '@mdi/js'
import {mdiText} from '@mdi/js'
import {mdiTextAccount} from '@mdi/js'
import {mdiTextBox} from '@mdi/js'
import {mdiTextBoxCheck} from '@mdi/js'
import {mdiTextBoxCheckOutline} from '@mdi/js'
import {mdiTextBoxEdit} from '@mdi/js'
import {mdiTextBoxEditOutline} from '@mdi/js'
import {mdiTextBoxMinus} from '@mdi/js'
import {mdiTextBoxMinusOutline} from '@mdi/js'
import {mdiTextBoxMultiple} from '@mdi/js'
import {mdiTextBoxMultipleOutline} from '@mdi/js'
import {mdiTextBoxOutline} from '@mdi/js'
import {mdiTextBoxPlus} from '@mdi/js'
import {mdiTextBoxPlusOutline} from '@mdi/js'
import {mdiTextBoxRemove} from '@mdi/js'
import {mdiTextBoxRemoveOutline} from '@mdi/js'
import {mdiTextBoxSearch} from '@mdi/js'
import {mdiTextBoxSearchOutline} from '@mdi/js'
import {mdiTextLong} from '@mdi/js'
import {mdiTextRecognition} from '@mdi/js'
import {mdiTextSearch} from '@mdi/js'
import {mdiTextSearchVariant} from '@mdi/js'
import {mdiTextShadow} from '@mdi/js'
import {mdiTextShort} from '@mdi/js'
import {mdiTexture} from '@mdi/js'
import {mdiTextureBox} from '@mdi/js'
import {mdiTheater} from '@mdi/js'
import {mdiThemeLightDark} from '@mdi/js'
import {mdiThermometer} from '@mdi/js'
import {mdiThermometerAlert} from '@mdi/js'
import {mdiThermometerAuto} from '@mdi/js'
import {mdiThermometerBluetooth} from '@mdi/js'
import {mdiThermometerCheck} from '@mdi/js'
import {mdiThermometerChevronDown} from '@mdi/js'
import {mdiThermometerChevronUp} from '@mdi/js'
import {mdiThermometerHigh} from '@mdi/js'
import {mdiThermometerLines} from '@mdi/js'
import {mdiThermometerLow} from '@mdi/js'
import {mdiThermometerMinus} from '@mdi/js'
import {mdiThermometerOff} from '@mdi/js'
import {mdiThermometerPlus} from '@mdi/js'
import {mdiThermometerProbe} from '@mdi/js'
import {mdiThermometerProbeOff} from '@mdi/js'
import {mdiThermometerWater} from '@mdi/js'
import {mdiThermostat} from '@mdi/js'
import {mdiThermostatAuto} from '@mdi/js'
import {mdiThermostatBox} from '@mdi/js'
import {mdiThermostatBoxAuto} from '@mdi/js'
import {mdiThoughtBubble} from '@mdi/js'
import {mdiThoughtBubbleOutline} from '@mdi/js'
import {mdiThumbDown} from '@mdi/js'
import {mdiThumbDownOutline} from '@mdi/js'
import {mdiThumbUp} from '@mdi/js'
import {mdiThumbUpOutline} from '@mdi/js'
import {mdiThumbsUpDown} from '@mdi/js'
import {mdiThumbsUpDownOutline} from '@mdi/js'
import {mdiTicket} from '@mdi/js'
import {mdiTicketAccount} from '@mdi/js'
import {mdiTicketConfirmation} from '@mdi/js'
import {mdiTicketConfirmationOutline} from '@mdi/js'
import {mdiTicketOutline} from '@mdi/js'
import {mdiTicketPercent} from '@mdi/js'
import {mdiTicketPercentOutline} from '@mdi/js'
import {mdiTie} from '@mdi/js'
import {mdiTilde} from '@mdi/js'
import {mdiTildeOff} from '@mdi/js'
import {mdiTimelapse} from '@mdi/js'
import {mdiTimeline} from '@mdi/js'
import {mdiTimelineAlert} from '@mdi/js'
import {mdiTimelineAlertOutline} from '@mdi/js'
import {mdiTimelineCheck} from '@mdi/js'
import {mdiTimelineCheckOutline} from '@mdi/js'
import {mdiTimelineClock} from '@mdi/js'
import {mdiTimelineClockOutline} from '@mdi/js'
import {mdiTimelineMinus} from '@mdi/js'
import {mdiTimelineMinusOutline} from '@mdi/js'
import {mdiTimelineOutline} from '@mdi/js'
import {mdiTimelinePlus} from '@mdi/js'
import {mdiTimelinePlusOutline} from '@mdi/js'
import {mdiTimelineQuestion} from '@mdi/js'
import {mdiTimelineQuestionOutline} from '@mdi/js'
import {mdiTimelineRemove} from '@mdi/js'
import {mdiTimelineRemoveOutline} from '@mdi/js'
import {mdiTimelineText} from '@mdi/js'
import {mdiTimelineTextOutline} from '@mdi/js'
import {mdiTimer} from '@mdi/js'
import {mdiTimer10} from '@mdi/js'
import {mdiTimer3} from '@mdi/js'
import {mdiTimerAlert} from '@mdi/js'
import {mdiTimerAlertOutline} from '@mdi/js'
import {mdiTimerCancel} from '@mdi/js'
import {mdiTimerCancelOutline} from '@mdi/js'
import {mdiTimerCheck} from '@mdi/js'
import {mdiTimerCheckOutline} from '@mdi/js'
import {mdiTimerCog} from '@mdi/js'
import {mdiTimerCogOutline} from '@mdi/js'
import {mdiTimerEdit} from '@mdi/js'
import {mdiTimerEditOutline} from '@mdi/js'
import {mdiTimerLock} from '@mdi/js'
import {mdiTimerLockOpen} from '@mdi/js'
import {mdiTimerLockOpenOutline} from '@mdi/js'
import {mdiTimerLockOutline} from '@mdi/js'
import {mdiTimerMarker} from '@mdi/js'
import {mdiTimerMarkerOutline} from '@mdi/js'
import {mdiTimerMinus} from '@mdi/js'
import {mdiTimerMinusOutline} from '@mdi/js'
import {mdiTimerMusic} from '@mdi/js'
import {mdiTimerMusicOutline} from '@mdi/js'
import {mdiTimerOff} from '@mdi/js'
import {mdiTimerOffOutline} from '@mdi/js'
import {mdiTimerOutline} from '@mdi/js'
import {mdiTimerPause} from '@mdi/js'
import {mdiTimerPauseOutline} from '@mdi/js'
import {mdiTimerPlay} from '@mdi/js'
import {mdiTimerPlayOutline} from '@mdi/js'
import {mdiTimerPlus} from '@mdi/js'
import {mdiTimerPlusOutline} from '@mdi/js'
import {mdiTimerRefresh} from '@mdi/js'
import {mdiTimerRefreshOutline} from '@mdi/js'
import {mdiTimerRemove} from '@mdi/js'
import {mdiTimerRemoveOutline} from '@mdi/js'
import {mdiTimerSand} from '@mdi/js'
import {mdiTimerSandComplete} from '@mdi/js'
import {mdiTimerSandEmpty} from '@mdi/js'
import {mdiTimerSandFull} from '@mdi/js'
import {mdiTimerSandPaused} from '@mdi/js'
import {mdiTimerSettings} from '@mdi/js'
import {mdiTimerSettingsOutline} from '@mdi/js'
import {mdiTimerStar} from '@mdi/js'
import {mdiTimerStarOutline} from '@mdi/js'
import {mdiTimerStop} from '@mdi/js'
import {mdiTimerStopOutline} from '@mdi/js'
import {mdiTimerSync} from '@mdi/js'
import {mdiTimerSyncOutline} from '@mdi/js'
import {mdiTimetable} from '@mdi/js'
import {mdiTire} from '@mdi/js'
import {mdiToaster} from '@mdi/js'
import {mdiToasterOff} from '@mdi/js'
import {mdiToasterOven} from '@mdi/js'
import {mdiToggleSwitch} from '@mdi/js'
import {mdiToggleSwitchOff} from '@mdi/js'
import {mdiToggleSwitchOffOutline} from '@mdi/js'
import {mdiToggleSwitchOutline} from '@mdi/js'
import {mdiToggleSwitchVariant} from '@mdi/js'
import {mdiToggleSwitchVariantOff} from '@mdi/js'
import {mdiToilet} from '@mdi/js'
import {mdiToolbox} from '@mdi/js'
import {mdiToolboxOutline} from '@mdi/js'
import {mdiTools} from '@mdi/js'
import {mdiTooltip} from '@mdi/js'
import {mdiTooltipAccount} from '@mdi/js'
import {mdiTooltipCellphone} from '@mdi/js'
import {mdiTooltipCheck} from '@mdi/js'
import {mdiTooltipCheckOutline} from '@mdi/js'
import {mdiTooltipEdit} from '@mdi/js'
import {mdiTooltipEditOutline} from '@mdi/js'
import {mdiTooltipImage} from '@mdi/js'
import {mdiTooltipImageOutline} from '@mdi/js'
import {mdiTooltipMinus} from '@mdi/js'
import {mdiTooltipMinusOutline} from '@mdi/js'
import {mdiTooltipOutline} from '@mdi/js'
import {mdiTooltipPlus} from '@mdi/js'
import {mdiTooltipPlusOutline} from '@mdi/js'
import {mdiTooltipRemove} from '@mdi/js'
import {mdiTooltipRemoveOutline} from '@mdi/js'
import {mdiTooltipText} from '@mdi/js'
import {mdiTooltipTextOutline} from '@mdi/js'
import {mdiTooth} from '@mdi/js'
import {mdiToothOutline} from '@mdi/js'
import {mdiToothbrush} from '@mdi/js'
import {mdiToothbrushElectric} from '@mdi/js'
import {mdiToothbrushPaste} from '@mdi/js'
import {mdiTorch} from '@mdi/js'
import {mdiTortoise} from '@mdi/js'
import {mdiToslink} from '@mdi/js'
import {mdiTournament} from '@mdi/js'
import {mdiTowTruck} from '@mdi/js'
import {mdiTowerBeach} from '@mdi/js'
import {mdiTowerFire} from '@mdi/js'
import {mdiTownHall} from '@mdi/js'
import {mdiToyBrick} from '@mdi/js'
import {mdiToyBrickMarker} from '@mdi/js'
import {mdiToyBrickMarkerOutline} from '@mdi/js'
import {mdiToyBrickMinus} from '@mdi/js'
import {mdiToyBrickMinusOutline} from '@mdi/js'
import {mdiToyBrickOutline} from '@mdi/js'
import {mdiToyBrickPlus} from '@mdi/js'
import {mdiToyBrickPlusOutline} from '@mdi/js'
import {mdiToyBrickRemove} from '@mdi/js'
import {mdiToyBrickRemoveOutline} from '@mdi/js'
import {mdiToyBrickSearch} from '@mdi/js'
import {mdiToyBrickSearchOutline} from '@mdi/js'
import {mdiTrackLight} from '@mdi/js'
import {mdiTrackLightOff} from '@mdi/js'
import {mdiTrackpad} from '@mdi/js'
import {mdiTrackpadLock} from '@mdi/js'
import {mdiTractor} from '@mdi/js'
import {mdiTractorVariant} from '@mdi/js'
import {mdiTrademark} from '@mdi/js'
import {mdiTrafficCone} from '@mdi/js'
import {mdiTrafficLight} from '@mdi/js'
import {mdiTrafficLightOutline} from '@mdi/js'
import {mdiTrain} from '@mdi/js'
import {mdiTrainCar} from '@mdi/js'
import {mdiTrainCarAutorack} from '@mdi/js'
import {mdiTrainCarBox} from '@mdi/js'
import {mdiTrainCarBoxFull} from '@mdi/js'
import {mdiTrainCarBoxOpen} from '@mdi/js'
import {mdiTrainCarCaboose} from '@mdi/js'
import {mdiTrainCarCenterbeam} from '@mdi/js'
import {mdiTrainCarCenterbeamFull} from '@mdi/js'
import {mdiTrainCarContainer} from '@mdi/js'
import {mdiTrainCarFlatbed} from '@mdi/js'
import {mdiTrainCarFlatbedCar} from '@mdi/js'
import {mdiTrainCarFlatbedTank} from '@mdi/js'
import {mdiTrainCarGondola} from '@mdi/js'
import {mdiTrainCarGondolaFull} from '@mdi/js'
import {mdiTrainCarHopper} from '@mdi/js'
import {mdiTrainCarHopperCovered} from '@mdi/js'
import {mdiTrainCarHopperFull} from '@mdi/js'
import {mdiTrainCarIntermodal} from '@mdi/js'
import {mdiTrainCarPassenger} from '@mdi/js'
import {mdiTrainCarPassengerDoor} from '@mdi/js'
import {mdiTrainCarPassengerDoorOpen} from '@mdi/js'
import {mdiTrainCarPassengerVariant} from '@mdi/js'
import {mdiTrainCarTank} from '@mdi/js'
import {mdiTrainVariant} from '@mdi/js'
import {mdiTram} from '@mdi/js'
import {mdiTramSide} from '@mdi/js'
import {mdiTranscribe} from '@mdi/js'
import {mdiTranscribeClose} from '@mdi/js'
import {mdiTransfer} from '@mdi/js'
import {mdiTransferDown} from '@mdi/js'
import {mdiTransferLeft} from '@mdi/js'
import {mdiTransferRight} from '@mdi/js'
import {mdiTransferUp} from '@mdi/js'
import {mdiTransitConnection} from '@mdi/js'
import {mdiTransitConnectionHorizontal} from '@mdi/js'
import {mdiTransitConnectionVariant} from '@mdi/js'
import {mdiTransitDetour} from '@mdi/js'
import {mdiTransitSkip} from '@mdi/js'
import {mdiTransitTransfer} from '@mdi/js'
import {mdiTransition} from '@mdi/js'
import {mdiTransitionMasked} from '@mdi/js'
import {mdiTranslate} from '@mdi/js'
import {mdiTranslateOff} from '@mdi/js'
import {mdiTranslateVariant} from '@mdi/js'
import {mdiTransmissionTower} from '@mdi/js'
import {mdiTransmissionTowerOff} from '@mdi/js'
import {mdiTrashCan} from '@mdi/js'
import {mdiTrashCanOutline} from '@mdi/js'
import {mdiTray} from '@mdi/js'
import {mdiTrayAlert} from '@mdi/js'
import {mdiTrayArrowDown} from '@mdi/js'
import {mdiTrayArrowUp} from '@mdi/js'
import {mdiTrayFull} from '@mdi/js'
import {mdiTrayMinus} from '@mdi/js'
import {mdiTrayPlus} from '@mdi/js'
import {mdiTrayRemove} from '@mdi/js'
import {mdiTreasureChest} from '@mdi/js'
import {mdiTree} from '@mdi/js'
import {mdiTreeOutline} from '@mdi/js'
import {mdiTrello} from '@mdi/js'
import {mdiTrendingDown} from '@mdi/js'
import {mdiTrendingNeutral} from '@mdi/js'
import {mdiTrendingUp} from '@mdi/js'
import {mdiTriangle} from '@mdi/js'
import {mdiTriangleOutline} from '@mdi/js'
import {mdiTriangleSmallDown} from '@mdi/js'
import {mdiTriangleSmallUp} from '@mdi/js'
import {mdiTriangleWave} from '@mdi/js'
import {mdiTriforce} from '@mdi/js'
import {mdiTrophy} from '@mdi/js'
import {mdiTrophyAward} from '@mdi/js'
import {mdiTrophyBroken} from '@mdi/js'
import {mdiTrophyOutline} from '@mdi/js'
import {mdiTrophyVariant} from '@mdi/js'
import {mdiTrophyVariantOutline} from '@mdi/js'
import {mdiTruck} from '@mdi/js'
import {mdiTruckAlert} from '@mdi/js'
import {mdiTruckAlertOutline} from '@mdi/js'
import {mdiTruckCargoContainer} from '@mdi/js'
import {mdiTruckCheck} from '@mdi/js'
import {mdiTruckCheckOutline} from '@mdi/js'
import {mdiTruckDelivery} from '@mdi/js'
import {mdiTruckDeliveryOutline} from '@mdi/js'
import {mdiTruckFast} from '@mdi/js'
import {mdiTruckFastOutline} from '@mdi/js'
import {mdiTruckFlatbed} from '@mdi/js'
import {mdiTruckMinus} from '@mdi/js'
import {mdiTruckMinusOutline} from '@mdi/js'
import {mdiTruckOutline} from '@mdi/js'
import {mdiTruckPlus} from '@mdi/js'
import {mdiTruckPlusOutline} from '@mdi/js'
import {mdiTruckRemove} from '@mdi/js'
import {mdiTruckRemoveOutline} from '@mdi/js'
import {mdiTruckSnowflake} from '@mdi/js'
import {mdiTruckTrailer} from '@mdi/js'
import {mdiTrumpet} from '@mdi/js'
import {mdiTshirtCrew} from '@mdi/js'
import {mdiTshirtCrewOutline} from '@mdi/js'
import {mdiTshirtV} from '@mdi/js'
import {mdiTshirtVOutline} from '@mdi/js'
import {mdiTsunami} from '@mdi/js'
import {mdiTumbleDryer} from '@mdi/js'
import {mdiTumbleDryerAlert} from '@mdi/js'
import {mdiTumbleDryerOff} from '@mdi/js'
import {mdiTune} from '@mdi/js'
import {mdiTuneVariant} from '@mdi/js'
import {mdiTuneVertical} from '@mdi/js'
import {mdiTuneVerticalVariant} from '@mdi/js'
import {mdiTunnel} from '@mdi/js'
import {mdiTunnelOutline} from '@mdi/js'
import {mdiTurbine} from '@mdi/js'
import {mdiTurkey} from '@mdi/js'
import {mdiTurnstile} from '@mdi/js'
import {mdiTurnstileOutline} from '@mdi/js'
import {mdiTurtle} from '@mdi/js'
import {mdiTwitch} from '@mdi/js'
import {mdiTwitter} from '@mdi/js'
import {mdiTwoFactorAuthentication} from '@mdi/js'
import {mdiTypewriter} from '@mdi/js'
import {mdiUbisoft} from '@mdi/js'
import {mdiUbuntu} from '@mdi/js'
import {mdiUfo} from '@mdi/js'
import {mdiUfoOutline} from '@mdi/js'
import {mdiUltraHighDefinition} from '@mdi/js'
import {mdiUmbraco} from '@mdi/js'
import {mdiUmbrella} from '@mdi/js'
import {mdiUmbrellaBeach} from '@mdi/js'
import {mdiUmbrellaBeachOutline} from '@mdi/js'
import {mdiUmbrellaClosed} from '@mdi/js'
import {mdiUmbrellaClosedOutline} from '@mdi/js'
import {mdiUmbrellaClosedVariant} from '@mdi/js'
import {mdiUmbrellaOutline} from '@mdi/js'
import {mdiUndo} from '@mdi/js'
import {mdiUndoVariant} from '@mdi/js'
import {mdiUnfoldLessHorizontal} from '@mdi/js'
import {mdiUnfoldLessVertical} from '@mdi/js'
import {mdiUnfoldMoreHorizontal} from '@mdi/js'
import {mdiUnfoldMoreVertical} from '@mdi/js'
import {mdiUngroup} from '@mdi/js'
import {mdiUnicode} from '@mdi/js'
import {mdiUnicorn} from '@mdi/js'
import {mdiUnicornVariant} from '@mdi/js'
import {mdiUnicycle} from '@mdi/js'
import {mdiUnity} from '@mdi/js'
import {mdiUnreal} from '@mdi/js'
import {mdiUpdate} from '@mdi/js'
import {mdiUpload} from '@mdi/js'
import {mdiUploadLock} from '@mdi/js'
import {mdiUploadLockOutline} from '@mdi/js'
import {mdiUploadMultiple} from '@mdi/js'
import {mdiUploadNetwork} from '@mdi/js'
import {mdiUploadNetworkOutline} from '@mdi/js'
import {mdiUploadOff} from '@mdi/js'
import {mdiUploadOffOutline} from '@mdi/js'
import {mdiUploadOutline} from '@mdi/js'
import {mdiUsb} from '@mdi/js'
import {mdiUsbFlashDrive} from '@mdi/js'
import {mdiUsbFlashDriveOutline} from '@mdi/js'
import {mdiUsbPort} from '@mdi/js'
import {mdiVacuum} from '@mdi/js'
import {mdiVacuumOutline} from '@mdi/js'
import {mdiValve} from '@mdi/js'
import {mdiValveClosed} from '@mdi/js'
import {mdiValveOpen} from '@mdi/js'
import {mdiVanPassenger} from '@mdi/js'
import {mdiVanUtility} from '@mdi/js'
import {mdiVanish} from '@mdi/js'
import {mdiVanishQuarter} from '@mdi/js'
import {mdiVanityLight} from '@mdi/js'
import {mdiVariable} from '@mdi/js'
import {mdiVariableBox} from '@mdi/js'
import {mdiVectorArrangeAbove} from '@mdi/js'
import {mdiVectorArrangeBelow} from '@mdi/js'
import {mdiVectorBezier} from '@mdi/js'
import {mdiVectorCircle} from '@mdi/js'
import {mdiVectorCircleVariant} from '@mdi/js'
import {mdiVectorCombine} from '@mdi/js'
import {mdiVectorCurve} from '@mdi/js'
import {mdiVectorDifference} from '@mdi/js'
import {mdiVectorDifferenceAb} from '@mdi/js'
import {mdiVectorDifferenceBa} from '@mdi/js'
import {mdiVectorEllipse} from '@mdi/js'
import {mdiVectorIntersection} from '@mdi/js'
import {mdiVectorLine} from '@mdi/js'
import {mdiVectorLink} from '@mdi/js'
import {mdiVectorPoint} from '@mdi/js'
import {mdiVectorPointEdit} from '@mdi/js'
import {mdiVectorPointMinus} from '@mdi/js'
import {mdiVectorPointPlus} from '@mdi/js'
import {mdiVectorPointSelect} from '@mdi/js'
import {mdiVectorPolygon} from '@mdi/js'
import {mdiVectorPolygonVariant} from '@mdi/js'
import {mdiVectorPolyline} from '@mdi/js'
import {mdiVectorPolylineEdit} from '@mdi/js'
import {mdiVectorPolylineMinus} from '@mdi/js'
import {mdiVectorPolylinePlus} from '@mdi/js'
import {mdiVectorPolylineRemove} from '@mdi/js'
import {mdiVectorRadius} from '@mdi/js'
import {mdiVectorRectangle} from '@mdi/js'
import {mdiVectorSelection} from '@mdi/js'
import {mdiVectorSquare} from '@mdi/js'
import {mdiVectorSquareClose} from '@mdi/js'
import {mdiVectorSquareEdit} from '@mdi/js'
import {mdiVectorSquareMinus} from '@mdi/js'
import {mdiVectorSquareOpen} from '@mdi/js'
import {mdiVectorSquarePlus} from '@mdi/js'
import {mdiVectorSquareRemove} from '@mdi/js'
import {mdiVectorTriangle} from '@mdi/js'
import {mdiVectorUnion} from '@mdi/js'
import {mdiVhs} from '@mdi/js'
import {mdiVibrate} from '@mdi/js'
import {mdiVibrateOff} from '@mdi/js'
import {mdiVideo} from '@mdi/js'
import {mdiVideo2d} from '@mdi/js'
import {mdiVideo3d} from '@mdi/js'
import {mdiVideo3dOff} from '@mdi/js'
import {mdiVideo3dVariant} from '@mdi/js'
import {mdiVideo4kBox} from '@mdi/js'
import {mdiVideoAccount} from '@mdi/js'
import {mdiVideoBox} from '@mdi/js'
import {mdiVideoBoxOff} from '@mdi/js'
import {mdiVideoCheck} from '@mdi/js'
import {mdiVideoCheckOutline} from '@mdi/js'
import {mdiVideoHighDefinition} from '@mdi/js'
import {mdiVideoImage} from '@mdi/js'
import {mdiVideoInputAntenna} from '@mdi/js'
import {mdiVideoInputComponent} from '@mdi/js'
import {mdiVideoInputHdmi} from '@mdi/js'
import {mdiVideoInputScart} from '@mdi/js'
import {mdiVideoInputSvideo} from '@mdi/js'
import {mdiVideoMarker} from '@mdi/js'
import {mdiVideoMarkerOutline} from '@mdi/js'
import {mdiVideoMinus} from '@mdi/js'
import {mdiVideoMinusOutline} from '@mdi/js'
import {mdiVideoOff} from '@mdi/js'
import {mdiVideoOffOutline} from '@mdi/js'
import {mdiVideoOutline} from '@mdi/js'
import {mdiVideoPlus} from '@mdi/js'
import {mdiVideoPlusOutline} from '@mdi/js'
import {mdiVideoStabilization} from '@mdi/js'
import {mdiVideoSwitch} from '@mdi/js'
import {mdiVideoSwitchOutline} from '@mdi/js'
import {mdiVideoVintage} from '@mdi/js'
import {mdiVideoWireless} from '@mdi/js'
import {mdiVideoWirelessOutline} from '@mdi/js'
import {mdiViewAgenda} from '@mdi/js'
import {mdiViewAgendaOutline} from '@mdi/js'
import {mdiViewArray} from '@mdi/js'
import {mdiViewArrayOutline} from '@mdi/js'
import {mdiViewCarousel} from '@mdi/js'
import {mdiViewCarouselOutline} from '@mdi/js'
import {mdiViewColumn} from '@mdi/js'
import {mdiViewColumnOutline} from '@mdi/js'
import {mdiViewComfy} from '@mdi/js'
import {mdiViewComfyOutline} from '@mdi/js'
import {mdiViewCompact} from '@mdi/js'
import {mdiViewCompactOutline} from '@mdi/js'
import {mdiViewDashboard} from '@mdi/js'
import {mdiViewDashboardEdit} from '@mdi/js'
import {mdiViewDashboardEditOutline} from '@mdi/js'
import {mdiViewDashboardOutline} from '@mdi/js'
import {mdiViewDashboardVariant} from '@mdi/js'
import {mdiViewDashboardVariantOutline} from '@mdi/js'
import {mdiViewDay} from '@mdi/js'
import {mdiViewDayOutline} from '@mdi/js'
import {mdiViewGallery} from '@mdi/js'
import {mdiViewGalleryOutline} from '@mdi/js'
import {mdiViewGrid} from '@mdi/js'
import {mdiViewGridOutline} from '@mdi/js'
import {mdiViewGridPlus} from '@mdi/js'
import {mdiViewGridPlusOutline} from '@mdi/js'
import {mdiViewHeadline} from '@mdi/js'
import {mdiViewList} from '@mdi/js'
import {mdiViewListOutline} from '@mdi/js'
import {mdiViewModule} from '@mdi/js'
import {mdiViewModuleOutline} from '@mdi/js'
import {mdiViewParallel} from '@mdi/js'
import {mdiViewParallelOutline} from '@mdi/js'
import {mdiViewQuilt} from '@mdi/js'
import {mdiViewQuiltOutline} from '@mdi/js'
import {mdiViewSequential} from '@mdi/js'
import {mdiViewSequentialOutline} from '@mdi/js'
import {mdiViewSplitHorizontal} from '@mdi/js'
import {mdiViewSplitVertical} from '@mdi/js'
import {mdiViewStream} from '@mdi/js'
import {mdiViewStreamOutline} from '@mdi/js'
import {mdiViewWeek} from '@mdi/js'
import {mdiViewWeekOutline} from '@mdi/js'
import {mdiVimeo} from '@mdi/js'
import {mdiViolin} from '@mdi/js'
import {mdiVirtualReality} from '@mdi/js'
import {mdiVirus} from '@mdi/js'
import {mdiVirusOff} from '@mdi/js'
import {mdiVirusOffOutline} from '@mdi/js'
import {mdiVirusOutline} from '@mdi/js'
import {mdiVlc} from '@mdi/js'
import {mdiVoicemail} from '@mdi/js'
import {mdiVolcano} from '@mdi/js'
import {mdiVolcanoOutline} from '@mdi/js'
import {mdiVolleyball} from '@mdi/js'
import {mdiVolumeEqual} from '@mdi/js'
import {mdiVolumeHigh} from '@mdi/js'
import {mdiVolumeLow} from '@mdi/js'
import {mdiVolumeMedium} from '@mdi/js'
import {mdiVolumeMinus} from '@mdi/js'
import {mdiVolumeMute} from '@mdi/js'
import {mdiVolumeOff} from '@mdi/js'
import {mdiVolumePlus} from '@mdi/js'
import {mdiVolumeSource} from '@mdi/js'
import {mdiVolumeVariantOff} from '@mdi/js'
import {mdiVolumeVibrate} from '@mdi/js'
import {mdiVote} from '@mdi/js'
import {mdiVoteOutline} from '@mdi/js'
import {mdiVpn} from '@mdi/js'
import {mdiVuejs} from '@mdi/js'
import {mdiVuetify} from '@mdi/js'
import {mdiWalk} from '@mdi/js'
import {mdiWall} from '@mdi/js'
import {mdiWallFire} from '@mdi/js'
import {mdiWallSconce} from '@mdi/js'
import {mdiWallSconceFlat} from '@mdi/js'
import {mdiWallSconceFlatOutline} from '@mdi/js'
import {mdiWallSconceFlatVariant} from '@mdi/js'
import {mdiWallSconceFlatVariantOutline} from '@mdi/js'
import {mdiWallSconceOutline} from '@mdi/js'
import {mdiWallSconceRound} from '@mdi/js'
import {mdiWallSconceRoundOutline} from '@mdi/js'
import {mdiWallSconceRoundVariant} from '@mdi/js'
import {mdiWallSconceRoundVariantOutline} from '@mdi/js'
import {mdiWallet} from '@mdi/js'
import {mdiWalletGiftcard} from '@mdi/js'
import {mdiWalletMembership} from '@mdi/js'
import {mdiWalletOutline} from '@mdi/js'
import {mdiWalletPlus} from '@mdi/js'
import {mdiWalletPlusOutline} from '@mdi/js'
import {mdiWalletTravel} from '@mdi/js'
import {mdiWallpaper} from '@mdi/js'
import {mdiWan} from '@mdi/js'
import {mdiWardrobe} from '@mdi/js'
import {mdiWardrobeOutline} from '@mdi/js'
import {mdiWarehouse} from '@mdi/js'
import {mdiWashingMachine} from '@mdi/js'
import {mdiWashingMachineAlert} from '@mdi/js'
import {mdiWashingMachineOff} from '@mdi/js'
import {mdiWatch} from '@mdi/js'
import {mdiWatchImportVariant} from '@mdi/js'
import {mdiWatchVariant} from '@mdi/js'
import {mdiWatchVibrate} from '@mdi/js'
import {mdiWatchVibrateOff} from '@mdi/js'
import {mdiWater} from '@mdi/js'
import {mdiWaterAlert} from '@mdi/js'
import {mdiWaterAlertOutline} from '@mdi/js'
import {mdiWaterBoiler} from '@mdi/js'
import {mdiWaterBoilerAlert} from '@mdi/js'
import {mdiWaterBoilerAuto} from '@mdi/js'
import {mdiWaterBoilerOff} from '@mdi/js'
import {mdiWaterCheck} from '@mdi/js'
import {mdiWaterCheckOutline} from '@mdi/js'
import {mdiWaterCircle} from '@mdi/js'
import {mdiWaterMinus} from '@mdi/js'
import {mdiWaterMinusOutline} from '@mdi/js'
import {mdiWaterOff} from '@mdi/js'
import {mdiWaterOffOutline} from '@mdi/js'
import {mdiWaterOpacity} from '@mdi/js'
import {mdiWaterOutline} from '@mdi/js'
import {mdiWaterPercent} from '@mdi/js'
import {mdiWaterPercentAlert} from '@mdi/js'
import {mdiWaterPlus} from '@mdi/js'
import {mdiWaterPlusOutline} from '@mdi/js'
import {mdiWaterPolo} from '@mdi/js'
import {mdiWaterPump} from '@mdi/js'
import {mdiWaterPumpOff} from '@mdi/js'
import {mdiWaterRemove} from '@mdi/js'
import {mdiWaterRemoveOutline} from '@mdi/js'
import {mdiWaterSync} from '@mdi/js'
import {mdiWaterThermometer} from '@mdi/js'
import {mdiWaterThermometerOutline} from '@mdi/js'
import {mdiWaterWell} from '@mdi/js'
import {mdiWaterWellOutline} from '@mdi/js'
import {mdiWaterfall} from '@mdi/js'
import {mdiWateringCan} from '@mdi/js'
import {mdiWateringCanOutline} from '@mdi/js'
import {mdiWatermark} from '@mdi/js'
import {mdiWave} from '@mdi/js'
import {mdiWaveform} from '@mdi/js'
import {mdiWaves} from '@mdi/js'
import {mdiWavesArrowLeft} from '@mdi/js'
import {mdiWavesArrowRight} from '@mdi/js'
import {mdiWavesArrowUp} from '@mdi/js'
import {mdiWaze} from '@mdi/js'
import {mdiWeatherCloudy} from '@mdi/js'
import {mdiWeatherCloudyAlert} from '@mdi/js'
import {mdiWeatherCloudyArrowRight} from '@mdi/js'
import {mdiWeatherCloudyClock} from '@mdi/js'
import {mdiWeatherDust} from '@mdi/js'
import {mdiWeatherFog} from '@mdi/js'
import {mdiWeatherHail} from '@mdi/js'
import {mdiWeatherHazy} from '@mdi/js'
import {mdiWeatherHurricane} from '@mdi/js'
import {mdiWeatherLightning} from '@mdi/js'
import {mdiWeatherLightningRainy} from '@mdi/js'
import {mdiWeatherNight} from '@mdi/js'
import {mdiWeatherNightPartlyCloudy} from '@mdi/js'
import {mdiWeatherPartlyCloudy} from '@mdi/js'
import {mdiWeatherPartlyLightning} from '@mdi/js'
import {mdiWeatherPartlyRainy} from '@mdi/js'
import {mdiWeatherPartlySnowy} from '@mdi/js'
import {mdiWeatherPartlySnowyRainy} from '@mdi/js'
import {mdiWeatherPouring} from '@mdi/js'
import {mdiWeatherRainy} from '@mdi/js'
import {mdiWeatherSnowy} from '@mdi/js'
import {mdiWeatherSnowyHeavy} from '@mdi/js'
import {mdiWeatherSnowyRainy} from '@mdi/js'
import {mdiWeatherSunny} from '@mdi/js'
import {mdiWeatherSunnyAlert} from '@mdi/js'
import {mdiWeatherSunnyOff} from '@mdi/js'
import {mdiWeatherSunset} from '@mdi/js'
import {mdiWeatherSunsetDown} from '@mdi/js'
import {mdiWeatherSunsetUp} from '@mdi/js'
import {mdiWeatherTornado} from '@mdi/js'
import {mdiWeatherWindy} from '@mdi/js'
import {mdiWeatherWindyVariant} from '@mdi/js'
import {mdiWeb} from '@mdi/js'
import {mdiWebBox} from '@mdi/js'
import {mdiWebCancel} from '@mdi/js'
import {mdiWebCheck} from '@mdi/js'
import {mdiWebClock} from '@mdi/js'
import {mdiWebMinus} from '@mdi/js'
import {mdiWebOff} from '@mdi/js'
import {mdiWebPlus} from '@mdi/js'
import {mdiWebRefresh} from '@mdi/js'
import {mdiWebRemove} from '@mdi/js'
import {mdiWebSync} from '@mdi/js'
import {mdiWebcam} from '@mdi/js'
import {mdiWebcamOff} from '@mdi/js'
import {mdiWebhook} from '@mdi/js'
import {mdiWebpack} from '@mdi/js'
import {mdiWebrtc} from '@mdi/js'
import {mdiWechat} from '@mdi/js'
import {mdiWeight} from '@mdi/js'
import {mdiWeightGram} from '@mdi/js'
import {mdiWeightKilogram} from '@mdi/js'
import {mdiWeightLifter} from '@mdi/js'
import {mdiWeightPound} from '@mdi/js'
import {mdiWhatsapp} from '@mdi/js'
import {mdiWheelBarrow} from '@mdi/js'
import {mdiWheelchair} from '@mdi/js'
import {mdiWheelchairAccessibility} from '@mdi/js'
import {mdiWhistle} from '@mdi/js'
import {mdiWhistleOutline} from '@mdi/js'
import {mdiWhiteBalanceAuto} from '@mdi/js'
import {mdiWhiteBalanceIncandescent} from '@mdi/js'
import {mdiWhiteBalanceIridescent} from '@mdi/js'
import {mdiWhiteBalanceSunny} from '@mdi/js'
import {mdiWidgets} from '@mdi/js'
import {mdiWidgetsOutline} from '@mdi/js'
import {mdiWifi} from '@mdi/js'
import {mdiWifiAlert} from '@mdi/js'
import {mdiWifiArrowDown} from '@mdi/js'
import {mdiWifiArrowLeft} from '@mdi/js'
import {mdiWifiArrowLeftRight} from '@mdi/js'
import {mdiWifiArrowRight} from '@mdi/js'
import {mdiWifiArrowUp} from '@mdi/js'
import {mdiWifiArrowUpDown} from '@mdi/js'
import {mdiWifiCancel} from '@mdi/js'
import {mdiWifiCheck} from '@mdi/js'
import {mdiWifiCog} from '@mdi/js'
import {mdiWifiLock} from '@mdi/js'
import {mdiWifiLockOpen} from '@mdi/js'
import {mdiWifiMarker} from '@mdi/js'
import {mdiWifiMinus} from '@mdi/js'
import {mdiWifiOff} from '@mdi/js'
import {mdiWifiPlus} from '@mdi/js'
import {mdiWifiRefresh} from '@mdi/js'
import {mdiWifiRemove} from '@mdi/js'
import {mdiWifiSettings} from '@mdi/js'
import {mdiWifiStar} from '@mdi/js'
import {mdiWifiStrength1} from '@mdi/js'
import {mdiWifiStrength1Alert} from '@mdi/js'
import {mdiWifiStrength1Lock} from '@mdi/js'
import {mdiWifiStrength1LockOpen} from '@mdi/js'
import {mdiWifiStrength2} from '@mdi/js'
import {mdiWifiStrength2Alert} from '@mdi/js'
import {mdiWifiStrength2Lock} from '@mdi/js'
import {mdiWifiStrength2LockOpen} from '@mdi/js'
import {mdiWifiStrength3} from '@mdi/js'
import {mdiWifiStrength3Alert} from '@mdi/js'
import {mdiWifiStrength3Lock} from '@mdi/js'
import {mdiWifiStrength3LockOpen} from '@mdi/js'
import {mdiWifiStrength4} from '@mdi/js'
import {mdiWifiStrength4Alert} from '@mdi/js'
import {mdiWifiStrength4Lock} from '@mdi/js'
import {mdiWifiStrength4LockOpen} from '@mdi/js'
import {mdiWifiStrengthAlertOutline} from '@mdi/js'
import {mdiWifiStrengthLockOpenOutline} from '@mdi/js'
import {mdiWifiStrengthLockOutline} from '@mdi/js'
import {mdiWifiStrengthOff} from '@mdi/js'
import {mdiWifiStrengthOffOutline} from '@mdi/js'
import {mdiWifiStrengthOutline} from '@mdi/js'
import {mdiWifiSync} from '@mdi/js'
import {mdiWikipedia} from '@mdi/js'
import {mdiWindPower} from '@mdi/js'
import {mdiWindPowerOutline} from '@mdi/js'
import {mdiWindTurbine} from '@mdi/js'
import {mdiWindTurbineAlert} from '@mdi/js'
import {mdiWindTurbineCheck} from '@mdi/js'
import {mdiWindowClose} from '@mdi/js'
import {mdiWindowClosed} from '@mdi/js'
import {mdiWindowClosedVariant} from '@mdi/js'
import {mdiWindowMaximize} from '@mdi/js'
import {mdiWindowMinimize} from '@mdi/js'
import {mdiWindowOpen} from '@mdi/js'
import {mdiWindowOpenVariant} from '@mdi/js'
import {mdiWindowRestore} from '@mdi/js'
import {mdiWindowShutter} from '@mdi/js'
import {mdiWindowShutterAlert} from '@mdi/js'
import {mdiWindowShutterAuto} from '@mdi/js'
import {mdiWindowShutterCog} from '@mdi/js'
import {mdiWindowShutterOpen} from '@mdi/js'
import {mdiWindowShutterSettings} from '@mdi/js'
import {mdiWindsock} from '@mdi/js'
import {mdiWiper} from '@mdi/js'
import {mdiWiperWash} from '@mdi/js'
import {mdiWiperWashAlert} from '@mdi/js'
import {mdiWizardHat} from '@mdi/js'
import {mdiWordpress} from '@mdi/js'
import {mdiWrap} from '@mdi/js'
import {mdiWrapDisabled} from '@mdi/js'
import {mdiWrench} from '@mdi/js'
import {mdiWrenchCheck} from '@mdi/js'
import {mdiWrenchCheckOutline} from '@mdi/js'
import {mdiWrenchClock} from '@mdi/js'
import {mdiWrenchClockOutline} from '@mdi/js'
import {mdiWrenchCog} from '@mdi/js'
import {mdiWrenchCogOutline} from '@mdi/js'
import {mdiWrenchOutline} from '@mdi/js'
import {mdiXamarin} from '@mdi/js'
import {mdiXml} from '@mdi/js'
import {mdiXmpp} from '@mdi/js'
import {mdiYahoo} from '@mdi/js'
import {mdiYeast} from '@mdi/js'
import {mdiYinYang} from '@mdi/js'
import {mdiYoga} from '@mdi/js'
import {mdiYoutube} from '@mdi/js'
import {mdiYoutubeGaming} from '@mdi/js'
import {mdiYoutubeStudio} from '@mdi/js'
import {mdiYoutubeSubscription} from '@mdi/js'
import {mdiYoutubeTv} from '@mdi/js'
import {mdiYurt} from '@mdi/js'
import {mdiZWave} from '@mdi/js'
import {mdiZend} from '@mdi/js'
import {mdiZigbee} from '@mdi/js'
import {mdiZipBox} from '@mdi/js'
import {mdiZipBoxOutline} from '@mdi/js'
import {mdiZipDisk} from '@mdi/js'
import {mdiZodiacAquarius} from '@mdi/js'
import {mdiZodiacAries} from '@mdi/js'
import {mdiZodiacCancer} from '@mdi/js'
import {mdiZodiacCapricorn} from '@mdi/js'
import {mdiZodiacGemini} from '@mdi/js'
import {mdiZodiacLeo} from '@mdi/js'
import {mdiZodiacLibra} from '@mdi/js'
import {mdiZodiacPisces} from '@mdi/js'
import {mdiZodiacSagittarius} from '@mdi/js'
import {mdiZodiacScorpio} from '@mdi/js'
import {mdiZodiacTaurus} from '@mdi/js'
import {mdiZodiacVirgo} from '@mdi/js'


const iconos = {
    mdiAbTesting: mdiAbTesting,
mdiAbacus: mdiAbacus,
mdiAbjadArabic: mdiAbjadArabic,
mdiAbjadHebrew: mdiAbjadHebrew,
mdiAbugidaDevanagari: mdiAbugidaDevanagari,
mdiAbugidaThai: mdiAbugidaThai,
mdiAccessPoint: mdiAccessPoint,
mdiAccessPointCheck: mdiAccessPointCheck,
mdiAccessPointMinus: mdiAccessPointMinus,
mdiAccessPointNetwork: mdiAccessPointNetwork,
mdiAccessPointNetworkOff: mdiAccessPointNetworkOff,
mdiAccessPointOff: mdiAccessPointOff,
mdiAccessPointPlus: mdiAccessPointPlus,
mdiAccessPointRemove: mdiAccessPointRemove,
mdiAccount: mdiAccount,
mdiAccountAlert: mdiAccountAlert,
mdiAccountAlertOutline: mdiAccountAlertOutline,
mdiAccountArrowDown: mdiAccountArrowDown,
mdiAccountArrowDownOutline: mdiAccountArrowDownOutline,
mdiAccountArrowLeft: mdiAccountArrowLeft,
mdiAccountArrowLeftOutline: mdiAccountArrowLeftOutline,
mdiAccountArrowRight: mdiAccountArrowRight,
mdiAccountArrowRightOutline: mdiAccountArrowRightOutline,
mdiAccountArrowUp: mdiAccountArrowUp,
mdiAccountArrowUpOutline: mdiAccountArrowUpOutline,
mdiAccountBadge: mdiAccountBadge,
mdiAccountBadgeOutline: mdiAccountBadgeOutline,
mdiAccountBox: mdiAccountBox,
mdiAccountBoxMultiple: mdiAccountBoxMultiple,
mdiAccountBoxMultipleOutline: mdiAccountBoxMultipleOutline,
mdiAccountBoxOutline: mdiAccountBoxOutline,
mdiAccountCancel: mdiAccountCancel,
mdiAccountCancelOutline: mdiAccountCancelOutline,
mdiAccountCard: mdiAccountCard,
mdiAccountCardOutline: mdiAccountCardOutline,
mdiAccountCash: mdiAccountCash,
mdiAccountCashOutline: mdiAccountCashOutline,
mdiAccountCheck: mdiAccountCheck,
mdiAccountCheckOutline: mdiAccountCheckOutline,
mdiAccountChild: mdiAccountChild,
mdiAccountChildCircle: mdiAccountChildCircle,
mdiAccountChildOutline: mdiAccountChildOutline,
mdiAccountCircle: mdiAccountCircle,
mdiAccountCircleOutline: mdiAccountCircleOutline,
mdiAccountClock: mdiAccountClock,
mdiAccountClockOutline: mdiAccountClockOutline,
mdiAccountCog: mdiAccountCog,
mdiAccountCogOutline: mdiAccountCogOutline,
mdiAccountConvert: mdiAccountConvert,
mdiAccountConvertOutline: mdiAccountConvertOutline,
mdiAccountCowboyHat: mdiAccountCowboyHat,
mdiAccountCowboyHatOutline: mdiAccountCowboyHatOutline,
mdiAccountCreditCard: mdiAccountCreditCard,
mdiAccountCreditCardOutline: mdiAccountCreditCardOutline,
mdiAccountDetails: mdiAccountDetails,
mdiAccountDetailsOutline: mdiAccountDetailsOutline,
mdiAccountEdit: mdiAccountEdit,
mdiAccountEditOutline: mdiAccountEditOutline,
mdiAccountEye: mdiAccountEye,
mdiAccountEyeOutline: mdiAccountEyeOutline,
mdiAccountFilter: mdiAccountFilter,
mdiAccountFilterOutline: mdiAccountFilterOutline,
mdiAccountGroup: mdiAccountGroup,
mdiAccountGroupOutline: mdiAccountGroupOutline,
mdiAccountHardHat: mdiAccountHardHat,
mdiAccountHardHatOutline: mdiAccountHardHatOutline,
mdiAccountHeart: mdiAccountHeart,
mdiAccountHeartOutline: mdiAccountHeartOutline,
mdiAccountInjury: mdiAccountInjury,
mdiAccountInjuryOutline: mdiAccountInjuryOutline,
mdiAccountKey: mdiAccountKey,
mdiAccountKeyOutline: mdiAccountKeyOutline,
mdiAccountLock: mdiAccountLock,
mdiAccountLockOpen: mdiAccountLockOpen,
mdiAccountLockOpenOutline: mdiAccountLockOpenOutline,
mdiAccountLockOutline: mdiAccountLockOutline,
mdiAccountMinus: mdiAccountMinus,
mdiAccountMinusOutline: mdiAccountMinusOutline,
mdiAccountMultiple: mdiAccountMultiple,
mdiAccountMultipleCheck: mdiAccountMultipleCheck,
mdiAccountMultipleCheckOutline: mdiAccountMultipleCheckOutline,
mdiAccountMultipleMinus: mdiAccountMultipleMinus,
mdiAccountMultipleMinusOutline: mdiAccountMultipleMinusOutline,
mdiAccountMultipleOutline: mdiAccountMultipleOutline,
mdiAccountMultiplePlus: mdiAccountMultiplePlus,
mdiAccountMultiplePlusOutline: mdiAccountMultiplePlusOutline,
mdiAccountMultipleRemove: mdiAccountMultipleRemove,
mdiAccountMultipleRemoveOutline: mdiAccountMultipleRemoveOutline,
mdiAccountMusic: mdiAccountMusic,
mdiAccountMusicOutline: mdiAccountMusicOutline,
mdiAccountNetwork: mdiAccountNetwork,
mdiAccountNetworkOff: mdiAccountNetworkOff,
mdiAccountNetworkOffOutline: mdiAccountNetworkOffOutline,
mdiAccountNetworkOutline: mdiAccountNetworkOutline,
mdiAccountOff: mdiAccountOff,
mdiAccountOffOutline: mdiAccountOffOutline,
mdiAccountOutline: mdiAccountOutline,
mdiAccountPlus: mdiAccountPlus,
mdiAccountPlusOutline: mdiAccountPlusOutline,
mdiAccountQuestion: mdiAccountQuestion,
mdiAccountQuestionOutline: mdiAccountQuestionOutline,
mdiAccountReactivate: mdiAccountReactivate,
mdiAccountReactivateOutline: mdiAccountReactivateOutline,
mdiAccountRemove: mdiAccountRemove,
mdiAccountRemoveOutline: mdiAccountRemoveOutline,
mdiAccountSchool: mdiAccountSchool,
mdiAccountSchoolOutline: mdiAccountSchoolOutline,
mdiAccountSearch: mdiAccountSearch,
mdiAccountSearchOutline: mdiAccountSearchOutline,
mdiAccountSettings: mdiAccountSettings,
mdiAccountSettingsOutline: mdiAccountSettingsOutline,
mdiAccountStar: mdiAccountStar,
mdiAccountStarOutline: mdiAccountStarOutline,
mdiAccountSupervisor: mdiAccountSupervisor,
mdiAccountSupervisorCircle: mdiAccountSupervisorCircle,
mdiAccountSupervisorCircleOutline: mdiAccountSupervisorCircleOutline,
mdiAccountSupervisorOutline: mdiAccountSupervisorOutline,
mdiAccountSwitch: mdiAccountSwitch,
mdiAccountSwitchOutline: mdiAccountSwitchOutline,
mdiAccountSync: mdiAccountSync,
mdiAccountSyncOutline: mdiAccountSyncOutline,
mdiAccountTie: mdiAccountTie,
mdiAccountTieHat: mdiAccountTieHat,
mdiAccountTieHatOutline: mdiAccountTieHatOutline,
mdiAccountTieOutline: mdiAccountTieOutline,
mdiAccountTieVoice: mdiAccountTieVoice,
mdiAccountTieVoiceOff: mdiAccountTieVoiceOff,
mdiAccountTieVoiceOffOutline: mdiAccountTieVoiceOffOutline,
mdiAccountTieVoiceOutline: mdiAccountTieVoiceOutline,
mdiAccountTieWoman: mdiAccountTieWoman,
mdiAccountVoice: mdiAccountVoice,
mdiAccountVoiceOff: mdiAccountVoiceOff,
mdiAccountWrench: mdiAccountWrench,
mdiAccountWrenchOutline: mdiAccountWrenchOutline,
mdiAdjust: mdiAdjust,
mdiAdvertisements: mdiAdvertisements,
mdiAdvertisementsOff: mdiAdvertisementsOff,
mdiAirConditioner: mdiAirConditioner,
mdiAirFilter: mdiAirFilter,
mdiAirHorn: mdiAirHorn,
mdiAirHumidifier: mdiAirHumidifier,
mdiAirHumidifierOff: mdiAirHumidifierOff,
mdiAirPurifier: mdiAirPurifier,
mdiAirPurifierOff: mdiAirPurifierOff,
mdiAirbag: mdiAirbag,
mdiAirballoon: mdiAirballoon,
mdiAirballoonOutline: mdiAirballoonOutline,
mdiAirplane: mdiAirplane,
mdiAirplaneAlert: mdiAirplaneAlert,
mdiAirplaneCheck: mdiAirplaneCheck,
mdiAirplaneClock: mdiAirplaneClock,
mdiAirplaneCog: mdiAirplaneCog,
mdiAirplaneEdit: mdiAirplaneEdit,
mdiAirplaneLanding: mdiAirplaneLanding,
mdiAirplaneMarker: mdiAirplaneMarker,
mdiAirplaneMinus: mdiAirplaneMinus,
mdiAirplaneOff: mdiAirplaneOff,
mdiAirplanePlus: mdiAirplanePlus,
mdiAirplaneRemove: mdiAirplaneRemove,
mdiAirplaneSearch: mdiAirplaneSearch,
mdiAirplaneSettings: mdiAirplaneSettings,
mdiAirplaneTakeoff: mdiAirplaneTakeoff,
mdiAirport: mdiAirport,
mdiAlarm: mdiAlarm,
mdiAlarmBell: mdiAlarmBell,
mdiAlarmCheck: mdiAlarmCheck,
mdiAlarmLight: mdiAlarmLight,
mdiAlarmLightOff: mdiAlarmLightOff,
mdiAlarmLightOffOutline: mdiAlarmLightOffOutline,
mdiAlarmLightOutline: mdiAlarmLightOutline,
mdiAlarmMultiple: mdiAlarmMultiple,
mdiAlarmNote: mdiAlarmNote,
mdiAlarmNoteOff: mdiAlarmNoteOff,
mdiAlarmOff: mdiAlarmOff,
mdiAlarmPanel: mdiAlarmPanel,
mdiAlarmPanelOutline: mdiAlarmPanelOutline,
mdiAlarmPlus: mdiAlarmPlus,
mdiAlarmSnooze: mdiAlarmSnooze,
mdiAlbum: mdiAlbum,
mdiAlert: mdiAlert,
mdiAlertBox: mdiAlertBox,
mdiAlertBoxOutline: mdiAlertBoxOutline,
mdiAlertCircle: mdiAlertCircle,
mdiAlertCircleCheck: mdiAlertCircleCheck,
mdiAlertCircleCheckOutline: mdiAlertCircleCheckOutline,
mdiAlertCircleOutline: mdiAlertCircleOutline,
mdiAlertDecagram: mdiAlertDecagram,
mdiAlertDecagramOutline: mdiAlertDecagramOutline,
mdiAlertMinus: mdiAlertMinus,
mdiAlertMinusOutline: mdiAlertMinusOutline,
mdiAlertOctagon: mdiAlertOctagon,
mdiAlertOctagonOutline: mdiAlertOctagonOutline,
mdiAlertOctagram: mdiAlertOctagram,
mdiAlertOctagramOutline: mdiAlertOctagramOutline,
mdiAlertOutline: mdiAlertOutline,
mdiAlertPlus: mdiAlertPlus,
mdiAlertPlusOutline: mdiAlertPlusOutline,
mdiAlertRemove: mdiAlertRemove,
mdiAlertRemoveOutline: mdiAlertRemoveOutline,
mdiAlertRhombus: mdiAlertRhombus,
mdiAlertRhombusOutline: mdiAlertRhombusOutline,
mdiAlien: mdiAlien,
mdiAlienOutline: mdiAlienOutline,
mdiAlignHorizontalCenter: mdiAlignHorizontalCenter,
mdiAlignHorizontalDistribute: mdiAlignHorizontalDistribute,
mdiAlignHorizontalLeft: mdiAlignHorizontalLeft,
mdiAlignHorizontalRight: mdiAlignHorizontalRight,
mdiAlignVerticalBottom: mdiAlignVerticalBottom,
mdiAlignVerticalCenter: mdiAlignVerticalCenter,
mdiAlignVerticalDistribute: mdiAlignVerticalDistribute,
mdiAlignVerticalTop: mdiAlignVerticalTop,
mdiAllInclusive: mdiAllInclusive,
mdiAllInclusiveBox: mdiAllInclusiveBox,
mdiAllInclusiveBoxOutline: mdiAllInclusiveBoxOutline,
mdiAllergy: mdiAllergy,
mdiAlpha: mdiAlpha,
mdiAlphaA: mdiAlphaA,
mdiAlphaABox: mdiAlphaABox,
mdiAlphaABoxOutline: mdiAlphaABoxOutline,
mdiAlphaACircle: mdiAlphaACircle,
mdiAlphaACircleOutline: mdiAlphaACircleOutline,
mdiAlphaB: mdiAlphaB,
mdiAlphaBBox: mdiAlphaBBox,
mdiAlphaBBoxOutline: mdiAlphaBBoxOutline,
mdiAlphaBCircle: mdiAlphaBCircle,
mdiAlphaBCircleOutline: mdiAlphaBCircleOutline,
mdiAlphaC: mdiAlphaC,
mdiAlphaCBox: mdiAlphaCBox,
mdiAlphaCBoxOutline: mdiAlphaCBoxOutline,
mdiAlphaCCircle: mdiAlphaCCircle,
mdiAlphaCCircleOutline: mdiAlphaCCircleOutline,
mdiAlphaD: mdiAlphaD,
mdiAlphaDBox: mdiAlphaDBox,
mdiAlphaDBoxOutline: mdiAlphaDBoxOutline,
mdiAlphaDCircle: mdiAlphaDCircle,
mdiAlphaDCircleOutline: mdiAlphaDCircleOutline,
mdiAlphaE: mdiAlphaE,
mdiAlphaEBox: mdiAlphaEBox,
mdiAlphaEBoxOutline: mdiAlphaEBoxOutline,
mdiAlphaECircle: mdiAlphaECircle,
mdiAlphaECircleOutline: mdiAlphaECircleOutline,
mdiAlphaF: mdiAlphaF,
mdiAlphaFBox: mdiAlphaFBox,
mdiAlphaFBoxOutline: mdiAlphaFBoxOutline,
mdiAlphaFCircle: mdiAlphaFCircle,
mdiAlphaFCircleOutline: mdiAlphaFCircleOutline,
mdiAlphaG: mdiAlphaG,
mdiAlphaGBox: mdiAlphaGBox,
mdiAlphaGBoxOutline: mdiAlphaGBoxOutline,
mdiAlphaGCircle: mdiAlphaGCircle,
mdiAlphaGCircleOutline: mdiAlphaGCircleOutline,
mdiAlphaH: mdiAlphaH,
mdiAlphaHBox: mdiAlphaHBox,
mdiAlphaHBoxOutline: mdiAlphaHBoxOutline,
mdiAlphaHCircle: mdiAlphaHCircle,
mdiAlphaHCircleOutline: mdiAlphaHCircleOutline,
mdiAlphaI: mdiAlphaI,
mdiAlphaIBox: mdiAlphaIBox,
mdiAlphaIBoxOutline: mdiAlphaIBoxOutline,
mdiAlphaICircle: mdiAlphaICircle,
mdiAlphaICircleOutline: mdiAlphaICircleOutline,
mdiAlphaJ: mdiAlphaJ,
mdiAlphaJBox: mdiAlphaJBox,
mdiAlphaJBoxOutline: mdiAlphaJBoxOutline,
mdiAlphaJCircle: mdiAlphaJCircle,
mdiAlphaJCircleOutline: mdiAlphaJCircleOutline,
mdiAlphaK: mdiAlphaK,
mdiAlphaKBox: mdiAlphaKBox,
mdiAlphaKBoxOutline: mdiAlphaKBoxOutline,
mdiAlphaKCircle: mdiAlphaKCircle,
mdiAlphaKCircleOutline: mdiAlphaKCircleOutline,
mdiAlphaL: mdiAlphaL,
mdiAlphaLBox: mdiAlphaLBox,
mdiAlphaLBoxOutline: mdiAlphaLBoxOutline,
mdiAlphaLCircle: mdiAlphaLCircle,
mdiAlphaLCircleOutline: mdiAlphaLCircleOutline,
mdiAlphaM: mdiAlphaM,
mdiAlphaMBox: mdiAlphaMBox,
mdiAlphaMBoxOutline: mdiAlphaMBoxOutline,
mdiAlphaMCircle: mdiAlphaMCircle,
mdiAlphaMCircleOutline: mdiAlphaMCircleOutline,
mdiAlphaN: mdiAlphaN,
mdiAlphaNBox: mdiAlphaNBox,
mdiAlphaNBoxOutline: mdiAlphaNBoxOutline,
mdiAlphaNCircle: mdiAlphaNCircle,
mdiAlphaNCircleOutline: mdiAlphaNCircleOutline,
mdiAlphaO: mdiAlphaO,
mdiAlphaOBox: mdiAlphaOBox,
mdiAlphaOBoxOutline: mdiAlphaOBoxOutline,
mdiAlphaOCircle: mdiAlphaOCircle,
mdiAlphaOCircleOutline: mdiAlphaOCircleOutline,
mdiAlphaP: mdiAlphaP,
mdiAlphaPBox: mdiAlphaPBox,
mdiAlphaPBoxOutline: mdiAlphaPBoxOutline,
mdiAlphaPCircle: mdiAlphaPCircle,
mdiAlphaPCircleOutline: mdiAlphaPCircleOutline,
mdiAlphaQ: mdiAlphaQ,
mdiAlphaQBox: mdiAlphaQBox,
mdiAlphaQBoxOutline: mdiAlphaQBoxOutline,
mdiAlphaQCircle: mdiAlphaQCircle,
mdiAlphaQCircleOutline: mdiAlphaQCircleOutline,
mdiAlphaR: mdiAlphaR,
mdiAlphaRBox: mdiAlphaRBox,
mdiAlphaRBoxOutline: mdiAlphaRBoxOutline,
mdiAlphaRCircle: mdiAlphaRCircle,
mdiAlphaRCircleOutline: mdiAlphaRCircleOutline,
mdiAlphaS: mdiAlphaS,
mdiAlphaSBox: mdiAlphaSBox,
mdiAlphaSBoxOutline: mdiAlphaSBoxOutline,
mdiAlphaSCircle: mdiAlphaSCircle,
mdiAlphaSCircleOutline: mdiAlphaSCircleOutline,
mdiAlphaT: mdiAlphaT,
mdiAlphaTBox: mdiAlphaTBox,
mdiAlphaTBoxOutline: mdiAlphaTBoxOutline,
mdiAlphaTCircle: mdiAlphaTCircle,
mdiAlphaTCircleOutline: mdiAlphaTCircleOutline,
mdiAlphaU: mdiAlphaU,
mdiAlphaUBox: mdiAlphaUBox,
mdiAlphaUBoxOutline: mdiAlphaUBoxOutline,
mdiAlphaUCircle: mdiAlphaUCircle,
mdiAlphaUCircleOutline: mdiAlphaUCircleOutline,
mdiAlphaV: mdiAlphaV,
mdiAlphaVBox: mdiAlphaVBox,
mdiAlphaVBoxOutline: mdiAlphaVBoxOutline,
mdiAlphaVCircle: mdiAlphaVCircle,
mdiAlphaVCircleOutline: mdiAlphaVCircleOutline,
mdiAlphaW: mdiAlphaW,
mdiAlphaWBox: mdiAlphaWBox,
mdiAlphaWBoxOutline: mdiAlphaWBoxOutline,
mdiAlphaWCircle: mdiAlphaWCircle,
mdiAlphaWCircleOutline: mdiAlphaWCircleOutline,
mdiAlphaX: mdiAlphaX,
mdiAlphaXBox: mdiAlphaXBox,
mdiAlphaXBoxOutline: mdiAlphaXBoxOutline,
mdiAlphaXCircle: mdiAlphaXCircle,
mdiAlphaXCircleOutline: mdiAlphaXCircleOutline,
mdiAlphaY: mdiAlphaY,
mdiAlphaYBox: mdiAlphaYBox,
mdiAlphaYBoxOutline: mdiAlphaYBoxOutline,
mdiAlphaYCircle: mdiAlphaYCircle,
mdiAlphaYCircleOutline: mdiAlphaYCircleOutline,
mdiAlphaZ: mdiAlphaZ,
mdiAlphaZBox: mdiAlphaZBox,
mdiAlphaZBoxOutline: mdiAlphaZBoxOutline,
mdiAlphaZCircle: mdiAlphaZCircle,
mdiAlphaZCircleOutline: mdiAlphaZCircleOutline,
mdiAlphabetAurebesh: mdiAlphabetAurebesh,
mdiAlphabetCyrillic: mdiAlphabetCyrillic,
mdiAlphabetGreek: mdiAlphabetGreek,
mdiAlphabetLatin: mdiAlphabetLatin,
mdiAlphabetPiqad: mdiAlphabetPiqad,
mdiAlphabetTengwar: mdiAlphabetTengwar,
mdiAlphabetical: mdiAlphabetical,
mdiAlphabeticalOff: mdiAlphabeticalOff,
mdiAlphabeticalVariant: mdiAlphabeticalVariant,
mdiAlphabeticalVariantOff: mdiAlphabeticalVariantOff,
mdiAltimeter: mdiAltimeter,
mdiAmbulance: mdiAmbulance,
mdiAmmunition: mdiAmmunition,
mdiAmpersand: mdiAmpersand,
mdiAmplifier: mdiAmplifier,
mdiAmplifierOff: mdiAmplifierOff,
mdiAnchor: mdiAnchor,
mdiAndroid: mdiAndroid,
mdiAndroidStudio: mdiAndroidStudio,
mdiAngleAcute: mdiAngleAcute,
mdiAngleObtuse: mdiAngleObtuse,
mdiAngleRight: mdiAngleRight,
mdiAngular: mdiAngular,
mdiAngularjs: mdiAngularjs,
mdiAnimation: mdiAnimation,
mdiAnimationOutline: mdiAnimationOutline,
mdiAnimationPlay: mdiAnimationPlay,
mdiAnimationPlayOutline: mdiAnimationPlayOutline,
mdiAnsible: mdiAnsible,
mdiAntenna: mdiAntenna,
mdiAnvil: mdiAnvil,
mdiApacheKafka: mdiApacheKafka,
mdiApi: mdiApi,
mdiApiOff: mdiApiOff,
mdiApple: mdiApple,
mdiAppleFinder: mdiAppleFinder,
mdiAppleIcloud: mdiAppleIcloud,
mdiAppleIos: mdiAppleIos,
mdiAppleKeyboardCaps: mdiAppleKeyboardCaps,
mdiAppleKeyboardCommand: mdiAppleKeyboardCommand,
mdiAppleKeyboardControl: mdiAppleKeyboardControl,
mdiAppleKeyboardOption: mdiAppleKeyboardOption,
mdiAppleKeyboardShift: mdiAppleKeyboardShift,
mdiAppleSafari: mdiAppleSafari,
mdiApplication: mdiApplication,
mdiApplicationArray: mdiApplicationArray,
mdiApplicationArrayOutline: mdiApplicationArrayOutline,
mdiApplicationBraces: mdiApplicationBraces,
mdiApplicationBracesOutline: mdiApplicationBracesOutline,
mdiApplicationBrackets: mdiApplicationBrackets,
mdiApplicationBracketsOutline: mdiApplicationBracketsOutline,
mdiApplicationCog: mdiApplicationCog,
mdiApplicationCogOutline: mdiApplicationCogOutline,
mdiApplicationEdit: mdiApplicationEdit,
mdiApplicationEditOutline: mdiApplicationEditOutline,
mdiApplicatio: mdiApplication,
mdiApplicationOutline: mdiApplicationOutline,
mdiApplicationParentheses: mdiApplicationParentheses,
mdiApplicationParenthesesOutline: mdiApplicationParenthesesOutline,
mdiApplicationSettings: mdiApplicationSettings,
mdiApplicationSettingsOutline: mdiApplicationSettingsOutline,
mdiApplicationVariable: mdiApplicationVariable,
mdiApplicationVariableOutline: mdiApplicationVariableOutline,
mdiApproximatelyEqual: mdiApproximatelyEqual,
mdiApproximatelyEqualBox: mdiApproximatelyEqualBox,
mdiApps: mdiApps,
mdiAppsBox: mdiAppsBox,
mdiArch: mdiArch,
mdiArchive: mdiArchive,
mdiArchiveAlert: mdiArchiveAlert,
mdiArchiveAlertOutline: mdiArchiveAlertOutline,
mdiArchiveArrowDown: mdiArchiveArrowDown,
mdiArchiveArrowDownOutline: mdiArchiveArrowDownOutline,
mdiArchiveArrowUp: mdiArchiveArrowUp,
mdiArchiveArrowUpOutline: mdiArchiveArrowUpOutline,
mdiArchiveCancel: mdiArchiveCancel,
mdiArchiveCancelOutline: mdiArchiveCancelOutline,
mdiArchiveCheck: mdiArchiveCheck,
mdiArchiveCheckOutline: mdiArchiveCheckOutline,
mdiArchiveClock: mdiArchiveClock,
mdiArchiveClockOutline: mdiArchiveClockOutline,
mdiArchiveCog: mdiArchiveCog,
mdiArchiveCogOutline: mdiArchiveCogOutline,
mdiArchiveEdit: mdiArchiveEdit,
mdiArchiveEditOutline: mdiArchiveEditOutline,
mdiArchiveEye: mdiArchiveEye,
mdiArchiveEyeOutline: mdiArchiveEyeOutline,
mdiArchiveLock: mdiArchiveLock,
mdiArchiveLockOpen: mdiArchiveLockOpen,
mdiArchiveLockOpenOutline: mdiArchiveLockOpenOutline,
mdiArchiveLockOutline: mdiArchiveLockOutline,
mdiArchiveMarker: mdiArchiveMarker,
mdiArchiveMarkerOutline: mdiArchiveMarkerOutline,
mdiArchiveMinus: mdiArchiveMinus,
mdiArchiveMinusOutline: mdiArchiveMinusOutline,
mdiArchiveMusic: mdiArchiveMusic,
mdiArchiveMusicOutline: mdiArchiveMusicOutline,
mdiArchiveOff: mdiArchiveOff,
mdiArchiveOffOutline: mdiArchiveOffOutline,
mdiArchiveOutline: mdiArchiveOutline,
mdiArchivePlus: mdiArchivePlus,
mdiArchivePlusOutline: mdiArchivePlusOutline,
mdiArchiveRefresh: mdiArchiveRefresh,
mdiArchiveRefreshOutline: mdiArchiveRefreshOutline,
mdiArchiveRemove: mdiArchiveRemove,
mdiArchiveRemoveOutline: mdiArchiveRemoveOutline,
mdiArchiveSearch: mdiArchiveSearch,
mdiArchiveSearchOutline: mdiArchiveSearchOutline,
mdiArchiveSettings: mdiArchiveSettings,
mdiArchiveSettingsOutline: mdiArchiveSettingsOutline,
mdiArchiveStar: mdiArchiveStar,
mdiArchiveStarOutline: mdiArchiveStarOutline,
mdiArchiveSync: mdiArchiveSync,
mdiArchiveSyncOutline: mdiArchiveSyncOutline,
mdiArmFlex: mdiArmFlex,
mdiArmFlexOutline: mdiArmFlexOutline,
mdiArrangeBringForward: mdiArrangeBringForward,
mdiArrangeBringToFront: mdiArrangeBringToFront,
mdiArrangeSendBackward: mdiArrangeSendBackward,
mdiArrangeSendToBack: mdiArrangeSendToBack,
mdiArrowAll: mdiArrowAll,
mdiArrowBottomLeft: mdiArrowBottomLeft,
mdiArrowBottomLeftBoldBox: mdiArrowBottomLeftBoldBox,
mdiArrowBottomLeftBoldBoxOutline: mdiArrowBottomLeftBoldBoxOutline,
mdiArrowBottomLeftBoldOutline: mdiArrowBottomLeftBoldOutline,
mdiArrowBottomLeftThick: mdiArrowBottomLeftThick,
mdiArrowBottomLeftThin: mdiArrowBottomLeftThin,
mdiArrowBottomLeftThinCircleOutline: mdiArrowBottomLeftThinCircleOutline,
mdiArrowBottomRight: mdiArrowBottomRight,
mdiArrowBottomRightBoldBox: mdiArrowBottomRightBoldBox,
mdiArrowBottomRightBoldBoxOutline: mdiArrowBottomRightBoldBoxOutline,
mdiArrowBottomRightBoldOutline: mdiArrowBottomRightBoldOutline,
mdiArrowBottomRightThick: mdiArrowBottomRightThick,
mdiArrowBottomRightThin: mdiArrowBottomRightThin,
mdiArrowBottomRightThinCircleOutline: mdiArrowBottomRightThinCircleOutline,
mdiArrowCollapse: mdiArrowCollapse,
mdiArrowCollapseAll: mdiArrowCollapseAll,
mdiArrowCollapseDown: mdiArrowCollapseDown,
mdiArrowCollapseHorizontal: mdiArrowCollapseHorizontal,
mdiArrowCollapseLeft: mdiArrowCollapseLeft,
mdiArrowCollapseRight: mdiArrowCollapseRight,
mdiArrowCollapseUp: mdiArrowCollapseUp,
mdiArrowCollapseVertical: mdiArrowCollapseVertical,
mdiArrowDecision: mdiArrowDecision,
mdiArrowDecisionAuto: mdiArrowDecisionAuto,
mdiArrowDecisionAutoOutline: mdiArrowDecisionAutoOutline,
mdiArrowDecisionOutline: mdiArrowDecisionOutline,
mdiArrowDown: mdiArrowDown,
mdiArrowDownBold: mdiArrowDownBold,
mdiArrowDownBoldBox: mdiArrowDownBoldBox,
mdiArrowDownBoldBoxOutline: mdiArrowDownBoldBoxOutline,
mdiArrowDownBoldCircle: mdiArrowDownBoldCircle,
mdiArrowDownBoldCircleOutline: mdiArrowDownBoldCircleOutline,
mdiArrowDownBoldHexagonOutline: mdiArrowDownBoldHexagonOutline,
mdiArrowDownBoldOutline: mdiArrowDownBoldOutline,
mdiArrowDownBox: mdiArrowDownBox,
mdiArrowDownCircle: mdiArrowDownCircle,
mdiArrowDownCircleOutline: mdiArrowDownCircleOutline,
mdiArrowDownDropCircle: mdiArrowDownDropCircle,
mdiArrowDownDropCircleOutline: mdiArrowDownDropCircleOutline,
mdiArrowDownLeft: mdiArrowDownLeft,
mdiArrowDownLeftBold: mdiArrowDownLeftBold,
mdiArrowDownRight: mdiArrowDownRight,
mdiArrowDownRightBold: mdiArrowDownRightBold,
mdiArrowDownThick: mdiArrowDownThick,
mdiArrowDownThin: mdiArrowDownThin,
mdiArrowDownThinCircleOutline: mdiArrowDownThinCircleOutline,
mdiArrowExpand: mdiArrowExpand,
mdiArrowExpandAll: mdiArrowExpandAll,
mdiArrowExpandDown: mdiArrowExpandDown,
mdiArrowExpandHorizontal: mdiArrowExpandHorizontal,
mdiArrowExpandLeft: mdiArrowExpandLeft,
mdiArrowExpandRight: mdiArrowExpandRight,
mdiArrowExpandUp: mdiArrowExpandUp,
mdiArrowExpandVertical: mdiArrowExpandVertical,
mdiArrowHorizontalLock: mdiArrowHorizontalLock,
mdiArrowLeft: mdiArrowLeft,
mdiArrowLeftBold: mdiArrowLeftBold,
mdiArrowLeftBoldBox: mdiArrowLeftBoldBox,
mdiArrowLeftBoldBoxOutline: mdiArrowLeftBoldBoxOutline,
mdiArrowLeftBoldCircle: mdiArrowLeftBoldCircle,
mdiArrowLeftBoldCircleOutline: mdiArrowLeftBoldCircleOutline,
mdiArrowLeftBoldHexagonOutline: mdiArrowLeftBoldHexagonOutline,
mdiArrowLeftBoldOutline: mdiArrowLeftBoldOutline,
mdiArrowLeftBottom: mdiArrowLeftBottom,
mdiArrowLeftBottomBold: mdiArrowLeftBottomBold,
mdiArrowLeftBox: mdiArrowLeftBox,
mdiArrowLeftCircle: mdiArrowLeftCircle,
mdiArrowLeftCircleOutline: mdiArrowLeftCircleOutline,
mdiArrowLeftDropCircle: mdiArrowLeftDropCircle,
mdiArrowLeftDropCircleOutline: mdiArrowLeftDropCircleOutline,
mdiArrowLeftRight: mdiArrowLeftRight,
mdiArrowLeftRightBold: mdiArrowLeftRightBold,
mdiArrowLeftRightBoldOutline: mdiArrowLeftRightBoldOutline,
mdiArrowLeftThick: mdiArrowLeftThick,
mdiArrowLeftThin: mdiArrowLeftThin,
mdiArrowLeftThinCircleOutline: mdiArrowLeftThinCircleOutline,
mdiArrowLeftTop: mdiArrowLeftTop,
mdiArrowLeftTopBold: mdiArrowLeftTopBold,
mdiArrowProjectile: mdiArrowProjectile,
mdiArrowProjectileMultiple: mdiArrowProjectileMultiple,
mdiArrowRight: mdiArrowRight,
mdiArrowRightBold: mdiArrowRightBold,
mdiArrowRightBoldBox: mdiArrowRightBoldBox,
mdiArrowRightBoldBoxOutline: mdiArrowRightBoldBoxOutline,
mdiArrowRightBoldCircle: mdiArrowRightBoldCircle,
mdiArrowRightBoldCircleOutline: mdiArrowRightBoldCircleOutline,
mdiArrowRightBoldHexagonOutline: mdiArrowRightBoldHexagonOutline,
mdiArrowRightBoldOutline: mdiArrowRightBoldOutline,
mdiArrowRightBottom: mdiArrowRightBottom,
mdiArrowRightBottomBold: mdiArrowRightBottomBold,
mdiArrowRightBox: mdiArrowRightBox,
mdiArrowRightCircle: mdiArrowRightCircle,
mdiArrowRightCircleOutline: mdiArrowRightCircleOutline,
mdiArrowRightDropCircle: mdiArrowRightDropCircle,
mdiArrowRightDropCircleOutline: mdiArrowRightDropCircleOutline,
mdiArrowRightThick: mdiArrowRightThick,
mdiArrowRightThin: mdiArrowRightThin,
mdiArrowRightThinCircleOutline: mdiArrowRightThinCircleOutline,
mdiArrowRightTop: mdiArrowRightTop,
mdiArrowRightTopBold: mdiArrowRightTopBold,
mdiArrowSplitHorizontal: mdiArrowSplitHorizontal,
mdiArrowSplitVertical: mdiArrowSplitVertical,
mdiArrowTopLeft: mdiArrowTopLeft,
mdiArrowTopLeftBoldBox: mdiArrowTopLeftBoldBox,
mdiArrowTopLeftBoldBoxOutline: mdiArrowTopLeftBoldBoxOutline,
mdiArrowTopLeftBoldOutline: mdiArrowTopLeftBoldOutline,
mdiArrowTopLeftBottomRight: mdiArrowTopLeftBottomRight,
mdiArrowTopLeftBottomRightBold: mdiArrowTopLeftBottomRightBold,
mdiArrowTopLeftThick: mdiArrowTopLeftThick,
mdiArrowTopLeftThin: mdiArrowTopLeftThin,
mdiArrowTopLeftThinCircleOutline: mdiArrowTopLeftThinCircleOutline,
mdiArrowTopRight: mdiArrowTopRight,
mdiArrowTopRightBoldBox: mdiArrowTopRightBoldBox,
mdiArrowTopRightBoldBoxOutline: mdiArrowTopRightBoldBoxOutline,
mdiArrowTopRightBoldOutline: mdiArrowTopRightBoldOutline,
mdiArrowTopRightBottomLeft: mdiArrowTopRightBottomLeft,
mdiArrowTopRightBottomLeftBold: mdiArrowTopRightBottomLeftBold,
mdiArrowTopRightThick: mdiArrowTopRightThick,
mdiArrowTopRightThin: mdiArrowTopRightThin,
mdiArrowTopRightThinCircleOutline: mdiArrowTopRightThinCircleOutline,
mdiArrowUDownLeft: mdiArrowUDownLeft,
mdiArrowUDownLeftBold: mdiArrowUDownLeftBold,
mdiArrowUDownRight: mdiArrowUDownRight,
mdiArrowUDownRightBold: mdiArrowUDownRightBold,
mdiArrowULeftBottom: mdiArrowULeftBottom,
mdiArrowULeftBottomBold: mdiArrowULeftBottomBold,
mdiArrowULeftTop: mdiArrowULeftTop,
mdiArrowULeftTopBold: mdiArrowULeftTopBold,
mdiArrowURightBottom: mdiArrowURightBottom,
mdiArrowURightBottomBold: mdiArrowURightBottomBold,
mdiArrowURightTop: mdiArrowURightTop,
mdiArrowURightTopBold: mdiArrowURightTopBold,
mdiArrowUUpLeft: mdiArrowUUpLeft,
mdiArrowUUpLeftBold: mdiArrowUUpLeftBold,
mdiArrowUUpRight: mdiArrowUUpRight,
mdiArrowUUpRightBold: mdiArrowUUpRightBold,
mdiArrowUp: mdiArrowUp,
mdiArrowUpBold: mdiArrowUpBold,
mdiArrowUpBoldBox: mdiArrowUpBoldBox,
mdiArrowUpBoldBoxOutline: mdiArrowUpBoldBoxOutline,
mdiArrowUpBoldCircle: mdiArrowUpBoldCircle,
mdiArrowUpBoldCircleOutline: mdiArrowUpBoldCircleOutline,
mdiArrowUpBoldHexagonOutline: mdiArrowUpBoldHexagonOutline,
mdiArrowUpBoldOutline: mdiArrowUpBoldOutline,
mdiArrowUpBox: mdiArrowUpBox,
mdiArrowUpCircle: mdiArrowUpCircle,
mdiArrowUpCircleOutline: mdiArrowUpCircleOutline,
mdiArrowUpDown: mdiArrowUpDown,
mdiArrowUpDownBold: mdiArrowUpDownBold,
mdiArrowUpDownBoldOutline: mdiArrowUpDownBoldOutline,
mdiArrowUpDropCircle: mdiArrowUpDropCircle,
mdiArrowUpDropCircleOutline: mdiArrowUpDropCircleOutline,
mdiArrowUpLeft: mdiArrowUpLeft,
mdiArrowUpLeftBold: mdiArrowUpLeftBold,
mdiArrowUpRight: mdiArrowUpRight,
mdiArrowUpRightBold: mdiArrowUpRightBold,
mdiArrowUpThick: mdiArrowUpThick,
mdiArrowUpThin: mdiArrowUpThin,
mdiArrowUpThinCircleOutline: mdiArrowUpThinCircleOutline,
mdiArrowVerticalLock: mdiArrowVerticalLock,
mdiArtboard: mdiArtboard,
mdiArtstation: mdiArtstation,
mdiAspectRatio: mdiAspectRatio,
mdiAssistant: mdiAssistant,
mdiAsterisk: mdiAsterisk,
mdiAsteriskCircleOutline: mdiAsteriskCircleOutline,
mdiAt: mdiAt,
mdiAtlassian: mdiAtlassian,
mdiAtm: mdiAtm,
mdiAtom: mdiAtom,
mdiAtomVariant: mdiAtomVariant,
mdiAttachment: mdiAttachment,
mdiAttachmentCheck: mdiAttachmentCheck,
mdiAttachmentLock: mdiAttachmentLock,
mdiAttachmentMinus: mdiAttachmentMinus,
mdiAttachmentOff: mdiAttachmentOff,
mdiAttachmentPlus: mdiAttachmentPlus,
mdiAttachmentRemove: mdiAttachmentRemove,
mdiAtv: mdiAtv,
mdiAudioInputRca: mdiAudioInputRca,
mdiAudioInputStereoMinijack: mdiAudioInputStereoMinijack,
mdiAudioInputXlr: mdiAudioInputXlr,
mdiAudioVideo: mdiAudioVideo,
mdiAudioVideoOff: mdiAudioVideoOff,
mdiAugmentedReality: mdiAugmentedReality,
mdiAutoDownload: mdiAutoDownload,
mdiAutoFix: mdiAutoFix,
mdiAutoUpload: mdiAutoUpload,
mdiAutorenew: mdiAutorenew,
mdiAutorenewOff: mdiAutorenewOff,
mdiAvTimer: mdiAvTimer,
mdiAwning: mdiAwning,
mdiAwningOutline: mdiAwningOutline,
mdiAws: mdiAws,
mdiAxe: mdiAxe,
mdiAxeBattle: mdiAxeBattle,
mdiAxis: mdiAxis,
mdiAxisArrow: mdiAxisArrow,
mdiAxisArrowInfo: mdiAxisArrowInfo,
mdiAxisArrowLock: mdiAxisArrowLock,
mdiAxisLock: mdiAxisLock,
mdiAxisXArrow: mdiAxisXArrow,
mdiAxisXArrowLock: mdiAxisXArrowLock,
mdiAxisXRotateClockwise: mdiAxisXRotateClockwise,
mdiAxisXRotateCounterclockwise: mdiAxisXRotateCounterclockwise,
mdiAxisXYArrowLock: mdiAxisXYArrowLock,
mdiAxisYArrow: mdiAxisYArrow,
mdiAxisYArrowLock: mdiAxisYArrowLock,
mdiAxisYRotateClockwise: mdiAxisYRotateClockwise,
mdiAxisYRotateCounterclockwise: mdiAxisYRotateCounterclockwise,
mdiAxisZArrow: mdiAxisZArrow,
mdiAxisZArrowLock: mdiAxisZArrowLock,
mdiAxisZRotateClockwise: mdiAxisZRotateClockwise,
mdiAxisZRotateCounterclockwise: mdiAxisZRotateCounterclockwise,
mdiBabel: mdiBabel,
mdiBaby: mdiBaby,
mdiBabyBottle: mdiBabyBottle,
mdiBabyBottleOutline: mdiBabyBottleOutline,
mdiBabyBuggy: mdiBabyBuggy,
mdiBabyBuggyOff: mdiBabyBuggyOff,
mdiBabyCarriage: mdiBabyCarriage,
mdiBabyCarriageOff: mdiBabyCarriageOff,
mdiBabyFace: mdiBabyFace,
mdiBabyFaceOutline: mdiBabyFaceOutline,
mdiBackburger: mdiBackburger,
mdiBackspace: mdiBackspace,
mdiBackspaceOutline: mdiBackspaceOutline,
mdiBackspaceReverse: mdiBackspaceReverse,
mdiBackspaceReverseOutline: mdiBackspaceReverseOutline,
mdiBackupRestore: mdiBackupRestore,
mdiBacteria: mdiBacteria,
mdiBacteriaOutline: mdiBacteriaOutline,
mdiBadgeAccount: mdiBadgeAccount,
mdiBadgeAccountAlert: mdiBadgeAccountAlert,
mdiBadgeAccountAlertOutline: mdiBadgeAccountAlertOutline,
mdiBadgeAccountHorizontal: mdiBadgeAccountHorizontal,
mdiBadgeAccountHorizontalOutline: mdiBadgeAccountHorizontalOutline,
mdiBadgeAccountOutline: mdiBadgeAccountOutline,
mdiBadminton: mdiBadminton,
mdiBagCarryOn: mdiBagCarryOn,
mdiBagCarryOnCheck: mdiBagCarryOnCheck,
mdiBagCarryOnOff: mdiBagCarryOnOff,
mdiBagChecked: mdiBagChecked,
mdiBagPersonal: mdiBagPersonal,
mdiBagPersonalOff: mdiBagPersonalOff,
mdiBagPersonalOffOutline: mdiBagPersonalOffOutline,
mdiBagPersonalOutline: mdiBagPersonalOutline,
mdiBagPersonalTag: mdiBagPersonalTag,
mdiBagPersonalTagOutline: mdiBagPersonalTagOutline,
mdiBagSuitcase: mdiBagSuitcase,
mdiBagSuitcaseOff: mdiBagSuitcaseOff,
mdiBagSuitcaseOffOutline: mdiBagSuitcaseOffOutline,
mdiBagSuitcaseOutline: mdiBagSuitcaseOutline,
mdiBaguette: mdiBaguette,
mdiBalcony: mdiBalcony,
mdiBalloon: mdiBalloon,
mdiBallot: mdiBallot,
mdiBallotOutline: mdiBallotOutline,
mdiBallotRecount: mdiBallotRecount,
mdiBallotRecountOutline: mdiBallotRecountOutline,
mdiBandage: mdiBandage,
mdiBank: mdiBank,
mdiBankCheck: mdiBankCheck,
mdiBankMinus: mdiBankMinus,
mdiBankOff: mdiBankOff,
mdiBankOffOutline: mdiBankOffOutline,
mdiBankOutline: mdiBankOutline,
mdiBankPlus: mdiBankPlus,
mdiBankRemove: mdiBankRemove,
mdiBankTransfer: mdiBankTransfer,
mdiBankTransferIn: mdiBankTransferIn,
mdiBankTransferOut: mdiBankTransferOut,
mdiBarcode: mdiBarcode,
mdiBarcodeOff: mdiBarcodeOff,
mdiBarcodeScan: mdiBarcodeScan,
mdiBarley: mdiBarley,
mdiBarleyOff: mdiBarleyOff,
mdiBarn: mdiBarn,
mdiBarrel: mdiBarrel,
mdiBarrelOutline: mdiBarrelOutline,
mdiBaseball: mdiBaseball,
mdiBaseballBat: mdiBaseballBat,
mdiBaseballDiamond: mdiBaseballDiamond,
mdiBaseballDiamondOutline: mdiBaseballDiamondOutline,
mdiBash: mdiBash,
mdiBasket: mdiBasket,
mdiBasketCheck: mdiBasketCheck,
mdiBasketCheckOutline: mdiBasketCheckOutline,
mdiBasketFill: mdiBasketFill,
mdiBasketMinus: mdiBasketMinus,
mdiBasketMinusOutline: mdiBasketMinusOutline,
mdiBasketOff: mdiBasketOff,
mdiBasketOffOutline: mdiBasketOffOutline,
mdiBasketOutline: mdiBasketOutline,
mdiBasketPlus: mdiBasketPlus,
mdiBasketPlusOutline: mdiBasketPlusOutline,
mdiBasketRemove: mdiBasketRemove,
mdiBasketRemoveOutline: mdiBasketRemoveOutline,
mdiBasketUnfill: mdiBasketUnfill,
mdiBasketball: mdiBasketball,
mdiBasketballHoop: mdiBasketballHoop,
mdiBasketballHoopOutline: mdiBasketballHoopOutline,
mdiBat: mdiBat,
mdiBathtub: mdiBathtub,
mdiBathtubOutline: mdiBathtubOutline,
mdiBattery: mdiBattery,
mdiBattery10: mdiBattery10,
mdiBattery10Bluetooth: mdiBattery10Bluetooth,
mdiBattery20: mdiBattery20,
mdiBattery20Bluetooth: mdiBattery20Bluetooth,
mdiBattery30: mdiBattery30,
mdiBattery30Bluetooth: mdiBattery30Bluetooth,
mdiBattery40: mdiBattery40,
mdiBattery40Bluetooth: mdiBattery40Bluetooth,
mdiBattery50: mdiBattery50,
mdiBattery50Bluetooth: mdiBattery50Bluetooth,
mdiBattery60: mdiBattery60,
mdiBattery60Bluetooth: mdiBattery60Bluetooth,
mdiBattery70: mdiBattery70,
mdiBattery70Bluetooth: mdiBattery70Bluetooth,
mdiBattery80: mdiBattery80,
mdiBattery80Bluetooth: mdiBattery80Bluetooth,
mdiBattery90: mdiBattery90,
mdiBattery90Bluetooth: mdiBattery90Bluetooth,
mdiBatteryAlert: mdiBatteryAlert,
mdiBatteryAlertBluetooth: mdiBatteryAlertBluetooth,
mdiBatteryAlertVariant: mdiBatteryAlertVariant,
mdiBatteryAlertVariantOutline: mdiBatteryAlertVariantOutline,
mdiBatteryArrowDown: mdiBatteryArrowDown,
mdiBatteryArrowDownOutline: mdiBatteryArrowDownOutline,
mdiBatteryArrowUp: mdiBatteryArrowUp,
mdiBatteryArrowUpOutline: mdiBatteryArrowUpOutline,
mdiBatteryBluetooth: mdiBatteryBluetooth,
mdiBatteryBluetoothVariant: mdiBatteryBluetoothVariant,
mdiBatteryCharging: mdiBatteryCharging,
mdiBatteryCharging10: mdiBatteryCharging10,
mdiBatteryCharging100: mdiBatteryCharging100,
mdiBatteryCharging20: mdiBatteryCharging20,
mdiBatteryCharging30: mdiBatteryCharging30,
mdiBatteryCharging40: mdiBatteryCharging40,
mdiBatteryCharging50: mdiBatteryCharging50,
mdiBatteryCharging60: mdiBatteryCharging60,
mdiBatteryCharging70: mdiBatteryCharging70,
mdiBatteryCharging80: mdiBatteryCharging80,
mdiBatteryCharging90: mdiBatteryCharging90,
mdiBatteryChargingHigh: mdiBatteryChargingHigh,
mdiBatteryChargingLow: mdiBatteryChargingLow,
mdiBatteryChargingMedium: mdiBatteryChargingMedium,
mdiBatteryChargingOutline: mdiBatteryChargingOutline,
mdiBatteryChargingWireless: mdiBatteryChargingWireless,
mdiBatteryChargingWireless10: mdiBatteryChargingWireless10,
mdiBatteryChargingWireless20: mdiBatteryChargingWireless20,
mdiBatteryChargingWireless30: mdiBatteryChargingWireless30,
mdiBatteryChargingWireless40: mdiBatteryChargingWireless40,
mdiBatteryChargingWireless50: mdiBatteryChargingWireless50,
mdiBatteryChargingWireless60: mdiBatteryChargingWireless60,
mdiBatteryChargingWireless70: mdiBatteryChargingWireless70,
mdiBatteryChargingWireless80: mdiBatteryChargingWireless80,
mdiBatteryChargingWireless90: mdiBatteryChargingWireless90,
mdiBatteryChargingWirelessAlert: mdiBatteryChargingWirelessAlert,
mdiBatteryChargingWirelessOutline: mdiBatteryChargingWirelessOutline,
mdiBatteryCheck: mdiBatteryCheck,
mdiBatteryCheckOutline: mdiBatteryCheckOutline,
mdiBatteryClock: mdiBatteryClock,
mdiBatteryClockOutline: mdiBatteryClockOutline,
mdiBatteryHeart: mdiBatteryHeart,
mdiBatteryHeartOutline: mdiBatteryHeartOutline,
mdiBatteryHeartVariant: mdiBatteryHeartVariant,
mdiBatteryHigh: mdiBatteryHigh,
mdiBatteryLock: mdiBatteryLock,
mdiBatteryLockOpen: mdiBatteryLockOpen,
mdiBatteryLow: mdiBatteryLow,
mdiBatteryMedium: mdiBatteryMedium,
mdiBatteryMinus: mdiBatteryMinus,
mdiBatteryMinusOutline: mdiBatteryMinusOutline,
mdiBatteryMinusVariant: mdiBatteryMinusVariant,
mdiBatteryNegative: mdiBatteryNegative,
mdiBatteryOff: mdiBatteryOff,
mdiBatteryOffOutline: mdiBatteryOffOutline,
mdiBatteryOutline: mdiBatteryOutline,
mdiBatteryPlus: mdiBatteryPlus,
mdiBatteryPlusOutline: mdiBatteryPlusOutline,
mdiBatteryPlusVariant: mdiBatteryPlusVariant,
mdiBatteryPositive: mdiBatteryPositive,
mdiBatteryRemove: mdiBatteryRemove,
mdiBatteryRemoveOutline: mdiBatteryRemoveOutline,
mdiBatterySync: mdiBatterySync,
mdiBatterySyncOutline: mdiBatterySyncOutline,
mdiBatteryUnknown: mdiBatteryUnknown,
mdiBatteryUnknownBluetooth: mdiBatteryUnknownBluetooth,
mdiBeach: mdiBeach,
mdiBeaker: mdiBeaker,
mdiBeakerAlert: mdiBeakerAlert,
mdiBeakerAlertOutline: mdiBeakerAlertOutline,
mdiBeakerCheck: mdiBeakerCheck,
mdiBeakerCheckOutline: mdiBeakerCheckOutline,
mdiBeakerMinus: mdiBeakerMinus,
mdiBeakerMinusOutline: mdiBeakerMinusOutline,
mdiBeakerOutline: mdiBeakerOutline,
mdiBeakerPlus: mdiBeakerPlus,
mdiBeakerPlusOutline: mdiBeakerPlusOutline,
mdiBeakerQuestion: mdiBeakerQuestion,
mdiBeakerQuestionOutline: mdiBeakerQuestionOutline,
mdiBeakerRemove: mdiBeakerRemove,
mdiBeakerRemoveOutline: mdiBeakerRemoveOutline,
mdiBed: mdiBed,
mdiBedClock: mdiBedClock,
mdiBedDouble: mdiBedDouble,
mdiBedDoubleOutline: mdiBedDoubleOutline,
mdiBedEmpty: mdiBedEmpty,
mdiBedKing: mdiBedKing,
mdiBedKingOutline: mdiBedKingOutline,
mdiBedOutline: mdiBedOutline,
mdiBedQueen: mdiBedQueen,
mdiBedQueenOutline: mdiBedQueenOutline,
mdiBedSingle: mdiBedSingle,
mdiBedSingleOutline: mdiBedSingleOutline,
mdiBee: mdiBee,
mdiBeeFlower: mdiBeeFlower,
mdiBeehiveOffOutline: mdiBeehiveOffOutline,
mdiBeehiveOutline: mdiBeehiveOutline,
mdiBeekeeper: mdiBeekeeper,
mdiBeer: mdiBeer,
mdiBeerOutline: mdiBeerOutline,
mdiBell: mdiBell,
mdiBellAlert: mdiBellAlert,
mdiBellAlertOutline: mdiBellAlertOutline,
mdiBellBadge: mdiBellBadge,
mdiBellBadgeOutline: mdiBellBadgeOutline,
mdiBellCancel: mdiBellCancel,
mdiBellCancelOutline: mdiBellCancelOutline,
mdiBellCheck: mdiBellCheck,
mdiBellCheckOutline: mdiBellCheckOutline,
mdiBellCircle: mdiBellCircle,
mdiBellCircleOutline: mdiBellCircleOutline,
mdiBellCog: mdiBellCog,
mdiBellCogOutline: mdiBellCogOutline,
mdiBellMinus: mdiBellMinus,
mdiBellMinusOutline: mdiBellMinusOutline,
mdiBellOff: mdiBellOff,
mdiBellOffOutline: mdiBellOffOutline,
mdiBellOutline: mdiBellOutline,
mdiBellPlus: mdiBellPlus,
mdiBellPlusOutline: mdiBellPlusOutline,
mdiBellRemove: mdiBellRemove,
mdiBellRemoveOutline: mdiBellRemoveOutline,
mdiBellRing: mdiBellRing,
mdiBellRingOutline: mdiBellRingOutline,
mdiBellSleep: mdiBellSleep,
mdiBellSleepOutline: mdiBellSleepOutline,
mdiBeta: mdiBeta,
mdiBetamax: mdiBetamax,
mdiBiathlon: mdiBiathlon,
mdiBicycle: mdiBicycle,
mdiBicycleBasket: mdiBicycleBasket,
mdiBicycleCargo: mdiBicycleCargo,
mdiBicycleElectric: mdiBicycleElectric,
mdiBicyclePennyFarthing: mdiBicyclePennyFarthing,
mdiBike: mdiBike,
mdiBikeFast: mdiBikeFast,
mdiBillboard: mdiBillboard,
mdiBilliards: mdiBilliards,
mdiBilliardsRack: mdiBilliardsRack,
mdiBinoculars: mdiBinoculars,
mdiBio: mdiBio,
mdiBiohazard: mdiBiohazard,
mdiBird: mdiBird,
mdiBitbucket: mdiBitbucket,
mdiBitcoin: mdiBitcoin,
mdiBlackMesa: mdiBlackMesa,
mdiBlender: mdiBlender,
mdiBlenderOutline: mdiBlenderOutline,
mdiBlenderSoftware: mdiBlenderSoftware,
mdiBlinds: mdiBlinds,
mdiBlindsHorizontal: mdiBlindsHorizontal,
mdiBlindsHorizontalClosed: mdiBlindsHorizontalClosed,
mdiBlindsOpen: mdiBlindsOpen,
mdiBlindsVertical: mdiBlindsVertical,
mdiBlindsVerticalClosed: mdiBlindsVerticalClosed,
mdiBlockHelper: mdiBlockHelper,
mdiBloodBag: mdiBloodBag,
mdiBluetooth: mdiBluetooth,
mdiBluetoothAudio: mdiBluetoothAudio,
mdiBluetoothConnect: mdiBluetoothConnect,
mdiBluetoothOff: mdiBluetoothOff,
mdiBluetoothSettings: mdiBluetoothSettings,
mdiBluetoothTransfer: mdiBluetoothTransfer,
mdiBlur: mdiBlur,
mdiBlurLinear: mdiBlurLinear,
mdiBlurOff: mdiBlurOff,
mdiBlurRadial: mdiBlurRadial,
mdiBolt: mdiBolt,
mdiBomb: mdiBomb,
mdiBombOff: mdiBombOff,
mdiBone: mdiBone,
mdiBoneOff: mdiBoneOff,
mdiBook: mdiBook,
mdiBookAccount: mdiBookAccount,
mdiBookAccountOutline: mdiBookAccountOutline,
mdiBookAlert: mdiBookAlert,
mdiBookAlertOutline: mdiBookAlertOutline,
mdiBookAlphabet: mdiBookAlphabet,
mdiBookArrowDown: mdiBookArrowDown,
mdiBookArrowDownOutline: mdiBookArrowDownOutline,
mdiBookArrowLeft: mdiBookArrowLeft,
mdiBookArrowLeftOutline: mdiBookArrowLeftOutline,
mdiBookArrowRight: mdiBookArrowRight,
mdiBookArrowRightOutline: mdiBookArrowRightOutline,
mdiBookArrowUp: mdiBookArrowUp,
mdiBookArrowUpOutline: mdiBookArrowUpOutline,
mdiBookCancel: mdiBookCancel,
mdiBookCancelOutline: mdiBookCancelOutline,
mdiBookCheck: mdiBookCheck,
mdiBookCheckOutline: mdiBookCheckOutline,
mdiBookClock: mdiBookClock,
mdiBookClockOutline: mdiBookClockOutline,
mdiBookCog: mdiBookCog,
mdiBookCogOutline: mdiBookCogOutline,
mdiBookCross: mdiBookCross,
mdiBookEdit: mdiBookEdit,
mdiBookEditOutline: mdiBookEditOutline,
mdiBookEducation: mdiBookEducation,
mdiBookEducationOutline: mdiBookEducationOutline,
mdiBookHeart: mdiBookHeart,
mdiBookHeartOutline: mdiBookHeartOutline,
mdiBookInformationVariant: mdiBookInformationVariant,
mdiBookLock: mdiBookLock,
mdiBookLockOpen: mdiBookLockOpen,
mdiBookLockOpenOutline: mdiBookLockOpenOutline,
mdiBookLockOutline: mdiBookLockOutline,
mdiBookMarker: mdiBookMarker,
mdiBookMarkerOutline: mdiBookMarkerOutline,
mdiBookMinus: mdiBookMinus,
mdiBookMinusMultiple: mdiBookMinusMultiple,
mdiBookMinusMultipleOutline: mdiBookMinusMultipleOutline,
mdiBookMinusOutline: mdiBookMinusOutline,
mdiBookMultiple: mdiBookMultiple,
mdiBookMultipleOutline: mdiBookMultipleOutline,
mdiBookMusic: mdiBookMusic,
mdiBookMusicOutline: mdiBookMusicOutline,
mdiBookOff: mdiBookOff,
mdiBookOffOutline: mdiBookOffOutline,
mdiBookOpen: mdiBookOpen,
mdiBookOpenBlankVariant: mdiBookOpenBlankVariant,
mdiBookOpenOutline: mdiBookOpenOutline,
mdiBookOpenPageVariant: mdiBookOpenPageVariant,
mdiBookOpenPageVariantOutline: mdiBookOpenPageVariantOutline,
mdiBookOpenVariant: mdiBookOpenVariant,
mdiBookOutline: mdiBookOutline,
mdiBookPlay: mdiBookPlay,
mdiBookPlayOutline: mdiBookPlayOutline,
mdiBookPlus: mdiBookPlus,
mdiBookPlusMultiple: mdiBookPlusMultiple,
mdiBookPlusMultipleOutline: mdiBookPlusMultipleOutline,
mdiBookPlusOutline: mdiBookPlusOutline,
mdiBookRefresh: mdiBookRefresh,
mdiBookRefreshOutline: mdiBookRefreshOutline,
mdiBookRemove: mdiBookRemove,
mdiBookRemoveMultiple: mdiBookRemoveMultiple,
mdiBookRemoveMultipleOutline: mdiBookRemoveMultipleOutline,
mdiBookRemoveOutline: mdiBookRemoveOutline,
mdiBookSearch: mdiBookSearch,
mdiBookSearchOutline: mdiBookSearchOutline,
mdiBookSettings: mdiBookSettings,
mdiBookSettingsOutline: mdiBookSettingsOutline,
mdiBookSync: mdiBookSync,
mdiBookSyncOutline: mdiBookSyncOutline,
mdiBookVariant: mdiBookVariant,
mdiBookmark: mdiBookmark,
mdiBookmarkBox: mdiBookmarkBox,
mdiBookmarkBoxMultiple: mdiBookmarkBoxMultiple,
mdiBookmarkBoxMultipleOutline: mdiBookmarkBoxMultipleOutline,
mdiBookmarkBoxOutline: mdiBookmarkBoxOutline,
mdiBookmarkCheck: mdiBookmarkCheck,
mdiBookmarkCheckOutline: mdiBookmarkCheckOutline,
mdiBookmarkMinus: mdiBookmarkMinus,
mdiBookmarkMinusOutline: mdiBookmarkMinusOutline,
mdiBookmarkMultiple: mdiBookmarkMultiple,
mdiBookmarkMultipleOutline: mdiBookmarkMultipleOutline,
mdiBookmarkMusic: mdiBookmarkMusic,
mdiBookmarkMusicOutline: mdiBookmarkMusicOutline,
mdiBookmarkOff: mdiBookmarkOff,
mdiBookmarkOffOutline: mdiBookmarkOffOutline,
mdiBookmarkOutline: mdiBookmarkOutline,
mdiBookmarkPlus: mdiBookmarkPlus,
mdiBookmarkPlusOutline: mdiBookmarkPlusOutline,
mdiBookmarkRemove: mdiBookmarkRemove,
mdiBookmarkRemoveOutline: mdiBookmarkRemoveOutline,
mdiBookshelf: mdiBookshelf,
mdiBoomGate: mdiBoomGate,
mdiBoomGateAlert: mdiBoomGateAlert,
mdiBoomGateAlertOutline: mdiBoomGateAlertOutline,
mdiBoomGateArrowDown: mdiBoomGateArrowDown,
mdiBoomGateArrowDownOutline: mdiBoomGateArrowDownOutline,
mdiBoomGateArrowUp: mdiBoomGateArrowUp,
mdiBoomGateArrowUpOutline: mdiBoomGateArrowUpOutline,
mdiBoomGateOutline: mdiBoomGateOutline,
mdiBoomGateUp: mdiBoomGateUp,
mdiBoomGateUpOutline: mdiBoomGateUpOutline,
mdiBoombox: mdiBoombox,
mdiBoomerang: mdiBoomerang,
mdiBootstrap: mdiBootstrap,
mdiBorderAll: mdiBorderAll,
mdiBorderAllVariant: mdiBorderAllVariant,
mdiBorderBottom: mdiBorderBottom,
mdiBorderBottomVariant: mdiBorderBottomVariant,
mdiBorderColor: mdiBorderColor,
mdiBorderHorizontal: mdiBorderHorizontal,
mdiBorderInside: mdiBorderInside,
mdiBorderLeft: mdiBorderLeft,
mdiBorderLeftVariant: mdiBorderLeftVariant,
mdiBorderNone: mdiBorderNone,
mdiBorderNoneVariant: mdiBorderNoneVariant,
mdiBorderOutside: mdiBorderOutside,
mdiBorderRadius: mdiBorderRadius,
mdiBorderRight: mdiBorderRight,
mdiBorderRightVariant: mdiBorderRightVariant,
mdiBorderStyle: mdiBorderStyle,
mdiBorderTop: mdiBorderTop,
mdiBorderTopVariant: mdiBorderTopVariant,
mdiBorderVertical: mdiBorderVertical,
mdiBottleSoda: mdiBottleSoda,
mdiBottleSodaClassic: mdiBottleSodaClassic,
mdiBottleSodaClassicOutline: mdiBottleSodaClassicOutline,
mdiBottleSodaOutline: mdiBottleSodaOutline,
mdiBottleTonic: mdiBottleTonic,
mdiBottleTonicOutline: mdiBottleTonicOutline,
mdiBottleTonicPlus: mdiBottleTonicPlus,
mdiBottleTonicPlusOutline: mdiBottleTonicPlusOutline,
mdiBottleTonicSkull: mdiBottleTonicSkull,
mdiBottleTonicSkullOutline: mdiBottleTonicSkullOutline,
mdiBottleWine: mdiBottleWine,
mdiBottleWineOutline: mdiBottleWineOutline,
mdiBowArrow: mdiBowArrow,
mdiBowTie: mdiBowTie,
mdiBowl: mdiBowl,
mdiBowlMix: mdiBowlMix,
mdiBowlMixOutline: mdiBowlMixOutline,
mdiBowlOutline: mdiBowlOutline,
mdiBowling: mdiBowling,
mdiBox: mdiBox,
mdiBoxCutter: mdiBoxCutter,
mdiBoxCutterOff: mdiBoxCutterOff,
mdiBoxShadow: mdiBoxShadow,
mdiBoxingGlove: mdiBoxingGlove,
mdiBraille: mdiBraille,
mdiBrain: mdiBrain,
mdiBreadSlice: mdiBreadSlice,
mdiBreadSliceOutline: mdiBreadSliceOutline,
mdiBridge: mdiBridge,
mdiBriefcase: mdiBriefcase,
mdiBriefcaseAccount: mdiBriefcaseAccount,
mdiBriefcaseAccountOutline: mdiBriefcaseAccountOutline,
mdiBriefcaseArrowLeftRight: mdiBriefcaseArrowLeftRight,
mdiBriefcaseArrowLeftRightOutline: mdiBriefcaseArrowLeftRightOutline,
mdiBriefcaseArrowUpDown: mdiBriefcaseArrowUpDown,
mdiBriefcaseArrowUpDownOutline: mdiBriefcaseArrowUpDownOutline,
mdiBriefcaseCheck: mdiBriefcaseCheck,
mdiBriefcaseCheckOutline: mdiBriefcaseCheckOutline,
mdiBriefcaseClock: mdiBriefcaseClock,
mdiBriefcaseClockOutline: mdiBriefcaseClockOutline,
mdiBriefcaseDownload: mdiBriefcaseDownload,
mdiBriefcaseDownloadOutline: mdiBriefcaseDownloadOutline,
mdiBriefcaseEdit: mdiBriefcaseEdit,
mdiBriefcaseEditOutline: mdiBriefcaseEditOutline,
mdiBriefcaseEye: mdiBriefcaseEye,
mdiBriefcaseEyeOutline: mdiBriefcaseEyeOutline,
mdiBriefcaseMinus: mdiBriefcaseMinus,
mdiBriefcaseMinusOutline: mdiBriefcaseMinusOutline,
mdiBriefcaseOff: mdiBriefcaseOff,
mdiBriefcaseOffOutline: mdiBriefcaseOffOutline,
mdiBriefcaseOutline: mdiBriefcaseOutline,
mdiBriefcasePlus: mdiBriefcasePlus,
mdiBriefcasePlusOutline: mdiBriefcasePlusOutline,
mdiBriefcaseRemove: mdiBriefcaseRemove,
mdiBriefcaseRemoveOutline: mdiBriefcaseRemoveOutline,
mdiBriefcaseSearch: mdiBriefcaseSearch,
mdiBriefcaseSearchOutline: mdiBriefcaseSearchOutline,
mdiBriefcaseUpload: mdiBriefcaseUpload,
mdiBriefcaseUploadOutline: mdiBriefcaseUploadOutline,
mdiBriefcaseVariant: mdiBriefcaseVariant,
mdiBriefcaseVariantOff: mdiBriefcaseVariantOff,
mdiBriefcaseVariantOffOutline: mdiBriefcaseVariantOffOutline,
mdiBriefcaseVariantOutline: mdiBriefcaseVariantOutline,
mdiBrightness1: mdiBrightness1,
mdiBrightness2: mdiBrightness2,
mdiBrightness3: mdiBrightness3,
mdiBrightness4: mdiBrightness4,
mdiBrightness5: mdiBrightness5,
mdiBrightness6: mdiBrightness6,
mdiBrightness7: mdiBrightness7,
mdiBrightnessAuto: mdiBrightnessAuto,
mdiBrightnessPercent: mdiBrightnessPercent,
mdiBroadcast: mdiBroadcast,
mdiBroadcastOff: mdiBroadcastOff,
mdiBroom: mdiBroom,
mdiBrush: mdiBrush,
mdiBrushOff: mdiBrushOff,
mdiBrushOutline: mdiBrushOutline,
mdiBrushVariant: mdiBrushVariant,
mdiBucket: mdiBucket,
mdiBucketOutline: mdiBucketOutline,
mdiBuffet: mdiBuffet,
mdiBug: mdiBug,
mdiBugCheck: mdiBugCheck,
mdiBugCheckOutline: mdiBugCheckOutline,
mdiBugOutline: mdiBugOutline,
mdiBugPause: mdiBugPause,
mdiBugPauseOutline: mdiBugPauseOutline,
mdiBugPlay: mdiBugPlay,
mdiBugPlayOutline: mdiBugPlayOutline,
mdiBugStop: mdiBugStop,
mdiBugStopOutline: mdiBugStopOutline,
mdiBugle: mdiBugle,
mdiBulkheadLight: mdiBulkheadLight,
mdiBulldozer: mdiBulldozer,
mdiBullet: mdiBullet,
mdiBulletinBoard: mdiBulletinBoard,
mdiBullhorn: mdiBullhorn,
mdiBullhornOutline: mdiBullhornOutline,
mdiBullhornVariant: mdiBullhornVariant,
mdiBullhornVariantOutline: mdiBullhornVariantOutline,
mdiBullseye: mdiBullseye,
mdiBullseyeArrow: mdiBullseyeArrow,
mdiBulma: mdiBulma,
mdiBunkBed: mdiBunkBed,
mdiBunkBedOutline: mdiBunkBedOutline,
mdiBus: mdiBus,
mdiBusAlert: mdiBusAlert,
mdiBusArticulatedEnd: mdiBusArticulatedEnd,
mdiBusArticulatedFront: mdiBusArticulatedFront,
mdiBusClock: mdiBusClock,
mdiBusDoubleDecker: mdiBusDoubleDecker,
mdiBusElectric: mdiBusElectric,
mdiBusMarker: mdiBusMarker,
mdiBusMultiple: mdiBusMultiple,
mdiBusSchool: mdiBusSchool,
mdiBusSide: mdiBusSide,
mdiBusStop: mdiBusStop,
mdiBusStopCovered: mdiBusStopCovered,
mdiBusStopUncovered: mdiBusStopUncovered,
mdiButterfly: mdiButterfly,
mdiButterflyOutline: mdiButterflyOutline,
mdiButtonCursor: mdiButtonCursor,
mdiButtonPointer: mdiButtonPointer,
mdiCabinAFrame: mdiCabinAFrame,
mdiCableData: mdiCableData,
mdiCached: mdiCached,
mdiCactus: mdiCactus,
mdiCake: mdiCake,
mdiCakeLayered: mdiCakeLayered,
mdiCakeVariant: mdiCakeVariant,
mdiCakeVariantOutline: mdiCakeVariantOutline,
mdiCalculator: mdiCalculator,
mdiCalculatorVariant: mdiCalculatorVariant,
mdiCalculatorVariantOutline: mdiCalculatorVariantOutline,
mdiCalendar: mdiCalendar,
mdiCalendarAccount: mdiCalendarAccount,
mdiCalendarAccountOutline: mdiCalendarAccountOutline,
mdiCalendarAlert: mdiCalendarAlert,
mdiCalendarAlertOutline: mdiCalendarAlertOutline,
mdiCalendarArrowLeft: mdiCalendarArrowLeft,
mdiCalendarArrowRight: mdiCalendarArrowRight,
mdiCalendarBadge: mdiCalendarBadge,
mdiCalendarBadgeOutline: mdiCalendarBadgeOutline,
mdiCalendarBlank: mdiCalendarBlank,
mdiCalendarBlankMultiple: mdiCalendarBlankMultiple,
mdiCalendarBlankOutline: mdiCalendarBlankOutline,
mdiCalendarCheck: mdiCalendarCheck,
mdiCalendarCheckOutline: mdiCalendarCheckOutline,
mdiCalendarClock: mdiCalendarClock,
mdiCalendarClockOutline: mdiCalendarClockOutline,
mdiCalendarCollapseHorizontal: mdiCalendarCollapseHorizontal,
mdiCalendarCollapseHorizontalOutline: mdiCalendarCollapseHorizontalOutline,
mdiCalendarCursor: mdiCalendarCursor,
mdiCalendarCursorOutline: mdiCalendarCursorOutline,
mdiCalendarEdit: mdiCalendarEdit,
mdiCalendarEditOutline: mdiCalendarEditOutline,
mdiCalendarEnd: mdiCalendarEnd,
mdiCalendarEndOutline: mdiCalendarEndOutline,
mdiCalendarExpandHorizontal: mdiCalendarExpandHorizontal,
mdiCalendarExpandHorizontalOutline: mdiCalendarExpandHorizontalOutline,
mdiCalenda: mdiCalendar,
// mdiCalendarstring: mdiCalendarstring,
// mdiCalendarFilter: mdiCalendarFilter,
mdiCalendarFilterOutline: mdiCalendarFilterOutline,
mdiCalendarHeart: mdiCalendarHeart,
mdiCalendarHeartOutline: mdiCalendarHeartOutline,
mdiCalendarImport: mdiCalendarImport,
mdiCalendarImportOutline: mdiCalendarImportOutline,
mdiCalendarLock: mdiCalendarLock,
mdiCalendarLockOpen: mdiCalendarLockOpen,
mdiCalendarLockOpenOutline: mdiCalendarLockOpenOutline,
mdiCalendarLockOutline: mdiCalendarLockOutline,
mdiCalendarMinus: mdiCalendarMinus,
mdiCalendarMinusOutline: mdiCalendarMinusOutline,
mdiCalendarMonth: mdiCalendarMonth,
mdiCalendarMonthOutline: mdiCalendarMonthOutline,
mdiCalendarMultiple: mdiCalendarMultiple,
mdiCalendarMultipleCheck: mdiCalendarMultipleCheck,
mdiCalendarMultiselect: mdiCalendarMultiselect,
mdiCalendarMultiselectOutline: mdiCalendarMultiselectOutline,
mdiCalendarOutline: mdiCalendarOutline,
mdiCalendarPlus: mdiCalendarPlus,
mdiCalendarPlusOutline: mdiCalendarPlusOutline,
mdiCalendarQuestion: mdiCalendarQuestion,
mdiCalendarQuestionOutline: mdiCalendarQuestionOutline,
mdiCalendarRange: mdiCalendarRange,
mdiCalendarRangeOutline: mdiCalendarRangeOutline,
mdiCalendarRefresh: mdiCalendarRefresh,
mdiCalendarRefreshOutline: mdiCalendarRefreshOutline,
mdiCalendarRemove: mdiCalendarRemove,
mdiCalendarRemoveOutline: mdiCalendarRemoveOutline,
mdiCalendarSearch: mdiCalendarSearch,
mdiCalendarSearchOutline: mdiCalendarSearchOutline,
mdiCalendarStar: mdiCalendarStar,
mdiCalendarStarOutline: mdiCalendarStarOutline,
mdiCalendarStart: mdiCalendarStart,
mdiCalendarStartOutline: mdiCalendarStartOutline,
mdiCalendarSync: mdiCalendarSync,
mdiCalendarSyncOutline: mdiCalendarSyncOutline,
mdiCalendarText: mdiCalendarText,
mdiCalendarTextOutline: mdiCalendarTextOutline,
mdiCalendarToday: mdiCalendarToday,
mdiCalendarTodayOutline: mdiCalendarTodayOutline,
mdiCalendarWeek: mdiCalendarWeek,
mdiCalendarWeekBegin: mdiCalendarWeekBegin,
mdiCalendarWeekBeginOutline: mdiCalendarWeekBeginOutline,
mdiCalendarWeekOutline: mdiCalendarWeekOutline,
mdiCalendarWeekend: mdiCalendarWeekend,
mdiCalendarWeekendOutline: mdiCalendarWeekendOutline,
mdiCallMade: mdiCallMade,
mdiCallMerge: mdiCallMerge,
mdiCallMissed: mdiCallMissed,
mdiCallReceived: mdiCallReceived,
mdiCallSplit: mdiCallSplit,
mdiCamcorder: mdiCamcorder,
mdiCamcorderOff: mdiCamcorderOff,
mdiCamera: mdiCamera,
mdiCameraAccount: mdiCameraAccount,
mdiCameraBurst: mdiCameraBurst,
mdiCameraControl: mdiCameraControl,
mdiCameraDocument: mdiCameraDocument,
mdiCameraDocumentOff: mdiCameraDocumentOff,
mdiCameraEnhance: mdiCameraEnhance,
mdiCameraEnhanceOutline: mdiCameraEnhanceOutline,
mdiCameraFlip: mdiCameraFlip,
mdiCameraFlipOutline: mdiCameraFlipOutline,
mdiCameraFront: mdiCameraFront,
mdiCameraFrontVariant: mdiCameraFrontVariant,
mdiCameraGopro: mdiCameraGopro,
mdiCameraImage: mdiCameraImage,
mdiCameraIris: mdiCameraIris,
mdiCameraLock: mdiCameraLock,
mdiCameraLockOutline: mdiCameraLockOutline,
mdiCameraMarker: mdiCameraMarker,
mdiCameraMarkerOutline: mdiCameraMarkerOutline,
mdiCameraMeteringCenter: mdiCameraMeteringCenter,
mdiCameraMeteringMatrix: mdiCameraMeteringMatrix,
mdiCameraMeteringPartial: mdiCameraMeteringPartial,
mdiCameraMeteringSpot: mdiCameraMeteringSpot,
mdiCameraOff: mdiCameraOff,
mdiCameraOffOutline: mdiCameraOffOutline,
mdiCameraOutline: mdiCameraOutline,
mdiCameraPartyMode: mdiCameraPartyMode,
mdiCameraPlus: mdiCameraPlus,
mdiCameraPlusOutline: mdiCameraPlusOutline,
mdiCameraRear: mdiCameraRear,
mdiCameraRearVariant: mdiCameraRearVariant,
mdiCameraRetake: mdiCameraRetake,
mdiCameraRetakeOutline: mdiCameraRetakeOutline,
mdiCameraSwitch: mdiCameraSwitch,
mdiCameraSwitchOutline: mdiCameraSwitchOutline,
mdiCameraTimer: mdiCameraTimer,
mdiCameraWireless: mdiCameraWireless,
mdiCameraWirelessOutline: mdiCameraWirelessOutline,
mdiCampfire: mdiCampfire,
mdiCancel: mdiCancel,
mdiCandelabra: mdiCandelabra,
mdiCandelabraFire: mdiCandelabraFire,
mdiCandle: mdiCandle,
mdiCandy: mdiCandy,
mdiCandyOff: mdiCandyOff,
mdiCandyOffOutline: mdiCandyOffOutline,
mdiCandyOutline: mdiCandyOutline,
mdiCandycane: mdiCandycane,
mdiCannabis: mdiCannabis,
mdiCannabisOff: mdiCannabisOff,
mdiCapsLock: mdiCapsLock,
mdiCar: mdiCar,
mdiCar2Plus: mdiCar2Plus,
mdiCar3Plus: mdiCar3Plus,
mdiCarArrowLeft: mdiCarArrowLeft,
mdiCarArrowRight: mdiCarArrowRight,
mdiCarBack: mdiCarBack,
mdiCarBattery: mdiCarBattery,
mdiCarBrakeAbs: mdiCarBrakeAbs,
mdiCarBrakeAlert: mdiCarBrakeAlert,
mdiCarBrakeFluidLevel: mdiCarBrakeFluidLevel,
mdiCarBrakeHold: mdiCarBrakeHold,
mdiCarBrakeLowPressure: mdiCarBrakeLowPressure,
mdiCarBrakeParking: mdiCarBrakeParking,
mdiCarBrakeRetarder: mdiCarBrakeRetarder,
mdiCarBrakeTemperature: mdiCarBrakeTemperature,
mdiCarBrakeWornLinings: mdiCarBrakeWornLinings,
mdiCarChildSeat: mdiCarChildSeat,
mdiCarClock: mdiCarClock,
mdiCarClutch: mdiCarClutch,
mdiCarCog: mdiCarCog,
mdiCarConnected: mdiCarConnected,
mdiCarConvertible: mdiCarConvertible,
mdiCarCoolantLevel: mdiCarCoolantLevel,
mdiCarCruiseControl: mdiCarCruiseControl,
mdiCarDefrostFront: mdiCarDefrostFront,
mdiCarDefrostRear: mdiCarDefrostRear,
mdiCarDoor: mdiCarDoor,
mdiCarDoorLock: mdiCarDoorLock,
mdiCarElectric: mdiCarElectric,
mdiCarElectricOutline: mdiCarElectricOutline,
mdiCarEmergency: mdiCarEmergency,
mdiCarEsp: mdiCarEsp,
mdiCarEstate: mdiCarEstate,
mdiCarHatchback: mdiCarHatchback,
mdiCarInfo: mdiCarInfo,
mdiCarKey: mdiCarKey,
mdiCarLiftedPickup: mdiCarLiftedPickup,
mdiCarLightAlert: mdiCarLightAlert,
mdiCarLightDimmed: mdiCarLightDimmed,
mdiCarLightFog: mdiCarLightFog,
mdiCarLightHigh: mdiCarLightHigh,
mdiCarLimousine: mdiCarLimousine,
mdiCarMultiple: mdiCarMultiple,
mdiCarOff: mdiCarOff,
mdiCarOutline: mdiCarOutline,
mdiCarParkingLights: mdiCarParkingLights,
mdiCarPickup: mdiCarPickup,
mdiCarSearch: mdiCarSearch,
mdiCarSearchOutline: mdiCarSearchOutline,
mdiCarSeat: mdiCarSeat,
mdiCarSeatCooler: mdiCarSeatCooler,
mdiCarSeatHeater: mdiCarSeatHeater,
mdiCarSelect: mdiCarSelect,
mdiCarSettings: mdiCarSettings,
mdiCarShiftPattern: mdiCarShiftPattern,
mdiCarSide: mdiCarSide,
mdiCarSpeedLimiter: mdiCarSpeedLimiter,
mdiCarSports: mdiCarSports,
mdiCarTireAlert: mdiCarTireAlert,
mdiCarTractionControl: mdiCarTractionControl,
mdiCarTurbocharger: mdiCarTurbocharger,
mdiCarWash: mdiCarWash,
mdiCarWindshield: mdiCarWindshield,
mdiCarWindshieldOutline: mdiCarWindshieldOutline,
mdiCarWireless: mdiCarWireless,
mdiCarWrench: mdiCarWrench,
mdiCarabiner: mdiCarabiner,
mdiCaravan: mdiCaravan,
mdiCard: mdiCard,
mdiCardAccountDetails: mdiCardAccountDetails,
mdiCardAccountDetailsOutline: mdiCardAccountDetailsOutline,
mdiCardAccountDetailsStar: mdiCardAccountDetailsStar,
mdiCardAccountDetailsStarOutline: mdiCardAccountDetailsStarOutline,
mdiCardAccountMail: mdiCardAccountMail,
mdiCardAccountMailOutline: mdiCardAccountMailOutline,
mdiCardAccountPhone: mdiCardAccountPhone,
mdiCardAccountPhoneOutline: mdiCardAccountPhoneOutline,
mdiCardBulleted: mdiCardBulleted,
mdiCardBulletedOff: mdiCardBulletedOff,
mdiCardBulletedOffOutline: mdiCardBulletedOffOutline,
mdiCardBulletedOutline: mdiCardBulletedOutline,
mdiCardBulletedSettings: mdiCardBulletedSettings,
mdiCardBulletedSettingsOutline: mdiCardBulletedSettingsOutline,
mdiCardMinus: mdiCardMinus,
mdiCardMinusOutline: mdiCardMinusOutline,
mdiCardMultiple: mdiCardMultiple,
mdiCardMultipleOutline: mdiCardMultipleOutline,
mdiCardOff: mdiCardOff,
mdiCardOffOutline: mdiCardOffOutline,
mdiCardOutline: mdiCardOutline,
mdiCardPlus: mdiCardPlus,
mdiCardPlusOutline: mdiCardPlusOutline,
mdiCardRemove: mdiCardRemove,
mdiCardRemoveOutline: mdiCardRemoveOutline,
mdiCardSearch: mdiCardSearch,
mdiCardSearchOutline: mdiCardSearchOutline,
mdiCardText: mdiCardText,
mdiCardTextOutline: mdiCardTextOutline,
mdiCards: mdiCards,
mdiCardsClub: mdiCardsClub,
mdiCardsClubOutline: mdiCardsClubOutline,
mdiCardsDiamond: mdiCardsDiamond,
mdiCardsDiamondOutline: mdiCardsDiamondOutline,
mdiCardsHeart: mdiCardsHeart,
mdiCardsHeartOutline: mdiCardsHeartOutline,
mdiCardsOutline: mdiCardsOutline,
mdiCardsPlaying: mdiCardsPlaying,
mdiCardsPlayingClub: mdiCardsPlayingClub,
mdiCardsPlayingClubMultiple: mdiCardsPlayingClubMultiple,
mdiCardsPlayingClubMultipleOutline: mdiCardsPlayingClubMultipleOutline,
mdiCardsPlayingClubOutline: mdiCardsPlayingClubOutline,
mdiCardsPlayingDiamond: mdiCardsPlayingDiamond,
mdiCardsPlayingDiamondMultiple: mdiCardsPlayingDiamondMultiple,
mdiCardsPlayingDiamondMultipleOutline: mdiCardsPlayingDiamondMultipleOutline,
mdiCardsPlayingDiamondOutline: mdiCardsPlayingDiamondOutline,
mdiCardsPlayingHeart: mdiCardsPlayingHeart,
mdiCardsPlayingHeartMultiple: mdiCardsPlayingHeartMultiple,
mdiCardsPlayingHeartMultipleOutline: mdiCardsPlayingHeartMultipleOutline,
mdiCardsPlayingHeartOutline: mdiCardsPlayingHeartOutline,
mdiCardsPlayingOutline: mdiCardsPlayingOutline,
mdiCardsPlayingSpade: mdiCardsPlayingSpade,
mdiCardsPlayingSpadeMultiple: mdiCardsPlayingSpadeMultiple,
mdiCardsPlayingSpadeMultipleOutline: mdiCardsPlayingSpadeMultipleOutline,
mdiCardsPlayingSpadeOutline: mdiCardsPlayingSpadeOutline,
mdiCardsSpade: mdiCardsSpade,
mdiCardsSpadeOutline: mdiCardsSpadeOutline,
mdiCardsVariant: mdiCardsVariant,
mdiCarrot: mdiCarrot,
mdiCart: mdiCart,
mdiCartArrowDown: mdiCartArrowDown,
mdiCartArrowRight: mdiCartArrowRight,
mdiCartArrowUp: mdiCartArrowUp,
mdiCartCheck: mdiCartCheck,
mdiCartHeart: mdiCartHeart,
mdiCartMinus: mdiCartMinus,
mdiCartOff: mdiCartOff,
mdiCartOutline: mdiCartOutline,
mdiCartPercent: mdiCartPercent,
mdiCartPlus: mdiCartPlus,
mdiCartRemove: mdiCartRemove,
mdiCartVariant: mdiCartVariant,
mdiCaseSensitiveAlt: mdiCaseSensitiveAlt,
mdiCash: mdiCash,
mdiCash100: mdiCash100,
mdiCashCheck: mdiCashCheck,
mdiCashClock: mdiCashClock,
mdiCashFast: mdiCashFast,
mdiCashLock: mdiCashLock,
mdiCashLockOpen: mdiCashLockOpen,
mdiCashMarker: mdiCashMarker,
mdiCashMinus: mdiCashMinus,
mdiCashMultiple: mdiCashMultiple,
mdiCashPlus: mdiCashPlus,
mdiCashRefund: mdiCashRefund,
mdiCashRegister: mdiCashRegister,
mdiCashRemove: mdiCashRemove,
mdiCashSync: mdiCashSync,
mdiCassette: mdiCassette,
mdiCast: mdiCast,
mdiCastAudio: mdiCastAudio,
mdiCastAudioVariant: mdiCastAudioVariant,
mdiCastConnected: mdiCastConnected,
mdiCastEducation: mdiCastEducation,
mdiCastOff: mdiCastOff,
mdiCastVariant: mdiCastVariant,
mdiCastle: mdiCastle,
mdiCat: mdiCat,
mdiCctv: mdiCctv,
mdiCctvOff: mdiCctvOff,
mdiCeilingFan: mdiCeilingFan,
mdiCeilingFanLight: mdiCeilingFanLight,
mdiCeilingLight: mdiCeilingLight,
mdiCeilingLightMultiple: mdiCeilingLightMultiple,
mdiCeilingLightMultipleOutline: mdiCeilingLightMultipleOutline,
mdiCeilingLightOutline: mdiCeilingLightOutline,
mdiCellphone: mdiCellphone,
mdiCellphoneArrowDown: mdiCellphoneArrowDown,
mdiCellphoneArrowDownVariant: mdiCellphoneArrowDownVariant,
mdiCellphoneBasic: mdiCellphoneBasic,
mdiCellphoneCharging: mdiCellphoneCharging,
mdiCellphoneCheck: mdiCellphoneCheck,
mdiCellphoneCog: mdiCellphoneCog,
mdiCellphoneDock: mdiCellphoneDock,
mdiCellphoneInformation: mdiCellphoneInformation,
mdiCellphoneKey: mdiCellphoneKey,
mdiCellphoneLink: mdiCellphoneLink,
mdiCellphoneLinkOff: mdiCellphoneLinkOff,
mdiCellphoneLock: mdiCellphoneLock,
mdiCellphoneMarker: mdiCellphoneMarker,
mdiCellphoneMessage: mdiCellphoneMessage,
mdiCellphoneMessageOff: mdiCellphoneMessageOff,
mdiCellphoneNfc: mdiCellphoneNfc,
mdiCellphoneNfcOff: mdiCellphoneNfcOff,
mdiCellphoneOff: mdiCellphoneOff,
mdiCellphonePlay: mdiCellphonePlay,
mdiCellphoneRemove: mdiCellphoneRemove,
mdiCellphoneScreenshot: mdiCellphoneScreenshot,
mdiCellphoneSettings: mdiCellphoneSettings,
mdiCellphoneSound: mdiCellphoneSound,
mdiCellphoneText: mdiCellphoneText,
mdiCellphoneWireless: mdiCellphoneWireless,
mdiCentos: mdiCentos,
mdiCertificate: mdiCertificate,
mdiCertificateOutline: mdiCertificateOutline,
mdiChairRolling: mdiChairRolling,
mdiChairSchool: mdiChairSchool,
mdiChandelier: mdiChandelier,
mdiCharity: mdiCharity,
mdiChartArc: mdiChartArc,
mdiChartAreaspline: mdiChartAreaspline,
mdiChartAreasplineVariant: mdiChartAreasplineVariant,
mdiChartBar: mdiChartBar,
mdiChartBarStacked: mdiChartBarStacked,
mdiChartBellCurve: mdiChartBellCurve,
mdiChartBellCurveCumulative: mdiChartBellCurveCumulative,
mdiChartBox: mdiChartBox,
mdiChartBoxOutline: mdiChartBoxOutline,
mdiChartBoxPlusOutline: mdiChartBoxPlusOutline,
mdiChartBubble: mdiChartBubble,
mdiChartDonut: mdiChartDonut,
mdiChartDonutVariant: mdiChartDonutVariant,
mdiChartGantt: mdiChartGantt,
mdiChartHistogram: mdiChartHistogram,
mdiChartLine: mdiChartLine,
mdiChartLineStacked: mdiChartLineStacked,
mdiChartLineVariant: mdiChartLineVariant,
mdiChartMultiline: mdiChartMultiline,
mdiChartMultiple: mdiChartMultiple,
mdiChartPie: mdiChartPie,
mdiChartPpf: mdiChartPpf,
mdiChartSankey: mdiChartSankey,
mdiChartSankeyVariant: mdiChartSankeyVariant,
mdiChartScatterPlot: mdiChartScatterPlot,
mdiChartScatterPlotHexbin: mdiChartScatterPlotHexbin,
mdiChartTimeline: mdiChartTimeline,
mdiChartTimelineVariant: mdiChartTimelineVariant,
mdiChartTimelineVariantShimmer: mdiChartTimelineVariantShimmer,
mdiChartTree: mdiChartTree,
mdiChartWaterfall: mdiChartWaterfall,
mdiChat: mdiChat,
mdiChatAlert: mdiChatAlert,
mdiChatAlertOutline: mdiChatAlertOutline,
mdiChatMinus: mdiChatMinus,
mdiChatMinusOutline: mdiChatMinusOutline,
mdiChatOutline: mdiChatOutline,
mdiChatPlus: mdiChatPlus,
mdiChatPlusOutline: mdiChatPlusOutline,
mdiChatProcessing: mdiChatProcessing,
mdiChatProcessingOutline: mdiChatProcessingOutline,
mdiChatQuestion: mdiChatQuestion,
mdiChatQuestionOutline: mdiChatQuestionOutline,
mdiChatRemove: mdiChatRemove,
mdiChatRemoveOutline: mdiChatRemoveOutline,
mdiChatSleep: mdiChatSleep,
mdiChatSleepOutline: mdiChatSleepOutline,
mdiCheck: mdiCheck,
mdiCheckAll: mdiCheckAll,
mdiCheckBold: mdiCheckBold,
mdiCheckCircle: mdiCheckCircle,
mdiCheckCircleOutline: mdiCheckCircleOutline,
mdiCheckDecagram: mdiCheckDecagram,
mdiCheckDecagramOutline: mdiCheckDecagramOutline,
mdiCheckNetwork: mdiCheckNetwork,
mdiCheckNetworkOutline: mdiCheckNetworkOutline,
mdiCheckOutline: mdiCheckOutline,
mdiCheckUnderline: mdiCheckUnderline,
mdiCheckUnderlineCircle: mdiCheckUnderlineCircle,
mdiCheckUnderlineCircleOutline: mdiCheckUnderlineCircleOutline,
mdiCheckbook: mdiCheckbook,
mdiCheckboxBlank: mdiCheckboxBlank,
mdiCheckboxBlankBadge: mdiCheckboxBlankBadge,
mdiCheckboxBlankBadgeOutline: mdiCheckboxBlankBadgeOutline,
mdiCheckboxBlankCircle: mdiCheckboxBlankCircle,
mdiCheckboxBlankCircleOutline: mdiCheckboxBlankCircleOutline,
mdiCheckboxBlankOff: mdiCheckboxBlankOff,
mdiCheckboxBlankOffOutline: mdiCheckboxBlankOffOutline,
mdiCheckboxBlankOutline: mdiCheckboxBlankOutline,
mdiCheckboxIntermediate: mdiCheckboxIntermediate,
mdiCheckboxIntermediateVariant: mdiCheckboxIntermediateVariant,
mdiCheckboxMarked: mdiCheckboxMarked,
mdiCheckboxMarkedCircle: mdiCheckboxMarkedCircle,
mdiCheckboxMarkedCircleOutline: mdiCheckboxMarkedCircleOutline,
mdiCheckboxMarkedCirclePlusOutline: mdiCheckboxMarkedCirclePlusOutline,
mdiCheckboxMarkedOutline: mdiCheckboxMarkedOutline,
mdiCheckboxMultipleBlank: mdiCheckboxMultipleBlank,
mdiCheckboxMultipleBlankCircle: mdiCheckboxMultipleBlankCircle,
mdiCheckboxMultipleBlankCircleOutline: mdiCheckboxMultipleBlankCircleOutline,
mdiCheckboxMultipleBlankOutline: mdiCheckboxMultipleBlankOutline,
mdiCheckboxMultipleMarked: mdiCheckboxMultipleMarked,
mdiCheckboxMultipleMarkedCircle: mdiCheckboxMultipleMarkedCircle,
mdiCheckboxMultipleMarkedCircleOutline: mdiCheckboxMultipleMarkedCircleOutline,
mdiCheckboxMultipleMarkedOutline: mdiCheckboxMultipleMarkedOutline,
mdiCheckboxMultipleOutline: mdiCheckboxMultipleOutline,
mdiCheckboxOutline: mdiCheckboxOutline,
mdiCheckerboard: mdiCheckerboard,
mdiCheckerboardMinus: mdiCheckerboardMinus,
mdiCheckerboardPlus: mdiCheckerboardPlus,
mdiCheckerboardRemove: mdiCheckerboardRemove,
mdiCheese: mdiCheese,
mdiCheeseOff: mdiCheeseOff,
mdiChefHat: mdiChefHat,
mdiChemicalWeapon: mdiChemicalWeapon,
mdiChessBishop: mdiChessBishop,
mdiChessKing: mdiChessKing,
mdiChessKnight: mdiChessKnight,
mdiChessPawn: mdiChessPawn,
mdiChessQueen: mdiChessQueen,
mdiChessRook: mdiChessRook,
mdiChevronDoubleDown: mdiChevronDoubleDown,
mdiChevronDoubleLeft: mdiChevronDoubleLeft,
mdiChevronDoubleRight: mdiChevronDoubleRight,
mdiChevronDoubleUp: mdiChevronDoubleUp,
mdiChevronDown: mdiChevronDown,
mdiChevronDownBox: mdiChevronDownBox,
mdiChevronDownBoxOutline: mdiChevronDownBoxOutline,
mdiChevronDownCircle: mdiChevronDownCircle,
mdiChevronDownCircleOutline: mdiChevronDownCircleOutline,
mdiChevronLeft: mdiChevronLeft,
mdiChevronLeftBox: mdiChevronLeftBox,
mdiChevronLeftBoxOutline: mdiChevronLeftBoxOutline,
mdiChevronLeftCircle: mdiChevronLeftCircle,
mdiChevronLeftCircleOutline: mdiChevronLeftCircleOutline,
mdiChevronRight: mdiChevronRight,
mdiChevronRightBox: mdiChevronRightBox,
mdiChevronRightBoxOutline: mdiChevronRightBoxOutline,
mdiChevronRightCircle: mdiChevronRightCircle,
mdiChevronRightCircleOutline: mdiChevronRightCircleOutline,
mdiChevronTripleDown: mdiChevronTripleDown,
mdiChevronTripleLeft: mdiChevronTripleLeft,
mdiChevronTripleRight: mdiChevronTripleRight,
mdiChevronTripleUp: mdiChevronTripleUp,
mdiChevronUp: mdiChevronUp,
mdiChevronUpBox: mdiChevronUpBox,
mdiChevronUpBoxOutline: mdiChevronUpBoxOutline,
mdiChevronUpCircle: mdiChevronUpCircle,
mdiChevronUpCircleOutline: mdiChevronUpCircleOutline,
mdiChiliAlert: mdiChiliAlert,
mdiChiliAlertOutline: mdiChiliAlertOutline,
mdiChiliHot: mdiChiliHot,
mdiChiliHotOutline: mdiChiliHotOutline,
mdiChiliMedium: mdiChiliMedium,
mdiChiliMediumOutline: mdiChiliMediumOutline,
mdiChiliMild: mdiChiliMild,
mdiChiliMildOutline: mdiChiliMildOutline,
mdiChiliOff: mdiChiliOff,
mdiChiliOffOutline: mdiChiliOffOutline,
mdiChip: mdiChip,
mdiChurch: mdiChurch,
mdiChurchOutline: mdiChurchOutline,
mdiCigar: mdiCigar,
mdiCigarOff: mdiCigarOff,
mdiCircle: mdiCircle,
mdiCircleBox: mdiCircleBox,
mdiCircleBoxOutline: mdiCircleBoxOutline,
mdiCircleDouble: mdiCircleDouble,
mdiCircleEditOutline: mdiCircleEditOutline,
mdiCircleExpand: mdiCircleExpand,
mdiCircleHalf: mdiCircleHalf,
mdiCircleHalfFull: mdiCircleHalfFull,
mdiCircleMedium: mdiCircleMedium,
mdiCircleMultiple: mdiCircleMultiple,
mdiCircleMultipleOutline: mdiCircleMultipleOutline,
mdiCircleOffOutline: mdiCircleOffOutline,
mdiCircleOpacity: mdiCircleOpacity,
mdiCircleOutline: mdiCircleOutline,
mdiCircleSlice1: mdiCircleSlice1,
mdiCircleSlice2: mdiCircleSlice2,
mdiCircleSlice3: mdiCircleSlice3,
mdiCircleSlice4: mdiCircleSlice4,
mdiCircleSlice5: mdiCircleSlice5,
mdiCircleSlice6: mdiCircleSlice6,
mdiCircleSlice7: mdiCircleSlice7,
mdiCircleSlice8: mdiCircleSlice8,
mdiCircleSmall: mdiCircleSmall,
mdiCircularSaw: mdiCircularSaw,
mdiCity: mdiCity,
mdiCityVariant: mdiCityVariant,
mdiCityVariantOutline: mdiCityVariantOutline,
mdiClipboard: mdiClipboard,
mdiClipboardAccount: mdiClipboardAccount,
mdiClipboardAccountOutline: mdiClipboardAccountOutline,
mdiClipboardAlert: mdiClipboardAlert,
mdiClipboardAlertOutline: mdiClipboardAlertOutline,
mdiClipboardArrowDown: mdiClipboardArrowDown,
mdiClipboardArrowDownOutline: mdiClipboardArrowDownOutline,
mdiClipboardArrowLeft: mdiClipboardArrowLeft,
mdiClipboardArrowLeftOutline: mdiClipboardArrowLeftOutline,
mdiClipboardArrowRight: mdiClipboardArrowRight,
mdiClipboardArrowRightOutline: mdiClipboardArrowRightOutline,
mdiClipboardArrowUp: mdiClipboardArrowUp,
mdiClipboardArrowUpOutline: mdiClipboardArrowUpOutline,
mdiClipboardCheck: mdiClipboardCheck,
mdiClipboardCheckMultiple: mdiClipboardCheckMultiple,
mdiClipboardCheckMultipleOutline: mdiClipboardCheckMultipleOutline,
mdiClipboardCheckOutline: mdiClipboardCheckOutline,
mdiClipboardClock: mdiClipboardClock,
mdiClipboardClockOutline: mdiClipboardClockOutline,
mdiClipboardEdit: mdiClipboardEdit,
mdiClipboardEditOutline: mdiClipboardEditOutline,
mdiClipboardFile: mdiClipboardFile,
mdiClipboardFileOutline: mdiClipboardFileOutline,
mdiClipboardFlow: mdiClipboardFlow,
mdiClipboardFlowOutline: mdiClipboardFlowOutline,
mdiClipboardList: mdiClipboardList,
mdiClipboardListOutline: mdiClipboardListOutline,
mdiClipboardMinus: mdiClipboardMinus,
mdiClipboardMinusOutline: mdiClipboardMinusOutline,
mdiClipboardMultiple: mdiClipboardMultiple,
mdiClipboardMultipleOutline: mdiClipboardMultipleOutline,
mdiClipboardOff: mdiClipboardOff,
mdiClipboardOffOutline: mdiClipboardOffOutline,
mdiClipboardOutline: mdiClipboardOutline,
mdiClipboardPlay: mdiClipboardPlay,
mdiClipboardPlayMultiple: mdiClipboardPlayMultiple,
mdiClipboardPlayMultipleOutline: mdiClipboardPlayMultipleOutline,
mdiClipboardPlayOutline: mdiClipboardPlayOutline,
mdiClipboardPlus: mdiClipboardPlus,
mdiClipboardPlusOutline: mdiClipboardPlusOutline,
mdiClipboardPulse: mdiClipboardPulse,
mdiClipboardPulseOutline: mdiClipboardPulseOutline,
mdiClipboardRemove: mdiClipboardRemove,
mdiClipboardRemoveOutline: mdiClipboardRemoveOutline,
mdiClipboardSearch: mdiClipboardSearch,
mdiClipboardSearchOutline: mdiClipboardSearchOutline,
mdiClipboardText: mdiClipboardText,
mdiClipboardTextClock: mdiClipboardTextClock,
mdiClipboardTextClockOutline: mdiClipboardTextClockOutline,
mdiClipboardTextMultiple: mdiClipboardTextMultiple,
mdiClipboardTextMultipleOutline: mdiClipboardTextMultipleOutline,
mdiClipboardTextOff: mdiClipboardTextOff,
mdiClipboardTextOffOutline: mdiClipboardTextOffOutline,
mdiClipboardTextOutline: mdiClipboardTextOutline,
mdiClipboardTextPlay: mdiClipboardTextPlay,
mdiClipboardTextPlayOutline: mdiClipboardTextPlayOutline,
mdiClipboardTextSearch: mdiClipboardTextSearch,
mdiClipboardTextSearchOutline: mdiClipboardTextSearchOutline,
mdiClippy: mdiClippy,
mdiClock: mdiClock,
mdiClockAlert: mdiClockAlert,
mdiClockAlertOutline: mdiClockAlertOutline,
mdiClockCheck: mdiClockCheck,
mdiClockCheckOutline: mdiClockCheckOutline,
mdiClockDigital: mdiClockDigital,
mdiClockEdit: mdiClockEdit,
mdiClockEditOutline: mdiClockEditOutline,
mdiClockEnd: mdiClockEnd,
mdiClockFast: mdiClockFast,
mdiClockIn: mdiClockIn,
mdiClockMinus: mdiClockMinus,
mdiClockMinusOutline: mdiClockMinusOutline,
mdiClockOut: mdiClockOut,
mdiClockOutline: mdiClockOutline,
mdiClockPlus: mdiClockPlus,
mdiClockPlusOutline: mdiClockPlusOutline,
mdiClockRemove: mdiClockRemove,
mdiClockRemoveOutline: mdiClockRemoveOutline,
mdiClockStart: mdiClockStart,
mdiClockTimeEight: mdiClockTimeEight,
mdiClockTimeEightOutline: mdiClockTimeEightOutline,
mdiClockTimeEleven: mdiClockTimeEleven,
mdiClockTimeElevenOutline: mdiClockTimeElevenOutline,
mdiClockTimeFive: mdiClockTimeFive,
mdiClockTimeFiveOutline: mdiClockTimeFiveOutline,
mdiClockTimeFour: mdiClockTimeFour,
mdiClockTimeFourOutline: mdiClockTimeFourOutline,
mdiClockTimeNine: mdiClockTimeNine,
mdiClockTimeNineOutline: mdiClockTimeNineOutline,
mdiClockTimeOne: mdiClockTimeOne,
mdiClockTimeOneOutline: mdiClockTimeOneOutline,
mdiClockTimeSeven: mdiClockTimeSeven,
mdiClockTimeSevenOutline: mdiClockTimeSevenOutline,
mdiClockTimeSix: mdiClockTimeSix,
mdiClockTimeSixOutline: mdiClockTimeSixOutline,
mdiClockTimeTen: mdiClockTimeTen,
mdiClockTimeTenOutline: mdiClockTimeTenOutline,
mdiClockTimeThree: mdiClockTimeThree,
mdiClockTimeThreeOutline: mdiClockTimeThreeOutline,
mdiClockTimeTwelve: mdiClockTimeTwelve,
mdiClockTimeTwelveOutline: mdiClockTimeTwelveOutline,
mdiClockTimeTwo: mdiClockTimeTwo,
mdiClockTimeTwoOutline: mdiClockTimeTwoOutline,
mdiClose: mdiClose,
mdiCloseBox: mdiCloseBox,
mdiCloseBoxMultiple: mdiCloseBoxMultiple,
mdiCloseBoxMultipleOutline: mdiCloseBoxMultipleOutline,
mdiCloseBoxOutline: mdiCloseBoxOutline,
mdiCloseCircle: mdiCloseCircle,
mdiCloseCircleMultiple: mdiCloseCircleMultiple,
mdiCloseCircleMultipleOutline: mdiCloseCircleMultipleOutline,
mdiCloseCircleOutline: mdiCloseCircleOutline,
mdiCloseNetwork: mdiCloseNetwork,
mdiCloseNetworkOutline: mdiCloseNetworkOutline,
mdiCloseOctagon: mdiCloseOctagon,
mdiCloseOctagonOutline: mdiCloseOctagonOutline,
mdiCloseOutline: mdiCloseOutline,
mdiCloseThick: mdiCloseThick,
mdiClosedCaption: mdiClosedCaption,
mdiClosedCaptionOutline: mdiClosedCaptionOutline,
mdiCloud: mdiCloud,
mdiCloudAlert: mdiCloudAlert,
mdiCloudBraces: mdiCloudBraces,
mdiCloudCheck: mdiCloudCheck,
mdiCloudCheckOutline: mdiCloudCheckOutline,
mdiCloudCircle: mdiCloudCircle,
mdiCloudDownload: mdiCloudDownload,
mdiCloudDownloadOutline: mdiCloudDownloadOutline,
mdiCloudLock: mdiCloudLock,
mdiCloudLockOutline: mdiCloudLockOutline,
mdiCloudOffOutline: mdiCloudOffOutline,
mdiCloudOutline: mdiCloudOutline,
mdiCloudPercent: mdiCloudPercent,
mdiCloudPercentOutline: mdiCloudPercentOutline,
mdiCloudPrint: mdiCloudPrint,
mdiCloudPrintOutline: mdiCloudPrintOutline,
mdiCloudQuestion: mdiCloudQuestion,
mdiCloudRefresh: mdiCloudRefresh,
mdiCloudSearch: mdiCloudSearch,
mdiCloudSearchOutline: mdiCloudSearchOutline,
mdiCloudSync: mdiCloudSync,
mdiCloudSyncOutline: mdiCloudSyncOutline,
mdiCloudTags: mdiCloudTags,
mdiCloudUpload: mdiCloudUpload,
mdiCloudUploadOutline: mdiCloudUploadOutline,
mdiClouds: mdiClouds,
mdiClover: mdiClover,
mdiCoachLamp: mdiCoachLamp,
mdiCoachLampVariant: mdiCoachLampVariant,
mdiCoatRack: mdiCoatRack,
mdiCodeArray: mdiCodeArray,
mdiCodeBraces: mdiCodeBraces,
mdiCodeBracesBox: mdiCodeBracesBox,
mdiCodeBrackets: mdiCodeBrackets,
mdiCodeEqual: mdiCodeEqual,
mdiCodeGreaterThan: mdiCodeGreaterThan,
mdiCodeGreaterThanOrEqual: mdiCodeGreaterThanOrEqual,
mdiCodeJson: mdiCodeJson,
mdiCodeLessThan: mdiCodeLessThan,
mdiCodeLessThanOrEqual: mdiCodeLessThanOrEqual,
mdiCodeNotEqual: mdiCodeNotEqual,
mdiCodeNotEqualVariant: mdiCodeNotEqualVariant,
mdiCodeParentheses: mdiCodeParentheses,
mdiCodeParenthesesBox: mdiCodeParenthesesBox,
mdiCodeString: mdiCodeString,
mdiCodeTags: mdiCodeTags,
mdiCodeTagsCheck: mdiCodeTagsCheck,
mdiCodepen: mdiCodepen,
mdiCoffee: mdiCoffee,
mdiCoffeeMaker: mdiCoffeeMaker,
mdiCoffeeMakerCheck: mdiCoffeeMakerCheck,
mdiCoffeeMakerCheckOutline: mdiCoffeeMakerCheckOutline,
mdiCoffeeMakerOutline: mdiCoffeeMakerOutline,
mdiCoffeeOff: mdiCoffeeOff,
mdiCoffeeOffOutline: mdiCoffeeOffOutline,
mdiCoffeeOutline: mdiCoffeeOutline,
mdiCoffeeToGo: mdiCoffeeToGo,
mdiCoffeeToGoOutline: mdiCoffeeToGoOutline,
mdiCoffin: mdiCoffin,
mdiCog: mdiCog,
mdiCogBox: mdiCogBox,
mdiCogClockwise: mdiCogClockwise,
mdiCogCounterclockwise: mdiCogCounterclockwise,
mdiCogOff: mdiCogOff,
mdiCogOffOutline: mdiCogOffOutline,
mdiCogOutline: mdiCogOutline,
mdiCogPause: mdiCogPause,
mdiCogPauseOutline: mdiCogPauseOutline,
mdiCogPlay: mdiCogPlay,
mdiCogPlayOutline: mdiCogPlayOutline,
mdiCogRefresh: mdiCogRefresh,
mdiCogRefreshOutline: mdiCogRefreshOutline,
mdiCogStop: mdiCogStop,
mdiCogStopOutline: mdiCogStopOutline,
mdiCogSync: mdiCogSync,
mdiCogSyncOutline: mdiCogSyncOutline,
mdiCogTransfer: mdiCogTransfer,
mdiCogTransferOutline: mdiCogTransferOutline,
mdiCogs: mdiCogs,
mdiCollage: mdiCollage,
mdiCollapseAll: mdiCollapseAll,
mdiCollapseAllOutline: mdiCollapseAllOutline,
mdiColorHelper: mdiColorHelper,
mdiComma: mdiComma,
mdiCommaBox: mdiCommaBox,
mdiCommaBoxOutline: mdiCommaBoxOutline,
mdiCommaCircle: mdiCommaCircle,
mdiCommaCircleOutline: mdiCommaCircleOutline,
mdiComment: mdiComment,
mdiCommentAccount: mdiCommentAccount,
mdiCommentAccountOutline: mdiCommentAccountOutline,
mdiCommentAlert: mdiCommentAlert,
mdiCommentAlertOutline: mdiCommentAlertOutline,
mdiCommentArrowLeft: mdiCommentArrowLeft,
mdiCommentArrowLeftOutline: mdiCommentArrowLeftOutline,
mdiCommentArrowRight: mdiCommentArrowRight,
mdiCommentArrowRightOutline: mdiCommentArrowRightOutline,
mdiCommentBookmark: mdiCommentBookmark,
mdiCommentBookmarkOutline: mdiCommentBookmarkOutline,
mdiCommentCheck: mdiCommentCheck,
mdiCommentCheckOutline: mdiCommentCheckOutline,
mdiCommentEdit: mdiCommentEdit,
mdiCommentEditOutline: mdiCommentEditOutline,
mdiCommentEye: mdiCommentEye,
mdiCommentEyeOutline: mdiCommentEyeOutline,
mdiCommentFlash: mdiCommentFlash,
mdiCommentFlashOutline: mdiCommentFlashOutline,
mdiCommentMinus: mdiCommentMinus,
mdiCommentMinusOutline: mdiCommentMinusOutline,
mdiCommentMultiple: mdiCommentMultiple,
mdiCommentMultipleOutline: mdiCommentMultipleOutline,
mdiCommentOff: mdiCommentOff,
mdiCommentOffOutline: mdiCommentOffOutline,
mdiCommentOutline: mdiCommentOutline,
mdiCommentPlus: mdiCommentPlus,
mdiCommentPlusOutline: mdiCommentPlusOutline,
mdiCommentProcessing: mdiCommentProcessing,
mdiCommentProcessingOutline: mdiCommentProcessingOutline,
mdiCommentQuestion: mdiCommentQuestion,
mdiCommentQuestionOutline: mdiCommentQuestionOutline,
mdiCommentQuote: mdiCommentQuote,
mdiCommentQuoteOutline: mdiCommentQuoteOutline,
mdiCommentRemove: mdiCommentRemove,
mdiCommentRemoveOutline: mdiCommentRemoveOutline,
mdiCommentSearch: mdiCommentSearch,
mdiCommentSearchOutline: mdiCommentSearchOutline,
mdiCommentText: mdiCommentText,
mdiCommentTextMultiple: mdiCommentTextMultiple,
mdiCommentTextMultipleOutline: mdiCommentTextMultipleOutline,
mdiCommentTextOutline: mdiCommentTextOutline,
mdiCompare: mdiCompare,
mdiCompareHorizontal: mdiCompareHorizontal,
mdiCompareRemove: mdiCompareRemove,
mdiCompareVertical: mdiCompareVertical,
mdiCompass: mdiCompass,
mdiCompassOff: mdiCompassOff,
mdiCompassOffOutline: mdiCompassOffOutline,
mdiCompassOutline: mdiCompassOutline,
mdiCompassRose: mdiCompassRose,
mdiCompost: mdiCompost,
mdiCone: mdiCone,
mdiConeOff: mdiConeOff,
mdiConnection: mdiConnection,
mdiConsole: mdiConsole,
mdiConsoleLine: mdiConsoleLine,
mdiConsoleNetwork: mdiConsoleNetwork,
mdiConsoleNetworkOutline: mdiConsoleNetworkOutline,
mdiConsolidate: mdiConsolidate,
mdiContactlessPayment: mdiContactlessPayment,
mdiContactlessPaymentCircle: mdiContactlessPaymentCircle,
mdiContactlessPaymentCircleOutline: mdiContactlessPaymentCircleOutline,
mdiContacts: mdiContacts,
mdiContactsOutline: mdiContactsOutline,
mdiContain: mdiContain,
mdiContainEnd: mdiContainEnd,
mdiContainStart: mdiContainStart,
mdiContentCopy: mdiContentCopy,
mdiContentCut: mdiContentCut,
mdiContentDuplicate: mdiContentDuplicate,
mdiContentPaste: mdiContentPaste,
mdiContentSave: mdiContentSave,
mdiContentSaveAlert: mdiContentSaveAlert,
mdiContentSaveAlertOutline: mdiContentSaveAlertOutline,
mdiContentSaveAll: mdiContentSaveAll,
mdiContentSaveAllOutline: mdiContentSaveAllOutline,
mdiContentSaveCheck: mdiContentSaveCheck,
mdiContentSaveCheckOutline: mdiContentSaveCheckOutline,
mdiContentSaveCog: mdiContentSaveCog,
mdiContentSaveCogOutline: mdiContentSaveCogOutline,
mdiContentSaveEdit: mdiContentSaveEdit,
mdiContentSaveEditOutline: mdiContentSaveEditOutline,
mdiContentSaveMinus: mdiContentSaveMinus,
mdiContentSaveMinusOutline: mdiContentSaveMinusOutline,
mdiContentSaveMove: mdiContentSaveMove,
mdiContentSaveMoveOutline: mdiContentSaveMoveOutline,
mdiContentSaveOff: mdiContentSaveOff,
mdiContentSaveOffOutline: mdiContentSaveOffOutline,
mdiContentSaveOutline: mdiContentSaveOutline,
mdiContentSavePlus: mdiContentSavePlus,
mdiContentSavePlusOutline: mdiContentSavePlusOutline,
mdiContentSaveSettings: mdiContentSaveSettings,
mdiContentSaveSettingsOutline: mdiContentSaveSettingsOutline,
mdiContrast: mdiContrast,
mdiContrastBox: mdiContrastBox,
mdiContrastCircle: mdiContrastCircle,
mdiController: mdiController,
mdiControllerClassic: mdiControllerClassic,
mdiControllerClassicOutline: mdiControllerClassicOutline,
mdiControllerOff: mdiControllerOff,
mdiCookie: mdiCookie,
mdiCookieAlert: mdiCookieAlert,
mdiCookieAlertOutline: mdiCookieAlertOutline,
mdiCookieCheck: mdiCookieCheck,
mdiCookieCheckOutline: mdiCookieCheckOutline,
mdiCookieClock: mdiCookieClock,
mdiCookieClockOutline: mdiCookieClockOutline,
mdiCookieCog: mdiCookieCog,
mdiCookieCogOutline: mdiCookieCogOutline,
mdiCookieEdit: mdiCookieEdit,
mdiCookieEditOutline: mdiCookieEditOutline,
mdiCookieLock: mdiCookieLock,
mdiCookieLockOutline: mdiCookieLockOutline,
mdiCookieMinus: mdiCookieMinus,
mdiCookieMinusOutline: mdiCookieMinusOutline,
mdiCookieOff: mdiCookieOff,
mdiCookieOffOutline: mdiCookieOffOutline,
mdiCookieOutline: mdiCookieOutline,
mdiCookiePlus: mdiCookiePlus,
mdiCookiePlusOutline: mdiCookiePlusOutline,
mdiCookieRefresh: mdiCookieRefresh,
mdiCookieRefreshOutline: mdiCookieRefreshOutline,
mdiCookieRemove: mdiCookieRemove,
mdiCookieRemoveOutline: mdiCookieRemoveOutline,
mdiCookieSettings: mdiCookieSettings,
mdiCookieSettingsOutline: mdiCookieSettingsOutline,
mdiCoolantTemperature: mdiCoolantTemperature,
mdiCopyleft: mdiCopyleft,
mdiCopyright: mdiCopyright,
mdiCordova: mdiCordova,
mdiCorn: mdiCorn,
mdiCornOff: mdiCornOff,
mdiCosineWave: mdiCosineWave,
mdiCounter: mdiCounter,
mdiCountertop: mdiCountertop,
mdiCountertopOutline: mdiCountertopOutline,
mdiCow: mdiCow,
mdiCowOff: mdiCowOff,
mdiCpu32Bit: mdiCpu32Bit,
mdiCpu64Bit: mdiCpu64Bit,
mdiCradle: mdiCradle,
mdiCradleOutline: mdiCradleOutline,
mdiCrane: mdiCrane,
mdiCreation: mdiCreation,
mdiCreativeCommons: mdiCreativeCommons,
mdiCreditCard: mdiCreditCard,
mdiCreditCardCheck: mdiCreditCardCheck,
mdiCreditCardCheckOutline: mdiCreditCardCheckOutline,
mdiCreditCardChip: mdiCreditCardChip,
mdiCreditCardChipOutline: mdiCreditCardChipOutline,
mdiCreditCardClock: mdiCreditCardClock,
mdiCreditCardClockOutline: mdiCreditCardClockOutline,
mdiCreditCardEdit: mdiCreditCardEdit,
mdiCreditCardEditOutline: mdiCreditCardEditOutline,
mdiCreditCardFast: mdiCreditCardFast,
mdiCreditCardFastOutline: mdiCreditCardFastOutline,
mdiCreditCardLock: mdiCreditCardLock,
mdiCreditCardLockOutline: mdiCreditCardLockOutline,
mdiCreditCardMarker: mdiCreditCardMarker,
mdiCreditCardMarkerOutline: mdiCreditCardMarkerOutline,
mdiCreditCardMinus: mdiCreditCardMinus,
mdiCreditCardMinusOutline: mdiCreditCardMinusOutline,
mdiCreditCardMultiple: mdiCreditCardMultiple,
mdiCreditCardMultipleOutline: mdiCreditCardMultipleOutline,
mdiCreditCardOff: mdiCreditCardOff,
mdiCreditCardOffOutline: mdiCreditCardOffOutline,
mdiCreditCardOutline: mdiCreditCardOutline,
mdiCreditCardPlus: mdiCreditCardPlus,
mdiCreditCardPlusOutline: mdiCreditCardPlusOutline,
mdiCreditCardRefresh: mdiCreditCardRefresh,
mdiCreditCardRefreshOutline: mdiCreditCardRefreshOutline,
mdiCreditCardRefund: mdiCreditCardRefund,
mdiCreditCardRefundOutline: mdiCreditCardRefundOutline,
mdiCreditCardRemove: mdiCreditCardRemove,
mdiCreditCardRemoveOutline: mdiCreditCardRemoveOutline,
mdiCreditCardScan: mdiCreditCardScan,
mdiCreditCardScanOutline: mdiCreditCardScanOutline,
mdiCreditCardSearch: mdiCreditCardSearch,
mdiCreditCardSearchOutline: mdiCreditCardSearchOutline,
mdiCreditCardSettings: mdiCreditCardSettings,
mdiCreditCardSettingsOutline: mdiCreditCardSettingsOutline,
mdiCreditCardSync: mdiCreditCardSync,
mdiCreditCardSyncOutline: mdiCreditCardSyncOutline,
mdiCreditCardWireless: mdiCreditCardWireless,
mdiCreditCardWirelessOff: mdiCreditCardWirelessOff,
mdiCreditCardWirelessOffOutline: mdiCreditCardWirelessOffOutline,
mdiCreditCardWirelessOutline: mdiCreditCardWirelessOutline,
mdiCricket: mdiCricket,
mdiCrop: mdiCrop,
mdiCropFree: mdiCropFree,
mdiCropLandscape: mdiCropLandscape,
mdiCropPortrait: mdiCropPortrait,
mdiCropRotate: mdiCropRotate,
mdiCropSquare: mdiCropSquare,
mdiCross: mdiCross,
mdiCrossBolnisi: mdiCrossBolnisi,
mdiCrossCeltic: mdiCrossCeltic,
mdiCrossOutline: mdiCrossOutline,
mdiCrosshairs: mdiCrosshairs,
mdiCrosshairsGps: mdiCrosshairsGps,
mdiCrosshairsOff: mdiCrosshairsOff,
mdiCrosshairsQuestion: mdiCrosshairsQuestion,
mdiCrowd: mdiCrowd,
mdiCrown: mdiCrown,
mdiCrownCircle: mdiCrownCircle,
mdiCrownCircleOutline: mdiCrownCircleOutline,
mdiCrownOutline: mdiCrownOutline,
mdiCryengine: mdiCryengine,
mdiCrystalBall: mdiCrystalBall,
mdiCube: mdiCube,
mdiCubeOff: mdiCubeOff,
mdiCubeOffOutline: mdiCubeOffOutline,
mdiCubeOutline: mdiCubeOutline,
mdiCubeScan: mdiCubeScan,
mdiCubeSend: mdiCubeSend,
mdiCubeUnfolded: mdiCubeUnfolded,
mdiCup: mdiCup,
mdiCupOff: mdiCupOff,
mdiCupOffOutline: mdiCupOffOutline,
mdiCupOutline: mdiCupOutline,
mdiCupWater: mdiCupWater,
mdiCupboard: mdiCupboard,
mdiCupboardOutline: mdiCupboardOutline,
mdiCupcake: mdiCupcake,
mdiCurling: mdiCurling,
mdiCurrencyBdt: mdiCurrencyBdt,
mdiCurrencyBrl: mdiCurrencyBrl,
mdiCurrencyBtc: mdiCurrencyBtc,
mdiCurrencyCny: mdiCurrencyCny,
mdiCurrencyEth: mdiCurrencyEth,
mdiCurrencyEur: mdiCurrencyEur,
mdiCurrencyEurOff: mdiCurrencyEurOff,
mdiCurrencyFra: mdiCurrencyFra,
mdiCurrencyGbp: mdiCurrencyGbp,
mdiCurrencyIls: mdiCurrencyIls,
mdiCurrencyInr: mdiCurrencyInr,
mdiCurrencyJpy: mdiCurrencyJpy,
mdiCurrencyKrw: mdiCurrencyKrw,
mdiCurrencyKzt: mdiCurrencyKzt,
mdiCurrencyMnt: mdiCurrencyMnt,
mdiCurrencyNgn: mdiCurrencyNgn,
mdiCurrencyPhp: mdiCurrencyPhp,
mdiCurrencyRial: mdiCurrencyRial,
mdiCurrencyRub: mdiCurrencyRub,
mdiCurrencyRupee: mdiCurrencyRupee,
mdiCurrencySign: mdiCurrencySign,
mdiCurrencyTry: mdiCurrencyTry,
mdiCurrencyTwd: mdiCurrencyTwd,
mdiCurrencyUah: mdiCurrencyUah,
mdiCurrencyUsd: mdiCurrencyUsd,
mdiCurrencyUsdOff: mdiCurrencyUsdOff,
mdiCurrentAc: mdiCurrentAc,
mdiCurrentDc: mdiCurrentDc,
mdiCursorDefault: mdiCursorDefault,
mdiCursorDefaultClick: mdiCursorDefaultClick,
mdiCursorDefaultClickOutline: mdiCursorDefaultClickOutline,
mdiCursorDefaultGesture: mdiCursorDefaultGesture,
mdiCursorDefaultGestureOutline: mdiCursorDefaultGestureOutline,
mdiCursorDefaultOutline: mdiCursorDefaultOutline,
mdiCursorMove: mdiCursorMove,
mdiCursorPointer: mdiCursorPointer,
mdiCursorText: mdiCursorText,
mdiCurtains: mdiCurtains,
mdiCurtainsClosed: mdiCurtainsClosed,
mdiCylinder: mdiCylinder,
mdiCylinderOff: mdiCylinderOff,
mdiDanceBallroom: mdiDanceBallroom,
mdiDancePole: mdiDancePole,
mdiDataMatrix: mdiDataMatrix,
mdiDataMatrixEdit: mdiDataMatrixEdit,
mdiDataMatrixMinus: mdiDataMatrixMinus,
mdiDataMatrixPlus: mdiDataMatrixPlus,
mdiDataMatrixRemove: mdiDataMatrixRemove,
mdiDataMatrixScan: mdiDataMatrixScan,
mdiDatabase: mdiDatabase,
mdiDatabaseAlert: mdiDatabaseAlert,
mdiDatabaseAlertOutline: mdiDatabaseAlertOutline,
mdiDatabaseArrowDown: mdiDatabaseArrowDown,
mdiDatabaseArrowDownOutline: mdiDatabaseArrowDownOutline,
mdiDatabaseArrowLeft: mdiDatabaseArrowLeft,
mdiDatabaseArrowLeftOutline: mdiDatabaseArrowLeftOutline,
mdiDatabaseArrowRight: mdiDatabaseArrowRight,
mdiDatabaseArrowRightOutline: mdiDatabaseArrowRightOutline,
mdiDatabaseArrowUp: mdiDatabaseArrowUp,
mdiDatabaseArrowUpOutline: mdiDatabaseArrowUpOutline,
mdiDatabaseCheck: mdiDatabaseCheck,
mdiDatabaseCheckOutline: mdiDatabaseCheckOutline,
mdiDatabaseClock: mdiDatabaseClock,
mdiDatabaseClockOutline: mdiDatabaseClockOutline,
mdiDatabaseCog: mdiDatabaseCog,
mdiDatabaseCogOutline: mdiDatabaseCogOutline,
mdiDatabaseEdit: mdiDatabaseEdit,
mdiDatabaseEditOutline: mdiDatabaseEditOutline,
mdiDatabas: mdiDatabase,
// mdiDatabasestring: mdiDatabasestring,
// mdiDatabaseEye: mdiDatabaseEye,
mdiDatabaseEyeOff: mdiDatabaseEyeOff,
mdiDatabaseEyeOffOutline: mdiDatabaseEyeOffOutline,
mdiDatabaseEyeOutline: mdiDatabaseEyeOutline,
mdiDatabaseImport: mdiDatabaseImport,
mdiDatabaseImportOutline: mdiDatabaseImportOutline,
mdiDatabaseLock: mdiDatabaseLock,
mdiDatabaseLockOutline: mdiDatabaseLockOutline,
mdiDatabaseMarker: mdiDatabaseMarker,
mdiDatabaseMarkerOutline: mdiDatabaseMarkerOutline,
mdiDatabaseMinus: mdiDatabaseMinus,
mdiDatabaseMinusOutline: mdiDatabaseMinusOutline,
mdiDatabaseOff: mdiDatabaseOff,
mdiDatabaseOffOutline: mdiDatabaseOffOutline,
mdiDatabaseOutline: mdiDatabaseOutline,
mdiDatabasePlus: mdiDatabasePlus,
mdiDatabasePlusOutline: mdiDatabasePlusOutline,
mdiDatabaseRefresh: mdiDatabaseRefresh,
mdiDatabaseRefreshOutline: mdiDatabaseRefreshOutline,
mdiDatabaseRemove: mdiDatabaseRemove,
mdiDatabaseRemoveOutline: mdiDatabaseRemoveOutline,
mdiDatabaseSearch: mdiDatabaseSearch,
mdiDatabaseSearchOutline: mdiDatabaseSearchOutline,
mdiDatabaseSettings: mdiDatabaseSettings,
mdiDatabaseSettingsOutline: mdiDatabaseSettingsOutline,
mdiDatabaseSync: mdiDatabaseSync,
mdiDatabaseSyncOutline: mdiDatabaseSyncOutline,
mdiDeathStar: mdiDeathStar,
mdiDeathStarVariant: mdiDeathStarVariant,
mdiDeathlyHallows: mdiDeathlyHallows,
mdiDebian: mdiDebian,
mdiDebugStepInto: mdiDebugStepInto,
mdiDebugStepOut: mdiDebugStepOut,
mdiDebugStepOver: mdiDebugStepOver,
mdiDecagram: mdiDecagram,
mdiDecagramOutline: mdiDecagramOutline,
mdiDecimal: mdiDecimal,
mdiDecimalComma: mdiDecimalComma,
mdiDecimalCommaDecrease: mdiDecimalCommaDecrease,
mdiDecimalCommaIncrease: mdiDecimalCommaIncrease,
mdiDecimalDecrease: mdiDecimalDecrease,
mdiDecimalIncrease: mdiDecimalIncrease,
mdiDelete: mdiDelete,
mdiDeleteAlert: mdiDeleteAlert,
mdiDeleteAlertOutline: mdiDeleteAlertOutline,
mdiDeleteCircle: mdiDeleteCircle,
mdiDeleteCircleOutline: mdiDeleteCircleOutline,
mdiDeleteClock: mdiDeleteClock,
mdiDeleteClockOutline: mdiDeleteClockOutline,
mdiDeleteEmpty: mdiDeleteEmpty,
mdiDeleteEmptyOutline: mdiDeleteEmptyOutline,
mdiDeleteForever: mdiDeleteForever,
mdiDeleteForeverOutline: mdiDeleteForeverOutline,
mdiDeleteOff: mdiDeleteOff,
mdiDeleteOffOutline: mdiDeleteOffOutline,
mdiDeleteOutline: mdiDeleteOutline,
mdiDeleteRestore: mdiDeleteRestore,
mdiDeleteSweep: mdiDeleteSweep,
mdiDeleteSweepOutline: mdiDeleteSweepOutline,
mdiDeleteVariant: mdiDeleteVariant,
mdiDelta: mdiDelta,
mdiDesk: mdiDesk,
mdiDeskLamp: mdiDeskLamp,
mdiDeskLampOff: mdiDeskLampOff,
mdiDeskLampOn: mdiDeskLampOn,
mdiDeskphone: mdiDeskphone,
mdiDesktopClassic: mdiDesktopClassic,
mdiDesktopTower: mdiDesktopTower,
mdiDesktopTowerMonitor: mdiDesktopTowerMonitor,
mdiDetails: mdiDetails,
mdiDevTo: mdiDevTo,
mdiDeveloperBoard: mdiDeveloperBoard,
mdiDeviantart: mdiDeviantart,
mdiDevices: mdiDevices,
mdiDharmachakra: mdiDharmachakra,
mdiDiabetes: mdiDiabetes,
mdiDialpad: mdiDialpad,
mdiDiameter: mdiDiameter,
mdiDiameterOutline: mdiDiameterOutline,
mdiDiameterVariant: mdiDiameterVariant,
mdiDiamond: mdiDiamond,
mdiDiamondOutline: mdiDiamondOutline,
mdiDiamondStone: mdiDiamondStone,
mdiDice1: mdiDice1,
mdiDice1Outline: mdiDice1Outline,
mdiDice2: mdiDice2,
mdiDice2Outline: mdiDice2Outline,
mdiDice3: mdiDice3,
mdiDice3Outline: mdiDice3Outline,
mdiDice4: mdiDice4,
mdiDice4Outline: mdiDice4Outline,
mdiDice5: mdiDice5,
mdiDice5Outline: mdiDice5Outline,
mdiDice6: mdiDice6,
mdiDice6Outline: mdiDice6Outline,
mdiDiceD10: mdiDiceD10,
mdiDiceD10Outline: mdiDiceD10Outline,
mdiDiceD12: mdiDiceD12,
mdiDiceD12Outline: mdiDiceD12Outline,
mdiDiceD20: mdiDiceD20,
mdiDiceD20Outline: mdiDiceD20Outline,
mdiDiceD4: mdiDiceD4,
mdiDiceD4Outline: mdiDiceD4Outline,
mdiDiceD6: mdiDiceD6,
mdiDiceD6Outline: mdiDiceD6Outline,
mdiDiceD8: mdiDiceD8,
mdiDiceD8Outline: mdiDiceD8Outline,
mdiDiceMultiple: mdiDiceMultiple,
mdiDiceMultipleOutline: mdiDiceMultipleOutline,
mdiDigitalOcean: mdiDigitalOcean,
mdiDipSwitch: mdiDipSwitch,
mdiDirections: mdiDirections,
mdiDirectionsFork: mdiDirectionsFork,
mdiDisc: mdiDisc,
mdiDiscAlert: mdiDiscAlert,
mdiDiscPlayer: mdiDiscPlayer,
mdiDishwasher: mdiDishwasher,
mdiDishwasherAlert: mdiDishwasherAlert,
mdiDishwasherOff: mdiDishwasherOff,
mdiDisqus: mdiDisqus,
mdiDistributeHorizontalCenter: mdiDistributeHorizontalCenter,
mdiDistributeHorizontalLeft: mdiDistributeHorizontalLeft,
mdiDistributeHorizontalRight: mdiDistributeHorizontalRight,
mdiDistributeVerticalBottom: mdiDistributeVerticalBottom,
mdiDistributeVerticalCenter: mdiDistributeVerticalCenter,
mdiDistributeVerticalTop: mdiDistributeVerticalTop,
mdiDiversify: mdiDiversify,
mdiDiving: mdiDiving,
mdiDivingFlippers: mdiDivingFlippers,
mdiDivingHelmet: mdiDivingHelmet,
mdiDivingScuba: mdiDivingScuba,
mdiDivingScubaFlag: mdiDivingScubaFlag,
mdiDivingScubaMask: mdiDivingScubaMask,
mdiDivingScubaTank: mdiDivingScubaTank,
mdiDivingScubaTankMultiple: mdiDivingScubaTankMultiple,
mdiDivingSnorkel: mdiDivingSnorkel,
mdiDivision: mdiDivision,
mdiDivisionBox: mdiDivisionBox,
mdiDlna: mdiDlna,
mdiDna: mdiDna,
mdiDns: mdiDns,
mdiDnsOutline: mdiDnsOutline,
mdiDockBottom: mdiDockBottom,
mdiDockLeft: mdiDockLeft,
mdiDockRight: mdiDockRight,
mdiDockTop: mdiDockTop,
mdiDockWindow: mdiDockWindow,
mdiDocker: mdiDocker,
mdiDoctor: mdiDoctor,
mdiDog: mdiDog,
mdiDogService: mdiDogService,
mdiDogSide: mdiDogSide,
mdiDogSideOff: mdiDogSideOff,
mdiDolby: mdiDolby,
mdiDolly: mdiDolly,
mdiDolphin: mdiDolphin,
mdiDomain: mdiDomain,
mdiDomainOff: mdiDomainOff,
mdiDomainPlus: mdiDomainPlus,
mdiDomainRemove: mdiDomainRemove,
mdiDomeLight: mdiDomeLight,
mdiDominoMask: mdiDominoMask,
mdiDonkey: mdiDonkey,
mdiDoor: mdiDoor,
mdiDoorClosed: mdiDoorClosed,
mdiDoorClosedLock: mdiDoorClosedLock,
mdiDoorOpen: mdiDoorOpen,
mdiDoorSliding: mdiDoorSliding,
mdiDoorSlidingLock: mdiDoorSlidingLock,
mdiDoorSlidingOpen: mdiDoorSlidingOpen,
mdiDoorbell: mdiDoorbell,
mdiDoorbellVideo: mdiDoorbellVideo,
mdiDotNet: mdiDotNet,
mdiDotsCircle: mdiDotsCircle,
mdiDotsGrid: mdiDotsGrid,
mdiDotsHexagon: mdiDotsHexagon,
mdiDotsHorizontal: mdiDotsHorizontal,
mdiDotsHorizontalCircle: mdiDotsHorizontalCircle,
mdiDotsHorizontalCircleOutline: mdiDotsHorizontalCircleOutline,
mdiDotsSquare: mdiDotsSquare,
mdiDotsTriangle: mdiDotsTriangle,
mdiDotsVertical: mdiDotsVertical,
mdiDotsVerticalCircle: mdiDotsVerticalCircle,
mdiDotsVerticalCircleOutline: mdiDotsVerticalCircleOutline,
mdiDownload: mdiDownload,
mdiDownloadBox: mdiDownloadBox,
mdiDownloadBoxOutline: mdiDownloadBoxOutline,
mdiDownloadCircle: mdiDownloadCircle,
mdiDownloadCircleOutline: mdiDownloadCircleOutline,
mdiDownloadLock: mdiDownloadLock,
mdiDownloadLockOutline: mdiDownloadLockOutline,
mdiDownloadMultiple: mdiDownloadMultiple,
mdiDownloadNetwork: mdiDownloadNetwork,
mdiDownloadNetworkOutline: mdiDownloadNetworkOutline,
mdiDownloadOff: mdiDownloadOff,
mdiDownloadOffOutline: mdiDownloadOffOutline,
mdiDownloadOutline: mdiDownloadOutline,
mdiDrag: mdiDrag,
mdiDragHorizontal: mdiDragHorizontal,
mdiDragHorizontalVariant: mdiDragHorizontalVariant,
mdiDragVariant: mdiDragVariant,
mdiDragVertical: mdiDragVertical,
mdiDragVerticalVariant: mdiDragVerticalVariant,
mdiDramaMasks: mdiDramaMasks,
mdiDraw: mdiDraw,
mdiDrawPen: mdiDrawPen,
mdiDrawing: mdiDrawing,
mdiDrawingBox: mdiDrawingBox,
mdiDresser: mdiDresser,
mdiDresserOutline: mdiDresserOutline,
mdiDrone: mdiDrone,
mdiDropbox: mdiDropbox,
mdiDrupal: mdiDrupal,
mdiDuck: mdiDuck,
mdiDumbbell: mdiDumbbell,
mdiDumpTruck: mdiDumpTruck,
mdiEarHearing: mdiEarHearing,
mdiEarHearingLoop: mdiEarHearingLoop,
mdiEarHearingOff: mdiEarHearingOff,
mdiEarbuds: mdiEarbuds,
mdiEarbudsOff: mdiEarbudsOff,
mdiEarbudsOffOutline: mdiEarbudsOffOutline,
mdiEarbudsOutline: mdiEarbudsOutline,
mdiEarth: mdiEarth,
mdiEarthArrowRight: mdiEarthArrowRight,
mdiEarthBox: mdiEarthBox,
mdiEarthBoxMinus: mdiEarthBoxMinus,
mdiEarthBoxOff: mdiEarthBoxOff,
mdiEarthBoxPlus: mdiEarthBoxPlus,
mdiEarthBoxRemove: mdiEarthBoxRemove,
mdiEarthMinus: mdiEarthMinus,
mdiEarthOff: mdiEarthOff,
mdiEarthPlus: mdiEarthPlus,
mdiEarthRemove: mdiEarthRemove,
mdiEgg: mdiEgg,
mdiEggEaster: mdiEggEaster,
mdiEggFried: mdiEggFried,
mdiEggOff: mdiEggOff,
mdiEggOffOutline: mdiEggOffOutline,
mdiEggOutline: mdiEggOutline,
mdiEiffelTower: mdiEiffelTower,
mdiEightTrack: mdiEightTrack,
mdiEject: mdiEject,
mdiEjectCircle: mdiEjectCircle,
mdiEjectCircleOutline: mdiEjectCircleOutline,
mdiEjectOutline: mdiEjectOutline,
mdiElectricSwitch: mdiElectricSwitch,
mdiElectricSwitchClosed: mdiElectricSwitchClosed,
mdiElectronFramework: mdiElectronFramework,
mdiElephant: mdiElephant,
mdiElevationDecline: mdiElevationDecline,
mdiElevationRise: mdiElevationRise,
mdiElevator: mdiElevator,
mdiElevatorDown: mdiElevatorDown,
mdiElevatorPassenger: mdiElevatorPassenger,
mdiElevatorPassengerOff: mdiElevatorPassengerOff,
mdiElevatorPassengerOffOutline: mdiElevatorPassengerOffOutline,
mdiElevatorPassengerOutline: mdiElevatorPassengerOutline,
mdiElevatorUp: mdiElevatorUp,
mdiEllipse: mdiEllipse,
mdiEllipseOutline: mdiEllipseOutline,
mdiEmail: mdiEmail,
mdiEmailAlert: mdiEmailAlert,
mdiEmailAlertOutline: mdiEmailAlertOutline,
mdiEmailArrowLeft: mdiEmailArrowLeft,
mdiEmailArrowLeftOutline: mdiEmailArrowLeftOutline,
mdiEmailArrowRight: mdiEmailArrowRight,
mdiEmailArrowRightOutline: mdiEmailArrowRightOutline,
mdiEmailBox: mdiEmailBox,
mdiEmailCheck: mdiEmailCheck,
mdiEmailCheckOutline: mdiEmailCheckOutline,
mdiEmailEdit: mdiEmailEdit,
mdiEmailEditOutline: mdiEmailEditOutline,
mdiEmailFast: mdiEmailFast,
mdiEmailFastOutline: mdiEmailFastOutline,
mdiEmailLock: mdiEmailLock,
mdiEmailLockOutline: mdiEmailLockOutline,
mdiEmailMarkAsUnread: mdiEmailMarkAsUnread,
mdiEmailMinus: mdiEmailMinus,
mdiEmailMinusOutline: mdiEmailMinusOutline,
mdiEmailMultiple: mdiEmailMultiple,
mdiEmailMultipleOutline: mdiEmailMultipleOutline,
mdiEmailNewsletter: mdiEmailNewsletter,
mdiEmailOff: mdiEmailOff,
mdiEmailOffOutline: mdiEmailOffOutline,
mdiEmailOpen: mdiEmailOpen,
mdiEmailOpenMultiple: mdiEmailOpenMultiple,
mdiEmailOpenMultipleOutline: mdiEmailOpenMultipleOutline,
mdiEmailOpenOutline: mdiEmailOpenOutline,
mdiEmailOutline: mdiEmailOutline,
mdiEmailPlus: mdiEmailPlus,
mdiEmailPlusOutline: mdiEmailPlusOutline,
mdiEmailRemove: mdiEmailRemove,
mdiEmailRemoveOutline: mdiEmailRemoveOutline,
mdiEmailSeal: mdiEmailSeal,
mdiEmailSealOutline: mdiEmailSealOutline,
mdiEmailSearch: mdiEmailSearch,
mdiEmailSearchOutline: mdiEmailSearchOutline,
mdiEmailSync: mdiEmailSync,
mdiEmailSyncOutline: mdiEmailSyncOutline,
mdiEmailVariant: mdiEmailVariant,
mdiEmber: mdiEmber,
mdiEmby: mdiEmby,
mdiEmoticon: mdiEmoticon,
mdiEmoticonAngry: mdiEmoticonAngry,
mdiEmoticonAngryOutline: mdiEmoticonAngryOutline,
mdiEmoticonConfused: mdiEmoticonConfused,
mdiEmoticonConfusedOutline: mdiEmoticonConfusedOutline,
mdiEmoticonCool: mdiEmoticonCool,
mdiEmoticonCoolOutline: mdiEmoticonCoolOutline,
mdiEmoticonCry: mdiEmoticonCry,
mdiEmoticonCryOutline: mdiEmoticonCryOutline,
mdiEmoticonDead: mdiEmoticonDead,
mdiEmoticonDeadOutline: mdiEmoticonDeadOutline,
mdiEmoticonDevil: mdiEmoticonDevil,
mdiEmoticonDevilOutline: mdiEmoticonDevilOutline,
mdiEmoticonExcited: mdiEmoticonExcited,
mdiEmoticonExcitedOutline: mdiEmoticonExcitedOutline,
mdiEmoticonFrown: mdiEmoticonFrown,
mdiEmoticonFrownOutline: mdiEmoticonFrownOutline,
mdiEmoticonHappy: mdiEmoticonHappy,
mdiEmoticonHappyOutline: mdiEmoticonHappyOutline,
mdiEmoticonKiss: mdiEmoticonKiss,
mdiEmoticonKissOutline: mdiEmoticonKissOutline,
mdiEmoticonLol: mdiEmoticonLol,
mdiEmoticonLolOutline: mdiEmoticonLolOutline,
mdiEmoticonNeutral: mdiEmoticonNeutral,
mdiEmoticonNeutralOutline: mdiEmoticonNeutralOutline,
mdiEmoticonOutline: mdiEmoticonOutline,
mdiEmoticonPoop: mdiEmoticonPoop,
mdiEmoticonPoopOutline: mdiEmoticonPoopOutline,
mdiEmoticonSad: mdiEmoticonSad,
mdiEmoticonSadOutline: mdiEmoticonSadOutline,
mdiEmoticonSick: mdiEmoticonSick,
mdiEmoticonSickOutline: mdiEmoticonSickOutline,
mdiEmoticonTongue: mdiEmoticonTongue,
mdiEmoticonTongueOutline: mdiEmoticonTongueOutline,
mdiEmoticonWink: mdiEmoticonWink,
mdiEmoticonWinkOutline: mdiEmoticonWinkOutline,
mdiEngine: mdiEngine,
mdiEngineOff: mdiEngineOff,
mdiEngineOffOutline: mdiEngineOffOutline,
mdiEngineOutline: mdiEngineOutline,
mdiEpsilon: mdiEpsilon,
mdiEqual: mdiEqual,
mdiEqualBox: mdiEqualBox,
mdiEqualizer: mdiEqualizer,
mdiEqualizerOutline: mdiEqualizerOutline,
mdiEraser: mdiEraser,
mdiEraserVariant: mdiEraserVariant,
mdiEscalator: mdiEscalator,
mdiEscalatorBox: mdiEscalatorBox,
mdiEscalatorDown: mdiEscalatorDown,
mdiEscalatorUp: mdiEscalatorUp,
mdiEslint: mdiEslint,
mdiEt: mdiEt,
mdiEthereum: mdiEthereum,
mdiEthernet: mdiEthernet,
mdiEthernetCable: mdiEthernetCable,
mdiEthernetCableOff: mdiEthernetCableOff,
mdiEvPlugCcs1: mdiEvPlugCcs1,
mdiEvPlugCcs2: mdiEvPlugCcs2,
mdiEvPlugChademo: mdiEvPlugChademo,
mdiEvPlugTesla: mdiEvPlugTesla,
mdiEvPlugType1: mdiEvPlugType1,
mdiEvPlugType2: mdiEvPlugType2,
mdiEvStation: mdiEvStation,
mdiEvernote: mdiEvernote,
mdiExcavator: mdiExcavator,
mdiExclamation: mdiExclamation,
mdiExclamationThick: mdiExclamationThick,
mdiExitRun: mdiExitRun,
mdiExitToApp: mdiExitToApp,
mdiExpandAll: mdiExpandAll,
mdiExpandAllOutline: mdiExpandAllOutline,
mdiExpansionCard: mdiExpansionCard,
mdiExpansionCardVariant: mdiExpansionCardVariant,
mdiExponent: mdiExponent,
mdiExponentBox: mdiExponentBox,
// md: mdi,
// mdistring:mdistring,
// mdiEye: mdiEye,
mdiEyeArrowLeft: mdiEyeArrowLeft,
mdiEyeArrowLeftOutline: mdiEyeArrowLeftOutline,
mdiEyeArrowRight: mdiEyeArrowRight,
mdiEyeArrowRightOutline: mdiEyeArrowRightOutline,
mdiEyeCheck: mdiEyeCheck,
mdiEyeCheckOutline: mdiEyeCheckOutline,
mdiEyeCircle: mdiEyeCircle,
mdiEyeCircleOutline: mdiEyeCircleOutline,
mdiEyeMinus: mdiEyeMinus,
mdiEyeMinusOutline: mdiEyeMinusOutline,
mdiEyeOff: mdiEyeOff,
mdiEyeOffOutline: mdiEyeOffOutline,
mdiEyeOutline: mdiEyeOutline,
mdiEyePlus: mdiEyePlus,
mdiEyePlusOutline: mdiEyePlusOutline,
mdiEyeRefresh: mdiEyeRefresh,
mdiEyeRefreshOutline: mdiEyeRefreshOutline,
mdiEyeRemove: mdiEyeRemove,
mdiEyeRemoveOutline: mdiEyeRemoveOutline,
mdiEyeSettings: mdiEyeSettings,
mdiEyeSettingsOutline: mdiEyeSettingsOutline,
mdiEyedropper: mdiEyedropper,
mdiEyedropperMinus: mdiEyedropperMinus,
mdiEyedropperOff: mdiEyedropperOff,
mdiEyedropperPlus: mdiEyedropperPlus,
mdiEyedropperRemove: mdiEyedropperRemove,
mdiEyedropperVariant: mdiEyedropperVariant,
mdiFaceAgent: mdiFaceAgent,
mdiFaceMan: mdiFaceMan,
mdiFaceManOutline: mdiFaceManOutline,
mdiFaceManProfile: mdiFaceManProfile,
mdiFaceManShimmer: mdiFaceManShimmer,
mdiFaceManShimmerOutline: mdiFaceManShimmerOutline,
mdiFaceMask: mdiFaceMask,
mdiFaceMaskOutline: mdiFaceMaskOutline,
mdiFaceRecognition: mdiFaceRecognition,
mdiFaceWoman: mdiFaceWoman,
mdiFaceWomanOutline: mdiFaceWomanOutline,
mdiFaceWomanProfile: mdiFaceWomanProfile,
mdiFaceWomanShimmer: mdiFaceWomanShimmer,
mdiFaceWomanShimmerOutline: mdiFaceWomanShimmerOutline,
mdiFacebook: mdiFacebook,
mdiFacebookGaming: mdiFacebookGaming,
mdiFacebookMessenger: mdiFacebookMessenger,
mdiFacebookWorkplace: mdiFacebookWorkplace,
mdiFactory: mdiFactory,
mdiFamilyTree: mdiFamilyTree,
mdiFan: mdiFan,
mdiFanAlert: mdiFanAlert,
mdiFanAuto: mdiFanAuto,
mdiFanChevronDown: mdiFanChevronDown,
mdiFanChevronUp: mdiFanChevronUp,
mdiFanClock: mdiFanClock,
mdiFanMinus: mdiFanMinus,
mdiFanOff: mdiFanOff,
mdiFanPlus: mdiFanPlus,
mdiFanRemove: mdiFanRemove,
mdiFanSpeed1: mdiFanSpeed1,
mdiFanSpeed2: mdiFanSpeed2,
mdiFanSpeed3: mdiFanSpeed3,
mdiFastForward: mdiFastForward,
mdiFastForward10: mdiFastForward10,
mdiFastForward15: mdiFastForward15,
mdiFastForward30: mdiFastForward30,
mdiFastForward45: mdiFastForward45,
mdiFastForward5: mdiFastForward5,
mdiFastForward60: mdiFastForward60,
mdiFastForwardOutline: mdiFastForwardOutline,
mdiFaucet: mdiFaucet,
mdiFaucetVariant: mdiFaucetVariant,
mdiFax: mdiFax,
mdiFeather: mdiFeather,
mdiFeatureSearch: mdiFeatureSearch,
mdiFeatureSearchOutline: mdiFeatureSearchOutline,
mdiFedora: mdiFedora,
mdiFence: mdiFence,
mdiFenceElectric: mdiFenceElectric,
mdiFencing: mdiFencing,
mdiFerrisWheel: mdiFerrisWheel,
mdiFerry: mdiFerry,
mdiFile: mdiFile,
mdiFileAccount: mdiFileAccount,
mdiFileAccountOutline: mdiFileAccountOutline,
mdiFileAlert: mdiFileAlert,
mdiFileAlertOutline: mdiFileAlertOutline,
mdiFileArrowLeftRight: mdiFileArrowLeftRight,
mdiFileArrowLeftRightOutline: mdiFileArrowLeftRightOutline,
mdiFileArrowUpDown: mdiFileArrowUpDown,
mdiFileArrowUpDownOutline: mdiFileArrowUpDownOutline,
mdiFileCabinet: mdiFileCabinet,
mdiFileCad: mdiFileCad,
mdiFileCadBox: mdiFileCadBox,
mdiFileCancel: mdiFileCancel,
mdiFileCancelOutline: mdiFileCancelOutline,
mdiFileCertificate: mdiFileCertificate,
mdiFileCertificateOutline: mdiFileCertificateOutline,
mdiFileChart: mdiFileChart,
mdiFileChartCheck: mdiFileChartCheck,
mdiFileChartCheckOutline: mdiFileChartCheckOutline,
mdiFileChartOutline: mdiFileChartOutline,
mdiFileCheck: mdiFileCheck,
mdiFileCheckOutline: mdiFileCheckOutline,
mdiFileClock: mdiFileClock,
mdiFileClockOutline: mdiFileClockOutline,
mdiFileCloud: mdiFileCloud,
mdiFileCloudOutline: mdiFileCloudOutline,
mdiFileCode: mdiFileCode,
mdiFileCodeOutline: mdiFileCodeOutline,
mdiFileCog: mdiFileCog,
mdiFileCogOutline: mdiFileCogOutline,
mdiFileCompare: mdiFileCompare,
mdiFileDelimited: mdiFileDelimited,
mdiFileDelimitedOutline: mdiFileDelimitedOutline,
mdiFileDocument: mdiFileDocument,
mdiFileDocumentAlert: mdiFileDocumentAlert,
mdiFileDocumentAlertOutline: mdiFileDocumentAlertOutline,
mdiFileDocumentCheck: mdiFileDocumentCheck,
mdiFileDocumentCheckOutline: mdiFileDocumentCheckOutline,
mdiFileDocumentEdit: mdiFileDocumentEdit,
mdiFileDocumentEditOutline: mdiFileDocumentEditOutline,
mdiFileDocumentMinus: mdiFileDocumentMinus,
mdiFileDocumentMinusOutline: mdiFileDocumentMinusOutline,
mdiFileDocumentMultiple: mdiFileDocumentMultiple,
mdiFileDocumentMultipleOutline: mdiFileDocumentMultipleOutline,
mdiFileDocumentOutline: mdiFileDocumentOutline,
mdiFileDocumentPlus: mdiFileDocumentPlus,
mdiFileDocumentPlusOutline: mdiFileDocumentPlusOutline,
mdiFileDocumentRemove: mdiFileDocumentRemove,
mdiFileDocumentRemoveOutline: mdiFileDocumentRemoveOutline,
mdiFileDownload: mdiFileDownload,
mdiFileDownloadOutline: mdiFileDownloadOutline,
mdiFileEdit: mdiFileEdit,
mdiFileEditOutline: mdiFileEditOutline,
mdiFileExcel: mdiFileExcel,
mdiFileExcelBox: mdiFileExcelBox,
mdiFileExcelBoxOutline: mdiFileExcelBoxOutline,
mdiFileExcelOutline: mdiFileExcelOutline,
mdiFil: mdiFile,
// mdiFilestring: mdiFilestring,
// mdiFileEye: mdiFileEye,
mdiFileEyeOutline: mdiFileEyeOutline,
mdiFileFind: mdiFileFind,
mdiFileFindOutline: mdiFileFindOutline,
mdiFileGifBox: mdiFileGifBox,
mdiFileHidden: mdiFileHidden,
mdiFileImage: mdiFileImage,
mdiFileImageMarker: mdiFileImageMarker,
mdiFileImageMarkerOutline: mdiFileImageMarkerOutline,
mdiFileImageMinus: mdiFileImageMinus,
mdiFileImageMinusOutline: mdiFileImageMinusOutline,
mdiFileImageOutline: mdiFileImageOutline,
mdiFileImagePlus: mdiFileImagePlus,
mdiFileImagePlusOutline: mdiFileImagePlusOutline,
mdiFileImageRemove: mdiFileImageRemove,
mdiFileImageRemoveOutline: mdiFileImageRemoveOutline,
mdiFileImport: mdiFileImport,
mdiFileImportOutline: mdiFileImportOutline,
mdiFileJpgBox: mdiFileJpgBox,
mdiFileKey: mdiFileKey,
mdiFileKeyOutline: mdiFileKeyOutline,
mdiFileLink: mdiFileLink,
mdiFileLinkOutline: mdiFileLinkOutline,
mdiFileLock: mdiFileLock,
mdiFileLockOpen: mdiFileLockOpen,
mdiFileLockOpenOutline: mdiFileLockOpenOutline,
mdiFileLockOutline: mdiFileLockOutline,
mdiFileMarker: mdiFileMarker,
mdiFileMarkerOutline: mdiFileMarkerOutline,
mdiFileMinus: mdiFileMinus,
mdiFileMinusOutline: mdiFileMinusOutline,
mdiFileMove: mdiFileMove,
mdiFileMoveOutline: mdiFileMoveOutline,
mdiFileMultiple: mdiFileMultiple,
mdiFileMultipleOutline: mdiFileMultipleOutline,
mdiFileMusic: mdiFileMusic,
mdiFileMusicOutline: mdiFileMusicOutline,
mdiFileOutline: mdiFileOutline,
mdiFilePdfBox: mdiFilePdfBox,
mdiFilePercent: mdiFilePercent,
mdiFilePercentOutline: mdiFilePercentOutline,
mdiFilePhone: mdiFilePhone,
mdiFilePhoneOutline: mdiFilePhoneOutline,
mdiFilePlus: mdiFilePlus,
mdiFilePlusOutline: mdiFilePlusOutline,
mdiFilePngBox: mdiFilePngBox,
mdiFilePowerpoint: mdiFilePowerpoint,
mdiFilePowerpointBox: mdiFilePowerpointBox,
mdiFilePowerpointBoxOutline: mdiFilePowerpointBoxOutline,
mdiFilePowerpointOutline: mdiFilePowerpointOutline,
mdiFilePresentationBox: mdiFilePresentationBox,
mdiFileQuestion: mdiFileQuestion,
mdiFileQuestionOutline: mdiFileQuestionOutline,
mdiFileRefresh: mdiFileRefresh,
mdiFileRefreshOutline: mdiFileRefreshOutline,
mdiFileRemove: mdiFileRemove,
mdiFileRemoveOutline: mdiFileRemoveOutline,
mdiFileReplace: mdiFileReplace,
mdiFileReplaceOutline: mdiFileReplaceOutline,
mdiFileRestore: mdiFileRestore,
mdiFileRestoreOutline: mdiFileRestoreOutline,
mdiFileRotateLeft: mdiFileRotateLeft,
mdiFileRotateLeftOutline: mdiFileRotateLeftOutline,
mdiFileRotateRight: mdiFileRotateRight,
mdiFileRotateRightOutline: mdiFileRotateRightOutline,
mdiFileSearch: mdiFileSearch,
mdiFileSearchOutline: mdiFileSearchOutline,
mdiFileSend: mdiFileSend,
mdiFileSendOutline: mdiFileSendOutline,
mdiFileSettings: mdiFileSettings,
mdiFileSettingsOutline: mdiFileSettingsOutline,
mdiFileSign: mdiFileSign,
mdiFileStar: mdiFileStar,
mdiFileStarOutline: mdiFileStarOutline,
mdiFileSwap: mdiFileSwap,
mdiFileSwapOutline: mdiFileSwapOutline,
mdiFileSync: mdiFileSync,
mdiFileSyncOutline: mdiFileSyncOutline,
mdiFileTable: mdiFileTable,
mdiFileTableBox: mdiFileTableBox,
mdiFileTableBoxMultiple: mdiFileTableBoxMultiple,
mdiFileTableBoxMultipleOutline: mdiFileTableBoxMultipleOutline,
mdiFileTableBoxOutline: mdiFileTableBoxOutline,
mdiFileTableOutline: mdiFileTableOutline,
mdiFileTree: mdiFileTree,
mdiFileTreeOutline: mdiFileTreeOutline,
mdiFileUndo: mdiFileUndo,
mdiFileUndoOutline: mdiFileUndoOutline,
mdiFileUpload: mdiFileUpload,
mdiFileUploadOutline: mdiFileUploadOutline,
mdiFileVideo: mdiFileVideo,
mdiFileVideoOutline: mdiFileVideoOutline,
mdiFileWord: mdiFileWord,
mdiFileWordBox: mdiFileWordBox,
mdiFileWordBoxOutline: mdiFileWordBoxOutline,
mdiFileWordOutline: mdiFileWordOutline,
mdiFileXmlBox: mdiFileXmlBox,
mdiFilm: mdiFilm,
mdiFilmstrip: mdiFilmstrip,
mdiFilmstripBox: mdiFilmstripBox,
mdiFilmstripBoxMultiple: mdiFilmstripBoxMultiple,
mdiFilmstripOff: mdiFilmstripOff,
mdiFilter: mdiFilter,
mdiFilterCheck: mdiFilterCheck,
mdiFilterCheckOutline: mdiFilterCheckOutline,
mdiFilterCog: mdiFilterCog,
mdiFilterCogOutline: mdiFilterCogOutline,
mdiFilterMenu: mdiFilterMenu,
mdiFilterMenuOutline: mdiFilterMenuOutline,
mdiFilterMinus: mdiFilterMinus,
mdiFilterMinusOutline: mdiFilterMinusOutline,
mdiFilterMultiple: mdiFilterMultiple,
mdiFilterMultipleOutline: mdiFilterMultipleOutline,
mdiFilterOff: mdiFilterOff,
mdiFilterOffOutline: mdiFilterOffOutline,
mdiFilterOutline: mdiFilterOutline,
mdiFilterPlus: mdiFilterPlus,
mdiFilterPlusOutline: mdiFilterPlusOutline,
mdiFilterRemove: mdiFilterRemove,
mdiFilterRemoveOutline: mdiFilterRemoveOutline,
mdiFilterSettings: mdiFilterSettings,
mdiFilterSettingsOutline: mdiFilterSettingsOutline,
mdiFilterVariant: mdiFilterVariant,
mdiFilterVariantMinus: mdiFilterVariantMinus,
mdiFilterVariantPlus: mdiFilterVariantPlus,
mdiFilterVariantRemove: mdiFilterVariantRemove,
mdiFinance: mdiFinance,
mdiFindReplace: mdiFindReplace,
mdiFingerprint: mdiFingerprint,
mdiFingerprintOff: mdiFingerprintOff,
mdiFire: mdiFire,
mdiFireAlert: mdiFireAlert,
mdiFireCircle: mdiFireCircle,
mdiFireExtinguisher: mdiFireExtinguisher,
mdiFireHydrant: mdiFireHydrant,
mdiFireHydrantAlert: mdiFireHydrantAlert,
mdiFireHydrantOff: mdiFireHydrantOff,
mdiFireOff: mdiFireOff,
mdiFireTruck: mdiFireTruck,
mdiFirebase: mdiFirebase,
mdiFirefox: mdiFirefox,
mdiFireplace: mdiFireplace,
mdiFireplaceOff: mdiFireplaceOff,
mdiFirewire: mdiFirewire,
mdiFirework: mdiFirework,
mdiFireworkOff: mdiFireworkOff,
mdiFish: mdiFish,
mdiFishOff: mdiFishOff,
mdiFishbowl: mdiFishbowl,
mdiFishbowlOutline: mdiFishbowlOutline,
mdiFitToPage: mdiFitToPage,
mdiFitToPageOutline: mdiFitToPageOutline,
mdiFitToScreen: mdiFitToScreen,
mdiFitToScreenOutline: mdiFitToScreenOutline,
mdiFlag: mdiFlag,
mdiFlagCheckered: mdiFlagCheckered,
mdiFlagMinus: mdiFlagMinus,
mdiFlagMinusOutline: mdiFlagMinusOutline,
mdiFlagOff: mdiFlagOff,
mdiFlagOffOutline: mdiFlagOffOutline,
mdiFlagOutline: mdiFlagOutline,
mdiFlagPlus: mdiFlagPlus,
mdiFlagPlusOutline: mdiFlagPlusOutline,
mdiFlagRemove: mdiFlagRemove,
mdiFlagRemoveOutline: mdiFlagRemoveOutline,
mdiFlagTriangle: mdiFlagTriangle,
mdiFlagVariant: mdiFlagVariant,
mdiFlagVariantMinus: mdiFlagVariantMinus,
mdiFlagVariantMinusOutline: mdiFlagVariantMinusOutline,
mdiFlagVariantOff: mdiFlagVariantOff,
mdiFlagVariantOffOutline: mdiFlagVariantOffOutline,
mdiFlagVariantOutline: mdiFlagVariantOutline,
mdiFlagVariantPlus: mdiFlagVariantPlus,
mdiFlagVariantPlusOutline: mdiFlagVariantPlusOutline,
mdiFlagVariantRemove: mdiFlagVariantRemove,
mdiFlagVariantRemoveOutline: mdiFlagVariantRemoveOutline,
mdiFlare: mdiFlare,
mdiFlash: mdiFlash,
mdiFlashAlert: mdiFlashAlert,
mdiFlashAlertOutline: mdiFlashAlertOutline,
mdiFlashAuto: mdiFlashAuto,
mdiFlashOff: mdiFlashOff,
mdiFlashOffOutline: mdiFlashOffOutline,
mdiFlashOutline: mdiFlashOutline,
mdiFlashRedEye: mdiFlashRedEye,
mdiFlashTriangle: mdiFlashTriangle,
mdiFlashTriangleOutline: mdiFlashTriangleOutline,
mdiFlashlight: mdiFlashlight,
mdiFlashlightOff: mdiFlashlightOff,
mdiFlask: mdiFlask,
mdiFlaskEmpty: mdiFlaskEmpty,
mdiFlaskEmptyMinus: mdiFlaskEmptyMinus,
mdiFlaskEmptyMinusOutline: mdiFlaskEmptyMinusOutline,
mdiFlaskEmptyOff: mdiFlaskEmptyOff,
mdiFlaskEmptyOffOutline: mdiFlaskEmptyOffOutline,
mdiFlaskEmptyOutline: mdiFlaskEmptyOutline,
mdiFlaskEmptyPlus: mdiFlaskEmptyPlus,
mdiFlaskEmptyPlusOutline: mdiFlaskEmptyPlusOutline,
mdiFlaskEmptyRemove: mdiFlaskEmptyRemove,
mdiFlaskEmptyRemoveOutline: mdiFlaskEmptyRemoveOutline,
mdiFlaskMinus: mdiFlaskMinus,
mdiFlaskMinusOutline: mdiFlaskMinusOutline,
mdiFlaskOff: mdiFlaskOff,
mdiFlaskOffOutline: mdiFlaskOffOutline,
mdiFlaskOutline: mdiFlaskOutline,
mdiFlaskPlus: mdiFlaskPlus,
mdiFlaskPlusOutline: mdiFlaskPlusOutline,
mdiFlaskRemove: mdiFlaskRemove,
mdiFlaskRemoveOutline: mdiFlaskRemoveOutline,
mdiFlaskRoundBottom: mdiFlaskRoundBottom,
mdiFlaskRoundBottomEmpty: mdiFlaskRoundBottomEmpty,
mdiFlaskRoundBottomEmptyOutline: mdiFlaskRoundBottomEmptyOutline,
mdiFlaskRoundBottomOutline: mdiFlaskRoundBottomOutline,
mdiFleurDeLis: mdiFleurDeLis,
mdiFlipHorizontal: mdiFlipHorizontal,
mdiFlipToBack: mdiFlipToBack,
mdiFlipToFront: mdiFlipToFront,
mdiFlipVertical: mdiFlipVertical,
mdiFloorLamp: mdiFloorLamp,
mdiFloorLampDual: mdiFloorLampDual,
mdiFloorLampDualOutline: mdiFloorLampDualOutline,
mdiFloorLampOutline: mdiFloorLampOutline,
mdiFloorLampTorchiere: mdiFloorLampTorchiere,
mdiFloorLampTorchiereOutline: mdiFloorLampTorchiereOutline,
mdiFloorLampTorchiereVariant: mdiFloorLampTorchiereVariant,
mdiFloorLampTorchiereVariantOutline: mdiFloorLampTorchiereVariantOutline,
mdiFloorPlan: mdiFloorPlan,
mdiFloppy: mdiFloppy,
mdiFloppyVariant: mdiFloppyVariant,
mdiFlower: mdiFlower,
mdiFlowerOutline: mdiFlowerOutline,
mdiFlowerPollen: mdiFlowerPollen,
mdiFlowerPollenOutline: mdiFlowerPollenOutline,
mdiFlowerPoppy: mdiFlowerPoppy,
mdiFlowerTulip: mdiFlowerTulip,
mdiFlowerTulipOutline: mdiFlowerTulipOutline,
mdiFocusAuto: mdiFocusAuto,
mdiFocusField: mdiFocusField,
mdiFocusFieldHorizontal: mdiFocusFieldHorizontal,
mdiFocusFieldVertical: mdiFocusFieldVertical,
mdiFolder: mdiFolder,
mdiFolderAccount: mdiFolderAccount,
mdiFolderAccountOutline: mdiFolderAccountOutline,
mdiFolderAlert: mdiFolderAlert,
mdiFolderAlertOutline: mdiFolderAlertOutline,
mdiFolderArrowDown: mdiFolderArrowDown,
mdiFolderArrowDownOutline: mdiFolderArrowDownOutline,
mdiFolderArrowLeft: mdiFolderArrowLeft,
mdiFolderArrowLeftOutline: mdiFolderArrowLeftOutline,
mdiFolderArrowLeftRight: mdiFolderArrowLeftRight,
mdiFolderArrowLeftRightOutline: mdiFolderArrowLeftRightOutline,
mdiFolderArrowRight: mdiFolderArrowRight,
mdiFolderArrowRightOutline: mdiFolderArrowRightOutline,
mdiFolderArrowUp: mdiFolderArrowUp,
mdiFolderArrowUpDown: mdiFolderArrowUpDown,
mdiFolderArrowUpDownOutline: mdiFolderArrowUpDownOutline,
mdiFolderArrowUpOutline: mdiFolderArrowUpOutline,
mdiFolderCancel: mdiFolderCancel,
mdiFolderCancelOutline: mdiFolderCancelOutline,
mdiFolderCheck: mdiFolderCheck,
mdiFolderCheckOutline: mdiFolderCheckOutline,
mdiFolderClock: mdiFolderClock,
mdiFolderClockOutline: mdiFolderClockOutline,
mdiFolderCog: mdiFolderCog,
mdiFolderCogOutline: mdiFolderCogOutline,
mdiFolderDownload: mdiFolderDownload,
mdiFolderDownloadOutline: mdiFolderDownloadOutline,
mdiFolderEdit: mdiFolderEdit,
mdiFolderEditOutline: mdiFolderEditOutline,
mdiFolderEye: mdiFolderEye,
mdiFolderEyeOutline: mdiFolderEyeOutline,
mdiFolderFile: mdiFolderFile,
mdiFolderFileOutline: mdiFolderFileOutline,
mdiFolderGoogleDrive: mdiFolderGoogleDrive,
mdiFolderHeart: mdiFolderHeart,
mdiFolderHeartOutline: mdiFolderHeartOutline,
mdiFolderHidden: mdiFolderHidden,
mdiFolderHome: mdiFolderHome,
mdiFolderHomeOutline: mdiFolderHomeOutline,
mdiFolderImage: mdiFolderImage,
mdiFolderInformation: mdiFolderInformation,
mdiFolderInformationOutline: mdiFolderInformationOutline,
mdiFolderKey: mdiFolderKey,
mdiFolderKeyNetwork: mdiFolderKeyNetwork,
mdiFolderKeyNetworkOutline: mdiFolderKeyNetworkOutline,
mdiFolderKeyOutline: mdiFolderKeyOutline,
mdiFolderLock: mdiFolderLock,
mdiFolderLockOpen: mdiFolderLockOpen,
mdiFolderLockOpenOutline: mdiFolderLockOpenOutline,
mdiFolderLockOutline: mdiFolderLockOutline,
mdiFolderMarker: mdiFolderMarker,
mdiFolderMarkerOutline: mdiFolderMarkerOutline,
mdiFolderMinus: mdiFolderMinus,
mdiFolderMinusOutline: mdiFolderMinusOutline,
mdiFolderMove: mdiFolderMove,
mdiFolderMoveOutline: mdiFolderMoveOutline,
mdiFolderMultiple: mdiFolderMultiple,
mdiFolderMultipleImage: mdiFolderMultipleImage,
mdiFolderMultipleOutline: mdiFolderMultipleOutline,
mdiFolderMultiplePlus: mdiFolderMultiplePlus,
mdiFolderMultiplePlusOutline: mdiFolderMultiplePlusOutline,
mdiFolderMusic: mdiFolderMusic,
mdiFolderMusicOutline: mdiFolderMusicOutline,
mdiFolderNetwork: mdiFolderNetwork,
mdiFolderNetworkOutline: mdiFolderNetworkOutline,
mdiFolderOff: mdiFolderOff,
mdiFolderOffOutline: mdiFolderOffOutline,
mdiFolderOpen: mdiFolderOpen,
mdiFolderOpenOutline: mdiFolderOpenOutline,
mdiFolderOutline: mdiFolderOutline,
mdiFolderPlay: mdiFolderPlay,
mdiFolderPlayOutline: mdiFolderPlayOutline,
mdiFolderPlus: mdiFolderPlus,
mdiFolderPlusOutline: mdiFolderPlusOutline,
mdiFolderPound: mdiFolderPound,
mdiFolderPoundOutline: mdiFolderPoundOutline,
mdiFolderQuestion: mdiFolderQuestion,
mdiFolderQuestionOutline: mdiFolderQuestionOutline,
mdiFolderRefresh: mdiFolderRefresh,
mdiFolderRefreshOutline: mdiFolderRefreshOutline,
mdiFolderRemove: mdiFolderRemove,
mdiFolderRemoveOutline: mdiFolderRemoveOutline,
mdiFolderSearch: mdiFolderSearch,
mdiFolderSearchOutline: mdiFolderSearchOutline,
mdiFolderSettings: mdiFolderSettings,
mdiFolderSettingsOutline: mdiFolderSettingsOutline,
mdiFolderStar: mdiFolderStar,
mdiFolderStarMultiple: mdiFolderStarMultiple,
mdiFolderStarMultipleOutline: mdiFolderStarMultipleOutline,
mdiFolderStarOutline: mdiFolderStarOutline,
mdiFolderSwap: mdiFolderSwap,
mdiFolderSwapOutline: mdiFolderSwapOutline,
mdiFolderSync: mdiFolderSync,
mdiFolderSyncOutline: mdiFolderSyncOutline,
mdiFolderTable: mdiFolderTable,
mdiFolderTableOutline: mdiFolderTableOutline,
mdiFolderText: mdiFolderText,
mdiFolderTextOutline: mdiFolderTextOutline,
mdiFolderUpload: mdiFolderUpload,
mdiFolderUploadOutline: mdiFolderUploadOutline,
mdiFolderWrench: mdiFolderWrench,
mdiFolderWrenchOutline: mdiFolderWrenchOutline,
mdiFolderZip: mdiFolderZip,
mdiFolderZipOutline: mdiFolderZipOutline,
mdiFontAwesome: mdiFontAwesome,
mdiFood: mdiFood,
mdiFoodApple: mdiFoodApple,
mdiFoodAppleOutline: mdiFoodAppleOutline,
mdiFoodCroissant: mdiFoodCroissant,
mdiFoodDrumstick: mdiFoodDrumstick,
mdiFoodDrumstickOff: mdiFoodDrumstickOff,
mdiFoodDrumstickOffOutline: mdiFoodDrumstickOffOutline,
mdiFoodDrumstickOutline: mdiFoodDrumstickOutline,
mdiFoodForkDrink: mdiFoodForkDrink,
mdiFoodHalal: mdiFoodHalal,
mdiFoodHotDog: mdiFoodHotDog,
mdiFoodKosher: mdiFoodKosher,
mdiFoodOff: mdiFoodOff,
mdiFoodOffOutline: mdiFoodOffOutline,
mdiFoodOutline: mdiFoodOutline,
mdiFoodSteak: mdiFoodSteak,
mdiFoodSteakOff: mdiFoodSteakOff,
mdiFoodTakeoutBox: mdiFoodTakeoutBox,
mdiFoodTakeoutBoxOutline: mdiFoodTakeoutBoxOutline,
mdiFoodTurkey: mdiFoodTurkey,
mdiFoodVariant: mdiFoodVariant,
mdiFoodVariantOff: mdiFoodVariantOff,
mdiFootPrint: mdiFootPrint,
mdiFootball: mdiFootball,
mdiFootballAustralian: mdiFootballAustralian,
mdiFootballHelmet: mdiFootballHelmet,
mdiForest: mdiForest,
mdiForklift: mdiForklift,
mdiFormDropdown: mdiFormDropdown,
mdiFormSelect: mdiFormSelect,
mdiFormTextarea: mdiFormTextarea,
mdiFormTextbox: mdiFormTextbox,
mdiFormTextboxLock: mdiFormTextboxLock,
mdiFormTextboxPassword: mdiFormTextboxPassword,
mdiFormatAlignBottom: mdiFormatAlignBottom,
mdiFormatAlignCenter: mdiFormatAlignCenter,
mdiFormatAlignJustify: mdiFormatAlignJustify,
mdiFormatAlignLeft: mdiFormatAlignLeft,
mdiFormatAlignMiddle: mdiFormatAlignMiddle,
mdiFormatAlignRight: mdiFormatAlignRight,
mdiFormatAlignTop: mdiFormatAlignTop,
mdiFormatAnnotationMinus: mdiFormatAnnotationMinus,
mdiFormatAnnotationPlus: mdiFormatAnnotationPlus,
mdiFormatBold: mdiFormatBold,
mdiFormatClear: mdiFormatClear,
mdiFormatColorFill: mdiFormatColorFill,
mdiFormatColorHighlight: mdiFormatColorHighlight,
mdiFormatColorMarkerCancel: mdiFormatColorMarkerCancel,
mdiFormatColorText: mdiFormatColorText,
mdiFormatColumns: mdiFormatColumns,
mdiFormatFloatCenter: mdiFormatFloatCenter,
mdiFormatFloatLeft: mdiFormatFloatLeft,
mdiFormatFloatNone: mdiFormatFloatNone,
mdiFormatFloatRight: mdiFormatFloatRight,
mdiFormatFont: mdiFormatFont,
mdiFormatFontSizeDecrease: mdiFormatFontSizeDecrease,
mdiFormatFontSizeIncrease: mdiFormatFontSizeIncrease,
mdiFormatHeader1: mdiFormatHeader1,
mdiFormatHeader2: mdiFormatHeader2,
mdiFormatHeader3: mdiFormatHeader3,
mdiFormatHeader4: mdiFormatHeader4,
mdiFormatHeader5: mdiFormatHeader5,
mdiFormatHeader6: mdiFormatHeader6,
mdiFormatHeaderDecrease: mdiFormatHeaderDecrease,
mdiFormatHeaderEqual: mdiFormatHeaderEqual,
mdiFormatHeaderIncrease: mdiFormatHeaderIncrease,
mdiFormatHeaderPound: mdiFormatHeaderPound,
mdiFormatHorizontalAlignCenter: mdiFormatHorizontalAlignCenter,
mdiFormatHorizontalAlignLeft: mdiFormatHorizontalAlignLeft,
mdiFormatHorizontalAlignRight: mdiFormatHorizontalAlignRight,
mdiFormatIndentDecrease: mdiFormatIndentDecrease,
mdiFormatIndentIncrease: mdiFormatIndentIncrease,
mdiFormatItalic: mdiFormatItalic,
mdiFormatLetterCase: mdiFormatLetterCase,
mdiFormatLetterCaseLower: mdiFormatLetterCaseLower,
mdiFormatLetterCaseUpper: mdiFormatLetterCaseUpper,
mdiFormatLetterEndsWith: mdiFormatLetterEndsWith,
mdiFormatLetterMatches: mdiFormatLetterMatches,
mdiFormatLetterSpacing: mdiFormatLetterSpacing,
mdiFormatLetterSpacingVariant: mdiFormatLetterSpacingVariant,
mdiFormatLetterStartsWith: mdiFormatLetterStartsWith,
mdiFormatLineHeight: mdiFormatLineHeight,
mdiFormatLineSpacing: mdiFormatLineSpacing,
mdiFormatLineStyle: mdiFormatLineStyle,
mdiFormatLineWeight: mdiFormatLineWeight,
mdiFormatListBulleted: mdiFormatListBulleted,
mdiFormatListBulletedSquare: mdiFormatListBulletedSquare,
mdiFormatListBulletedTriangle: mdiFormatListBulletedTriangle,
mdiFormatListBulletedType: mdiFormatListBulletedType,
mdiFormatListCheckbox: mdiFormatListCheckbox,
mdiFormatListChecks: mdiFormatListChecks,
mdiFormatListGroup: mdiFormatListGroup,
mdiFormatListGroupPlus: mdiFormatListGroupPlus,
mdiFormatListNumbered: mdiFormatListNumbered,
mdiFormatListNumberedRtl: mdiFormatListNumberedRtl,
mdiFormatListText: mdiFormatListText,
mdiFormatOverline: mdiFormatOverline,
mdiFormatPageBreak: mdiFormatPageBreak,
mdiFormatPageSplit: mdiFormatPageSplit,
mdiFormatPaint: mdiFormatPaint,
mdiFormatParagraph: mdiFormatParagraph,
mdiFormatParagraphSpacing: mdiFormatParagraphSpacing,
mdiFormatPilcrow: mdiFormatPilcrow,
mdiFormatPilcrowArrowLeft: mdiFormatPilcrowArrowLeft,
mdiFormatPilcrowArrowRight: mdiFormatPilcrowArrowRight,
mdiFormatQuoteClose: mdiFormatQuoteClose,
mdiFormatQuoteCloseOutline: mdiFormatQuoteCloseOutline,
mdiFormatQuoteOpen: mdiFormatQuoteOpen,
mdiFormatQuoteOpenOutline: mdiFormatQuoteOpenOutline,
mdiFormatRotate90: mdiFormatRotate90,
mdiFormatSection: mdiFormatSection,
mdiFormatSize: mdiFormatSize,
mdiFormatStrikethrough: mdiFormatStrikethrough,
mdiFormatStrikethroughVariant: mdiFormatStrikethroughVariant,
mdiFormatSubscript: mdiFormatSubscript,
mdiFormatSuperscript: mdiFormatSuperscript,
mdiFormatText: mdiFormatText,
mdiFormatTextRotationAngleDown: mdiFormatTextRotationAngleDown,
mdiFormatTextRotationAngleUp: mdiFormatTextRotationAngleUp,
mdiFormatTextRotationDown: mdiFormatTextRotationDown,
mdiFormatTextRotationDownVertical: mdiFormatTextRotationDownVertical,
mdiFormatTextRotationNone: mdiFormatTextRotationNone,
mdiFormatTextRotationUp: mdiFormatTextRotationUp,
mdiFormatTextRotationVertical: mdiFormatTextRotationVertical,
mdiFormatTextVariant: mdiFormatTextVariant,
mdiFormatTextVariantOutline: mdiFormatTextVariantOutline,
mdiFormatTextWrappingClip: mdiFormatTextWrappingClip,
mdiFormatTextWrappingOverflow: mdiFormatTextWrappingOverflow,
mdiFormatTextWrappingWrap: mdiFormatTextWrappingWrap,
mdiFormatTextbox: mdiFormatTextbox,
mdiFormatTitle: mdiFormatTitle,
mdiFormatUnderline: mdiFormatUnderline,
mdiFormatUnderlineWavy: mdiFormatUnderlineWavy,
mdiFormatVerticalAlignBottom: mdiFormatVerticalAlignBottom,
mdiFormatVerticalAlignCenter: mdiFormatVerticalAlignCenter,
mdiFormatVerticalAlignTop: mdiFormatVerticalAlignTop,
mdiFormatWrapInline: mdiFormatWrapInline,
mdiFormatWrapSquare: mdiFormatWrapSquare,
mdiFormatWrapTight: mdiFormatWrapTight,
mdiFormatWrapTopBottom: mdiFormatWrapTopBottom,
mdiForum: mdiForum,
mdiForumMinus: mdiForumMinus,
mdiForumMinusOutline: mdiForumMinusOutline,
mdiForumOutline: mdiForumOutline,
mdiForumPlus: mdiForumPlus,
mdiForumPlusOutline: mdiForumPlusOutline,
mdiForumRemove: mdiForumRemove,
mdiForumRemoveOutline: mdiForumRemoveOutline,
mdiForward: mdiForward,
mdiForwardburger: mdiForwardburger,
mdiFountain: mdiFountain,
mdiFountainPen: mdiFountainPen,
mdiFountainPenTip: mdiFountainPenTip,
mdiFractionOneHalf: mdiFractionOneHalf,
mdiFreebsd: mdiFreebsd,
mdiFrenchFries: mdiFrenchFries,
mdiFrequentlyAskedQuestions: mdiFrequentlyAskedQuestions,
mdiFridge: mdiFridge,
mdiFridgeAlert: mdiFridgeAlert,
mdiFridgeAlertOutline: mdiFridgeAlertOutline,
mdiFridgeBottom: mdiFridgeBottom,
mdiFridgeIndustrial: mdiFridgeIndustrial,
mdiFridgeIndustrialAlert: mdiFridgeIndustrialAlert,
mdiFridgeIndustrialAlertOutline: mdiFridgeIndustrialAlertOutline,
mdiFridgeIndustrialOff: mdiFridgeIndustrialOff,
mdiFridgeIndustrialOffOutline: mdiFridgeIndustrialOffOutline,
mdiFridgeIndustrialOutline: mdiFridgeIndustrialOutline,
mdiFridgeOff: mdiFridgeOff,
mdiFridgeOffOutline: mdiFridgeOffOutline,
mdiFridgeOutline: mdiFridgeOutline,
mdiFridgeTop: mdiFridgeTop,
mdiFridgeVariant: mdiFridgeVariant,
mdiFridgeVariantAlert: mdiFridgeVariantAlert,
mdiFridgeVariantAlertOutline: mdiFridgeVariantAlertOutline,
mdiFridgeVariantOff: mdiFridgeVariantOff,
mdiFridgeVariantOffOutline: mdiFridgeVariantOffOutline,
mdiFridgeVariantOutline: mdiFridgeVariantOutline,
mdiFruitCherries: mdiFruitCherries,
mdiFruitCherriesOff: mdiFruitCherriesOff,
mdiFruitCitrus: mdiFruitCitrus,
mdiFruitCitrusOff: mdiFruitCitrusOff,
mdiFruitGrapes: mdiFruitGrapes,
mdiFruitGrapesOutline: mdiFruitGrapesOutline,
mdiFruitPear: mdiFruitPear,
mdiFruitPineapple: mdiFruitPineapple,
mdiFruitWatermelon: mdiFruitWatermelon,
mdiFuel: mdiFuel,
mdiFuelCell: mdiFuelCell,
mdiFullscreen: mdiFullscreen,
mdiFullscreenExit: mdiFullscreenExit,
mdiFunction: mdiFunction,
mdiFunctionVariant: mdiFunctionVariant,
mdiFuriganaHorizontal: mdiFuriganaHorizontal,
mdiFuriganaVertical: mdiFuriganaVertical,
mdiFuse: mdiFuse,
mdiFuseAlert: mdiFuseAlert,
mdiFuseBlade: mdiFuseBlade,
mdiFuseOff: mdiFuseOff,
mdiGamepad: mdiGamepad,
mdiGamepadCircle: mdiGamepadCircle,
mdiGamepadCircleDown: mdiGamepadCircleDown,
mdiGamepadCircleLeft: mdiGamepadCircleLeft,
mdiGamepadCircleOutline: mdiGamepadCircleOutline,
mdiGamepadCircleRight: mdiGamepadCircleRight,
mdiGamepadCircleUp: mdiGamepadCircleUp,
mdiGamepadDown: mdiGamepadDown,
mdiGamepadLeft: mdiGamepadLeft,
mdiGamepadOutline: mdiGamepadOutline,
mdiGamepadRight: mdiGamepadRight,
mdiGamepadRound: mdiGamepadRound,
mdiGamepadRoundDown: mdiGamepadRoundDown,
mdiGamepadRoundLeft: mdiGamepadRoundLeft,
mdiGamepadRoundOutline: mdiGamepadRoundOutline,
mdiGamepadRoundRight: mdiGamepadRoundRight,
mdiGamepadRoundUp: mdiGamepadRoundUp,
mdiGamepadSquare: mdiGamepadSquare,
mdiGamepadSquareOutline: mdiGamepadSquareOutline,
mdiGamepadUp: mdiGamepadUp,
mdiGamepadVariant: mdiGamepadVariant,
mdiGamepadVariantOutline: mdiGamepadVariantOutline,
mdiGamma: mdiGamma,
mdiGantryCrane: mdiGantryCrane,
mdiGarage: mdiGarage,
mdiGarageAlert: mdiGarageAlert,
mdiGarageAlertVariant: mdiGarageAlertVariant,
mdiGarageLock: mdiGarageLock,
mdiGarageOpen: mdiGarageOpen,
mdiGarageOpenVariant: mdiGarageOpenVariant,
mdiGarageVariant: mdiGarageVariant,
mdiGarageVariantLock: mdiGarageVariantLock,
mdiGasBurner: mdiGasBurner,
mdiGasCylinder: mdiGasCylinder,
mdiGasStation: mdiGasStation,
mdiGasStationOff: mdiGasStationOff,
mdiGasStationOffOutline: mdiGasStationOffOutline,
mdiGasStationOutline: mdiGasStationOutline,
mdiGate: mdiGate,
mdiGateAlert: mdiGateAlert,
mdiGateAnd: mdiGateAnd,
mdiGateArrowLeft: mdiGateArrowLeft,
mdiGateArrowRight: mdiGateArrowRight,
mdiGateBuffer: mdiGateBuffer,
mdiGateNand: mdiGateNand,
mdiGateNor: mdiGateNor,
mdiGateNot: mdiGateNot,
mdiGateOpen: mdiGateOpen,
mdiGateOr: mdiGateOr,
mdiGateXnor: mdiGateXnor,
mdiGateXor: mdiGateXor,
mdiGatsby: mdiGatsby,
mdiGauge: mdiGauge,
mdiGaugeEmpty: mdiGaugeEmpty,
mdiGaugeFull: mdiGaugeFull,
mdiGaugeLow: mdiGaugeLow,
mdiGavel: mdiGavel,
mdiGenderFemale: mdiGenderFemale,
mdiGenderMale: mdiGenderMale,
mdiGenderMaleFemale: mdiGenderMaleFemale,
mdiGenderMaleFemaleVariant: mdiGenderMaleFemaleVariant,
mdiGenderNonBinary: mdiGenderNonBinary,
mdiGenderTransgender: mdiGenderTransgender,
mdiGentoo: mdiGentoo,
mdiGesture: mdiGesture,
mdiGestureDoubleTap: mdiGestureDoubleTap,
mdiGesturePinch: mdiGesturePinch,
mdiGestureSpread: mdiGestureSpread,
mdiGestureSwipe: mdiGestureSwipe,
mdiGestureSwipeDown: mdiGestureSwipeDown,
mdiGestureSwipeHorizontal: mdiGestureSwipeHorizontal,
mdiGestureSwipeLeft: mdiGestureSwipeLeft,
mdiGestureSwipeRight: mdiGestureSwipeRight,
mdiGestureSwipeUp: mdiGestureSwipeUp,
mdiGestureSwipeVertical: mdiGestureSwipeVertical,
mdiGestureTap: mdiGestureTap,
mdiGestureTapBox: mdiGestureTapBox,
mdiGestureTapButton: mdiGestureTapButton,
mdiGestureTapHold: mdiGestureTapHold,
mdiGestureTwoDoubleTap: mdiGestureTwoDoubleTap,
mdiGestureTwoTap: mdiGestureTwoTap,
mdiGhost: mdiGhost,
mdiGhostOff: mdiGhostOff,
mdiGhostOffOutline: mdiGhostOffOutline,
mdiGhostOutline: mdiGhostOutline,
mdiGift: mdiGift,
mdiGiftOff: mdiGiftOff,
mdiGiftOffOutline: mdiGiftOffOutline,
mdiGiftOpen: mdiGiftOpen,
mdiGiftOpenOutline: mdiGiftOpenOutline,
mdiGiftOutline: mdiGiftOutline,
mdiGit: mdiGit,
mdiGithub: mdiGithub,
mdiGitlab: mdiGitlab,
mdiGlassCocktail: mdiGlassCocktail,
mdiGlassCocktailOff: mdiGlassCocktailOff,
mdiGlassFlute: mdiGlassFlute,
mdiGlassFragile: mdiGlassFragile,
mdiGlassMug: mdiGlassMug,
mdiGlassMugOff: mdiGlassMugOff,
mdiGlassMugVariant: mdiGlassMugVariant,
mdiGlassMugVariantOff: mdiGlassMugVariantOff,
mdiGlassPintOutline: mdiGlassPintOutline,
mdiGlassStange: mdiGlassStange,
mdiGlassTulip: mdiGlassTulip,
mdiGlassWine: mdiGlassWine,
mdiGlasses: mdiGlasses,
mdiGlobeLight: mdiGlobeLight,
mdiGlobeLightOutline: mdiGlobeLightOutline,
mdiGlobeModel: mdiGlobeModel,
mdiGmail: mdiGmail,
mdiGnome: mdiGnome,
mdiGoKart: mdiGoKart,
mdiGoKartTrack: mdiGoKartTrack,
mdiGog: mdiGog,
mdiGold: mdiGold,
mdiGolf: mdiGolf,
mdiGolfCart: mdiGolfCart,
mdiGolfTee: mdiGolfTee,
mdiGondola: mdiGondola,
mdiGoodreads: mdiGoodreads,
mdiGoogle: mdiGoogle,
mdiGoogleAds: mdiGoogleAds,
mdiGoogleAnalytics: mdiGoogleAnalytics,
mdiGoogleAssistant: mdiGoogleAssistant,
mdiGoogleCardboard: mdiGoogleCardboard,
mdiGoogleChrome: mdiGoogleChrome,
mdiGoogleCircles: mdiGoogleCircles,
mdiGoogleCirclesCommunities: mdiGoogleCirclesCommunities,
mdiGoogleCirclesExtended: mdiGoogleCirclesExtended,
mdiGoogleCirclesGroup: mdiGoogleCirclesGroup,
mdiGoogleClassroom: mdiGoogleClassroom,
mdiGoogleCloud: mdiGoogleCloud,
mdiGoogleDownasaur: mdiGoogleDownasaur,
mdiGoogleDrive: mdiGoogleDrive,
mdiGoogleEarth: mdiGoogleEarth,
mdiGoogleFit: mdiGoogleFit,
mdiGoogleGlass: mdiGoogleGlass,
mdiGoogleHangouts: mdiGoogleHangouts,
mdiGoogleKeep: mdiGoogleKeep,
mdiGoogleLens: mdiGoogleLens,
mdiGoogleMaps: mdiGoogleMaps,
mdiGoogleMyBusiness: mdiGoogleMyBusiness,
mdiGoogleNearby: mdiGoogleNearby,
mdiGooglePlay: mdiGooglePlay,
mdiGooglePlus: mdiGooglePlus,
mdiGooglePodcast: mdiGooglePodcast,
mdiGoogleSpreadsheet: mdiGoogleSpreadsheet,
mdiGoogleStreetView: mdiGoogleStreetView,
mdiGoogleTranslate: mdiGoogleTranslate,
mdiGradientHorizontal: mdiGradientHorizontal,
mdiGradientVertical: mdiGradientVertical,
mdiGrain: mdiGrain,
mdiGraph: mdiGraph,
mdiGraphOutline: mdiGraphOutline,
mdiGraphql: mdiGraphql,
mdiGrass: mdiGrass,
mdiGraveStone: mdiGraveStone,
mdiGreasePencil: mdiGreasePencil,
mdiGreaterThan: mdiGreaterThan,
mdiGreaterThanOrEqual: mdiGreaterThanOrEqual,
mdiGreenhouse: mdiGreenhouse,
mdiGrid: mdiGrid,
mdiGridLarge: mdiGridLarge,
mdiGridOff: mdiGridOff,
mdiGrill: mdiGrill,
mdiGrillOutline: mdiGrillOutline,
mdiGroup: mdiGroup,
mdiGuitarAcoustic: mdiGuitarAcoustic,
mdiGuitarElectric: mdiGuitarElectric,
mdiGuitarPick: mdiGuitarPick,
mdiGuitarPickOutline: mdiGuitarPickOutline,
mdiGuyFawkesMask: mdiGuyFawkesMask,
mdiGymnastics: mdiGymnastics,
mdiHail: mdiHail,
mdiHairDryer: mdiHairDryer,
mdiHairDryerOutline: mdiHairDryerOutline,
mdiHalloween: mdiHalloween,
mdiHamburger: mdiHamburger,
mdiHamburgerCheck: mdiHamburgerCheck,
mdiHamburgerMinus: mdiHamburgerMinus,
mdiHamburgerOff: mdiHamburgerOff,
mdiHamburgerPlus: mdiHamburgerPlus,
mdiHamburgerRemove: mdiHamburgerRemove,
mdiHammer: mdiHammer,
mdiHammerScrewdriver: mdiHammerScrewdriver,
mdiHammerSickle: mdiHammerSickle,
mdiHammerWrench: mdiHammerWrench,
mdiHandBackLeft: mdiHandBackLeft,
mdiHandBackLeftOff: mdiHandBackLeftOff,
mdiHandBackLeftOffOutline: mdiHandBackLeftOffOutline,
mdiHandBackLeftOutline: mdiHandBackLeftOutline,
mdiHandBackRight: mdiHandBackRight,
mdiHandBackRightOff: mdiHandBackRightOff,
mdiHandBackRightOffOutline: mdiHandBackRightOffOutline,
mdiHandBackRightOutline: mdiHandBackRightOutline,
mdiHandClap: mdiHandClap,
mdiHandClapOff: mdiHandClapOff,
mdiHandCoin: mdiHandCoin,
mdiHandCoinOutline: mdiHandCoinOutline,
mdiHandCycle: mdiHandCycle,
mdiHandExtended: mdiHandExtended,
mdiHandExtendedOutline: mdiHandExtendedOutline,
mdiHandFrontLeft: mdiHandFrontLeft,
mdiHandFrontLeftOutline: mdiHandFrontLeftOutline,
mdiHandFrontRight: mdiHandFrontRight,
mdiHandFrontRightOutline: mdiHandFrontRightOutline,
mdiHandHeart: mdiHandHeart,
mdiHandHeartOutline: mdiHandHeartOutline,
mdiHandOkay: mdiHandOkay,
mdiHandPeace: mdiHandPeace,
mdiHandPeaceVariant: mdiHandPeaceVariant,
mdiHandPointingDown: mdiHandPointingDown,
mdiHandPointingLeft: mdiHandPointingLeft,
mdiHandPointingRight: mdiHandPointingRight,
mdiHandPointingUp: mdiHandPointingUp,
mdiHandSaw: mdiHandSaw,
mdiHandWash: mdiHandWash,
mdiHandWashOutline: mdiHandWashOutline,
mdiHandWater: mdiHandWater,
mdiHandWave: mdiHandWave,
mdiHandWaveOutline: mdiHandWaveOutline,
mdiHandball: mdiHandball,
mdiHandcuffs: mdiHandcuffs,
mdiHandsPray: mdiHandsPray,
mdiHandshake: mdiHandshake,
mdiHandshakeOutline: mdiHandshakeOutline,
mdiHanger: mdiHanger,
mdiHardHat: mdiHardHat,
mdiHarddisk: mdiHarddisk,
mdiHarddiskPlus: mdiHarddiskPlus,
mdiHarddiskRemove: mdiHarddiskRemove,
mdiHatFedora: mdiHatFedora,
mdiHazardLights: mdiHazardLights,
mdiHdmiPort: mdiHdmiPort,
mdiHdr: mdiHdr,
mdiHdrOff: mdiHdrOff,
mdiHead: mdiHead,
mdiHeadAlert: mdiHeadAlert,
mdiHeadAlertOutline: mdiHeadAlertOutline,
mdiHeadCheck: mdiHeadCheck,
mdiHeadCheckOutline: mdiHeadCheckOutline,
mdiHeadCog: mdiHeadCog,
mdiHeadCogOutline: mdiHeadCogOutline,
mdiHeadDotsHorizontal: mdiHeadDotsHorizontal,
mdiHeadDotsHorizontalOutline: mdiHeadDotsHorizontalOutline,
mdiHeadFlash: mdiHeadFlash,
mdiHeadFlashOutline: mdiHeadFlashOutline,
mdiHeadHeart: mdiHeadHeart,
mdiHeadHeartOutline: mdiHeadHeartOutline,
mdiHeadLightbulb: mdiHeadLightbulb,
mdiHeadLightbulbOutline: mdiHeadLightbulbOutline,
mdiHeadMinus: mdiHeadMinus,
mdiHeadMinusOutline: mdiHeadMinusOutline,
mdiHeadOutline: mdiHeadOutline,
mdiHeadPlus: mdiHeadPlus,
mdiHeadPlusOutline: mdiHeadPlusOutline,
mdiHeadQuestion: mdiHeadQuestion,
mdiHeadQuestionOutline: mdiHeadQuestionOutline,
mdiHeadRemove: mdiHeadRemove,
mdiHeadRemoveOutline: mdiHeadRemoveOutline,
mdiHeadSnowflake: mdiHeadSnowflake,
mdiHeadSnowflakeOutline: mdiHeadSnowflakeOutline,
mdiHeadSync: mdiHeadSync,
mdiHeadSyncOutline: mdiHeadSyncOutline,
mdiHeadphones: mdiHeadphones,
mdiHeadphonesBluetooth: mdiHeadphonesBluetooth,
mdiHeadphonesBox: mdiHeadphonesBox,
mdiHeadphonesOff: mdiHeadphonesOff,
mdiHeadphonesSettings: mdiHeadphonesSettings,
mdiHeadset: mdiHeadset,
mdiHeadsetDock: mdiHeadsetDock,
mdiHeadsetOff: mdiHeadsetOff,
mdiHeart: mdiHeart,
mdiHeartBox: mdiHeartBox,
mdiHeartBoxOutline: mdiHeartBoxOutline,
mdiHeartBroken: mdiHeartBroken,
mdiHeartBrokenOutline: mdiHeartBrokenOutline,
mdiHeartCircle: mdiHeartCircle,
mdiHeartCircleOutline: mdiHeartCircleOutline,
mdiHeartCog: mdiHeartCog,
mdiHeartCogOutline: mdiHeartCogOutline,
mdiHeartFlash: mdiHeartFlash,
mdiHeartHalf: mdiHeartHalf,
mdiHeartHalfFull: mdiHeartHalfFull,
mdiHeartHalfOutline: mdiHeartHalfOutline,
mdiHeartMinus: mdiHeartMinus,
mdiHeartMinusOutline: mdiHeartMinusOutline,
mdiHeartMultiple: mdiHeartMultiple,
mdiHeartMultipleOutline: mdiHeartMultipleOutline,
mdiHeartOff: mdiHeartOff,
mdiHeartOffOutline: mdiHeartOffOutline,
mdiHeartOutline: mdiHeartOutline,
mdiHeartPlus: mdiHeartPlus,
mdiHeartPlusOutline: mdiHeartPlusOutline,
mdiHeartPulse: mdiHeartPulse,
mdiHeartRemove: mdiHeartRemove,
mdiHeartRemoveOutline: mdiHeartRemoveOutline,
mdiHeartSettings: mdiHeartSettings,
mdiHeartSettingsOutline: mdiHeartSettingsOutline,
mdiHeatPump: mdiHeatPump,
mdiHeatPumpOutline: mdiHeatPumpOutline,
mdiHeatWave: mdiHeatWave,
mdiHeatingCoil: mdiHeatingCoil,
mdiHelicopter: mdiHelicopter,
mdiHelp: mdiHelp,
mdiHelpBox: mdiHelpBox,
mdiHelpCircle: mdiHelpCircle,
mdiHelpCircleOutline: mdiHelpCircleOutline,
mdiHelpNetwork: mdiHelpNetwork,
mdiHelpNetworkOutline: mdiHelpNetworkOutline,
mdiHelpRhombus: mdiHelpRhombus,
mdiHelpRhombusOutline: mdiHelpRhombusOutline,
mdiHexadecimal: mdiHexadecimal,
mdiHexagon: mdiHexagon,
mdiHexagonMultiple: mdiHexagonMultiple,
mdiHexagonMultipleOutline: mdiHexagonMultipleOutline,
mdiHexagonOutline: mdiHexagonOutline,
mdiHexagonSlice1: mdiHexagonSlice1,
mdiHexagonSlice2: mdiHexagonSlice2,
mdiHexagonSlice3: mdiHexagonSlice3,
mdiHexagonSlice4: mdiHexagonSlice4,
mdiHexagonSlice5: mdiHexagonSlice5,
mdiHexagonSlice6: mdiHexagonSlice6,
mdiHexagram: mdiHexagram,
mdiHexagramOutline: mdiHexagramOutline,
mdiHighDefinition: mdiHighDefinition,
mdiHighDefinitionBox: mdiHighDefinitionBox,
mdiHighway: mdiHighway,
mdiHiking: mdiHiking,
mdiHistory: mdiHistory,
mdiHockeyPuck: mdiHockeyPuck,
mdiHockeySticks: mdiHockeySticks,
mdiHololens: mdiHololens,
mdiHome: mdiHome,
mdiHomeAccount: mdiHomeAccount,
mdiHomeAlert: mdiHomeAlert,
mdiHomeAlertOutline: mdiHomeAlertOutline,
mdiHomeAnalytics: mdiHomeAnalytics,
mdiHomeAssistant: mdiHomeAssistant,
mdiHomeAutomation: mdiHomeAutomation,
mdiHomeBattery: mdiHomeBattery,
mdiHomeBatteryOutline: mdiHomeBatteryOutline,
mdiHomeCircle: mdiHomeCircle,
mdiHomeCircleOutline: mdiHomeCircleOutline,
mdiHomeCity: mdiHomeCity,
mdiHomeCityOutline: mdiHomeCityOutline,
mdiHomeClock: mdiHomeClock,
mdiHomeClockOutline: mdiHomeClockOutline,
mdiHomeEdit: mdiHomeEdit,
mdiHomeEditOutline: mdiHomeEditOutline,
// mdiHomestring: mdiHomestring,
// mdiHomeFlood: mdiHomeFlood,
mdiHomeFloor0: mdiHomeFloor0,
mdiHomeFloor1: mdiHomeFloor1,
mdiHomeFloor2: mdiHomeFloor2,
mdiHomeFloor3: mdiHomeFloor3,
mdiHomeFloorA: mdiHomeFloorA,
mdiHomeFloorB: mdiHomeFloorB,
mdiHomeFloorG: mdiHomeFloorG,
mdiHomeFloorL: mdiHomeFloorL,
mdiHomeFloorNegative1: mdiHomeFloorNegative1,
mdiHomeGroup: mdiHomeGroup,
mdiHomeGroupMinus: mdiHomeGroupMinus,
mdiHomeGroupPlus: mdiHomeGroupPlus,
mdiHomeGroupRemove: mdiHomeGroupRemove,
mdiHomeHeart: mdiHomeHeart,
mdiHomeImportOutline: mdiHomeImportOutline,
mdiHomeLightbulb: mdiHomeLightbulb,
mdiHomeLightbulbOutline: mdiHomeLightbulbOutline,
mdiHomeLightningBolt: mdiHomeLightningBolt,
mdiHomeLightningBoltOutline: mdiHomeLightningBoltOutline,
mdiHomeLock: mdiHomeLock,
mdiHomeLockOpen: mdiHomeLockOpen,
mdiHomeMapMarker: mdiHomeMapMarker,
mdiHomeMinus: mdiHomeMinus,
mdiHomeMinusOutline: mdiHomeMinusOutline,
mdiHomeModern: mdiHomeModern,
mdiHomeOff: mdiHomeOff,
mdiHomeOffOutline: mdiHomeOffOutline,
mdiHomeOutline: mdiHomeOutline,
mdiHomePlus: mdiHomePlus,
mdiHomePlusOutline: mdiHomePlusOutline,
mdiHomeRemove: mdiHomeRemove,
mdiHomeRemoveOutline: mdiHomeRemoveOutline,
mdiHomeRoof: mdiHomeRoof,
mdiHomeSearch: mdiHomeSearch,
mdiHomeSearchOutline: mdiHomeSearchOutline,
mdiHomeSilo: mdiHomeSilo,
mdiHomeSiloOutline: mdiHomeSiloOutline,
mdiHomeSwitch: mdiHomeSwitch,
mdiHomeSwitchOutline: mdiHomeSwitchOutline,
mdiHomeThermometer: mdiHomeThermometer,
mdiHomeThermometerOutline: mdiHomeThermometerOutline,
mdiHomeVariant: mdiHomeVariant,
mdiHomeVariantOutline: mdiHomeVariantOutline,
mdiHook: mdiHook,
mdiHookOff: mdiHookOff,
mdiHoopHouse: mdiHoopHouse,
mdiHops: mdiHops,
mdiHorizontalRotateClockwise: mdiHorizontalRotateClockwise,
mdiHorizontalRotateCounterclockwise: mdiHorizontalRotateCounterclockwise,
mdiHorse: mdiHorse,
mdiHorseHuman: mdiHorseHuman,
mdiHorseVariant: mdiHorseVariant,
mdiHorseVariantFast: mdiHorseVariantFast,
mdiHorseshoe: mdiHorseshoe,
mdiHospital: mdiHospital,
mdiHospitalBox: mdiHospitalBox,
mdiHospitalBoxOutline: mdiHospitalBoxOutline,
mdiHospitalBuilding: mdiHospitalBuilding,
mdiHospitalMarker: mdiHospitalMarker,
mdiHotTub: mdiHotTub,
mdiHours24: mdiHours24,
mdiHubspot: mdiHubspot,
mdiHulu: mdiHulu,
mdiHuman: mdiHuman,
mdiHumanBabyChangingTable: mdiHumanBabyChangingTable,
mdiHumanCane: mdiHumanCane,
mdiHumanCapacityDecrease: mdiHumanCapacityDecrease,
mdiHumanCapacityIncrease: mdiHumanCapacityIncrease,
mdiHumanChild: mdiHumanChild,
mdiHumanDolly: mdiHumanDolly,
mdiHumanEdit: mdiHumanEdit,
mdiHumanFemale: mdiHumanFemale,
mdiHumanFemaleBoy: mdiHumanFemaleBoy,
mdiHumanFemaleDance: mdiHumanFemaleDance,
mdiHumanFemaleFemale: mdiHumanFemaleFemale,
mdiHumanFemaleGirl: mdiHumanFemaleGirl,
mdiHumanGreeting: mdiHumanGreeting,
mdiHumanGreetingProximity: mdiHumanGreetingProximity,
mdiHumanGreetingVariant: mdiHumanGreetingVariant,
mdiHumanHandsdown: mdiHumanHandsdown,
mdiHumanHandsup: mdiHumanHandsup,
mdiHumanMale: mdiHumanMale,
mdiHumanMaleBoard: mdiHumanMaleBoard,
mdiHumanMaleBoardPoll: mdiHumanMaleBoardPoll,
mdiHumanMaleBoy: mdiHumanMaleBoy,
mdiHumanMaleChild: mdiHumanMaleChild,
mdiHumanMaleFemale: mdiHumanMaleFemale,
mdiHumanMaleFemaleChild: mdiHumanMaleFemaleChild,
mdiHumanMaleGirl: mdiHumanMaleGirl,
mdiHumanMaleHeight: mdiHumanMaleHeight,
mdiHumanMaleHeightVariant: mdiHumanMaleHeightVariant,
mdiHumanMaleMale: mdiHumanMaleMale,
mdiHumanNonBinary: mdiHumanNonBinary,
mdiHumanPregnant: mdiHumanPregnant,
mdiHumanQueue: mdiHumanQueue,
mdiHumanScooter: mdiHumanScooter,
mdiHumanWalker: mdiHumanWalker,
mdiHumanWheelchair: mdiHumanWheelchair,
mdiHumanWhiteCane: mdiHumanWhiteCane,
mdiHumbleBundle: mdiHumbleBundle,
mdiHvac: mdiHvac,
mdiHvacOff: mdiHvacOff,
mdiHydraulicOilLevel: mdiHydraulicOilLevel,
mdiHydraulicOilTemperature: mdiHydraulicOilTemperature,
mdiHydroPower: mdiHydroPower,
mdiHydrogenStation: mdiHydrogenStation,
mdiIceCream: mdiIceCream,
mdiIceCreamOff: mdiIceCreamOff,
mdiIcePop: mdiIcePop,
mdiIdCard: mdiIdCard,
mdiIdentifier: mdiIdentifier,
mdiIdeogramCjk: mdiIdeogramCjk,
mdiIdeogramCjkVariant: mdiIdeogramCjkVariant,
mdiImage: mdiImage,
mdiImageAlbum: mdiImageAlbum,
mdiImageArea: mdiImageArea,
mdiImageAreaClose: mdiImageAreaClose,
mdiImageAutoAdjust: mdiImageAutoAdjust,
mdiImageBroken: mdiImageBroken,
mdiImageBrokenVariant: mdiImageBrokenVariant,
mdiImageCheck: mdiImageCheck,
mdiImageCheckOutline: mdiImageCheckOutline,
mdiImageEdit: mdiImageEdit,
mdiImageEditOutline: mdiImageEditOutline,
mdiImageFilterBlackWhite: mdiImageFilterBlackWhite,
mdiImageFilterCenterFocus: mdiImageFilterCenterFocus,
mdiImageFilterCenterFocusStrong: mdiImageFilterCenterFocusStrong,
mdiImageFilterCenterFocusStrongOutline: mdiImageFilterCenterFocusStrongOutline,
mdiImageFilterCenterFocusWeak: mdiImageFilterCenterFocusWeak,
mdiImageFilterDrama: mdiImageFilterDrama,
mdiImageFilterFrames: mdiImageFilterFrames,
mdiImageFilterHdr: mdiImageFilterHdr,
mdiImageFilterNone: mdiImageFilterNone,
mdiImageFilterTiltShift: mdiImageFilterTiltShift,
mdiImageFilterVintage: mdiImageFilterVintage,
mdiImageFrame: mdiImageFrame,
mdiImageLock: mdiImageLock,
mdiImageLockOutline: mdiImageLockOutline,
mdiImageMarker: mdiImageMarker,
mdiImageMarkerOutline: mdiImageMarkerOutline,
mdiImageMinus: mdiImageMinus,
mdiImageMinusOutline: mdiImageMinusOutline,
mdiImageMove: mdiImageMove,
mdiImageMultiple: mdiImageMultiple,
mdiImageMultipleOutline: mdiImageMultipleOutline,
mdiImageOff: mdiImageOff,
mdiImageOffOutline: mdiImageOffOutline,
mdiImageOutline: mdiImageOutline,
mdiImagePlus: mdiImagePlus,
mdiImagePlusOutline: mdiImagePlusOutline,
mdiImageRefresh: mdiImageRefresh,
mdiImageRefreshOutline: mdiImageRefreshOutline,
mdiImageRemove: mdiImageRemove,
mdiImageRemoveOutline: mdiImageRemoveOutline,
mdiImageSearch: mdiImageSearch,
mdiImageSearchOutline: mdiImageSearchOutline,
mdiImageSizeSelectActual: mdiImageSizeSelectActual,
mdiImageSizeSelectLarge: mdiImageSizeSelectLarge,
mdiImageSizeSelectSmall: mdiImageSizeSelectSmall,
mdiImageSync: mdiImageSync,
mdiImageSyncOutline: mdiImageSyncOutline,
mdiImageText: mdiImageText,
mdiImport: mdiImport,
mdiInbox: mdiInbox,
mdiInboxArrowDown: mdiInboxArrowDown,
mdiInboxArrowDownOutline: mdiInboxArrowDownOutline,
mdiInboxArrowUp: mdiInboxArrowUp,
mdiInboxArrowUpOutline: mdiInboxArrowUpOutline,
mdiInboxFull: mdiInboxFull,
mdiInboxFullOutline: mdiInboxFullOutline,
mdiInboxMultiple: mdiInboxMultiple,
mdiInboxMultipleOutline: mdiInboxMultipleOutline,
mdiInboxOutline: mdiInboxOutline,
mdiInboxRemove: mdiInboxRemove,
mdiInboxRemoveOutline: mdiInboxRemoveOutline,
mdiIncognito: mdiIncognito,
mdiIncognitoCircle: mdiIncognitoCircle,
mdiIncognitoCircleOff: mdiIncognitoCircleOff,
mdiIncognitoOff: mdiIncognitoOff,
mdiInduction: mdiInduction,
mdiInfinity: mdiInfinity,
mdiInformation: mdiInformation,
mdiInformationOff: mdiInformationOff,
mdiInformationOffOutline: mdiInformationOffOutline,
mdiInformationOutline: mdiInformationOutline,
mdiInformationVariant: mdiInformationVariant,
mdiInstagram: mdiInstagram,
mdiInstrumentTriangle: mdiInstrumentTriangle,
mdiIntegratedCircuitChip: mdiIntegratedCircuitChip,
mdiInvertColors: mdiInvertColors,
mdiInvertColorsOff: mdiInvertColorsOff,
mdiIobroker: mdiIobroker,
mdiIp: mdiIp,
mdiIpNetwork: mdiIpNetwork,
mdiIpNetworkOutline: mdiIpNetworkOutline,
mdiIpOutline: mdiIpOutline,
mdiIpod: mdiIpod,
mdiIron: mdiIron,
mdiIronBoard: mdiIronBoard,
mdiIronOutline: mdiIronOutline,
mdiIsland: mdiIsland,
mdiIvBag: mdiIvBag,
mdiJabber: mdiJabber,
mdiJeepney: mdiJeepney,
mdiJellyfish: mdiJellyfish,
mdiJellyfishOutline: mdiJellyfishOutline,
mdiJira: mdiJira,
mdiJquery: mdiJquery,
mdiJsfiddle: mdiJsfiddle,
mdiJumpRope: mdiJumpRope,
mdiKabaddi: mdiKabaddi,
mdiKangaroo: mdiKangaroo,
mdiKarate: mdiKarate,
mdiKayaking: mdiKayaking,
mdiKeg: mdiKeg,
mdiKettle: mdiKettle,
mdiKettleAlert: mdiKettleAlert,
mdiKettleAlertOutline: mdiKettleAlertOutline,
mdiKettleOff: mdiKettleOff,
mdiKettleOffOutline: mdiKettleOffOutline,
mdiKettleOutline: mdiKettleOutline,
mdiKettlePourOver: mdiKettlePourOver,
mdiKettleSteam: mdiKettleSteam,
mdiKettleSteamOutline: mdiKettleSteamOutline,
mdiKettlebell: mdiKettlebell,
mdiKey: mdiKey,
mdiKeyAlert: mdiKeyAlert,
mdiKeyAlertOutline: mdiKeyAlertOutline,
mdiKeyArrowRight: mdiKeyArrowRight,
mdiKeyChain: mdiKeyChain,
mdiKeyChainVariant: mdiKeyChainVariant,
mdiKeyChange: mdiKeyChange,
mdiKeyLink: mdiKeyLink,
mdiKeyMinus: mdiKeyMinus,
mdiKeyOutline: mdiKeyOutline,
mdiKeyPlus: mdiKeyPlus,
mdiKeyRemove: mdiKeyRemove,
mdiKeyStar: mdiKeyStar,
mdiKeyVariant: mdiKeyVariant,
mdiKeyWireless: mdiKeyWireless,
mdiKeyboard: mdiKeyboard,
mdiKeyboardBackspace: mdiKeyboardBackspace,
mdiKeyboardCaps: mdiKeyboardCaps,
mdiKeyboardClose: mdiKeyboardClose,
mdiKeyboardEsc: mdiKeyboardEsc,
mdiKeyboardF1: mdiKeyboardF1,
mdiKeyboardF10: mdiKeyboardF10,
mdiKeyboardF11: mdiKeyboardF11,
mdiKeyboardF12: mdiKeyboardF12,
mdiKeyboardF2: mdiKeyboardF2,
mdiKeyboardF3: mdiKeyboardF3,
mdiKeyboardF4: mdiKeyboardF4,
mdiKeyboardF5: mdiKeyboardF5,
mdiKeyboardF6: mdiKeyboardF6,
mdiKeyboardF7: mdiKeyboardF7,
mdiKeyboardF8: mdiKeyboardF8,
mdiKeyboardF9: mdiKeyboardF9,
mdiKeyboardOff: mdiKeyboardOff,
mdiKeyboardOffOutline: mdiKeyboardOffOutline,
mdiKeyboardOutline: mdiKeyboardOutline,
mdiKeyboardReturn: mdiKeyboardReturn,
mdiKeyboardSettings: mdiKeyboardSettings,
mdiKeyboardSettingsOutline: mdiKeyboardSettingsOutline,
mdiKeyboardSpace: mdiKeyboardSpace,
mdiKeyboardTab: mdiKeyboardTab,
mdiKeyboardTabReverse: mdiKeyboardTabReverse,
mdiKeyboardVariant: mdiKeyboardVariant,
mdiKhanda: mdiKhanda,
mdiKickstarter: mdiKickstarter,
mdiKite: mdiKite,
mdiKiteOutline: mdiKiteOutline,
mdiKitesurfing: mdiKitesurfing,
mdiKlingon: mdiKlingon,
mdiKnife: mdiKnife,
mdiKnifeMilitary: mdiKnifeMilitary,
mdiKnob: mdiKnob,
mdiKoala: mdiKoala,
mdiKodi: mdiKodi,
mdiKubernetes: mdiKubernetes,
mdiLabel: mdiLabel,
mdiLabelMultiple: mdiLabelMultiple,
mdiLabelMultipleOutline: mdiLabelMultipleOutline,
mdiLabelOff: mdiLabelOff,
mdiLabelOffOutline: mdiLabelOffOutline,
mdiLabelOutline: mdiLabelOutline,
mdiLabelPercent: mdiLabelPercent,
mdiLabelPercentOutline: mdiLabelPercentOutline,
mdiLabelVariant: mdiLabelVariant,
mdiLabelVariantOutline: mdiLabelVariantOutline,
mdiLadder: mdiLadder,
mdiLadybug: mdiLadybug,
mdiLambda: mdiLambda,
mdiLamp: mdiLamp,
mdiLampOutline: mdiLampOutline,
mdiLamps: mdiLamps,
mdiLampsOutline: mdiLampsOutline,
mdiLan: mdiLan,
mdiLanCheck: mdiLanCheck,
mdiLanConnect: mdiLanConnect,
mdiLanDisconnect: mdiLanDisconnect,
mdiLanPending: mdiLanPending,
mdiLandFields: mdiLandFields,
mdiLandPlots: mdiLandPlots,
mdiLandPlotsCircle: mdiLandPlotsCircle,
mdiLandPlotsCircleVariant: mdiLandPlotsCircleVariant,
mdiLandRowsHorizontal: mdiLandRowsHorizontal,
mdiLandRowsVertical: mdiLandRowsVertical,
mdiLandslide: mdiLandslide,
mdiLandslideOutline: mdiLandslideOutline,
mdiLanguageC: mdiLanguageC,
mdiLanguageCpp: mdiLanguageCpp,
mdiLanguageCsharp: mdiLanguageCsharp,
mdiLanguageCss3: mdiLanguageCss3,
mdiLanguageFortran: mdiLanguageFortran,
mdiLanguageGo: mdiLanguageGo,
mdiLanguageHaskell: mdiLanguageHaskell,
mdiLanguageHtml5: mdiLanguageHtml5,
mdiLanguageJava: mdiLanguageJava,
mdiLanguageJavascript: mdiLanguageJavascript,
mdiLanguageKotlin: mdiLanguageKotlin,
mdiLanguageLua: mdiLanguageLua,
mdiLanguageMarkdown: mdiLanguageMarkdown,
mdiLanguageMarkdownOutline: mdiLanguageMarkdownOutline,
mdiLanguagePhp: mdiLanguagePhp,
mdiLanguagePython: mdiLanguagePython,
mdiLanguageR: mdiLanguageR,
mdiLanguageRuby: mdiLanguageRuby,
mdiLanguageRubyOnRails: mdiLanguageRubyOnRails,
mdiLanguageRust: mdiLanguageRust,
mdiLanguageSwift: mdiLanguageSwift,
mdiLanguageTypescript: mdiLanguageTypescript,
mdiLanguageXaml: mdiLanguageXaml,
mdiLaptop: mdiLaptop,
mdiLaptopAccount: mdiLaptopAccount,
mdiLaptopOff: mdiLaptopOff,
mdiLaravel: mdiLaravel,
mdiLaserPointer: mdiLaserPointer,
mdiLasso: mdiLasso,
mdiLastpass: mdiLastpass,
mdiLatitude: mdiLatitude,
mdiLaunch: mdiLaunch,
mdiLavaLamp: mdiLavaLamp,
mdiLayers: mdiLayers,
mdiLayersEdit: mdiLayersEdit,
mdiLayersMinus: mdiLayersMinus,
mdiLayersOff: mdiLayersOff,
mdiLayersOffOutline: mdiLayersOffOutline,
mdiLayersOutline: mdiLayersOutline,
mdiLayersPlus: mdiLayersPlus,
mdiLayersRemove: mdiLayersRemove,
mdiLayersSearch: mdiLayersSearch,
mdiLayersSearchOutline: mdiLayersSearchOutline,
mdiLayersTriple: mdiLayersTriple,
mdiLayersTripleOutline: mdiLayersTripleOutline,
mdiLeadPencil: mdiLeadPencil,
mdiLeaf: mdiLeaf,
mdiLeafCircle: mdiLeafCircle,
mdiLeafCircleOutline: mdiLeafCircleOutline,
mdiLeafMaple: mdiLeafMaple,
mdiLeafMapleOff: mdiLeafMapleOff,
mdiLeafOff: mdiLeafOff,
mdiLeak: mdiLeak,
mdiLeakOff: mdiLeakOff,
mdiLectern: mdiLectern,
mdiLedOff: mdiLedOff,
mdiLedOn: mdiLedOn,
mdiLedOutline: mdiLedOutline,
mdiLedStrip: mdiLedStrip,
mdiLedStripVariant: mdiLedStripVariant,
mdiLedStripVariantOff: mdiLedStripVariantOff,
mdiLedVariantOff: mdiLedVariantOff,
mdiLedVariantOn: mdiLedVariantOn,
mdiLedVariantOutline: mdiLedVariantOutline,
mdiLeek: mdiLeek,
mdiLessThan: mdiLessThan,
mdiLessThanOrEqual: mdiLessThanOrEqual,
mdiLibrary: mdiLibrary,
mdiLibraryOutline: mdiLibraryOutline,
mdiLibraryShelves: mdiLibraryShelves,
mdiLicense: mdiLicense,
mdiLifebuoy: mdiLifebuoy,
mdiLightFloodDown: mdiLightFloodDown,
mdiLightFloodUp: mdiLightFloodUp,
mdiLightRecessed: mdiLightRecessed,
mdiLightSwitch: mdiLightSwitch,
mdiLightSwitchOff: mdiLightSwitchOff,
mdiLightbulb: mdiLightbulb,
mdiLightbulbAlert: mdiLightbulbAlert,
mdiLightbulbAlertOutline: mdiLightbulbAlertOutline,
mdiLightbulbAuto: mdiLightbulbAuto,
mdiLightbulbAutoOutline: mdiLightbulbAutoOutline,
mdiLightbulbCfl: mdiLightbulbCfl,
mdiLightbulbCflOff: mdiLightbulbCflOff,
mdiLightbulbCflSpiral: mdiLightbulbCflSpiral,
mdiLightbulbCflSpiralOff: mdiLightbulbCflSpiralOff,
mdiLightbulbFluorescentTube: mdiLightbulbFluorescentTube,
mdiLightbulbFluorescentTubeOutline: mdiLightbulbFluorescentTubeOutline,
mdiLightbulbGroup: mdiLightbulbGroup,
mdiLightbulbGroupOff: mdiLightbulbGroupOff,
mdiLightbulbGroupOffOutline: mdiLightbulbGroupOffOutline,
mdiLightbulbGroupOutline: mdiLightbulbGroupOutline,
mdiLightbulbMultiple: mdiLightbulbMultiple,
mdiLightbulbMultipleOff: mdiLightbulbMultipleOff,
mdiLightbulbMultipleOffOutline: mdiLightbulbMultipleOffOutline,
mdiLightbulbMultipleOutline: mdiLightbulbMultipleOutline,
mdiLightbulbNight: mdiLightbulbNight,
mdiLightbulbNightOutline: mdiLightbulbNightOutline,
mdiLightbulbOff: mdiLightbulbOff,
mdiLightbulbOffOutline: mdiLightbulbOffOutline,
mdiLightbulbOn: mdiLightbulbOn,
mdiLightbulbOn10: mdiLightbulbOn10,
mdiLightbulbOn20: mdiLightbulbOn20,
mdiLightbulbOn30: mdiLightbulbOn30,
mdiLightbulbOn40: mdiLightbulbOn40,
mdiLightbulbOn50: mdiLightbulbOn50,
mdiLightbulbOn60: mdiLightbulbOn60,
mdiLightbulbOn70: mdiLightbulbOn70,
mdiLightbulbOn80: mdiLightbulbOn80,
mdiLightbulbOn90: mdiLightbulbOn90,
mdiLightbulbOnOutline: mdiLightbulbOnOutline,
mdiLightbulbOutline: mdiLightbulbOutline,
mdiLightbulbQuestion: mdiLightbulbQuestion,
mdiLightbulbQuestionOutline: mdiLightbulbQuestionOutline,
mdiLightbulbSpot: mdiLightbulbSpot,
mdiLightbulbSpotOff: mdiLightbulbSpotOff,
mdiLightbulbVariant: mdiLightbulbVariant,
mdiLightbulbVariantOutline: mdiLightbulbVariantOutline,
mdiLighthouse: mdiLighthouse,
mdiLighthouseOn: mdiLighthouseOn,
mdiLightningBolt: mdiLightningBolt,
mdiLightningBoltCircle: mdiLightningBoltCircle,
mdiLightningBoltOutline: mdiLightningBoltOutline,
mdiLineScan: mdiLineScan,
mdiLingerie: mdiLingerie,
mdiLink: mdiLink,
mdiLinkBox: mdiLinkBox,
mdiLinkBoxOutline: mdiLinkBoxOutline,
mdiLinkBoxVariant: mdiLinkBoxVariant,
mdiLinkBoxVariantOutline: mdiLinkBoxVariantOutline,
mdiLinkLock: mdiLinkLock,
mdiLinkOff: mdiLinkOff,
mdiLinkPlus: mdiLinkPlus,
mdiLinkVariant: mdiLinkVariant,
mdiLinkVariantMinus: mdiLinkVariantMinus,
mdiLinkVariantOff: mdiLinkVariantOff,
mdiLinkVariantPlus: mdiLinkVariantPlus,
mdiLinkVariantRemove: mdiLinkVariantRemove,
mdiLinkedin: mdiLinkedin,
mdiLinux: mdiLinux,
mdiLinuxMint: mdiLinuxMint,
mdiLipstick: mdiLipstick,
mdiLiquidSpot: mdiLiquidSpot,
mdiLiquor: mdiLiquor,
mdiListBox: mdiListBox,
mdiListBoxOutline: mdiListBoxOutline,
mdiListStatus: mdiListStatus,
mdiLitecoin: mdiLitecoin,
mdiLoading: mdiLoading,
mdiLocationEnter: mdiLocationEnter,
mdiLocationExit: mdiLocationExit,
mdiLock: mdiLock,
mdiLockAlert: mdiLockAlert,
mdiLockAlertOutline: mdiLockAlertOutline,
mdiLockCheck: mdiLockCheck,
mdiLockCheckOutline: mdiLockCheckOutline,
mdiLockClock: mdiLockClock,
mdiLockMinus: mdiLockMinus,
mdiLockMinusOutline: mdiLockMinusOutline,
mdiLockOff: mdiLockOff,
mdiLockOffOutline: mdiLockOffOutline,
mdiLockOpen: mdiLockOpen,
mdiLockOpenAlert: mdiLockOpenAlert,
mdiLockOpenAlertOutline: mdiLockOpenAlertOutline,
mdiLockOpenCheck: mdiLockOpenCheck,
mdiLockOpenCheckOutline: mdiLockOpenCheckOutline,
mdiLockOpenMinus: mdiLockOpenMinus,
mdiLockOpenMinusOutline: mdiLockOpenMinusOutline,
mdiLockOpenOutline: mdiLockOpenOutline,
mdiLockOpenPlus: mdiLockOpenPlus,
mdiLockOpenPlusOutline: mdiLockOpenPlusOutline,
mdiLockOpenRemove: mdiLockOpenRemove,
mdiLockOpenRemoveOutline: mdiLockOpenRemoveOutline,
mdiLockOpenVariant: mdiLockOpenVariant,
mdiLockOpenVariantOutline: mdiLockOpenVariantOutline,
mdiLockOutline: mdiLockOutline,
mdiLockPattern: mdiLockPattern,
mdiLockPlus: mdiLockPlus,
mdiLockPlusOutline: mdiLockPlusOutline,
mdiLockQuestion: mdiLockQuestion,
mdiLockRemove: mdiLockRemove,
mdiLockRemoveOutline: mdiLockRemoveOutline,
mdiLockReset: mdiLockReset,
mdiLockSmart: mdiLockSmart,
mdiLocker: mdiLocker,
mdiLockerMultiple: mdiLockerMultiple,
mdiLogin: mdiLogin,
mdiLoginVariant: mdiLoginVariant,
mdiLogout: mdiLogout,
mdiLogoutVariant: mdiLogoutVariant,
mdiLongitude: mdiLongitude,
mdiLooks: mdiLooks,
mdiLotion: mdiLotion,
mdiLotionOutline: mdiLotionOutline,
mdiLotionPlus: mdiLotionPlus,
mdiLotionPlusOutline: mdiLotionPlusOutline,
mdiLoupe: mdiLoupe,
mdiLumx: mdiLumx,
mdiLungs: mdiLungs,
mdiMace: mdiMace,
mdiMagazinePistol: mdiMagazinePistol,
mdiMagazineRifle: mdiMagazineRifle,
mdiMagicStaff: mdiMagicStaff,
mdiMagnet: mdiMagnet,
mdiMagnetOn: mdiMagnetOn,
mdiMagnify: mdiMagnify,
mdiMagnifyClose: mdiMagnifyClose,
mdiMagnifyExpand: mdiMagnifyExpand,
mdiMagnifyMinus: mdiMagnifyMinus,
mdiMagnifyMinusCursor: mdiMagnifyMinusCursor,
mdiMagnifyMinusOutline: mdiMagnifyMinusOutline,
mdiMagnifyPlus: mdiMagnifyPlus,
mdiMagnifyPlusCursor: mdiMagnifyPlusCursor,
mdiMagnifyPlusOutline: mdiMagnifyPlusOutline,
mdiMagnifyRemoveCursor: mdiMagnifyRemoveCursor,
mdiMagnifyRemoveOutline: mdiMagnifyRemoveOutline,
mdiMagnifyScan: mdiMagnifyScan,
mdiMail: mdiMail,
mdiMailbox: mdiMailbox,
mdiMailboxOpen: mdiMailboxOpen,
mdiMailboxOpenOutline: mdiMailboxOpenOutline,
mdiMailboxOpenUp: mdiMailboxOpenUp,
mdiMailboxOpenUpOutline: mdiMailboxOpenUpOutline,
mdiMailboxOutline: mdiMailboxOutline,
mdiMailboxUp: mdiMailboxUp,
mdiMailboxUpOutline: mdiMailboxUpOutline,
mdiManjaro: mdiManjaro,
mdiMap: mdiMap,
mdiMapCheck: mdiMapCheck,
mdiMapCheckOutline: mdiMapCheckOutline,
mdiMapClock: mdiMapClock,
mdiMapClockOutline: mdiMapClockOutline,
mdiMapLegend: mdiMapLegend,
mdiMapMarker: mdiMapMarker,
mdiMapMarkerAccount: mdiMapMarkerAccount,
mdiMapMarkerAccountOutline: mdiMapMarkerAccountOutline,
mdiMapMarkerAlert: mdiMapMarkerAlert,
mdiMapMarkerAlertOutline: mdiMapMarkerAlertOutline,
mdiMapMarkerCheck: mdiMapMarkerCheck,
mdiMapMarkerCheckOutline: mdiMapMarkerCheckOutline,
mdiMapMarkerCircle: mdiMapMarkerCircle,
mdiMapMarkerDistance: mdiMapMarkerDistance,
mdiMapMarkerDown: mdiMapMarkerDown,
mdiMapMarkerLeft: mdiMapMarkerLeft,
mdiMapMarkerLeftOutline: mdiMapMarkerLeftOutline,
mdiMapMarkerMinus: mdiMapMarkerMinus,
mdiMapMarkerMinusOutline: mdiMapMarkerMinusOutline,
mdiMapMarkerMultiple: mdiMapMarkerMultiple,
mdiMapMarkerMultipleOutline: mdiMapMarkerMultipleOutline,
mdiMapMarkerOff: mdiMapMarkerOff,
mdiMapMarkerOffOutline: mdiMapMarkerOffOutline,
mdiMapMarkerOutline: mdiMapMarkerOutline,
mdiMapMarkerPath: mdiMapMarkerPath,
mdiMapMarkerPlus: mdiMapMarkerPlus,
mdiMapMarkerPlusOutline: mdiMapMarkerPlusOutline,
mdiMapMarkerQuestion: mdiMapMarkerQuestion,
mdiMapMarkerQuestionOutline: mdiMapMarkerQuestionOutline,
mdiMapMarkerRadius: mdiMapMarkerRadius,
mdiMapMarkerRadiusOutline: mdiMapMarkerRadiusOutline,
mdiMapMarkerRemove: mdiMapMarkerRemove,
mdiMapMarkerRemoveOutline: mdiMapMarkerRemoveOutline,
mdiMapMarkerRemoveVariant: mdiMapMarkerRemoveVariant,
mdiMapMarkerRight: mdiMapMarkerRight,
mdiMapMarkerRightOutline: mdiMapMarkerRightOutline,
mdiMapMarkerStar: mdiMapMarkerStar,
mdiMapMarkerStarOutline: mdiMapMarkerStarOutline,
mdiMapMarkerUp: mdiMapMarkerUp,
mdiMapMinus: mdiMapMinus,
mdiMapOutline: mdiMapOutline,
mdiMapPlus: mdiMapPlus,
mdiMapSearch: mdiMapSearch,
mdiMapSearchOutline: mdiMapSearchOutline,
mdiMapbox: mdiMapbox,
mdiMargin: mdiMargin,
mdiMarker: mdiMarker,
mdiMarkerCancel: mdiMarkerCancel,
mdiMarkerCheck: mdiMarkerCheck,
mdiMastodon: mdiMastodon,
mdiMaterialDesign: mdiMaterialDesign,
mdiMaterialUi: mdiMaterialUi,
mdiMathCompass: mdiMathCompass,
mdiMathCos: mdiMathCos,
mdiMathIntegral: mdiMathIntegral,
mdiMathIntegralBox: mdiMathIntegralBox,
mdiMathLog: mdiMathLog,
mdiMathNorm: mdiMathNorm,
mdiMathNormBox: mdiMathNormBox,
mdiMathSin: mdiMathSin,
mdiMathTan: mdiMathTan,
mdiMatrix: mdiMatrix,
mdiMedal: mdiMedal,
mdiMedalOutline: mdiMedalOutline,
mdiMedicalBag: mdiMedicalBag,
mdiMedicalCottonSwab: mdiMedicalCottonSwab,
mdiMedication: mdiMedication,
mdiMedicationOutline: mdiMedicationOutline,
mdiMeditation: mdiMeditation,
mdiMemory: mdiMemory,
mdiMenorah: mdiMenorah,
mdiMenorahFire: mdiMenorahFire,
mdiMenu: mdiMenu,
mdiMenuDown: mdiMenuDown,
mdiMenuDownOutline: mdiMenuDownOutline,
mdiMenuLeft: mdiMenuLeft,
mdiMenuLeftOutline: mdiMenuLeftOutline,
mdiMenuOpen: mdiMenuOpen,
mdiMenuRight: mdiMenuRight,
mdiMenuRightOutline: mdiMenuRightOutline,
mdiMenuSwap: mdiMenuSwap,
mdiMenuSwapOutline: mdiMenuSwapOutline,
mdiMenuUp: mdiMenuUp,
mdiMenuUpOutline: mdiMenuUpOutline,
mdiMerge: mdiMerge,
mdiMessage: mdiMessage,
mdiMessageAlert: mdiMessageAlert,
mdiMessageAlertOutline: mdiMessageAlertOutline,
mdiMessageArrowLeft: mdiMessageArrowLeft,
mdiMessageArrowLeftOutline: mdiMessageArrowLeftOutline,
mdiMessageArrowRight: mdiMessageArrowRight,
mdiMessageArrowRightOutline: mdiMessageArrowRightOutline,
mdiMessageBadge: mdiMessageBadge,
mdiMessageBadgeOutline: mdiMessageBadgeOutline,
mdiMessageBookmark: mdiMessageBookmark,
mdiMessageBookmarkOutline: mdiMessageBookmarkOutline,
mdiMessageBulleted: mdiMessageBulleted,
mdiMessageBulletedOff: mdiMessageBulletedOff,
mdiMessageCheck: mdiMessageCheck,
mdiMessageCheckOutline: mdiMessageCheckOutline,
mdiMessageCog: mdiMessageCog,
mdiMessageCogOutline: mdiMessageCogOutline,
mdiMessageDraw: mdiMessageDraw,
mdiMessageFast: mdiMessageFast,
mdiMessageFastOutline: mdiMessageFastOutline,
mdiMessageFlash: mdiMessageFlash,
mdiMessageFlashOutline: mdiMessageFlashOutline,
mdiMessageImage: mdiMessageImage,
mdiMessageImageOutline: mdiMessageImageOutline,
mdiMessageLock: mdiMessageLock,
mdiMessageLockOutline: mdiMessageLockOutline,
mdiMessageMinus: mdiMessageMinus,
mdiMessageMinusOutline: mdiMessageMinusOutline,
mdiMessageOff: mdiMessageOff,
mdiMessageOffOutline: mdiMessageOffOutline,
mdiMessageOutline: mdiMessageOutline,
mdiMessagePlus: mdiMessagePlus,
mdiMessagePlusOutline: mdiMessagePlusOutline,
mdiMessageProcessing: mdiMessageProcessing,
mdiMessageProcessingOutline: mdiMessageProcessingOutline,
mdiMessageQuestion: mdiMessageQuestion,
mdiMessageQuestionOutline: mdiMessageQuestionOutline,
mdiMessageReply: mdiMessageReply,
mdiMessageReplyOutline: mdiMessageReplyOutline,
mdiMessageReplyText: mdiMessageReplyText,
mdiMessageReplyTextOutline: mdiMessageReplyTextOutline,
mdiMessageSettings: mdiMessageSettings,
mdiMessageSettingsOutline: mdiMessageSettingsOutline,
mdiMessageStar: mdiMessageStar,
mdiMessageStarOutline: mdiMessageStarOutline,
mdiMessageText: mdiMessageText,
mdiMessageTextClock: mdiMessageTextClock,
mdiMessageTextClockOutline: mdiMessageTextClockOutline,
mdiMessageTextFast: mdiMessageTextFast,
mdiMessageTextFastOutline: mdiMessageTextFastOutline,
mdiMessageTextLock: mdiMessageTextLock,
mdiMessageTextLockOutline: mdiMessageTextLockOutline,
mdiMessageTextOutline: mdiMessageTextOutline,
mdiMessageVideo: mdiMessageVideo,
mdiMeteor: mdiMeteor,
mdiMeterElectric: mdiMeterElectric,
mdiMeterElectricOutline: mdiMeterElectricOutline,
mdiMeterGas: mdiMeterGas,
mdiMeterGasOutline: mdiMeterGasOutline,
mdiMetronome: mdiMetronome,
mdiMetronomeTick: mdiMetronomeTick,
mdiMicroSd: mdiMicroSd,
mdiMicrophone: mdiMicrophone,
mdiMicrophoneMessage: mdiMicrophoneMessage,
mdiMicrophoneMessageOff: mdiMicrophoneMessageOff,
mdiMicrophoneMinus: mdiMicrophoneMinus,
mdiMicrophoneOff: mdiMicrophoneOff,
mdiMicrophoneOutline: mdiMicrophoneOutline,
mdiMicrophonePlus: mdiMicrophonePlus,
mdiMicrophoneQuestion: mdiMicrophoneQuestion,
mdiMicrophoneQuestionOutline: mdiMicrophoneQuestionOutline,
mdiMicrophoneSettings: mdiMicrophoneSettings,
mdiMicrophoneVariant: mdiMicrophoneVariant,
mdiMicrophoneVariantOff: mdiMicrophoneVariantOff,
mdiMicroscope: mdiMicroscope,
mdiMicrosoft: mdiMicrosoft,
mdiMicrosoftAccess: mdiMicrosoftAccess,
mdiMicrosoftAzure: mdiMicrosoftAzure,
mdiMicrosoftAzureDevops: mdiMicrosoftAzureDevops,
mdiMicrosoftBing: mdiMicrosoftBing,
mdiMicrosoftDynamics365: mdiMicrosoftDynamics365,
mdiMicrosoftEdge: mdiMicrosoftEdge,
mdiMicrosoftExcel: mdiMicrosoftExcel,
mdiMicrosoftInternetExplorer: mdiMicrosoftInternetExplorer,
mdiMicrosoftOffice: mdiMicrosoftOffice,
mdiMicrosoftOnedrive: mdiMicrosoftOnedrive,
mdiMicrosoftOnenote: mdiMicrosoftOnenote,
mdiMicrosoftOutlook: mdiMicrosoftOutlook,
mdiMicrosoftPowerpoint: mdiMicrosoftPowerpoint,
mdiMicrosoftSharepoint: mdiMicrosoftSharepoint,
mdiMicrosoftTeams: mdiMicrosoftTeams,
mdiMicrosoftVisualStudio: mdiMicrosoftVisualStudio,
mdiMicrosoftVisualStudioCode: mdiMicrosoftVisualStudioCode,
mdiMicrosoftWindows: mdiMicrosoftWindows,
mdiMicrosoftWindowsClassic: mdiMicrosoftWindowsClassic,
mdiMicrosoftWord: mdiMicrosoftWord,
mdiMicrosoftXbox: mdiMicrosoftXbox,
mdiMicrosoftXboxController: mdiMicrosoftXboxController,
mdiMicrosoftXboxControllerBatteryAlert: mdiMicrosoftXboxControllerBatteryAlert,
mdiMicrosoftXboxControllerBatteryCharging: mdiMicrosoftXboxControllerBatteryCharging,
mdiMicrosoftXboxControllerBatteryEmpty: mdiMicrosoftXboxControllerBatteryEmpty,
mdiMicrosoftXboxControllerBatteryFull: mdiMicrosoftXboxControllerBatteryFull,
mdiMicrosoftXboxControllerBatteryLow: mdiMicrosoftXboxControllerBatteryLow,
mdiMicrosoftXboxControllerBatteryMedium: mdiMicrosoftXboxControllerBatteryMedium,
mdiMicrosoftXboxControllerBatteryUnknown: mdiMicrosoftXboxControllerBatteryUnknown,
mdiMicrosoftXboxControllerMenu: mdiMicrosoftXboxControllerMenu,
mdiMicrosoftXboxControllerOff: mdiMicrosoftXboxControllerOff,
mdiMicrosoftXboxControllerView: mdiMicrosoftXboxControllerView,
mdiMicrowave: mdiMicrowave,
mdiMicrowaveOff: mdiMicrowaveOff,
mdiMiddleware: mdiMiddleware,
mdiMiddlewareOutline: mdiMiddlewareOutline,
mdiMidi: mdiMidi,
mdiMidiPort: mdiMidiPort,
mdiMine: mdiMine,
mdiMinecraft: mdiMinecraft,
mdiMiniSd: mdiMiniSd,
mdiMinidisc: mdiMinidisc,
mdiMinus: mdiMinus,
mdiMinusBox: mdiMinusBox,
mdiMinusBoxMultiple: mdiMinusBoxMultiple,
mdiMinusBoxMultipleOutline: mdiMinusBoxMultipleOutline,
mdiMinusBoxOutline: mdiMinusBoxOutline,
mdiMinusCircle: mdiMinusCircle,
mdiMinusCircleMultiple: mdiMinusCircleMultiple,
mdiMinusCircleMultipleOutline: mdiMinusCircleMultipleOutline,
mdiMinusCircleOff: mdiMinusCircleOff,
mdiMinusCircleOffOutline: mdiMinusCircleOffOutline,
mdiMinusCircleOutline: mdiMinusCircleOutline,
mdiMinusNetwork: mdiMinusNetwork,
mdiMinusNetworkOutline: mdiMinusNetworkOutline,
mdiMinusThick: mdiMinusThick,
mdiMirror: mdiMirror,
mdiMirrorRectangle: mdiMirrorRectangle,
mdiMirrorVariant: mdiMirrorVariant,
mdiMixedMartialArts: mdiMixedMartialArts,
mdiMixedReality: mdiMixedReality,
mdiMolecule: mdiMolecule,
mdiMoleculeCo: mdiMoleculeCo,
mdiMoleculeCo2: mdiMoleculeCo2,
mdiMonitor: mdiMonitor,
mdiMonitorAccount: mdiMonitorAccount,
mdiMonitorArrowDown: mdiMonitorArrowDown,
mdiMonitorArrowDownVariant: mdiMonitorArrowDownVariant,
mdiMonitorCellphone: mdiMonitorCellphone,
mdiMonitorCellphoneStar: mdiMonitorCellphoneStar,
mdiMonitorDashboard: mdiMonitorDashboard,
mdiMonitorEdit: mdiMonitorEdit,
mdiMonitorEye: mdiMonitorEye,
mdiMonitorLock: mdiMonitorLock,
mdiMonitorMultiple: mdiMonitorMultiple,
mdiMonitorOff: mdiMonitorOff,
mdiMonitorScreenshot: mdiMonitorScreenshot,
mdiMonitorShare: mdiMonitorShare,
mdiMonitorShimmer: mdiMonitorShimmer,
mdiMonitorSmall: mdiMonitorSmall,
mdiMonitorSpeaker: mdiMonitorSpeaker,
mdiMonitorSpeakerOff: mdiMonitorSpeakerOff,
mdiMonitorStar: mdiMonitorStar,
mdiMoonFirstQuarter: mdiMoonFirstQuarter,
mdiMoonFull: mdiMoonFull,
mdiMoonLastQuarter: mdiMoonLastQuarter,
mdiMoonNew: mdiMoonNew,
mdiMoonWaningCrescent: mdiMoonWaningCrescent,
mdiMoonWaningGibbous: mdiMoonWaningGibbous,
mdiMoonWaxingCrescent: mdiMoonWaxingCrescent,
mdiMoonWaxingGibbous: mdiMoonWaxingGibbous,
mdiMoped: mdiMoped,
mdiMopedElectric: mdiMopedElectric,
mdiMopedElectricOutline: mdiMopedElectricOutline,
mdiMopedOutline: mdiMopedOutline,
mdiMore: mdiMore,
mdiMortarPestle: mdiMortarPestle,
mdiMortarPestlePlus: mdiMortarPestlePlus,
mdiMosque: mdiMosque,
mdiMosqueOutline: mdiMosqueOutline,
mdiMotherHeart: mdiMotherHeart,
mdiMotherNurse: mdiMotherNurse,
mdiMotion: mdiMotion,
mdiMotionOutline: mdiMotionOutline,
mdiMotionPause: mdiMotionPause,
mdiMotionPauseOutline: mdiMotionPauseOutline,
mdiMotionPlay: mdiMotionPlay,
mdiMotionPlayOutline: mdiMotionPlayOutline,
mdiMotionSensor: mdiMotionSensor,
mdiMotionSensorOff: mdiMotionSensorOff,
mdiMotorbike: mdiMotorbike,
mdiMotorbikeElectric: mdiMotorbikeElectric,
mdiMotorbikeOff: mdiMotorbikeOff,
mdiMouse: mdiMouse,
mdiMouseBluetooth: mdiMouseBluetooth,
mdiMouseMoveDown: mdiMouseMoveDown,
mdiMouseMoveUp: mdiMouseMoveUp,
mdiMouseMoveVertical: mdiMouseMoveVertical,
mdiMouseOff: mdiMouseOff,
mdiMouseVariant: mdiMouseVariant,
mdiMouseVariantOff: mdiMouseVariantOff,
mdiMoveResize: mdiMoveResize,
mdiMoveResizeVariant: mdiMoveResizeVariant,
mdiMovie: mdiMovie,
mdiMovieCheck: mdiMovieCheck,
mdiMovieCheckOutline: mdiMovieCheckOutline,
mdiMovieCog: mdiMovieCog,
mdiMovieCogOutline: mdiMovieCogOutline,
mdiMovieEdit: mdiMovieEdit,
mdiMovieEditOutline: mdiMovieEditOutline,
mdiMovieFilter: mdiMovieFilter,
mdiMovieFilterOutline: mdiMovieFilterOutline,
mdiMovieMinus: mdiMovieMinus,
mdiMovieMinusOutline: mdiMovieMinusOutline,
mdiMovieOff: mdiMovieOff,
mdiMovieOffOutline: mdiMovieOffOutline,
mdiMovieOpen: mdiMovieOpen,
mdiMovieOpenCheck: mdiMovieOpenCheck,
mdiMovieOpenCheckOutline: mdiMovieOpenCheckOutline,
mdiMovieOpenCog: mdiMovieOpenCog,
mdiMovieOpenCogOutline: mdiMovieOpenCogOutline,
mdiMovieOpenEdit: mdiMovieOpenEdit,
mdiMovieOpenEditOutline: mdiMovieOpenEditOutline,
mdiMovieOpenMinus: mdiMovieOpenMinus,
mdiMovieOpenMinusOutline: mdiMovieOpenMinusOutline,
mdiMovieOpenOff: mdiMovieOpenOff,
mdiMovieOpenOffOutline: mdiMovieOpenOffOutline,
mdiMovieOpenOutline: mdiMovieOpenOutline,
mdiMovieOpenPlay: mdiMovieOpenPlay,
mdiMovieOpenPlayOutline: mdiMovieOpenPlayOutline,
mdiMovieOpenPlus: mdiMovieOpenPlus,
mdiMovieOpenPlusOutline: mdiMovieOpenPlusOutline,
mdiMovieOpenRemove: mdiMovieOpenRemove,
mdiMovieOpenRemoveOutline: mdiMovieOpenRemoveOutline,
mdiMovieOpenSettings: mdiMovieOpenSettings,
mdiMovieOpenSettingsOutline: mdiMovieOpenSettingsOutline,
mdiMovieOpenStar: mdiMovieOpenStar,
mdiMovieOpenStarOutline: mdiMovieOpenStarOutline,
mdiMovieOutline: mdiMovieOutline,
mdiMoviePlay: mdiMoviePlay,
mdiMoviePlayOutline: mdiMoviePlayOutline,
mdiMoviePlus: mdiMoviePlus,
mdiMoviePlusOutline: mdiMoviePlusOutline,
mdiMovieRemove: mdiMovieRemove,
mdiMovieRemoveOutline: mdiMovieRemoveOutline,
mdiMovieRoll: mdiMovieRoll,
mdiMovieSearch: mdiMovieSearch,
mdiMovieSearchOutline: mdiMovieSearchOutline,
mdiMovieSettings: mdiMovieSettings,
mdiMovieSettingsOutline: mdiMovieSettingsOutline,
mdiMovieStar: mdiMovieStar,
mdiMovieStarOutline: mdiMovieStarOutline,
mdiMower: mdiMower,
mdiMowerBag: mdiMowerBag,
mdiMowerBagOn: mdiMowerBagOn,
mdiMowerOn: mdiMowerOn,
mdiMuffin: mdiMuffin,
mdiMulticast: mdiMulticast,
mdiMultimedia: mdiMultimedia,
mdiMultiplication: mdiMultiplication,
mdiMultiplicationBox: mdiMultiplicationBox,
mdiMushroom: mdiMushroom,
mdiMushroomOff: mdiMushroomOff,
mdiMushroomOffOutline: mdiMushroomOffOutline,
mdiMushroomOutline: mdiMushroomOutline,
mdiMusic: mdiMusic,
mdiMusicAccidentalDoubleFlat: mdiMusicAccidentalDoubleFlat,
mdiMusicAccidentalDoubleSharp: mdiMusicAccidentalDoubleSharp,
mdiMusicAccidentalFlat: mdiMusicAccidentalFlat,
mdiMusicAccidentalNatural: mdiMusicAccidentalNatural,
mdiMusicAccidentalSharp: mdiMusicAccidentalSharp,
mdiMusicBox: mdiMusicBox,
mdiMusicBoxMultiple: mdiMusicBoxMultiple,
mdiMusicBoxMultipleOutline: mdiMusicBoxMultipleOutline,
mdiMusicBoxOutline: mdiMusicBoxOutline,
mdiMusicCircle: mdiMusicCircle,
mdiMusicCircleOutline: mdiMusicCircleOutline,
mdiMusicClefAlto: mdiMusicClefAlto,
mdiMusicClefBass: mdiMusicClefBass,
mdiMusicClefTreble: mdiMusicClefTreble,
mdiMusicNote: mdiMusicNote,
mdiMusicNoteBluetooth: mdiMusicNoteBluetooth,
mdiMusicNoteBluetoothOff: mdiMusicNoteBluetoothOff,
mdiMusicNoteEighth: mdiMusicNoteEighth,
mdiMusicNoteEighthDotted: mdiMusicNoteEighthDotted,
mdiMusicNoteHalf: mdiMusicNoteHalf,
mdiMusicNoteHalfDotted: mdiMusicNoteHalfDotted,
mdiMusicNoteMinus: mdiMusicNoteMinus,
mdiMusicNoteOff: mdiMusicNoteOff,
mdiMusicNoteOffOutline: mdiMusicNoteOffOutline,
mdiMusicNoteOutline: mdiMusicNoteOutline,
mdiMusicNotePlus: mdiMusicNotePlus,
mdiMusicNoteQuarter: mdiMusicNoteQuarter,
mdiMusicNoteQuarterDotted: mdiMusicNoteQuarterDotted,
mdiMusicNoteSixteenth: mdiMusicNoteSixteenth,
mdiMusicNoteSixteenthDotted: mdiMusicNoteSixteenthDotted,
mdiMusicNoteWhole: mdiMusicNoteWhole,
mdiMusicNoteWholeDotted: mdiMusicNoteWholeDotted,
mdiMusicOff: mdiMusicOff,
mdiMusicRestEighth: mdiMusicRestEighth,
mdiMusicRestHalf: mdiMusicRestHalf,
mdiMusicRestQuarter: mdiMusicRestQuarter,
mdiMusicRestSixteenth: mdiMusicRestSixteenth,
mdiMusicRestWhole: mdiMusicRestWhole,
mdiMustache: mdiMustache,
mdiNail: mdiNail,
mdiNas: mdiNas,
mdiNativescript: mdiNativescript,
mdiNature: mdiNature,
mdiNaturePeople: mdiNaturePeople,
mdiNavigation: mdiNavigation,
mdiNavigationOutline: mdiNavigationOutline,
mdiNavigationVariant: mdiNavigationVariant,
mdiNavigationVariantOutline: mdiNavigationVariantOutline,
mdiNearMe: mdiNearMe,
mdiNecklace: mdiNecklace,
mdiNeedle: mdiNeedle,
mdiNeedleOff: mdiNeedleOff,
mdiNetflix: mdiNetflix,
mdiNetwork: mdiNetwork,
mdiNetworkOff: mdiNetworkOff,
mdiNetworkOffOutline: mdiNetworkOffOutline,
mdiNetworkOutline: mdiNetworkOutline,
mdiNetworkPos: mdiNetworkPos,
mdiNetworkStrength1: mdiNetworkStrength1,
mdiNetworkStrength1Alert: mdiNetworkStrength1Alert,
mdiNetworkStrength2: mdiNetworkStrength2,
mdiNetworkStrength2Alert: mdiNetworkStrength2Alert,
mdiNetworkStrength3: mdiNetworkStrength3,
mdiNetworkStrength3Alert: mdiNetworkStrength3Alert,
mdiNetworkStrength4: mdiNetworkStrength4,
mdiNetworkStrength4Alert: mdiNetworkStrength4Alert,
mdiNetworkStrength4Cog: mdiNetworkStrength4Cog,
mdiNetworkStrengthOff: mdiNetworkStrengthOff,
mdiNetworkStrengthOffOutline: mdiNetworkStrengthOffOutline,
mdiNetworkStrengthOutline: mdiNetworkStrengthOutline,
mdiNewBox: mdiNewBox,
mdiNewspaper: mdiNewspaper,
mdiNewspaperCheck: mdiNewspaperCheck,
mdiNewspaperMinus: mdiNewspaperMinus,
mdiNewspaperPlus: mdiNewspaperPlus,
mdiNewspaperRemove: mdiNewspaperRemove,
mdiNewspaperVariant: mdiNewspaperVariant,
mdiNewspaperVariantMultiple: mdiNewspaperVariantMultiple,
mdiNewspaperVariantMultipleOutline: mdiNewspaperVariantMultipleOutline,
mdiNewspaperVariantOutline: mdiNewspaperVariantOutline,
mdiNfc: mdiNfc,
mdiNfcSearchVariant: mdiNfcSearchVariant,
mdiNfcTap: mdiNfcTap,
mdiNfcVariant: mdiNfcVariant,
mdiNfcVariantOff: mdiNfcVariantOff,
mdiNinja: mdiNinja,
mdiNintendoGameBoy: mdiNintendoGameBoy,
mdiNintendoSwitch: mdiNintendoSwitch,
mdiNintendoWii: mdiNintendoWii,
mdiNintendoWiiu: mdiNintendoWiiu,
mdiNix: mdiNix,
mdiNodejs: mdiNodejs,
mdiNoodles: mdiNoodles,
mdiNotEqual: mdiNotEqual,
mdiNotEqualVariant: mdiNotEqualVariant,
mdiNote: mdiNote,
mdiNoteAlert: mdiNoteAlert,
mdiNoteAlertOutline: mdiNoteAlertOutline,
mdiNoteCheck: mdiNoteCheck,
mdiNoteCheckOutline: mdiNoteCheckOutline,
mdiNoteEdit: mdiNoteEdit,
mdiNoteEditOutline: mdiNoteEditOutline,
mdiNoteMinus: mdiNoteMinus,
mdiNoteMinusOutline: mdiNoteMinusOutline,
mdiNoteMultiple: mdiNoteMultiple,
mdiNoteMultipleOutline: mdiNoteMultipleOutline,
mdiNoteOff: mdiNoteOff,
mdiNoteOffOutline: mdiNoteOffOutline,
mdiNoteOutline: mdiNoteOutline,
mdiNotePlus: mdiNotePlus,
mdiNotePlusOutline: mdiNotePlusOutline,
mdiNoteRemove: mdiNoteRemove,
mdiNoteRemoveOutline: mdiNoteRemoveOutline,
mdiNoteSearch: mdiNoteSearch,
mdiNoteSearchOutline: mdiNoteSearchOutline,
mdiNoteText: mdiNoteText,
mdiNoteTextOutline: mdiNoteTextOutline,
mdiNotebook: mdiNotebook,
mdiNotebookCheck: mdiNotebookCheck,
mdiNotebookCheckOutline: mdiNotebookCheckOutline,
mdiNotebookEdit: mdiNotebookEdit,
mdiNotebookEditOutline: mdiNotebookEditOutline,
mdiNotebookHeart: mdiNotebookHeart,
mdiNotebookHeartOutline: mdiNotebookHeartOutline,
mdiNotebookMinus: mdiNotebookMinus,
mdiNotebookMinusOutline: mdiNotebookMinusOutline,
mdiNotebookMultiple: mdiNotebookMultiple,
mdiNotebookOutline: mdiNotebookOutline,
mdiNotebookPlus: mdiNotebookPlus,
mdiNotebookPlusOutline: mdiNotebookPlusOutline,
mdiNotebookRemove: mdiNotebookRemove,
mdiNotebookRemoveOutline: mdiNotebookRemoveOutline,
mdiNotificationClearAll: mdiNotificationClearAll,
mdiNpm: mdiNpm,
mdiNuke: mdiNuke,
mdiNull: mdiNull,
mdiNumeric: mdiNumeric,
mdiNumeric0: mdiNumeric0,
mdiNumeric0Box: mdiNumeric0Box,
mdiNumeric0BoxMultiple: mdiNumeric0BoxMultiple,
mdiNumeric0BoxMultipleOutline: mdiNumeric0BoxMultipleOutline,
mdiNumeric0BoxOutline: mdiNumeric0BoxOutline,
mdiNumeric0Circle: mdiNumeric0Circle,
mdiNumeric0CircleOutline: mdiNumeric0CircleOutline,
mdiNumeric1: mdiNumeric1,
mdiNumeric1Box: mdiNumeric1Box,
mdiNumeric1BoxMultiple: mdiNumeric1BoxMultiple,
mdiNumeric1BoxMultipleOutline: mdiNumeric1BoxMultipleOutline,
mdiNumeric1BoxOutline: mdiNumeric1BoxOutline,
mdiNumeric1Circle: mdiNumeric1Circle,
mdiNumeric1CircleOutline: mdiNumeric1CircleOutline,
mdiNumeric10: mdiNumeric10,
mdiNumeric10Box: mdiNumeric10Box,
mdiNumeric10BoxMultiple: mdiNumeric10BoxMultiple,
mdiNumeric10BoxMultipleOutline: mdiNumeric10BoxMultipleOutline,
mdiNumeric10BoxOutline: mdiNumeric10BoxOutline,
mdiNumeric10Circle: mdiNumeric10Circle,
mdiNumeric10CircleOutline: mdiNumeric10CircleOutline,
mdiNumeric2: mdiNumeric2,
mdiNumeric2Box: mdiNumeric2Box,
mdiNumeric2BoxMultiple: mdiNumeric2BoxMultiple,
mdiNumeric2BoxMultipleOutline: mdiNumeric2BoxMultipleOutline,
mdiNumeric2BoxOutline: mdiNumeric2BoxOutline,
mdiNumeric2Circle: mdiNumeric2Circle,
mdiNumeric2CircleOutline: mdiNumeric2CircleOutline,
mdiNumeric3: mdiNumeric3,
mdiNumeric3Box: mdiNumeric3Box,
mdiNumeric3BoxMultiple: mdiNumeric3BoxMultiple,
mdiNumeric3BoxMultipleOutline: mdiNumeric3BoxMultipleOutline,
mdiNumeric3BoxOutline: mdiNumeric3BoxOutline,
mdiNumeric3Circle: mdiNumeric3Circle,
mdiNumeric3CircleOutline: mdiNumeric3CircleOutline,
mdiNumeric4: mdiNumeric4,
mdiNumeric4Box: mdiNumeric4Box,
mdiNumeric4BoxMultiple: mdiNumeric4BoxMultiple,
mdiNumeric4BoxMultipleOutline: mdiNumeric4BoxMultipleOutline,
mdiNumeric4BoxOutline: mdiNumeric4BoxOutline,
mdiNumeric4Circle: mdiNumeric4Circle,
mdiNumeric4CircleOutline: mdiNumeric4CircleOutline,
mdiNumeric5: mdiNumeric5,
mdiNumeric5Box: mdiNumeric5Box,
mdiNumeric5BoxMultiple: mdiNumeric5BoxMultiple,
mdiNumeric5BoxMultipleOutline: mdiNumeric5BoxMultipleOutline,
mdiNumeric5BoxOutline: mdiNumeric5BoxOutline,
mdiNumeric5Circle: mdiNumeric5Circle,
mdiNumeric5CircleOutline: mdiNumeric5CircleOutline,
mdiNumeric6: mdiNumeric6,
mdiNumeric6Box: mdiNumeric6Box,
mdiNumeric6BoxMultiple: mdiNumeric6BoxMultiple,
mdiNumeric6BoxMultipleOutline: mdiNumeric6BoxMultipleOutline,
mdiNumeric6BoxOutline: mdiNumeric6BoxOutline,
mdiNumeric6Circle: mdiNumeric6Circle,
mdiNumeric6CircleOutline: mdiNumeric6CircleOutline,
mdiNumeric7: mdiNumeric7,
mdiNumeric7Box: mdiNumeric7Box,
mdiNumeric7BoxMultiple: mdiNumeric7BoxMultiple,
mdiNumeric7BoxMultipleOutline: mdiNumeric7BoxMultipleOutline,
mdiNumeric7BoxOutline: mdiNumeric7BoxOutline,
mdiNumeric7Circle: mdiNumeric7Circle,
mdiNumeric7CircleOutline: mdiNumeric7CircleOutline,
mdiNumeric8: mdiNumeric8,
mdiNumeric8Box: mdiNumeric8Box,
mdiNumeric8BoxMultiple: mdiNumeric8BoxMultiple,
mdiNumeric8BoxMultipleOutline: mdiNumeric8BoxMultipleOutline,
mdiNumeric8BoxOutline: mdiNumeric8BoxOutline,
mdiNumeric8Circle: mdiNumeric8Circle,
mdiNumeric8CircleOutline: mdiNumeric8CircleOutline,
mdiNumeric9: mdiNumeric9,
mdiNumeric9Box: mdiNumeric9Box,
mdiNumeric9BoxMultiple: mdiNumeric9BoxMultiple,
mdiNumeric9BoxMultipleOutline: mdiNumeric9BoxMultipleOutline,
mdiNumeric9BoxOutline: mdiNumeric9BoxOutline,
mdiNumeric9Circle: mdiNumeric9Circle,
mdiNumeric9CircleOutline: mdiNumeric9CircleOutline,
mdiNumeric9Plus: mdiNumeric9Plus,
mdiNumeric9PlusBox: mdiNumeric9PlusBox,
mdiNumeric9PlusBoxMultiple: mdiNumeric9PlusBoxMultiple,
mdiNumeric9PlusBoxMultipleOutline: mdiNumeric9PlusBoxMultipleOutline,
mdiNumeric9PlusBoxOutline: mdiNumeric9PlusBoxOutline,
mdiNumeric9PlusCircle: mdiNumeric9PlusCircle,
mdiNumeric9PlusCircleOutline: mdiNumeric9PlusCircleOutline,
mdiNumericNegative1: mdiNumericNegative1,
mdiNumericOff: mdiNumericOff,
mdiNumericPositive1: mdiNumericPositive1,
mdiNut: mdiNut,
mdiNutrition: mdiNutrition,
mdiNuxt: mdiNuxt,
mdiOar: mdiOar,
mdiOcarina: mdiOcarina,
mdiOci: mdiOci,
mdiOcr: mdiOcr,
mdiOctagon: mdiOctagon,
mdiOctagonOutline: mdiOctagonOutline,
mdiOctagram: mdiOctagram,
mdiOctagramOutline: mdiOctagramOutline,
mdiOctahedron: mdiOctahedron,
mdiOctahedronOff: mdiOctahedronOff,
mdiOdnoklassniki: mdiOdnoklassniki,
mdiOffer: mdiOffer,
mdiOfficeBuilding: mdiOfficeBuilding,
mdiOfficeBuildingCog: mdiOfficeBuildingCog,
mdiOfficeBuildingCogOutline: mdiOfficeBuildingCogOutline,
mdiOfficeBuildingMarker: mdiOfficeBuildingMarker,
mdiOfficeBuildingMarkerOutline: mdiOfficeBuildingMarkerOutline,
mdiOfficeBuildingMinus: mdiOfficeBuildingMinus,
mdiOfficeBuildingMinusOutline: mdiOfficeBuildingMinusOutline,
mdiOfficeBuildingOutline: mdiOfficeBuildingOutline,
mdiOfficeBuildingPlus: mdiOfficeBuildingPlus,
mdiOfficeBuildingPlusOutline: mdiOfficeBuildingPlusOutline,
mdiOfficeBuildingRemove: mdiOfficeBuildingRemove,
mdiOfficeBuildingRemoveOutline: mdiOfficeBuildingRemoveOutline,
mdiOil: mdiOil,
mdiOilLamp: mdiOilLamp,
mdiOilLevel: mdiOilLevel,
mdiOilTemperature: mdiOilTemperature,
mdiOm: mdiOm,
mdiOmega: mdiOmega,
mdiOneUp: mdiOneUp,
mdiOnepassword: mdiOnepassword,
mdiOpacity: mdiOpacity,
mdiOpenInApp: mdiOpenInApp,
mdiOpenInNew: mdiOpenInNew,
mdiOpenSourceInitiative: mdiOpenSourceInitiative,
mdiOpenid: mdiOpenid,
mdiOpera: mdiOpera,
mdiOrbit: mdiOrbit,
mdiOrbitVariant: mdiOrbitVariant,
mdiOrderAlphabeticalAscending: mdiOrderAlphabeticalAscending,
mdiOrderAlphabeticalDescending: mdiOrderAlphabeticalDescending,
mdiOrderBoolAscending: mdiOrderBoolAscending,
mdiOrderBoolAscendingVariant: mdiOrderBoolAscendingVariant,
mdiOrderBoolDescending: mdiOrderBoolDescending,
mdiOrderBoolDescendingVariant: mdiOrderBoolDescendingVariant,
mdiOrderNumericAscending: mdiOrderNumericAscending,
mdiOrderNumericDescending: mdiOrderNumericDescending,
mdiOrigin: mdiOrigin,
mdiOrnament: mdiOrnament,
mdiOrnamentVariant: mdiOrnamentVariant,
mdiOutdoorLamp: mdiOutdoorLamp,
mdiOverscan: mdiOverscan,
mdiOwl: mdiOwl,
mdiPacMan: mdiPacMan,
mdiPackage: mdiPackage,
mdiPackageCheck: mdiPackageCheck,
mdiPackageDown: mdiPackageDown,
mdiPackageUp: mdiPackageUp,
mdiPackageVariant: mdiPackageVariant,
mdiPackageVariantClosed: mdiPackageVariantClosed,
mdiPackageVariantClosedCheck: mdiPackageVariantClosedCheck,
mdiPackageVariantClosedMinus: mdiPackageVariantClosedMinus,
mdiPackageVariantClosedPlus: mdiPackageVariantClosedPlus,
mdiPackageVariantClosedRemove: mdiPackageVariantClosedRemove,
mdiPackageVariantMinus: mdiPackageVariantMinus,
mdiPackageVariantPlus: mdiPackageVariantPlus,
mdiPackageVariantRemove: mdiPackageVariantRemove,
mdiPageFirst: mdiPageFirst,
mdiPageLast: mdiPageLast,
mdiPageLayoutBody: mdiPageLayoutBody,
mdiPageLayoutFooter: mdiPageLayoutFooter,
mdiPageLayoutHeader: mdiPageLayoutHeader,
mdiPageLayoutHeaderFooter: mdiPageLayoutHeaderFooter,
mdiPageLayoutSidebarLeft: mdiPageLayoutSidebarLeft,
mdiPageLayoutSidebarRight: mdiPageLayoutSidebarRight,
mdiPageNext: mdiPageNext,
mdiPageNextOutline: mdiPageNextOutline,
mdiPagePrevious: mdiPagePrevious,
mdiPagePreviousOutline: mdiPagePreviousOutline,
mdiPail: mdiPail,
mdiPailMinus: mdiPailMinus,
mdiPailMinusOutline: mdiPailMinusOutline,
mdiPailOff: mdiPailOff,
mdiPailOffOutline: mdiPailOffOutline,
mdiPailOutline: mdiPailOutline,
mdiPailPlus: mdiPailPlus,
mdiPailPlusOutline: mdiPailPlusOutline,
mdiPailRemove: mdiPailRemove,
mdiPailRemoveOutline: mdiPailRemoveOutline,
mdiPalette: mdiPalette,
mdiPaletteAdvanced: mdiPaletteAdvanced,
mdiPaletteOutline: mdiPaletteOutline,
mdiPaletteSwatch: mdiPaletteSwatch,
mdiPaletteSwatchOutline: mdiPaletteSwatchOutline,
mdiPaletteSwatchVariant: mdiPaletteSwatchVariant,
mdiPalmTree: mdiPalmTree,
mdiPan: mdiPan,
mdiPanBottomLeft: mdiPanBottomLeft,
mdiPanBottomRight: mdiPanBottomRight,
mdiPanDown: mdiPanDown,
mdiPanHorizontal: mdiPanHorizontal,
mdiPanLeft: mdiPanLeft,
mdiPanRight: mdiPanRight,
mdiPanTopLeft: mdiPanTopLeft,
mdiPanTopRight: mdiPanTopRight,
mdiPanUp: mdiPanUp,
mdiPanVertical: mdiPanVertical,
mdiPanda: mdiPanda,
mdiPandora: mdiPandora,
mdiPanorama: mdiPanorama,
mdiPanoramaFisheye: mdiPanoramaFisheye,
mdiPanoramaHorizontal: mdiPanoramaHorizontal,
mdiPanoramaHorizontalOutline: mdiPanoramaHorizontalOutline,
mdiPanoramaOutline: mdiPanoramaOutline,
mdiPanoramaSphere: mdiPanoramaSphere,
mdiPanoramaSphereOutline: mdiPanoramaSphereOutline,
mdiPanoramaVariant: mdiPanoramaVariant,
mdiPanoramaVariantOutline: mdiPanoramaVariantOutline,
mdiPanoramaVertical: mdiPanoramaVertical,
mdiPanoramaVerticalOutline: mdiPanoramaVerticalOutline,
mdiPanoramaWideAngle: mdiPanoramaWideAngle,
mdiPanoramaWideAngleOutline: mdiPanoramaWideAngleOutline,
mdiPaperCutVertical: mdiPaperCutVertical,
mdiPaperRoll: mdiPaperRoll,
mdiPaperRollOutline: mdiPaperRollOutline,
mdiPaperclip: mdiPaperclip,
mdiPaperclipCheck: mdiPaperclipCheck,
mdiPaperclipLock: mdiPaperclipLock,
mdiPaperclipMinus: mdiPaperclipMinus,
mdiPaperclipOff: mdiPaperclipOff,
mdiPaperclipPlus: mdiPaperclipPlus,
mdiPaperclipRemove: mdiPaperclipRemove,
mdiParachute: mdiParachute,
mdiParachuteOutline: mdiParachuteOutline,
mdiParagliding: mdiParagliding,
mdiParking: mdiParking,
mdiPartyPopper: mdiPartyPopper,
mdiPassport: mdiPassport,
mdiPassportBiometric: mdiPassportBiometric,
mdiPasta: mdiPasta,
mdiPatioHeater: mdiPatioHeater,
mdiPatreon: mdiPatreon,
mdiPause: mdiPause,
mdiPauseBox: mdiPauseBox,
mdiPauseBoxOutline: mdiPauseBoxOutline,
mdiPauseCircle: mdiPauseCircle,
mdiPauseCircleOutline: mdiPauseCircleOutline,
mdiPauseOctagon: mdiPauseOctagon,
mdiPauseOctagonOutline: mdiPauseOctagonOutline,
mdiPaw: mdiPaw,
mdiPawOff: mdiPawOff,
mdiPawOffOutline: mdiPawOffOutline,
mdiPawOutline: mdiPawOutline,
mdiPeace: mdiPeace,
mdiPeanut: mdiPeanut,
mdiPeanutOff: mdiPeanutOff,
mdiPeanutOffOutline: mdiPeanutOffOutline,
mdiPeanutOutline: mdiPeanutOutline,
mdiPen: mdiPen,
mdiPenLock: mdiPenLock,
mdiPenMinus: mdiPenMinus,
mdiPenOff: mdiPenOff,
mdiPenPlus: mdiPenPlus,
mdiPenRemove: mdiPenRemove,
mdiPencil: mdiPencil,
mdiPencilBox: mdiPencilBox,
mdiPencilBoxMultiple: mdiPencilBoxMultiple,
mdiPencilBoxMultipleOutline: mdiPencilBoxMultipleOutline,
mdiPencilBoxOutline: mdiPencilBoxOutline,
mdiPencilCircle: mdiPencilCircle,
mdiPencilCircleOutline: mdiPencilCircleOutline,
mdiPencilLock: mdiPencilLock,
mdiPencilLockOutline: mdiPencilLockOutline,
mdiPencilMinus: mdiPencilMinus,
mdiPencilMinusOutline: mdiPencilMinusOutline,
mdiPencilOff: mdiPencilOff,
mdiPencilOffOutline: mdiPencilOffOutline,
mdiPencilOutline: mdiPencilOutline,
mdiPencilPlus: mdiPencilPlus,
mdiPencilPlusOutline: mdiPencilPlusOutline,
mdiPencilRemove: mdiPencilRemove,
mdiPencilRemoveOutline: mdiPencilRemoveOutline,
mdiPencilRuler: mdiPencilRuler,
mdiPenguin: mdiPenguin,
mdiPentagon: mdiPentagon,
mdiPentagonOutline: mdiPentagonOutline,
mdiPentagram: mdiPentagram,
mdiPercent: mdiPercent,
mdiPercentBox: mdiPercentBox,
mdiPercentBoxOutline: mdiPercentBoxOutline,
mdiPercentCircle: mdiPercentCircle,
mdiPercentCircleOutline: mdiPercentCircleOutline,
mdiPercentOutline: mdiPercentOutline,
mdiPeriodicTable: mdiPeriodicTable,
mdiPerspectiveLess: mdiPerspectiveLess,
mdiPerspectiveMore: mdiPerspectiveMore,
mdiPh: mdiPh,
mdiPhone: mdiPhone,
mdiPhoneAlert: mdiPhoneAlert,
mdiPhoneAlertOutline: mdiPhoneAlertOutline,
mdiPhoneBluetooth: mdiPhoneBluetooth,
mdiPhoneBluetoothOutline: mdiPhoneBluetoothOutline,
mdiPhoneCancel: mdiPhoneCancel,
mdiPhoneCancelOutline: mdiPhoneCancelOutline,
mdiPhoneCheck: mdiPhoneCheck,
mdiPhoneCheckOutline: mdiPhoneCheckOutline,
mdiPhoneClassic: mdiPhoneClassic,
mdiPhoneClassicOff: mdiPhoneClassicOff,
mdiPhoneClock: mdiPhoneClock,
mdiPhoneDial: mdiPhoneDial,
mdiPhoneDialOutline: mdiPhoneDialOutline,
mdiPhoneForward: mdiPhoneForward,
mdiPhoneForwardOutline: mdiPhoneForwardOutline,
mdiPhoneHangup: mdiPhoneHangup,
mdiPhoneHangupOutline: mdiPhoneHangupOutline,
mdiPhoneInTalk: mdiPhoneInTalk,
mdiPhoneInTalkOutline: mdiPhoneInTalkOutline,
mdiPhoneIncoming: mdiPhoneIncoming,
mdiPhoneIncomingOutgoing: mdiPhoneIncomingOutgoing,
mdiPhoneIncomingOutgoingOutline: mdiPhoneIncomingOutgoingOutline,
mdiPhoneIncomingOutline: mdiPhoneIncomingOutline,
mdiPhoneLock: mdiPhoneLock,
mdiPhoneLockOutline: mdiPhoneLockOutline,
mdiPhoneLog: mdiPhoneLog,
mdiPhoneLogOutline: mdiPhoneLogOutline,
mdiPhoneMessage: mdiPhoneMessage,
mdiPhoneMessageOutline: mdiPhoneMessageOutline,
mdiPhoneMinus: mdiPhoneMinus,
mdiPhoneMinusOutline: mdiPhoneMinusOutline,
mdiPhoneMissed: mdiPhoneMissed,
mdiPhoneMissedOutline: mdiPhoneMissedOutline,
mdiPhoneOff: mdiPhoneOff,
mdiPhoneOffOutline: mdiPhoneOffOutline,
mdiPhoneOutgoing: mdiPhoneOutgoing,
mdiPhoneOutgoingOutline: mdiPhoneOutgoingOutline,
mdiPhoneOutline: mdiPhoneOutline,
mdiPhonePaused: mdiPhonePaused,
mdiPhonePausedOutline: mdiPhonePausedOutline,
mdiPhonePlus: mdiPhonePlus,
mdiPhonePlusOutline: mdiPhonePlusOutline,
mdiPhoneRefresh: mdiPhoneRefresh,
mdiPhoneRefreshOutline: mdiPhoneRefreshOutline,
mdiPhoneRemove: mdiPhoneRemove,
mdiPhoneRemoveOutline: mdiPhoneRemoveOutline,
mdiPhoneReturn: mdiPhoneReturn,
mdiPhoneReturnOutline: mdiPhoneReturnOutline,
mdiPhoneRing: mdiPhoneRing,
mdiPhoneRingOutline: mdiPhoneRingOutline,
mdiPhoneRotateLandscape: mdiPhoneRotateLandscape,
mdiPhoneRotatePortrait: mdiPhoneRotatePortrait,
mdiPhoneSettings: mdiPhoneSettings,
mdiPhoneSettingsOutline: mdiPhoneSettingsOutline,
mdiPhoneSync: mdiPhoneSync,
mdiPhoneSyncOutline: mdiPhoneSyncOutline,
mdiPhoneVoip: mdiPhoneVoip,
mdiPi: mdiPi,
mdiPiBox: mdiPiBox,
mdiPiHole: mdiPiHole,
mdiPiano: mdiPiano,
mdiPianoOff: mdiPianoOff,
mdiPickaxe: mdiPickaxe,
mdiPictureInPictureBottomRight: mdiPictureInPictureBottomRight,
mdiPictureInPictureBottomRightOutline: mdiPictureInPictureBottomRightOutline,
mdiPictureInPictureTopRight: mdiPictureInPictureTopRight,
mdiPictureInPictureTopRightOutline: mdiPictureInPictureTopRightOutline,
mdiPier: mdiPier,
mdiPierCrane: mdiPierCrane,
mdiPig: mdiPig,
mdiPigVariant: mdiPigVariant,
mdiPigVariantOutline: mdiPigVariantOutline,
mdiPiggyBank: mdiPiggyBank,
mdiPiggyBankOutline: mdiPiggyBankOutline,
mdiPill: mdiPill,
mdiPillMultiple: mdiPillMultiple,
mdiPillOff: mdiPillOff,
mdiPillar: mdiPillar,
mdiPin: mdiPin,
mdiPinOff: mdiPinOff,
mdiPinOffOutline: mdiPinOffOutline,
mdiPinOutline: mdiPinOutline,
mdiPineTree: mdiPineTree,
mdiPineTreeBox: mdiPineTreeBox,
mdiPineTreeFire: mdiPineTreeFire,
mdiPinterest: mdiPinterest,
mdiPinwheel: mdiPinwheel,
mdiPinwheelOutline: mdiPinwheelOutline,
mdiPipe: mdiPipe,
mdiPipeDisconnected: mdiPipeDisconnected,
mdiPipeLeak: mdiPipeLeak,
mdiPipeValve: mdiPipeValve,
mdiPipeWrench: mdiPipeWrench,
mdiPirate: mdiPirate,
mdiPistol: mdiPistol,
mdiPiston: mdiPiston,
mdiPitchfork: mdiPitchfork,
mdiPizza: mdiPizza,
mdiPlaneCar: mdiPlaneCar,
mdiPlaneTrain: mdiPlaneTrain,
mdiPlay: mdiPlay,
mdiPlayBox: mdiPlayBox,
mdiPlayBoxLock: mdiPlayBoxLock,
mdiPlayBoxLockOpen: mdiPlayBoxLockOpen,
mdiPlayBoxLockOpenOutline: mdiPlayBoxLockOpenOutline,
mdiPlayBoxLockOutline: mdiPlayBoxLockOutline,
mdiPlayBoxMultiple: mdiPlayBoxMultiple,
mdiPlayBoxMultipleOutline: mdiPlayBoxMultipleOutline,
mdiPlayBoxOutline: mdiPlayBoxOutline,
mdiPlayCircle: mdiPlayCircle,
mdiPlayCircleOutline: mdiPlayCircleOutline,
mdiPlayNetwork: mdiPlayNetwork,
mdiPlayNetworkOutline: mdiPlayNetworkOutline,
mdiPlayOutline: mdiPlayOutline,
mdiPlayPause: mdiPlayPause,
mdiPlayProtectedContent: mdiPlayProtectedContent,
mdiPlaySpeed: mdiPlaySpeed,
mdiPlaylistCheck: mdiPlaylistCheck,
mdiPlaylistEdit: mdiPlaylistEdit,
mdiPlaylistMinus: mdiPlaylistMinus,
mdiPlaylistMusic: mdiPlaylistMusic,
mdiPlaylistMusicOutline: mdiPlaylistMusicOutline,
mdiPlaylistPlay: mdiPlaylistPlay,
mdiPlaylistPlus: mdiPlaylistPlus,
mdiPlaylistRemove: mdiPlaylistRemove,
mdiPlaylistStar: mdiPlaylistStar,
mdiPlex: mdiPlex,
mdiPliers: mdiPliers,
mdiPlus: mdiPlus,
mdiPlusBox: mdiPlusBox,
mdiPlusBoxMultiple: mdiPlusBoxMultiple,
mdiPlusBoxMultipleOutline: mdiPlusBoxMultipleOutline,
mdiPlusBoxOutline: mdiPlusBoxOutline,
mdiPlusCircle: mdiPlusCircle,
mdiPlusCircleMultiple: mdiPlusCircleMultiple,
mdiPlusCircleMultipleOutline: mdiPlusCircleMultipleOutline,
mdiPlusCircleOutline: mdiPlusCircleOutline,
mdiPlusLock: mdiPlusLock,
mdiPlusLockOpen: mdiPlusLockOpen,
mdiPlusMinus: mdiPlusMinus,
mdiPlusMinusBox: mdiPlusMinusBox,
mdiPlusMinusVariant: mdiPlusMinusVariant,
mdiPlusNetwork: mdiPlusNetwork,
mdiPlusNetworkOutline: mdiPlusNetworkOutline,
mdiPlusOutline: mdiPlusOutline,
mdiPlusThick: mdiPlusThick,
mdiPodcast: mdiPodcast,
mdiPodium: mdiPodium,
mdiPodiumBronze: mdiPodiumBronze,
mdiPodiumGold: mdiPodiumGold,
mdiPodiumSilver: mdiPodiumSilver,
mdiPointOfSale: mdiPointOfSale,
mdiPokeball: mdiPokeball,
mdiPokemonGo: mdiPokemonGo,
mdiPokerChip: mdiPokerChip,
mdiPolaroid: mdiPolaroid,
mdiPoliceBadge: mdiPoliceBadge,
mdiPoliceBadgeOutline: mdiPoliceBadgeOutline,
mdiPoliceStation: mdiPoliceStation,
mdiPoll: mdiPoll,
mdiPolo: mdiPolo,
mdiPolymer: mdiPolymer,
mdiPool: mdiPool,
mdiPoolThermometer: mdiPoolThermometer,
mdiPopcorn: mdiPopcorn,
mdiPost: mdiPost,
mdiPostLamp: mdiPostLamp,
mdiPostOutline: mdiPostOutline,
mdiPostageStamp: mdiPostageStamp,
mdiPot: mdiPot,
mdiPotMix: mdiPotMix,
mdiPotMixOutline: mdiPotMixOutline,
mdiPotOutline: mdiPotOutline,
mdiPotSteam: mdiPotSteam,
mdiPotSteamOutline: mdiPotSteamOutline,
mdiPound: mdiPound,
mdiPoundBox: mdiPoundBox,
mdiPoundBoxOutline: mdiPoundBoxOutline,
mdiPower: mdiPower,
mdiPowerCycle: mdiPowerCycle,
mdiPowerOff: mdiPowerOff,
mdiPowerOn: mdiPowerOn,
mdiPowerPlug: mdiPowerPlug,
mdiPowerPlugOff: mdiPowerPlugOff,
mdiPowerPlugOffOutline: mdiPowerPlugOffOutline,
mdiPowerPlugOutline: mdiPowerPlugOutline,
mdiPowerSettings: mdiPowerSettings,
mdiPowerSleep: mdiPowerSleep,
mdiPowerSocket: mdiPowerSocket,
mdiPowerSocketAu: mdiPowerSocketAu,
mdiPowerSocketCh: mdiPowerSocketCh,
mdiPowerSocketDe: mdiPowerSocketDe,
mdiPowerSocketEu: mdiPowerSocketEu,
mdiPowerSocketFr: mdiPowerSocketFr,
mdiPowerSocketIt: mdiPowerSocketIt,
mdiPowerSocketJp: mdiPowerSocketJp,
mdiPowerSocketUk: mdiPowerSocketUk,
mdiPowerSocketUs: mdiPowerSocketUs,
mdiPowerStandby: mdiPowerStandby,
mdiPowershell: mdiPowershell,
mdiPrescription: mdiPrescription,
mdiPresentation: mdiPresentation,
mdiPresentationPlay: mdiPresentationPlay,
mdiPretzel: mdiPretzel,
mdiPrinter: mdiPrinter,
mdiPrinter3d: mdiPrinter3d,
mdiPrinter3dNozzle: mdiPrinter3dNozzle,
mdiPrinter3dNozzleAlert: mdiPrinter3dNozzleAlert,
mdiPrinter3dNozzleAlertOutline: mdiPrinter3dNozzleAlertOutline,
mdiPrinter3dNozzleHeat: mdiPrinter3dNozzleHeat,
mdiPrinter3dNozzleHeatOutline: mdiPrinter3dNozzleHeatOutline,
mdiPrinter3dNozzleOff: mdiPrinter3dNozzleOff,
mdiPrinter3dNozzleOffOutline: mdiPrinter3dNozzleOffOutline,
mdiPrinter3dNozzleOutline: mdiPrinter3dNozzleOutline,
mdiPrinter3dOff: mdiPrinter3dOff,
mdiPrinterAlert: mdiPrinterAlert,
mdiPrinterCheck: mdiPrinterCheck,
mdiPrinterEye: mdiPrinterEye,
mdiPrinterOff: mdiPrinterOff,
mdiPrinterOffOutline: mdiPrinterOffOutline,
mdiPrinterOutline: mdiPrinterOutline,
mdiPrinterPos: mdiPrinterPos,
mdiPrinterSearch: mdiPrinterSearch,
mdiPrinterSettings: mdiPrinterSettings,
mdiPrinterWireless: mdiPrinterWireless,
mdiPriorityHigh: mdiPriorityHigh,
mdiPriorityLow: mdiPriorityLow,
mdiProfessionalHexagon: mdiProfessionalHexagon,
mdiProgressAlert: mdiProgressAlert,
mdiProgressCheck: mdiProgressCheck,
mdiProgressClock: mdiProgressClock,
mdiProgressClose: mdiProgressClose,
mdiProgressDownload: mdiProgressDownload,
mdiProgressHelper: mdiProgressHelper,
mdiProgressPencil: mdiProgressPencil,
mdiProgressQuestion: mdiProgressQuestion,
mdiProgressStar: mdiProgressStar,
mdiProgressUpload: mdiProgressUpload,
mdiProgressWrench: mdiProgressWrench,
mdiProjector: mdiProjector,
mdiProjectorOff: mdiProjectorOff,
mdiProjectorScreen: mdiProjectorScreen,
mdiProjectorScreenOff: mdiProjectorScreenOff,
mdiProjectorScreenOffOutline: mdiProjectorScreenOffOutline,
mdiProjectorScreenOutline: mdiProjectorScreenOutline,
mdiProjectorScreenVariant: mdiProjectorScreenVariant,
mdiProjectorScreenVariantOff: mdiProjectorScreenVariantOff,
mdiProjectorScreenVariantOffOutline: mdiProjectorScreenVariantOffOutline,
mdiProjectorScreenVariantOutline: mdiProjectorScreenVariantOutline,
mdiPropaneTank: mdiPropaneTank,
mdiPropaneTankOutline: mdiPropaneTankOutline,
mdiProtocol: mdiProtocol,
mdiPublish: mdiPublish,
mdiPublishOff: mdiPublishOff,
mdiPulse: mdiPulse,
mdiPump: mdiPump,
mdiPumpOff: mdiPumpOff,
mdiPumpkin: mdiPumpkin,
mdiPurse: mdiPurse,
mdiPurseOutline: mdiPurseOutline,
mdiPuzzle: mdiPuzzle,
mdiPuzzleCheck: mdiPuzzleCheck,
mdiPuzzleCheckOutline: mdiPuzzleCheckOutline,
mdiPuzzleEdit: mdiPuzzleEdit,
mdiPuzzleEditOutline: mdiPuzzleEditOutline,
mdiPuzzleHeart: mdiPuzzleHeart,
mdiPuzzleHeartOutline: mdiPuzzleHeartOutline,
mdiPuzzleMinus: mdiPuzzleMinus,
mdiPuzzleMinusOutline: mdiPuzzleMinusOutline,
mdiPuzzleOutline: mdiPuzzleOutline,
mdiPuzzlePlus: mdiPuzzlePlus,
mdiPuzzlePlusOutline: mdiPuzzlePlusOutline,
mdiPuzzleRemove: mdiPuzzleRemove,
mdiPuzzleRemoveOutline: mdiPuzzleRemoveOutline,
mdiPuzzleStar: mdiPuzzleStar,
mdiPuzzleStarOutline: mdiPuzzleStarOutline,
mdiPyramid: mdiPyramid,
mdiPyramidOff: mdiPyramidOff,
mdiQi: mdiQi,
mdiQqchat: mdiQqchat,
mdiQrcode: mdiQrcode,
mdiQrcodeEdit: mdiQrcodeEdit,
mdiQrcodeMinus: mdiQrcodeMinus,
mdiQrcodePlus: mdiQrcodePlus,
mdiQrcodeRemove: mdiQrcodeRemove,
mdiQrcodeScan: mdiQrcodeScan,
mdiQuadcopter: mdiQuadcopter,
mdiQualityHigh: mdiQualityHigh,
mdiQualityLow: mdiQualityLow,
mdiQualityMedium: mdiQualityMedium,
mdiQuora: mdiQuora,
mdiRabbit: mdiRabbit,
mdiRabbitVariant: mdiRabbitVariant,
mdiRabbitVariantOutline: mdiRabbitVariantOutline,
mdiRacingHelmet: mdiRacingHelmet,
mdiRacquetball: mdiRacquetball,
mdiRadar: mdiRadar,
mdiRadiator: mdiRadiator,
mdiRadiatorDisabled: mdiRadiatorDisabled,
mdiRadiatorOff: mdiRadiatorOff,
mdiRadio: mdiRadio,
mdiRadioAm: mdiRadioAm,
mdiRadioFm: mdiRadioFm,
mdiRadioHandheld: mdiRadioHandheld,
mdiRadioOff: mdiRadioOff,
mdiRadioTower: mdiRadioTower,
mdiRadioactive: mdiRadioactive,
mdiRadioactiveCircle: mdiRadioactiveCircle,
mdiRadioactiveCircleOutline: mdiRadioactiveCircleOutline,
mdiRadioactiveOff: mdiRadioactiveOff,
mdiRadioboxBlank: mdiRadioboxBlank,
mdiRadioboxMarked: mdiRadioboxMarked,
mdiRadiologyBox: mdiRadiologyBox,
mdiRadiologyBoxOutline: mdiRadiologyBoxOutline,
mdiRadius: mdiRadius,
mdiRadiusOutline: mdiRadiusOutline,
mdiRailroadLight: mdiRailroadLight,
mdiRake: mdiRake,
mdiRaspberryPi: mdiRaspberryPi,
mdiRaw: mdiRaw,
mdiRawOff: mdiRawOff,
mdiRayEnd: mdiRayEnd,
mdiRayEndArrow: mdiRayEndArrow,
mdiRayStart: mdiRayStart,
mdiRayStartArrow: mdiRayStartArrow,
mdiRayStartEnd: mdiRayStartEnd,
mdiRayStartVertexEnd: mdiRayStartVertexEnd,
mdiRayVertex: mdiRayVertex,
mdiRazorDoubleEdge: mdiRazorDoubleEdge,
mdiRazorSingleEdge: mdiRazorSingleEdge,
mdiReact: mdiReact,
mdiRead: mdiRead,
mdiReceipt: mdiReceipt,
mdiReceiptOutline: mdiReceiptOutline,
mdiReceiptText: mdiReceiptText,
mdiReceiptTextCheck: mdiReceiptTextCheck,
mdiReceiptTextCheckOutline: mdiReceiptTextCheckOutline,
mdiReceiptTextMinus: mdiReceiptTextMinus,
mdiReceiptTextMinusOutline: mdiReceiptTextMinusOutline,
mdiReceiptTextOutline: mdiReceiptTextOutline,
mdiReceiptTextPlus: mdiReceiptTextPlus,
mdiReceiptTextPlusOutline: mdiReceiptTextPlusOutline,
mdiReceiptTextRemove: mdiReceiptTextRemove,
mdiReceiptTextRemoveOutline: mdiReceiptTextRemoveOutline,
mdiRecord: mdiRecord,
mdiRecordCircle: mdiRecordCircle,
mdiRecordCircleOutline: mdiRecordCircleOutline,
mdiRecordPlayer: mdiRecordPlayer,
mdiRecordRec: mdiRecordRec,
mdiRectangle: mdiRectangle,
mdiRectangleOutline: mdiRectangleOutline,
mdiRecycle: mdiRecycle,
mdiRecycleVariant: mdiRecycleVariant,
mdiReddit: mdiReddit,
mdiRedhat: mdiRedhat,
mdiRedo: mdiRedo,
mdiRedoVariant: mdiRedoVariant,
mdiReflectHorizontal: mdiReflectHorizontal,
mdiReflectVertical: mdiReflectVertical,
mdiRefresh: mdiRefresh,
mdiRefreshAuto: mdiRefreshAuto,
mdiRefreshCircle: mdiRefreshCircle,
mdiRegex: mdiRegex,
mdiRegisteredTrademark: mdiRegisteredTrademark,
mdiReiterate: mdiReiterate,
mdiRelationManyToMany: mdiRelationManyToMany,
mdiRelationManyToOne: mdiRelationManyToOne,
mdiRelationManyToOneOrMany: mdiRelationManyToOneOrMany,
mdiRelationManyToOnlyOne: mdiRelationManyToOnlyOne,
mdiRelationManyToZeroOrMany: mdiRelationManyToZeroOrMany,
mdiRelationManyToZeroOrOne: mdiRelationManyToZeroOrOne,
mdiRelationOneOrManyToMany: mdiRelationOneOrManyToMany,
mdiRelationOneOrManyToOne: mdiRelationOneOrManyToOne,
mdiRelationOneOrManyToOneOrMany: mdiRelationOneOrManyToOneOrMany,
mdiRelationOneOrManyToOnlyOne: mdiRelationOneOrManyToOnlyOne,
mdiRelationOneOrManyToZeroOrMany: mdiRelationOneOrManyToZeroOrMany,
mdiRelationOneOrManyToZeroOrOne: mdiRelationOneOrManyToZeroOrOne,
mdiRelationOneToMany: mdiRelationOneToMany,
mdiRelationOneToOne: mdiRelationOneToOne,
mdiRelationOneToOneOrMany: mdiRelationOneToOneOrMany,
mdiRelationOneToOnlyOne: mdiRelationOneToOnlyOne,
mdiRelationOneToZeroOrMany: mdiRelationOneToZeroOrMany,
mdiRelationOneToZeroOrOne: mdiRelationOneToZeroOrOne,
mdiRelationOnlyOneToMany: mdiRelationOnlyOneToMany,
mdiRelationOnlyOneToOne: mdiRelationOnlyOneToOne,
mdiRelationOnlyOneToOneOrMany: mdiRelationOnlyOneToOneOrMany,
mdiRelationOnlyOneToOnlyOne: mdiRelationOnlyOneToOnlyOne,
mdiRelationOnlyOneToZeroOrMany: mdiRelationOnlyOneToZeroOrMany,
mdiRelationOnlyOneToZeroOrOne: mdiRelationOnlyOneToZeroOrOne,
mdiRelationZeroOrManyToMany: mdiRelationZeroOrManyToMany,
mdiRelationZeroOrManyToOne: mdiRelationZeroOrManyToOne,
mdiRelationZeroOrManyToOneOrMany: mdiRelationZeroOrManyToOneOrMany,
mdiRelationZeroOrManyToOnlyOne: mdiRelationZeroOrManyToOnlyOne,
mdiRelationZeroOrManyToZeroOrMany: mdiRelationZeroOrManyToZeroOrMany,
mdiRelationZeroOrManyToZeroOrOne: mdiRelationZeroOrManyToZeroOrOne,
mdiRelationZeroOrOneToMany: mdiRelationZeroOrOneToMany,
mdiRelationZeroOrOneToOne: mdiRelationZeroOrOneToOne,
mdiRelationZeroOrOneToOneOrMany: mdiRelationZeroOrOneToOneOrMany,
mdiRelationZeroOrOneToOnlyOne: mdiRelationZeroOrOneToOnlyOne,
mdiRelationZeroOrOneToZeroOrMany: mdiRelationZeroOrOneToZeroOrMany,
mdiRelationZeroOrOneToZeroOrOne: mdiRelationZeroOrOneToZeroOrOne,
mdiRelativeScale: mdiRelativeScale,
mdiReload: mdiReload,
mdiReloadAlert: mdiReloadAlert,
mdiReminder: mdiReminder,
mdiRemote: mdiRemote,
mdiRemoteDesktop: mdiRemoteDesktop,
mdiRemoteOff: mdiRemoteOff,
mdiRemoteTv: mdiRemoteTv,
mdiRemoteTvOff: mdiRemoteTvOff,
mdiRenameBox: mdiRenameBox,
mdiReorderHorizontal: mdiReorderHorizontal,
mdiReorderVertical: mdiReorderVertical,
mdiRepeat: mdiRepeat,
mdiRepeatOff: mdiRepeatOff,
mdiRepeatOnce: mdiRepeatOnce,
mdiRepeatVariant: mdiRepeatVariant,
mdiReplay: mdiReplay,
mdiReply: mdiReply,
mdiReplyAll: mdiReplyAll,
mdiReplyAllOutline: mdiReplyAllOutline,
mdiReplyCircle: mdiReplyCircle,
mdiReplyOutline: mdiReplyOutline,
mdiReproduction: mdiReproduction,
mdiResistor: mdiResistor,
mdiResistorNodes: mdiResistorNodes,
mdiResize: mdiResize,
mdiResizeBottomRight: mdiResizeBottomRight,
mdiResponsive: mdiResponsive,
mdiRestart: mdiRestart,
mdiRestartAlert: mdiRestartAlert,
mdiRestartOff: mdiRestartOff,
mdiRestore: mdiRestore,
mdiRestoreAlert: mdiRestoreAlert,
mdiRewind: mdiRewind,
mdiRewind10: mdiRewind10,
mdiRewind15: mdiRewind15,
mdiRewind30: mdiRewind30,
mdiRewind45: mdiRewind45,
mdiRewind5: mdiRewind5,
mdiRewind60: mdiRewind60,
mdiRewindOutline: mdiRewindOutline,
mdiRhombus: mdiRhombus,
mdiRhombusMedium: mdiRhombusMedium,
mdiRhombusMediumOutline: mdiRhombusMediumOutline,
mdiRhombusOutline: mdiRhombusOutline,
mdiRhombusSplit: mdiRhombusSplit,
mdiRhombusSplitOutline: mdiRhombusSplitOutline,
mdiRibbon: mdiRibbon,
mdiRice: mdiRice,
mdiRickshaw: mdiRickshaw,
mdiRickshawElectric: mdiRickshawElectric,
mdiRing: mdiRing,
mdiRivet: mdiRivet,
mdiRoad: mdiRoad,
mdiRoadVariant: mdiRoadVariant,
mdiRobber: mdiRobber,
mdiRobot: mdiRobot,
mdiRobotAngry: mdiRobotAngry,
mdiRobotAngryOutline: mdiRobotAngryOutline,
mdiRobotConfused: mdiRobotConfused,
mdiRobotConfusedOutline: mdiRobotConfusedOutline,
mdiRobotDead: mdiRobotDead,
mdiRobotDeadOutline: mdiRobotDeadOutline,
mdiRobotExcited: mdiRobotExcited,
mdiRobotExcitedOutline: mdiRobotExcitedOutline,
mdiRobotHappy: mdiRobotHappy,
mdiRobotHappyOutline: mdiRobotHappyOutline,
mdiRobotIndustrial: mdiRobotIndustrial,
mdiRobotIndustrialOutline: mdiRobotIndustrialOutline,
mdiRobotLove: mdiRobotLove,
mdiRobotLoveOutline: mdiRobotLoveOutline,
mdiRobotMower: mdiRobotMower,
mdiRobotMowerOutline: mdiRobotMowerOutline,
mdiRobotOff: mdiRobotOff,
mdiRobotOffOutline: mdiRobotOffOutline,
mdiRobotOutline: mdiRobotOutline,
mdiRobotVacuum: mdiRobotVacuum,
mdiRobotVacuumAlert: mdiRobotVacuumAlert,
mdiRobotVacuumVariant: mdiRobotVacuumVariant,
mdiRobotVacuumVariantAlert: mdiRobotVacuumVariantAlert,
mdiRocket: mdiRocket,
mdiRocketLaunch: mdiRocketLaunch,
mdiRocketLaunchOutline: mdiRocketLaunchOutline,
mdiRocketOutline: mdiRocketOutline,
mdiRodent: mdiRodent,
mdiRollerShade: mdiRollerShade,
mdiRollerShadeClosed: mdiRollerShadeClosed,
mdiRollerSkate: mdiRollerSkate,
mdiRollerSkateOff: mdiRollerSkateOff,
mdiRollerblade: mdiRollerblade,
mdiRollerbladeOff: mdiRollerbladeOff,
mdiRollupjs: mdiRollupjs,
mdiRolodex: mdiRolodex,
mdiRolodexOutline: mdiRolodexOutline,
mdiRomanNumeral1: mdiRomanNumeral1,
mdiRomanNumeral10: mdiRomanNumeral10,
mdiRomanNumeral2: mdiRomanNumeral2,
mdiRomanNumeral3: mdiRomanNumeral3,
mdiRomanNumeral4: mdiRomanNumeral4,
mdiRomanNumeral5: mdiRomanNumeral5,
mdiRomanNumeral6: mdiRomanNumeral6,
mdiRomanNumeral7: mdiRomanNumeral7,
mdiRomanNumeral8: mdiRomanNumeral8,
mdiRomanNumeral9: mdiRomanNumeral9,
mdiRoomService: mdiRoomService,
mdiRoomServiceOutline: mdiRoomServiceOutline,
mdiRotate360: mdiRotate360,
mdiRotate3d: mdiRotate3d,
mdiRotate3dVariant: mdiRotate3dVariant,
mdiRotateLeft: mdiRotateLeft,
mdiRotateLeftVariant: mdiRotateLeftVariant,
mdiRotateOrbit: mdiRotateOrbit,
mdiRotateRight: mdiRotateRight,
mdiRotateRightVariant: mdiRotateRightVariant,
mdiRoundedCorner: mdiRoundedCorner,
mdiRouter: mdiRouter,
mdiRouterNetwork: mdiRouterNetwork,
mdiRouterWireless: mdiRouterWireless,
mdiRouterWirelessOff: mdiRouterWirelessOff,
mdiRouterWirelessSettings: mdiRouterWirelessSettings,
mdiRoutes: mdiRoutes,
mdiRoutesClock: mdiRoutesClock,
mdiRowing: mdiRowing,
mdiRss: mdiRss,
mdiRssBox: mdiRssBox,
mdiRssOff: mdiRssOff,
mdiRug: mdiRug,
mdiRugby: mdiRugby,
mdiRuler: mdiRuler,
mdiRulerSquare: mdiRulerSquare,
mdiRulerSquareCompass: mdiRulerSquareCompass,
mdiRun: mdiRun,
mdiRunFast: mdiRunFast,
mdiRvTruck: mdiRvTruck,
mdiSack: mdiSack,
mdiSackPercent: mdiSackPercent,
mdiSafe: mdiSafe,
mdiSafeSquare: mdiSafeSquare,
mdiSafeSquareOutline: mdiSafeSquareOutline,
mdiSafetyGoggles: mdiSafetyGoggles,
mdiSailBoat: mdiSailBoat,
mdiSailBoatSink: mdiSailBoatSink,
mdiSale: mdiSale,
mdiSaleOutline: mdiSaleOutline,
mdiSalesforce: mdiSalesforce,
mdiSass: mdiSass,
mdiSatellite: mdiSatellite,
mdiSatelliteUplink: mdiSatelliteUplink,
mdiSatelliteVariant: mdiSatelliteVariant,
mdiSausage: mdiSausage,
mdiSausageOff: mdiSausageOff,
mdiSawBlade: mdiSawBlade,
mdiSawtoothWave: mdiSawtoothWave,
mdiSaxophone: mdiSaxophone,
mdiScale: mdiScale,
mdiScaleBalance: mdiScaleBalance,
mdiScaleBathroom: mdiScaleBathroom,
mdiScaleOff: mdiScaleOff,
mdiScaleUnbalanced: mdiScaleUnbalanced,
mdiScanHelper: mdiScanHelper,
mdiScanner: mdiScanner,
mdiScannerOff: mdiScannerOff,
mdiScatterPlot: mdiScatterPlot,
mdiScatterPlotOutline: mdiScatterPlotOutline,
mdiScent: mdiScent,
mdiScentOff: mdiScentOff,
mdiSchool: mdiSchool,
mdiSchoolOutline: mdiSchoolOutline,
mdiScissorsCutting: mdiScissorsCutting,
mdiScooter: mdiScooter,
mdiScooterElectric: mdiScooterElectric,
mdiScoreboard: mdiScoreboard,
mdiScoreboardOutline: mdiScoreboardOutline,
mdiScreenRotation: mdiScreenRotation,
mdiScreenRotationLock: mdiScreenRotationLock,
mdiScrewFlatTop: mdiScrewFlatTop,
mdiScrewLag: mdiScrewLag,
mdiScrewMachineFlatTop: mdiScrewMachineFlatTop,
mdiScrewMachineRoundTop: mdiScrewMachineRoundTop,
mdiScrewRoundTop: mdiScrewRoundTop,
mdiScrewdriver: mdiScrewdriver,
mdiScript: mdiScript,
mdiScriptOutline: mdiScriptOutline,
mdiScriptText: mdiScriptText,
mdiScriptTextKey: mdiScriptTextKey,
mdiScriptTextKeyOutline: mdiScriptTextKeyOutline,
mdiScriptTextOutline: mdiScriptTextOutline,
mdiScriptTextPlay: mdiScriptTextPlay,
mdiScriptTextPlayOutline: mdiScriptTextPlayOutline,
mdiSd: mdiSd,
mdiSeal: mdiSeal,
mdiSealVariant: mdiSealVariant,
mdiSearchWeb: mdiSearchWeb,
mdiSeat: mdiSeat,
mdiSeatFlat: mdiSeatFlat,
mdiSeatFlatAngled: mdiSeatFlatAngled,
mdiSeatIndividualSuite: mdiSeatIndividualSuite,
mdiSeatLegroomExtra: mdiSeatLegroomExtra,
mdiSeatLegroomNormal: mdiSeatLegroomNormal,
mdiSeatLegroomReduced: mdiSeatLegroomReduced,
mdiSeatOutline: mdiSeatOutline,
mdiSeatPassenger: mdiSeatPassenger,
mdiSeatReclineExtra: mdiSeatReclineExtra,
mdiSeatReclineNormal: mdiSeatReclineNormal,
mdiSeatbelt: mdiSeatbelt,
mdiSecurity: mdiSecurity,
mdiSecurityNetwork: mdiSecurityNetwork,
mdiSeed: mdiSeed,
mdiSeedOff: mdiSeedOff,
mdiSeedOffOutline: mdiSeedOffOutline,
mdiSeedOutline: mdiSeedOutline,
mdiSeedPlus: mdiSeedPlus,
mdiSeedPlusOutline: mdiSeedPlusOutline,
mdiSeesaw: mdiSeesaw,
mdiSegment: mdiSegment,
mdiSelect: mdiSelect,
mdiSelectAll: mdiSelectAll,
mdiSelectArrowDown: mdiSelectArrowDown,
mdiSelectArrowUp: mdiSelectArrowUp,
mdiSelectColor: mdiSelectColor,
mdiSelectCompare: mdiSelectCompare,
mdiSelectDrag: mdiSelectDrag,
mdiSelectGroup: mdiSelectGroup,
mdiSelectInverse: mdiSelectInverse,
mdiSelectMarker: mdiSelectMarker,
mdiSelectMultiple: mdiSelectMultiple,
mdiSelectMultipleMarker: mdiSelectMultipleMarker,
mdiSelectOff: mdiSelectOff,
mdiSelectPlace: mdiSelectPlace,
mdiSelectRemove: mdiSelectRemove,
mdiSelectSearch: mdiSelectSearch,
mdiSelection: mdiSelection,
mdiSelectionDrag: mdiSelectionDrag,
mdiSelectionEllipse: mdiSelectionEllipse,
mdiSelectionEllipseArrowInside: mdiSelectionEllipseArrowInside,
mdiSelectionEllipseRemove: mdiSelectionEllipseRemove,
mdiSelectionMarker: mdiSelectionMarker,
mdiSelectionMultiple: mdiSelectionMultiple,
mdiSelectionMultipleMarker: mdiSelectionMultipleMarker,
mdiSelectionOff: mdiSelectionOff,
mdiSelectionRemove: mdiSelectionRemove,
mdiSelectionSearch: mdiSelectionSearch,
mdiSemanticWeb: mdiSemanticWeb,
mdiSend: mdiSend,
mdiSendCheck: mdiSendCheck,
mdiSendCheckOutline: mdiSendCheckOutline,
mdiSendCircle: mdiSendCircle,
mdiSendCircleOutline: mdiSendCircleOutline,
mdiSendClock: mdiSendClock,
mdiSendClockOutline: mdiSendClockOutline,
mdiSendLock: mdiSendLock,
mdiSendLockOutline: mdiSendLockOutline,
mdiSendOutline: mdiSendOutline,
mdiSerialPort: mdiSerialPort,
mdiServer: mdiServer,
mdiServerMinus: mdiServerMinus,
mdiServerNetwork: mdiServerNetwork,
mdiServerNetworkOff: mdiServerNetworkOff,
mdiServerOff: mdiServerOff,
mdiServerPlus: mdiServerPlus,
mdiServerRemove: mdiServerRemove,
mdiServerSecurity: mdiServerSecurity,
mdiSetAll: mdiSetAll,
mdiSetCenter: mdiSetCenter,
mdiSetCenterRight: mdiSetCenterRight,
mdiSetLeft: mdiSetLeft,
mdiSetLeftCenter: mdiSetLeftCenter,
mdiSetLeftRight: mdiSetLeftRight,
mdiSetMerge: mdiSetMerge,
mdiSetNone: mdiSetNone,
mdiSetRight: mdiSetRight,
mdiSetSplit: mdiSetSplit,
mdiSetSquare: mdiSetSquare,
mdiSetTopBox: mdiSetTopBox,
mdiSettingsHelper: mdiSettingsHelper,
mdiShaker: mdiShaker,
mdiShakerOutline: mdiShakerOutline,
mdiShape: mdiShape,
mdiShapeCirclePlus: mdiShapeCirclePlus,
mdiShapeOutline: mdiShapeOutline,
mdiShapeOvalPlus: mdiShapeOvalPlus,
mdiShapePlus: mdiShapePlus,
mdiShapePolygonPlus: mdiShapePolygonPlus,
mdiShapeRectanglePlus: mdiShapeRectanglePlus,
mdiShapeSquarePlus: mdiShapeSquarePlus,
mdiShapeSquareRoundedPlus: mdiShapeSquareRoundedPlus,
mdiShare: mdiShare,
mdiShareAll: mdiShareAll,
mdiShareAllOutline: mdiShareAllOutline,
mdiShareCircle: mdiShareCircle,
mdiShareOff: mdiShareOff,
mdiShareOffOutline: mdiShareOffOutline,
mdiShareOutline: mdiShareOutline,
mdiShareVariant: mdiShareVariant,
mdiShareVariantOutline: mdiShareVariantOutline,
mdiShark: mdiShark,
mdiSharkFin: mdiSharkFin,
mdiSharkFinOutline: mdiSharkFinOutline,
mdiSharkOff: mdiSharkOff,
mdiSheep: mdiSheep,
mdiShield: mdiShield,
mdiShieldAccount: mdiShieldAccount,
mdiShieldAccountOutline: mdiShieldAccountOutline,
mdiShieldAccountVariant: mdiShieldAccountVariant,
mdiShieldAccountVariantOutline: mdiShieldAccountVariantOutline,
mdiShieldAirplane: mdiShieldAirplane,
mdiShieldAirplaneOutline: mdiShieldAirplaneOutline,
mdiShieldAlert: mdiShieldAlert,
mdiShieldAlertOutline: mdiShieldAlertOutline,
mdiShieldBug: mdiShieldBug,
mdiShieldBugOutline: mdiShieldBugOutline,
mdiShieldCar: mdiShieldCar,
mdiShieldCheck: mdiShieldCheck,
mdiShieldCheckOutline: mdiShieldCheckOutline,
mdiShieldCross: mdiShieldCross,
mdiShieldCrossOutline: mdiShieldCrossOutline,
mdiShieldCrown: mdiShieldCrown,
mdiShieldCrownOutline: mdiShieldCrownOutline,
mdiShieldEdit: mdiShieldEdit,
mdiShieldEditOutline: mdiShieldEditOutline,
mdiShieldHalf: mdiShieldHalf,
mdiShieldHalfFull: mdiShieldHalfFull,
mdiShieldHome: mdiShieldHome,
mdiShieldHomeOutline: mdiShieldHomeOutline,
mdiShieldKey: mdiShieldKey,
mdiShieldKeyOutline: mdiShieldKeyOutline,
mdiShieldLinkVariant: mdiShieldLinkVariant,
mdiShieldLinkVariantOutline: mdiShieldLinkVariantOutline,
mdiShieldLock: mdiShieldLock,
mdiShieldLockOpen: mdiShieldLockOpen,
mdiShieldLockOpenOutline: mdiShieldLockOpenOutline,
mdiShieldLockOutline: mdiShieldLockOutline,
mdiShieldMoon: mdiShieldMoon,
mdiShieldMoonOutline: mdiShieldMoonOutline,
mdiShieldOff: mdiShieldOff,
mdiShieldOffOutline: mdiShieldOffOutline,
mdiShieldOutline: mdiShieldOutline,
mdiShieldPlus: mdiShieldPlus,
mdiShieldPlusOutline: mdiShieldPlusOutline,
mdiShieldRefresh: mdiShieldRefresh,
mdiShieldRefreshOutline: mdiShieldRefreshOutline,
mdiShieldRemove: mdiShieldRemove,
mdiShieldRemoveOutline: mdiShieldRemoveOutline,
mdiShieldSearch: mdiShieldSearch,
mdiShieldStar: mdiShieldStar,
mdiShieldStarOutline: mdiShieldStarOutline,
mdiShieldSun: mdiShieldSun,
mdiShieldSunOutline: mdiShieldSunOutline,
mdiShieldSword: mdiShieldSword,
mdiShieldSwordOutline: mdiShieldSwordOutline,
mdiShieldSync: mdiShieldSync,
mdiShieldSyncOutline: mdiShieldSyncOutline,
mdiShimmer: mdiShimmer,
mdiShipWheel: mdiShipWheel,
mdiShippingPallet: mdiShippingPallet,
mdiShoeBallet: mdiShoeBallet,
mdiShoeCleat: mdiShoeCleat,
mdiShoeFormal: mdiShoeFormal,
mdiShoeHeel: mdiShoeHeel,
mdiShoePrint: mdiShoePrint,
mdiShoeSneaker: mdiShoeSneaker,
mdiShopping: mdiShopping,
mdiShoppingMusic: mdiShoppingMusic,
mdiShoppingOutline: mdiShoppingOutline,
mdiShoppingSearch: mdiShoppingSearch,
mdiShoppingSearchOutline: mdiShoppingSearchOutline,
mdiShore: mdiShore,
mdiShovel: mdiShovel,
mdiShovelOff: mdiShovelOff,
mdiShower: mdiShower,
mdiShowerHead: mdiShowerHead,
mdiShredder: mdiShredder,
mdiShuffle: mdiShuffle,
mdiShuffleDisabled: mdiShuffleDisabled,
mdiShuffleVariant: mdiShuffleVariant,
mdiShuriken: mdiShuriken,
mdiSickle: mdiSickle,
mdiSigma: mdiSigma,
mdiSigmaLower: mdiSigmaLower,
mdiSignCaution: mdiSignCaution,
mdiSignDirection: mdiSignDirection,
mdiSignDirectionMinus: mdiSignDirectionMinus,
mdiSignDirectionPlus: mdiSignDirectionPlus,
mdiSignDirectionRemove: mdiSignDirectionRemove,
mdiSignLanguage: mdiSignLanguage,
mdiSignLanguageOutline: mdiSignLanguageOutline,
mdiSignPole: mdiSignPole,
mdiSignRealEstate: mdiSignRealEstate,
mdiSignText: mdiSignText,
mdiSignYield: mdiSignYield,
mdiSignal: mdiSignal,
mdiSignal2g: mdiSignal2g,
mdiSignal3g: mdiSignal3g,
mdiSignal4g: mdiSignal4g,
mdiSignal5g: mdiSignal5g,
mdiSignalCellular1: mdiSignalCellular1,
mdiSignalCellular2: mdiSignalCellular2,
mdiSignalCellular3: mdiSignalCellular3,
mdiSignalCellularOutline: mdiSignalCellularOutline,
mdiSignalDistanceVariant: mdiSignalDistanceVariant,
mdiSignalHspa: mdiSignalHspa,
mdiSignalHspaPlus: mdiSignalHspaPlus,
mdiSignalOff: mdiSignalOff,
mdiSignalVariant: mdiSignalVariant,
mdiSignature: mdiSignature,
mdiSignatureFreehand: mdiSignatureFreehand,
mdiSignatureImage: mdiSignatureImage,
mdiSignatureText: mdiSignatureText,
mdiSilo: mdiSilo,
mdiSiloOutline: mdiSiloOutline,
mdiSilverware: mdiSilverware,
mdiSilverwareClean: mdiSilverwareClean,
mdiSilverwareFork: mdiSilverwareFork,
mdiSilverwareForkKnife: mdiSilverwareForkKnife,
mdiSilverwareSpoon: mdiSilverwareSpoon,
mdiSilverwareVariant: mdiSilverwareVariant,
mdiSim: mdiSim,
mdiSimAlert: mdiSimAlert,
mdiSimAlertOutline: mdiSimAlertOutline,
mdiSimOff: mdiSimOff,
mdiSimOffOutline: mdiSimOffOutline,
mdiSimOutline: mdiSimOutline,
mdiSimpleIcons: mdiSimpleIcons,
mdiSinaWeibo: mdiSinaWeibo,
mdiSineWave: mdiSineWave,
mdiSitemap: mdiSitemap,
mdiSitemapOutline: mdiSitemapOutline,
mdiSizeL: mdiSizeL,
mdiSizeM: mdiSizeM,
mdiSizeS: mdiSizeS,
mdiSizeXl: mdiSizeXl,
mdiSizeXs: mdiSizeXs,
mdiSizeXxl: mdiSizeXxl,
mdiSizeXxs: mdiSizeXxs,
mdiSizeXxxl: mdiSizeXxxl,
mdiSkate: mdiSkate,
mdiSkateOff: mdiSkateOff,
mdiSkateboard: mdiSkateboard,
mdiSkateboarding: mdiSkateboarding,
mdiSkewLess: mdiSkewLess,
mdiSkewMore: mdiSkewMore,
mdiSki: mdiSki,
mdiSkiCrossCountry: mdiSkiCrossCountry,
mdiSkiWater: mdiSkiWater,
mdiSkipBackward: mdiSkipBackward,
mdiSkipBackwardOutline: mdiSkipBackwardOutline,
mdiSkipForward: mdiSkipForward,
mdiSkipForwardOutline: mdiSkipForwardOutline,
mdiSkipNext: mdiSkipNext,
mdiSkipNextCircle: mdiSkipNextCircle,
mdiSkipNextCircleOutline: mdiSkipNextCircleOutline,
mdiSkipNextOutline: mdiSkipNextOutline,
mdiSkipPrevious: mdiSkipPrevious,
mdiSkipPreviousCircle: mdiSkipPreviousCircle,
mdiSkipPreviousCircleOutline: mdiSkipPreviousCircleOutline,
mdiSkipPreviousOutline: mdiSkipPreviousOutline,
mdiSkull: mdiSkull,
mdiSkullCrossbones: mdiSkullCrossbones,
mdiSkullCrossbonesOutline: mdiSkullCrossbonesOutline,
mdiSkullOutline: mdiSkullOutline,
mdiSkullScan: mdiSkullScan,
mdiSkullScanOutline: mdiSkullScanOutline,
mdiSkype: mdiSkype,
mdiSkypeBusiness: mdiSkypeBusiness,
mdiSlack: mdiSlack,
mdiSlashForward: mdiSlashForward,
mdiSlashForwardBox: mdiSlashForwardBox,
mdiSledding: mdiSledding,
mdiSleep: mdiSleep,
mdiSleepOff: mdiSleepOff,
mdiSlide: mdiSlide,
mdiSlopeDownhill: mdiSlopeDownhill,
mdiSlopeUphill: mdiSlopeUphill,
mdiSlotMachine: mdiSlotMachine,
mdiSlotMachineOutline: mdiSlotMachineOutline,
mdiSmartCard: mdiSmartCard,
mdiSmartCardOff: mdiSmartCardOff,
mdiSmartCardOffOutline: mdiSmartCardOffOutline,
mdiSmartCardOutline: mdiSmartCardOutline,
mdiSmartCardReader: mdiSmartCardReader,
mdiSmartCardReaderOutline: mdiSmartCardReaderOutline,
mdiSmog: mdiSmog,
mdiSmoke: mdiSmoke,
mdiSmokeDetector: mdiSmokeDetector,
mdiSmokeDetectorAlert: mdiSmokeDetectorAlert,
mdiSmokeDetectorAlertOutline: mdiSmokeDetectorAlertOutline,
mdiSmokeDetectorOff: mdiSmokeDetectorOff,
mdiSmokeDetectorOffOutline: mdiSmokeDetectorOffOutline,
mdiSmokeDetectorOutline: mdiSmokeDetectorOutline,
mdiSmokeDetectorVariant: mdiSmokeDetectorVariant,
mdiSmokeDetectorVariantAlert: mdiSmokeDetectorVariantAlert,
mdiSmokeDetectorVariantOff: mdiSmokeDetectorVariantOff,
mdiSmoking: mdiSmoking,
mdiSmokingOff: mdiSmokingOff,
mdiSmokingPipe: mdiSmokingPipe,
mdiSmokingPipeOff: mdiSmokingPipeOff,
mdiSnail: mdiSnail,
mdiSnake: mdiSnake,
mdiSnapchat: mdiSnapchat,
mdiSnowboard: mdiSnowboard,
mdiSnowflake: mdiSnowflake,
mdiSnowflakeAlert: mdiSnowflakeAlert,
mdiSnowflakeCheck: mdiSnowflakeCheck,
mdiSnowflakeMelt: mdiSnowflakeMelt,
mdiSnowflakeOff: mdiSnowflakeOff,
mdiSnowflakeThermometer: mdiSnowflakeThermometer,
mdiSnowflakeVariant: mdiSnowflakeVariant,
mdiSnowman: mdiSnowman,
mdiSnowmobile: mdiSnowmobile,
mdiSnowshoeing: mdiSnowshoeing,
mdiSoccer: mdiSoccer,
mdiSoccerField: mdiSoccerField,
mdiSocialDistance2Meters: mdiSocialDistance2Meters,
mdiSocialDistance6Feet: mdiSocialDistance6Feet,
mdiSofa: mdiSofa,
mdiSofaOutline: mdiSofaOutline,
mdiSofaSingle: mdiSofaSingle,
mdiSofaSingleOutline: mdiSofaSingleOutline,
mdiSolarPanel: mdiSolarPanel,
mdiSolarPanelLarge: mdiSolarPanelLarge,
mdiSolarPower: mdiSolarPower,
mdiSolarPowerVariant: mdiSolarPowerVariant,
mdiSolarPowerVariantOutline: mdiSolarPowerVariantOutline,
mdiSolderingIron: mdiSolderingIron,
mdiSolid: mdiSolid,
mdiSonyPlaystation: mdiSonyPlaystation,
mdiSort: mdiSort,
mdiSortAlphabeticalAscending: mdiSortAlphabeticalAscending,
mdiSortAlphabeticalAscendingVariant: mdiSortAlphabeticalAscendingVariant,
mdiSortAlphabeticalDescending: mdiSortAlphabeticalDescending,
mdiSortAlphabeticalDescendingVariant: mdiSortAlphabeticalDescendingVariant,
mdiSortAlphabeticalVariant: mdiSortAlphabeticalVariant,
mdiSortAscending: mdiSortAscending,
mdiSortBoolAscending: mdiSortBoolAscending,
mdiSortBoolAscendingVariant: mdiSortBoolAscendingVariant,
mdiSortBoolDescending: mdiSortBoolDescending,
mdiSortBoolDescendingVariant: mdiSortBoolDescendingVariant,
mdiSortCalendarAscending: mdiSortCalendarAscending,
mdiSortCalendarDescending: mdiSortCalendarDescending,
mdiSortClockAscending: mdiSortClockAscending,
mdiSortClockAscendingOutline: mdiSortClockAscendingOutline,
mdiSortClockDescending: mdiSortClockDescending,
mdiSortClockDescendingOutline: mdiSortClockDescendingOutline,
mdiSortDescending: mdiSortDescending,
mdiSortNumericAscending: mdiSortNumericAscending,
mdiSortNumericAscendingVariant: mdiSortNumericAscendingVariant,
mdiSortNumericDescending: mdiSortNumericDescending,
mdiSortNumericDescendingVariant: mdiSortNumericDescendingVariant,
mdiSortNumericVariant: mdiSortNumericVariant,
mdiSortReverseVariant: mdiSortReverseVariant,
mdiSortVariant: mdiSortVariant,
mdiSortVariantLock: mdiSortVariantLock,
mdiSortVariantLockOpen: mdiSortVariantLockOpen,
mdiSortVariantOff: mdiSortVariantOff,
mdiSortVariantRemove: mdiSortVariantRemove,
mdiSoundbar: mdiSoundbar,
mdiSoundcloud: mdiSoundcloud,
mdiSourceBranch: mdiSourceBranch,
mdiSourceBranchCheck: mdiSourceBranchCheck,
mdiSourceBranchMinus: mdiSourceBranchMinus,
mdiSourceBranchPlus: mdiSourceBranchPlus,
mdiSourceBranchRefresh: mdiSourceBranchRefresh,
mdiSourceBranchRemove: mdiSourceBranchRemove,
mdiSourceBranchSync: mdiSourceBranchSync,
mdiSourceCommit: mdiSourceCommit,
mdiSourceCommitEnd: mdiSourceCommitEnd,
mdiSourceCommitEndLocal: mdiSourceCommitEndLocal,
mdiSourceCommitLocal: mdiSourceCommitLocal,
mdiSourceCommitNextLocal: mdiSourceCommitNextLocal,
mdiSourceCommitStart: mdiSourceCommitStart,
mdiSourceCommitStartNextLocal: mdiSourceCommitStartNextLocal,
mdiSourceFork: mdiSourceFork,
mdiSourceMerge: mdiSourceMerge,
mdiSourcePull: mdiSourcePull,
mdiSourceRepository: mdiSourceRepository,
mdiSourceRepositoryMultiple: mdiSourceRepositoryMultiple,
mdiSoySauce: mdiSoySauce,
mdiSoySauceOff: mdiSoySauceOff,
mdiSpa: mdiSpa,
mdiSpaOutline: mdiSpaOutline,
mdiSpaceInvaders: mdiSpaceInvaders,
mdiSpaceStation: mdiSpaceStation,
mdiSpade: mdiSpade,
mdiSpeaker: mdiSpeaker,
mdiSpeakerBluetooth: mdiSpeakerBluetooth,
mdiSpeakerMessage: mdiSpeakerMessage,
mdiSpeakerMultiple: mdiSpeakerMultiple,
mdiSpeakerOff: mdiSpeakerOff,
mdiSpeakerPause: mdiSpeakerPause,
mdiSpeakerPlay: mdiSpeakerPlay,
mdiSpeakerStop: mdiSpeakerStop,
mdiSpeakerWireless: mdiSpeakerWireless,
mdiSpear: mdiSpear,
mdiSpeedometer: mdiSpeedometer,
mdiSpeedometerMedium: mdiSpeedometerMedium,
mdiSpeedometerSlow: mdiSpeedometerSlow,
mdiSpellcheck: mdiSpellcheck,
mdiSphere: mdiSphere,
mdiSphereOff: mdiSphereOff,
mdiSpider: mdiSpider,
mdiSpiderThread: mdiSpiderThread,
mdiSpiderWeb: mdiSpiderWeb,
mdiSpiritLevel: mdiSpiritLevel,
mdiSpoonSugar: mdiSpoonSugar,
mdiSpotify: mdiSpotify,
mdiSpotlight: mdiSpotlight,
mdiSpotlightBeam: mdiSpotlightBeam,
mdiSpray: mdiSpray,
mdiSprayBottle: mdiSprayBottle,
mdiSprinkler: mdiSprinkler,
mdiSprinklerFire: mdiSprinklerFire,
mdiSprinklerVariant: mdiSprinklerVariant,
mdiSprout: mdiSprout,
mdiSproutOutline: mdiSproutOutline,
mdiSquare: mdiSquare,
mdiSquareCircle: mdiSquareCircle,
mdiSquareEditOutline: mdiSquareEditOutline,
mdiSquareMedium: mdiSquareMedium,
mdiSquareMediumOutline: mdiSquareMediumOutline,
mdiSquareOff: mdiSquareOff,
mdiSquareOffOutline: mdiSquareOffOutline,
mdiSquareOpacity: mdiSquareOpacity,
mdiSquareOutline: mdiSquareOutline,
mdiSquareRoot: mdiSquareRoot,
mdiSquareRootBox: mdiSquareRootBox,
mdiSquareRounded: mdiSquareRounded,
mdiSquareRoundedBadge: mdiSquareRoundedBadge,
mdiSquareRoundedBadgeOutline: mdiSquareRoundedBadgeOutline,
mdiSquareRoundedOutline: mdiSquareRoundedOutline,
mdiSquareSmall: mdiSquareSmall,
mdiSquareWave: mdiSquareWave,
mdiSqueegee: mdiSqueegee,
mdiSsh: mdiSsh,
mdiStackExchange: mdiStackExchange,
mdiStackOverflow: mdiStackOverflow,
mdiStackpath: mdiStackpath,
mdiStadium: mdiStadium,
mdiStadiumOutline: mdiStadiumOutline,
mdiStadiumVariant: mdiStadiumVariant,
mdiStairs: mdiStairs,
mdiStairsBox: mdiStairsBox,
mdiStairsDown: mdiStairsDown,
mdiStairsUp: mdiStairsUp,
mdiStamper: mdiStamper,
mdiStandardDefinition: mdiStandardDefinition,
mdiStar: mdiStar,
mdiStarBox: mdiStarBox,
mdiStarBoxMultiple: mdiStarBoxMultiple,
mdiStarBoxMultipleOutline: mdiStarBoxMultipleOutline,
mdiStarBoxOutline: mdiStarBoxOutline,
mdiStarCheck: mdiStarCheck,
mdiStarCheckOutline: mdiStarCheckOutline,
mdiStarCircle: mdiStarCircle,
mdiStarCircleOutline: mdiStarCircleOutline,
mdiStarCog: mdiStarCog,
mdiStarCogOutline: mdiStarCogOutline,
mdiStarCrescent: mdiStarCrescent,
mdiStarDavid: mdiStarDavid,
mdiStarFace: mdiStarFace,
mdiStarFourPoints: mdiStarFourPoints,
mdiStarFourPointsOutline: mdiStarFourPointsOutline,
mdiStarHalf: mdiStarHalf,
mdiStarHalfFull: mdiStarHalfFull,
mdiStarMinus: mdiStarMinus,
mdiStarMinusOutline: mdiStarMinusOutline,
mdiStarOff: mdiStarOff,
mdiStarOffOutline: mdiStarOffOutline,
mdiStarOutline: mdiStarOutline,
mdiStarPlus: mdiStarPlus,
mdiStarPlusOutline: mdiStarPlusOutline,
mdiStarRemove: mdiStarRemove,
mdiStarRemoveOutline: mdiStarRemoveOutline,
mdiStarSettings: mdiStarSettings,
mdiStarSettingsOutline: mdiStarSettingsOutline,
mdiStarShooting: mdiStarShooting,
mdiStarShootingOutline: mdiStarShootingOutline,
mdiStarThreePoints: mdiStarThreePoints,
mdiStarThreePointsOutline: mdiStarThreePointsOutline,
mdiStateMachine: mdiStateMachine,
mdiSteam: mdiSteam,
mdiSteering: mdiSteering,
mdiSteeringOff: mdiSteeringOff,
mdiStepBackward: mdiStepBackward,
mdiStepBackward2: mdiStepBackward2,
mdiStepForward: mdiStepForward,
mdiStepForward2: mdiStepForward2,
mdiStethoscope: mdiStethoscope,
mdiSticker: mdiSticker,
mdiStickerAlert: mdiStickerAlert,
mdiStickerAlertOutline: mdiStickerAlertOutline,
mdiStickerCheck: mdiStickerCheck,
mdiStickerCheckOutline: mdiStickerCheckOutline,
mdiStickerCircleOutline: mdiStickerCircleOutline,
mdiStickerEmoji: mdiStickerEmoji,
mdiStickerMinus: mdiStickerMinus,
mdiStickerMinusOutline: mdiStickerMinusOutline,
mdiStickerOutline: mdiStickerOutline,
mdiStickerPlus: mdiStickerPlus,
mdiStickerPlusOutline: mdiStickerPlusOutline,
mdiStickerRemove: mdiStickerRemove,
mdiStickerRemoveOutline: mdiStickerRemoveOutline,
mdiStickerText: mdiStickerText,
mdiStickerTextOutline: mdiStickerTextOutline,
mdiStocking: mdiStocking,
mdiStomach: mdiStomach,
mdiStool: mdiStool,
mdiStoolOutline: mdiStoolOutline,
mdiStop: mdiStop,
mdiStopCircle: mdiStopCircle,
mdiStopCircleOutline: mdiStopCircleOutline,
mdiStorageTank: mdiStorageTank,
mdiStorageTankOutline: mdiStorageTankOutline,
mdiStore: mdiStore,
mdiStore24Hour: mdiStore24Hour,
mdiStoreAlert: mdiStoreAlert,
mdiStoreAlertOutline: mdiStoreAlertOutline,
mdiStoreCheck: mdiStoreCheck,
mdiStoreCheckOutline: mdiStoreCheckOutline,
mdiStoreClock: mdiStoreClock,
mdiStoreClockOutline: mdiStoreClockOutline,
mdiStoreCog: mdiStoreCog,
mdiStoreCogOutline: mdiStoreCogOutline,
mdiStoreEdit: mdiStoreEdit,
mdiStoreEditOutline: mdiStoreEditOutline,
mdiStoreMarker: mdiStoreMarker,
mdiStoreMarkerOutline: mdiStoreMarkerOutline,
mdiStoreMinus: mdiStoreMinus,
mdiStoreMinusOutline: mdiStoreMinusOutline,
mdiStoreOff: mdiStoreOff,
mdiStoreOffOutline: mdiStoreOffOutline,
mdiStoreOutline: mdiStoreOutline,
mdiStorePlus: mdiStorePlus,
mdiStorePlusOutline: mdiStorePlusOutline,
mdiStoreRemove: mdiStoreRemove,
mdiStoreRemoveOutline: mdiStoreRemoveOutline,
mdiStoreSearch: mdiStoreSearch,
mdiStoreSearchOutline: mdiStoreSearchOutline,
mdiStoreSettings: mdiStoreSettings,
mdiStoreSettingsOutline: mdiStoreSettingsOutline,
mdiStorefront: mdiStorefront,
mdiStorefrontCheck: mdiStorefrontCheck,
mdiStorefrontCheckOutline: mdiStorefrontCheckOutline,
mdiStorefrontEdit: mdiStorefrontEdit,
mdiStorefrontEditOutline: mdiStorefrontEditOutline,
mdiStorefrontMinus: mdiStorefrontMinus,
mdiStorefrontMinusOutline: mdiStorefrontMinusOutline,
mdiStorefrontOutline: mdiStorefrontOutline,
mdiStorefrontPlus: mdiStorefrontPlus,
mdiStorefrontPlusOutline: mdiStorefrontPlusOutline,
mdiStorefrontRemove: mdiStorefrontRemove,
mdiStorefrontRemoveOutline: mdiStorefrontRemoveOutline,
mdiStove: mdiStove,
mdiStrategy: mdiStrategy,
mdiStretchToPage: mdiStretchToPage,
mdiStretchToPageOutline: mdiStretchToPageOutline,
mdiStringLights: mdiStringLights,
mdiStringLightsOff: mdiStringLightsOff,
mdiSubdirectoryArrowLeft: mdiSubdirectoryArrowLeft,
mdiSubdirectoryArrowRight: mdiSubdirectoryArrowRight,
mdiSubmarine: mdiSubmarine,
mdiSubtitles: mdiSubtitles,
mdiSubtitlesOutline: mdiSubtitlesOutline,
mdiSubway: mdiSubway,
mdiSubwayAlertVariant: mdiSubwayAlertVariant,
mdiSubwayVariant: mdiSubwayVariant,
mdiSummit: mdiSummit,
mdiSunAngle: mdiSunAngle,
mdiSunAngleOutline: mdiSunAngleOutline,
mdiSunClock: mdiSunClock,
mdiSunClockOutline: mdiSunClockOutline,
mdiSunCompass: mdiSunCompass,
mdiSunSnowflake: mdiSunSnowflake,
mdiSunSnowflakeVariant: mdiSunSnowflakeVariant,
mdiSunThermometer: mdiSunThermometer,
mdiSunThermometerOutline: mdiSunThermometerOutline,
mdiSunWireless: mdiSunWireless,
mdiSunWirelessOutline: mdiSunWirelessOutline,
mdiSunglasses: mdiSunglasses,
mdiSurfing: mdiSurfing,
mdiSurroundSound: mdiSurroundSound,
mdiSurroundSound20: mdiSurroundSound20,
mdiSurroundSound21: mdiSurroundSound21,
mdiSurroundSound31: mdiSurroundSound31,
mdiSurroundSound51: mdiSurroundSound51,
mdiSurroundSound512: mdiSurroundSound512,
mdiSurroundSound71: mdiSurroundSound71,
mdiSvg: mdiSvg,
mdiSwapHorizontal: mdiSwapHorizontal,
mdiSwapHorizontalBold: mdiSwapHorizontalBold,
mdiSwapHorizontalCircle: mdiSwapHorizontalCircle,
mdiSwapHorizontalCircleOutline: mdiSwapHorizontalCircleOutline,
mdiSwapHorizontalVariant: mdiSwapHorizontalVariant,
mdiSwapVertical: mdiSwapVertical,
mdiSwapVerticalBold: mdiSwapVerticalBold,
mdiSwapVerticalCircle: mdiSwapVerticalCircle,
mdiSwapVerticalCircleOutline: mdiSwapVerticalCircleOutline,
mdiSwapVerticalVariant: mdiSwapVerticalVariant,
mdiSwim: mdiSwim,
mdiSwitch: mdiSwitch,
mdiSword: mdiSword,
mdiSwordCross: mdiSwordCross,
mdiSyllabaryHangul: mdiSyllabaryHangul,
mdiSyllabaryHiragana: mdiSyllabaryHiragana,
mdiSyllabaryKatakana: mdiSyllabaryKatakana,
mdiSyllabaryKatakanaHalfwidth: mdiSyllabaryKatakanaHalfwidth,
mdiSymbol: mdiSymbol,
mdiSymfony: mdiSymfony,
mdiSynagogue: mdiSynagogue,
mdiSynagogueOutline: mdiSynagogueOutline,
mdiSync: mdiSync,
mdiSyncAlert: mdiSyncAlert,
mdiSyncCircle: mdiSyncCircle,
mdiSyncOff: mdiSyncOff,
mdiTab: mdiTab,
mdiTabMinus: mdiTabMinus,
mdiTabPlus: mdiTabPlus,
mdiTabRemove: mdiTabRemove,
mdiTabSearch: mdiTabSearch,
mdiTabUnselected: mdiTabUnselected,
mdiTable: mdiTable,
mdiTableAccount: mdiTableAccount,
mdiTableAlert: mdiTableAlert,
mdiTableArrowDown: mdiTableArrowDown,
mdiTableArrowLeft: mdiTableArrowLeft,
mdiTableArrowRight: mdiTableArrowRight,
mdiTableArrowUp: mdiTableArrowUp,
mdiTableBorder: mdiTableBorder,
mdiTableCancel: mdiTableCancel,
mdiTableChair: mdiTableChair,
mdiTableCheck: mdiTableCheck,
mdiTableClock: mdiTableClock,
mdiTableCog: mdiTableCog,
mdiTableColumn: mdiTableColumn,
mdiTableColumnPlusAfter: mdiTableColumnPlusAfter,
mdiTableColumnPlusBefore: mdiTableColumnPlusBefore,
mdiTableColumnRemove: mdiTableColumnRemove,
mdiTableColumnWidth: mdiTableColumnWidth,
mdiTableEdit: mdiTableEdit,
mdiTableEye: mdiTableEye,
mdiTableEyeOff: mdiTableEyeOff,
mdiTableFilter: mdiTableFilter,
mdiTableFurniture: mdiTableFurniture,
mdiTableHeadersEye: mdiTableHeadersEye,
mdiTableHeadersEyeOff: mdiTableHeadersEyeOff,
mdiTableHeart: mdiTableHeart,
mdiTableKey: mdiTableKey,
mdiTableLarge: mdiTableLarge,
mdiTableLargePlus: mdiTableLargePlus,
mdiTableLargeRemove: mdiTableLargeRemove,
mdiTableLock: mdiTableLock,
mdiTableMergeCells: mdiTableMergeCells,
mdiTableMinus: mdiTableMinus,
mdiTableMultiple: mdiTableMultiple,
mdiTableNetwork: mdiTableNetwork,
mdiTableOfContents: mdiTableOfContents,
mdiTableOff: mdiTableOff,
mdiTablePicnic: mdiTablePicnic,
mdiTablePivot: mdiTablePivot,
mdiTablePlus: mdiTablePlus,
mdiTableQuestion: mdiTableQuestion,
mdiTableRefresh: mdiTableRefresh,
mdiTableRemove: mdiTableRemove,
mdiTableRow: mdiTableRow,
mdiTableRowHeight: mdiTableRowHeight,
mdiTableRowPlusAfter: mdiTableRowPlusAfter,
mdiTableRowPlusBefore: mdiTableRowPlusBefore,
mdiTableRowRemove: mdiTableRowRemove,
mdiTableSearch: mdiTableSearch,
mdiTableSettings: mdiTableSettings,
mdiTableSplitCell: mdiTableSplitCell,
mdiTableStar: mdiTableStar,
mdiTableSync: mdiTableSync,
mdiTableTennis: mdiTableTennis,
mdiTablet: mdiTablet,
mdiTabletCellphone: mdiTabletCellphone,
mdiTabletDashboard: mdiTabletDashboard,
mdiTaco: mdiTaco,
mdiTag: mdiTag,
mdiTagArrowDown: mdiTagArrowDown,
mdiTagArrowDownOutline: mdiTagArrowDownOutline,
mdiTagArrowLeft: mdiTagArrowLeft,
mdiTagArrowLeftOutline: mdiTagArrowLeftOutline,
mdiTagArrowRight: mdiTagArrowRight,
mdiTagArrowRightOutline: mdiTagArrowRightOutline,
mdiTagArrowUp: mdiTagArrowUp,
mdiTagArrowUpOutline: mdiTagArrowUpOutline,
mdiTagCheck: mdiTagCheck,
mdiTagCheckOutline: mdiTagCheckOutline,
mdiTagFaces: mdiTagFaces,
mdiTagHeart: mdiTagHeart,
mdiTagHeartOutline: mdiTagHeartOutline,
mdiTagMinus: mdiTagMinus,
mdiTagMinusOutline: mdiTagMinusOutline,
mdiTagMultiple: mdiTagMultiple,
mdiTagMultipleOutline: mdiTagMultipleOutline,
mdiTagOff: mdiTagOff,
mdiTagOffOutline: mdiTagOffOutline,
mdiTagOutline: mdiTagOutline,
mdiTagPlus: mdiTagPlus,
mdiTagPlusOutline: mdiTagPlusOutline,
mdiTagRemove: mdiTagRemove,
mdiTagRemoveOutline: mdiTagRemoveOutline,
mdiTagSearch: mdiTagSearch,
mdiTagSearchOutline: mdiTagSearchOutline,
mdiTagText: mdiTagText,
mdiTagTextOutline: mdiTagTextOutline,
mdiTailwind: mdiTailwind,
mdiTallyMark1: mdiTallyMark1,
mdiTallyMark2: mdiTallyMark2,
mdiTallyMark3: mdiTallyMark3,
mdiTallyMark4: mdiTallyMark4,
mdiTallyMark5: mdiTallyMark5,
mdiTangram: mdiTangram,
mdiTank: mdiTank,
mdiTankerTruck: mdiTankerTruck,
mdiTapeDrive: mdiTapeDrive,
mdiTapeMeasure: mdiTapeMeasure,
mdiTarget: mdiTarget,
mdiTargetAccount: mdiTargetAccount,
mdiTargetVariant: mdiTargetVariant,
mdiTaxi: mdiTaxi,
mdiTea: mdiTea,
mdiTeaOutline: mdiTeaOutline,
mdiTeamviewer: mdiTeamviewer,
mdiTeddyBear: mdiTeddyBear,
mdiTelescope: mdiTelescope,
mdiTelevision: mdiTelevision,
mdiTelevisionAmbientLight: mdiTelevisionAmbientLight,
mdiTelevisionBox: mdiTelevisionBox,
mdiTelevisionClassic: mdiTelevisionClassic,
mdiTelevisionClassicOff: mdiTelevisionClassicOff,
mdiTelevisionGuide: mdiTelevisionGuide,
mdiTelevisionOff: mdiTelevisionOff,
mdiTelevisionPause: mdiTelevisionPause,
mdiTelevisionPlay: mdiTelevisionPlay,
mdiTelevisionShimmer: mdiTelevisionShimmer,
mdiTelevisionSpeaker: mdiTelevisionSpeaker,
mdiTelevisionSpeakerOff: mdiTelevisionSpeakerOff,
mdiTelevisionStop: mdiTelevisionStop,
mdiTemperatureCelsius: mdiTemperatureCelsius,
mdiTemperatureFahrenheit: mdiTemperatureFahrenheit,
mdiTemperatureKelvin: mdiTemperatureKelvin,
mdiTempleBuddhist: mdiTempleBuddhist,
mdiTempleBuddhistOutline: mdiTempleBuddhistOutline,
mdiTempleHindu: mdiTempleHindu,
mdiTempleHinduOutline: mdiTempleHinduOutline,
mdiTennis: mdiTennis,
mdiTennisBall: mdiTennisBall,
mdiTent: mdiTent,
mdiTerraform: mdiTerraform,
mdiTerrain: mdiTerrain,
mdiTestTube: mdiTestTube,
mdiTestTubeEmpty: mdiTestTubeEmpty,
mdiTestTubeOff: mdiTestTubeOff,
mdiText: mdiText,
mdiTextAccount: mdiTextAccount,
mdiTextBox: mdiTextBox,
mdiTextBoxCheck: mdiTextBoxCheck,
mdiTextBoxCheckOutline: mdiTextBoxCheckOutline,
mdiTextBoxEdit: mdiTextBoxEdit,
mdiTextBoxEditOutline: mdiTextBoxEditOutline,
mdiTextBoxMinus: mdiTextBoxMinus,
mdiTextBoxMinusOutline: mdiTextBoxMinusOutline,
mdiTextBoxMultiple: mdiTextBoxMultiple,
mdiTextBoxMultipleOutline: mdiTextBoxMultipleOutline,
mdiTextBoxOutline: mdiTextBoxOutline,
mdiTextBoxPlus: mdiTextBoxPlus,
mdiTextBoxPlusOutline: mdiTextBoxPlusOutline,
mdiTextBoxRemove: mdiTextBoxRemove,
mdiTextBoxRemoveOutline: mdiTextBoxRemoveOutline,
mdiTextBoxSearch: mdiTextBoxSearch,
mdiTextBoxSearchOutline: mdiTextBoxSearchOutline,
mdiTextLong: mdiTextLong,
mdiTextRecognition: mdiTextRecognition,
mdiTextSearch: mdiTextSearch,
mdiTextSearchVariant: mdiTextSearchVariant,
mdiTextShadow: mdiTextShadow,
mdiTextShort: mdiTextShort,
mdiTexture: mdiTexture,
mdiTextureBox: mdiTextureBox,
mdiTheater: mdiTheater,
mdiThemeLightDark: mdiThemeLightDark,
mdiThermometer: mdiThermometer,
mdiThermometerAlert: mdiThermometerAlert,
mdiThermometerAuto: mdiThermometerAuto,
mdiThermometerBluetooth: mdiThermometerBluetooth,
mdiThermometerCheck: mdiThermometerCheck,
mdiThermometerChevronDown: mdiThermometerChevronDown,
mdiThermometerChevronUp: mdiThermometerChevronUp,
mdiThermometerHigh: mdiThermometerHigh,
mdiThermometerLines: mdiThermometerLines,
mdiThermometerLow: mdiThermometerLow,
mdiThermometerMinus: mdiThermometerMinus,
mdiThermometerOff: mdiThermometerOff,
mdiThermometerPlus: mdiThermometerPlus,
mdiThermometerProbe: mdiThermometerProbe,
mdiThermometerProbeOff: mdiThermometerProbeOff,
mdiThermometerWater: mdiThermometerWater,
mdiThermostat: mdiThermostat,
mdiThermostatAuto: mdiThermostatAuto,
mdiThermostatBox: mdiThermostatBox,
mdiThermostatBoxAuto: mdiThermostatBoxAuto,
mdiThoughtBubble: mdiThoughtBubble,
mdiThoughtBubbleOutline: mdiThoughtBubbleOutline,
mdiThumbDown: mdiThumbDown,
mdiThumbDownOutline: mdiThumbDownOutline,
mdiThumbUp: mdiThumbUp,
mdiThumbUpOutline: mdiThumbUpOutline,
mdiThumbsUpDown: mdiThumbsUpDown,
mdiThumbsUpDownOutline: mdiThumbsUpDownOutline,
mdiTicket: mdiTicket,
mdiTicketAccount: mdiTicketAccount,
mdiTicketConfirmation: mdiTicketConfirmation,
mdiTicketConfirmationOutline: mdiTicketConfirmationOutline,
mdiTicketOutline: mdiTicketOutline,
mdiTicketPercent: mdiTicketPercent,
mdiTicketPercentOutline: mdiTicketPercentOutline,
mdiTie: mdiTie,
mdiTilde: mdiTilde,
mdiTildeOff: mdiTildeOff,
mdiTimelapse: mdiTimelapse,
mdiTimeline: mdiTimeline,
mdiTimelineAlert: mdiTimelineAlert,
mdiTimelineAlertOutline: mdiTimelineAlertOutline,
mdiTimelineCheck: mdiTimelineCheck,
mdiTimelineCheckOutline: mdiTimelineCheckOutline,
mdiTimelineClock: mdiTimelineClock,
mdiTimelineClockOutline: mdiTimelineClockOutline,
mdiTimelineMinus: mdiTimelineMinus,
mdiTimelineMinusOutline: mdiTimelineMinusOutline,
mdiTimelineOutline: mdiTimelineOutline,
mdiTimelinePlus: mdiTimelinePlus,
mdiTimelinePlusOutline: mdiTimelinePlusOutline,
mdiTimelineQuestion: mdiTimelineQuestion,
mdiTimelineQuestionOutline: mdiTimelineQuestionOutline,
mdiTimelineRemove: mdiTimelineRemove,
mdiTimelineRemoveOutline: mdiTimelineRemoveOutline,
mdiTimelineText: mdiTimelineText,
mdiTimelineTextOutline: mdiTimelineTextOutline,
mdiTimer: mdiTimer,
mdiTimer10: mdiTimer10,
mdiTimer3: mdiTimer3,
mdiTimerAlert: mdiTimerAlert,
mdiTimerAlertOutline: mdiTimerAlertOutline,
mdiTimerCancel: mdiTimerCancel,
mdiTimerCancelOutline: mdiTimerCancelOutline,
mdiTimerCheck: mdiTimerCheck,
mdiTimerCheckOutline: mdiTimerCheckOutline,
mdiTimerCog: mdiTimerCog,
mdiTimerCogOutline: mdiTimerCogOutline,
mdiTimerEdit: mdiTimerEdit,
mdiTimerEditOutline: mdiTimerEditOutline,
mdiTimerLock: mdiTimerLock,
mdiTimerLockOpen: mdiTimerLockOpen,
mdiTimerLockOpenOutline: mdiTimerLockOpenOutline,
mdiTimerLockOutline: mdiTimerLockOutline,
mdiTimerMarker: mdiTimerMarker,
mdiTimerMarkerOutline: mdiTimerMarkerOutline,
mdiTimerMinus: mdiTimerMinus,
mdiTimerMinusOutline: mdiTimerMinusOutline,
mdiTimerMusic: mdiTimerMusic,
mdiTimerMusicOutline: mdiTimerMusicOutline,
mdiTimerOff: mdiTimerOff,
mdiTimerOffOutline: mdiTimerOffOutline,
mdiTimerOutline: mdiTimerOutline,
mdiTimerPause: mdiTimerPause,
mdiTimerPauseOutline: mdiTimerPauseOutline,
mdiTimerPlay: mdiTimerPlay,
mdiTimerPlayOutline: mdiTimerPlayOutline,
mdiTimerPlus: mdiTimerPlus,
mdiTimerPlusOutline: mdiTimerPlusOutline,
mdiTimerRefresh: mdiTimerRefresh,
mdiTimerRefreshOutline: mdiTimerRefreshOutline,
mdiTimerRemove: mdiTimerRemove,
mdiTimerRemoveOutline: mdiTimerRemoveOutline,
mdiTimerSand: mdiTimerSand,
mdiTimerSandComplete: mdiTimerSandComplete,
mdiTimerSandEmpty: mdiTimerSandEmpty,
mdiTimerSandFull: mdiTimerSandFull,
mdiTimerSandPaused: mdiTimerSandPaused,
mdiTimerSettings: mdiTimerSettings,
mdiTimerSettingsOutline: mdiTimerSettingsOutline,
mdiTimerStar: mdiTimerStar,
mdiTimerStarOutline: mdiTimerStarOutline,
mdiTimerStop: mdiTimerStop,
mdiTimerStopOutline: mdiTimerStopOutline,
mdiTimerSync: mdiTimerSync,
mdiTimerSyncOutline: mdiTimerSyncOutline,
mdiTimetable: mdiTimetable,
mdiTire: mdiTire,
mdiToaster: mdiToaster,
mdiToasterOff: mdiToasterOff,
mdiToasterOven: mdiToasterOven,
mdiToggleSwitch: mdiToggleSwitch,
mdiToggleSwitchOff: mdiToggleSwitchOff,
mdiToggleSwitchOffOutline: mdiToggleSwitchOffOutline,
mdiToggleSwitchOutline: mdiToggleSwitchOutline,
mdiToggleSwitchVariant: mdiToggleSwitchVariant,
mdiToggleSwitchVariantOff: mdiToggleSwitchVariantOff,
mdiToilet: mdiToilet,
mdiToolbox: mdiToolbox,
mdiToolboxOutline: mdiToolboxOutline,
mdiTools: mdiTools,
mdiTooltip: mdiTooltip,
mdiTooltipAccount: mdiTooltipAccount,
mdiTooltipCellphone: mdiTooltipCellphone,
mdiTooltipCheck: mdiTooltipCheck,
mdiTooltipCheckOutline: mdiTooltipCheckOutline,
mdiTooltipEdit: mdiTooltipEdit,
mdiTooltipEditOutline: mdiTooltipEditOutline,
mdiTooltipImage: mdiTooltipImage,
mdiTooltipImageOutline: mdiTooltipImageOutline,
mdiTooltipMinus: mdiTooltipMinus,
mdiTooltipMinusOutline: mdiTooltipMinusOutline,
mdiTooltipOutline: mdiTooltipOutline,
mdiTooltipPlus: mdiTooltipPlus,
mdiTooltipPlusOutline: mdiTooltipPlusOutline,
mdiTooltipRemove: mdiTooltipRemove,
mdiTooltipRemoveOutline: mdiTooltipRemoveOutline,
mdiTooltipText: mdiTooltipText,
mdiTooltipTextOutline: mdiTooltipTextOutline,
mdiTooth: mdiTooth,
mdiToothOutline: mdiToothOutline,
mdiToothbrush: mdiToothbrush,
mdiToothbrushElectric: mdiToothbrushElectric,
mdiToothbrushPaste: mdiToothbrushPaste,
mdiTorch: mdiTorch,
mdiTortoise: mdiTortoise,
mdiToslink: mdiToslink,
mdiTournament: mdiTournament,
mdiTowTruck: mdiTowTruck,
mdiTowerBeach: mdiTowerBeach,
mdiTowerFire: mdiTowerFire,
mdiTownHall: mdiTownHall,
mdiToyBrick: mdiToyBrick,
mdiToyBrickMarker: mdiToyBrickMarker,
mdiToyBrickMarkerOutline: mdiToyBrickMarkerOutline,
mdiToyBrickMinus: mdiToyBrickMinus,
mdiToyBrickMinusOutline: mdiToyBrickMinusOutline,
mdiToyBrickOutline: mdiToyBrickOutline,
mdiToyBrickPlus: mdiToyBrickPlus,
mdiToyBrickPlusOutline: mdiToyBrickPlusOutline,
mdiToyBrickRemove: mdiToyBrickRemove,
mdiToyBrickRemoveOutline: mdiToyBrickRemoveOutline,
mdiToyBrickSearch: mdiToyBrickSearch,
mdiToyBrickSearchOutline: mdiToyBrickSearchOutline,
mdiTrackLight: mdiTrackLight,
mdiTrackLightOff: mdiTrackLightOff,
mdiTrackpad: mdiTrackpad,
mdiTrackpadLock: mdiTrackpadLock,
mdiTractor: mdiTractor,
mdiTractorVariant: mdiTractorVariant,
mdiTrademark: mdiTrademark,
mdiTrafficCone: mdiTrafficCone,
mdiTrafficLight: mdiTrafficLight,
mdiTrafficLightOutline: mdiTrafficLightOutline,
mdiTrain: mdiTrain,
mdiTrainCar: mdiTrainCar,
mdiTrainCarAutorack: mdiTrainCarAutorack,
mdiTrainCarBox: mdiTrainCarBox,
mdiTrainCarBoxFull: mdiTrainCarBoxFull,
mdiTrainCarBoxOpen: mdiTrainCarBoxOpen,
mdiTrainCarCaboose: mdiTrainCarCaboose,
mdiTrainCarCenterbeam: mdiTrainCarCenterbeam,
mdiTrainCarCenterbeamFull: mdiTrainCarCenterbeamFull,
mdiTrainCarContainer: mdiTrainCarContainer,
mdiTrainCarFlatbed: mdiTrainCarFlatbed,
mdiTrainCarFlatbedCar: mdiTrainCarFlatbedCar,
mdiTrainCarFlatbedTank: mdiTrainCarFlatbedTank,
mdiTrainCarGondola: mdiTrainCarGondola,
mdiTrainCarGondolaFull: mdiTrainCarGondolaFull,
mdiTrainCarHopper: mdiTrainCarHopper,
mdiTrainCarHopperCovered: mdiTrainCarHopperCovered,
mdiTrainCarHopperFull: mdiTrainCarHopperFull,
mdiTrainCarIntermodal: mdiTrainCarIntermodal,
mdiTrainCarPassenger: mdiTrainCarPassenger,
mdiTrainCarPassengerDoor: mdiTrainCarPassengerDoor,
mdiTrainCarPassengerDoorOpen: mdiTrainCarPassengerDoorOpen,
mdiTrainCarPassengerVariant: mdiTrainCarPassengerVariant,
mdiTrainCarTank: mdiTrainCarTank,
mdiTrainVariant: mdiTrainVariant,
mdiTram: mdiTram,
mdiTramSide: mdiTramSide,
mdiTranscribe: mdiTranscribe,
mdiTranscribeClose: mdiTranscribeClose,
mdiTransfer: mdiTransfer,
mdiTransferDown: mdiTransferDown,
mdiTransferLeft: mdiTransferLeft,
mdiTransferRight: mdiTransferRight,
mdiTransferUp: mdiTransferUp,
mdiTransitConnection: mdiTransitConnection,
mdiTransitConnectionHorizontal: mdiTransitConnectionHorizontal,
mdiTransitConnectionVariant: mdiTransitConnectionVariant,
mdiTransitDetour: mdiTransitDetour,
mdiTransitSkip: mdiTransitSkip,
mdiTransitTransfer: mdiTransitTransfer,
mdiTransition: mdiTransition,
mdiTransitionMasked: mdiTransitionMasked,
mdiTranslate: mdiTranslate,
mdiTranslateOff: mdiTranslateOff,
mdiTranslateVariant: mdiTranslateVariant,
mdiTransmissionTower: mdiTransmissionTower,
mdiTransmissionTowe: mdiTransmissionTower,
mdiTransmissionTowerOff: mdiTransmissionTowerOff,
mdiTrashCan: mdiTrashCan,
mdiTrashCanOutline: mdiTrashCanOutline,
mdiTray: mdiTray,
mdiTrayAlert: mdiTrayAlert,
mdiTrayArrowDown: mdiTrayArrowDown,
mdiTrayArrowUp: mdiTrayArrowUp,
mdiTrayFull: mdiTrayFull,
mdiTrayMinus: mdiTrayMinus,
mdiTrayPlus: mdiTrayPlus,
mdiTrayRemove: mdiTrayRemove,
mdiTreasureChest: mdiTreasureChest,
mdiTree: mdiTree,
mdiTreeOutline: mdiTreeOutline,
mdiTrello: mdiTrello,
mdiTrendingDown: mdiTrendingDown,
mdiTrendingNeutral: mdiTrendingNeutral,
mdiTrendingUp: mdiTrendingUp,
mdiTriangle: mdiTriangle,
mdiTriangleOutline: mdiTriangleOutline,
mdiTriangleSmallDown: mdiTriangleSmallDown,
mdiTriangleSmallUp: mdiTriangleSmallUp,
mdiTriangleWave: mdiTriangleWave,
mdiTriforce: mdiTriforce,
mdiTrophy: mdiTrophy,
mdiTrophyAward: mdiTrophyAward,
mdiTrophyBroken: mdiTrophyBroken,
mdiTrophyOutline: mdiTrophyOutline,
mdiTrophyVariant: mdiTrophyVariant,
mdiTrophyVariantOutline: mdiTrophyVariantOutline,
mdiTruck: mdiTruck,
mdiTruckAlert: mdiTruckAlert,
mdiTruckAlertOutline: mdiTruckAlertOutline,
mdiTruckCargoContainer: mdiTruckCargoContainer,
mdiTruckCheck: mdiTruckCheck,
mdiTruckCheckOutline: mdiTruckCheckOutline,
mdiTruckDelivery: mdiTruckDelivery,
mdiTruckDeliveryOutline: mdiTruckDeliveryOutline,
mdiTruckFast: mdiTruckFast,
mdiTruckFastOutline: mdiTruckFastOutline,
mdiTruckFlatbed: mdiTruckFlatbed,
mdiTruckMinus: mdiTruckMinus,
mdiTruckMinusOutline: mdiTruckMinusOutline,
mdiTruckOutline: mdiTruckOutline,
mdiTruckPlus: mdiTruckPlus,
mdiTruckPlusOutline: mdiTruckPlusOutline,
mdiTruckRemove: mdiTruckRemove,
mdiTruckRemoveOutline: mdiTruckRemoveOutline,
mdiTruckSnowflake: mdiTruckSnowflake,
mdiTruckTrailer: mdiTruckTrailer,
mdiTrumpet: mdiTrumpet,
mdiTshirtCrew: mdiTshirtCrew,
mdiTshirtCrewOutline: mdiTshirtCrewOutline,
mdiTshirtV: mdiTshirtV,
mdiTshirtVOutline: mdiTshirtVOutline,
mdiTsunami: mdiTsunami,
mdiTumbleDryer: mdiTumbleDryer,
mdiTumbleDryerAlert: mdiTumbleDryerAlert,
mdiTumbleDryerOff: mdiTumbleDryerOff,
mdiTune: mdiTune,
mdiTuneVariant: mdiTuneVariant,
mdiTuneVertical: mdiTuneVertical,
mdiTuneVerticalVariant: mdiTuneVerticalVariant,
mdiTunnel: mdiTunnel,
mdiTunnelOutline: mdiTunnelOutline,
mdiTurbine: mdiTurbine,
mdiTurkey: mdiTurkey,
mdiTurnstile: mdiTurnstile,
mdiTurnstileOutline: mdiTurnstileOutline,
mdiTurtle: mdiTurtle,
mdiTwitch: mdiTwitch,
mdiTwitter: mdiTwitter,
mdiTwoFactorAuthentication: mdiTwoFactorAuthentication,
mdiTypewriter: mdiTypewriter,
mdiUbisoft: mdiUbisoft,
mdiUbuntu: mdiUbuntu,
mdiUfo: mdiUfo,
mdiUfoOutline: mdiUfoOutline,
mdiUltraHighDefinition: mdiUltraHighDefinition,
mdiUmbraco: mdiUmbraco,
mdiUmbrella: mdiUmbrella,
mdiUmbrellaBeach: mdiUmbrellaBeach,
mdiUmbrellaBeachOutline: mdiUmbrellaBeachOutline,
mdiUmbrellaClosed: mdiUmbrellaClosed,
mdiUmbrellaClosedOutline: mdiUmbrellaClosedOutline,
mdiUmbrellaClosedVariant: mdiUmbrellaClosedVariant,
mdiUmbrellaOutline: mdiUmbrellaOutline,
mdiUndo: mdiUndo,
mdiUndoVariant: mdiUndoVariant,
mdiUnfoldLessHorizontal: mdiUnfoldLessHorizontal,
mdiUnfoldLessVertical: mdiUnfoldLessVertical,
mdiUnfoldMoreHorizontal: mdiUnfoldMoreHorizontal,
mdiUnfoldMoreVertical: mdiUnfoldMoreVertical,
mdiUngroup: mdiUngroup,
mdiUnicode: mdiUnicode,
mdiUnicorn: mdiUnicorn,
mdiUnicornVariant: mdiUnicornVariant,
mdiUnicycle: mdiUnicycle,
mdiUnity: mdiUnity,
mdiUnreal: mdiUnreal,
mdiUpdate: mdiUpdate,
mdiUpload: mdiUpload,
mdiUploadLock: mdiUploadLock,
mdiUploadLockOutline: mdiUploadLockOutline,
mdiUploadMultiple: mdiUploadMultiple,
mdiUploadNetwork: mdiUploadNetwork,
mdiUploadNetworkOutline: mdiUploadNetworkOutline,
mdiUploadOff: mdiUploadOff,
mdiUploadOffOutline: mdiUploadOffOutline,
mdiUploadOutline: mdiUploadOutline,
mdiUsb: mdiUsb,
mdiUsbFlashDrive: mdiUsbFlashDrive,
mdiUsbFlashDriveOutline: mdiUsbFlashDriveOutline,
mdiUsbPort: mdiUsbPort,
mdiVacuum: mdiVacuum,
mdiVacuumOutline: mdiVacuumOutline,
mdiValve: mdiValve,
mdiValveClosed: mdiValveClosed,
mdiValveOpen: mdiValveOpen,
mdiVanPassenger: mdiVanPassenger,
mdiVanUtility: mdiVanUtility,
mdiVanish: mdiVanish,
mdiVanishQuarter: mdiVanishQuarter,
mdiVanityLight: mdiVanityLight,
mdiVariable: mdiVariable,
mdiVariableBox: mdiVariableBox,
mdiVectorArrangeAbove: mdiVectorArrangeAbove,
mdiVectorArrangeBelow: mdiVectorArrangeBelow,
mdiVectorBezier: mdiVectorBezier,
mdiVectorCircle: mdiVectorCircle,
mdiVectorCircleVariant: mdiVectorCircleVariant,
mdiVectorCombine: mdiVectorCombine,
mdiVectorCurve: mdiVectorCurve,
mdiVectorDifference: mdiVectorDifference,
mdiVectorDifferenceAb: mdiVectorDifferenceAb,
mdiVectorDifferenceBa: mdiVectorDifferenceBa,
mdiVectorEllipse: mdiVectorEllipse,
mdiVectorIntersection: mdiVectorIntersection,
mdiVectorLine: mdiVectorLine,
mdiVectorLink: mdiVectorLink,
mdiVectorPoint: mdiVectorPoint,
mdiVectorPointEdit: mdiVectorPointEdit,
mdiVectorPointMinus: mdiVectorPointMinus,
mdiVectorPointPlus: mdiVectorPointPlus,
mdiVectorPointSelect: mdiVectorPointSelect,
mdiVectorPolygon: mdiVectorPolygon,
mdiVectorPolygonVariant: mdiVectorPolygonVariant,
mdiVectorPolyline: mdiVectorPolyline,
mdiVectorPolylineEdit: mdiVectorPolylineEdit,
mdiVectorPolylineMinus: mdiVectorPolylineMinus,
mdiVectorPolylinePlus: mdiVectorPolylinePlus,
mdiVectorPolylineRemove: mdiVectorPolylineRemove,
mdiVectorRadius: mdiVectorRadius,
mdiVectorRectangle: mdiVectorRectangle,
mdiVectorSelection: mdiVectorSelection,
mdiVectorSquare: mdiVectorSquare,
mdiVectorSquareClose: mdiVectorSquareClose,
mdiVectorSquareEdit: mdiVectorSquareEdit,
mdiVectorSquareMinus: mdiVectorSquareMinus,
mdiVectorSquareOpen: mdiVectorSquareOpen,
mdiVectorSquarePlus: mdiVectorSquarePlus,
mdiVectorSquareRemove: mdiVectorSquareRemove,
mdiVectorTriangle: mdiVectorTriangle,
mdiVectorUnion: mdiVectorUnion,
mdiVhs: mdiVhs,
mdiVibrate: mdiVibrate,
mdiVibrateOff: mdiVibrateOff,
mdiVideo: mdiVideo,
mdiVideo2d: mdiVideo2d,
mdiVideo3d: mdiVideo3d,
mdiVideo3dOff: mdiVideo3dOff,
mdiVideo3dVariant: mdiVideo3dVariant,
mdiVideo4kBox: mdiVideo4kBox,
mdiVideoAccount: mdiVideoAccount,
mdiVideoBox: mdiVideoBox,
mdiVideoBoxOff: mdiVideoBoxOff,
mdiVideoCheck: mdiVideoCheck,
mdiVideoCheckOutline: mdiVideoCheckOutline,
mdiVideoHighDefinition: mdiVideoHighDefinition,
mdiVideoImage: mdiVideoImage,
mdiVideoInputAntenna: mdiVideoInputAntenna,
mdiVideoInputComponent: mdiVideoInputComponent,
mdiVideoInputHdmi: mdiVideoInputHdmi,
mdiVideoInputScart: mdiVideoInputScart,
mdiVideoInputSvideo: mdiVideoInputSvideo,
mdiVideoMarker: mdiVideoMarker,
mdiVideoMarkerOutline: mdiVideoMarkerOutline,
mdiVideoMinus: mdiVideoMinus,
mdiVideoMinusOutline: mdiVideoMinusOutline,
mdiVideoOff: mdiVideoOff,
mdiVideoOffOutline: mdiVideoOffOutline,
mdiVideoOutline: mdiVideoOutline,
mdiVideoPlus: mdiVideoPlus,
mdiVideoPlusOutline: mdiVideoPlusOutline,
mdiVideoStabilization: mdiVideoStabilization,
mdiVideoSwitch: mdiVideoSwitch,
mdiVideoSwitchOutline: mdiVideoSwitchOutline,
mdiVideoVintage: mdiVideoVintage,
mdiVideoWireless: mdiVideoWireless,
mdiVideoWirelessOutline: mdiVideoWirelessOutline,
mdiViewAgenda: mdiViewAgenda,
mdiViewAgendaOutline: mdiViewAgendaOutline,
mdiViewArray: mdiViewArray,
mdiViewArrayOutline: mdiViewArrayOutline,
mdiViewCarousel: mdiViewCarousel,
mdiViewCarouselOutline: mdiViewCarouselOutline,
mdiViewColumn: mdiViewColumn,
mdiViewColumnOutline: mdiViewColumnOutline,
mdiViewComfy: mdiViewComfy,
mdiViewComfyOutline: mdiViewComfyOutline,
mdiViewCompact: mdiViewCompact,
mdiViewCompactOutline: mdiViewCompactOutline,
mdiViewDashboard: mdiViewDashboard,
mdiViewDashboardEdit: mdiViewDashboardEdit,
mdiViewDashboardEditOutline: mdiViewDashboardEditOutline,
mdiViewDashboardOutline: mdiViewDashboardOutline,
mdiViewDashboardVariant: mdiViewDashboardVariant,
mdiViewDashboardVariantOutline: mdiViewDashboardVariantOutline,
mdiViewDay: mdiViewDay,
mdiViewDayOutline: mdiViewDayOutline,
mdiViewGallery: mdiViewGallery,
mdiViewGalleryOutline: mdiViewGalleryOutline,
mdiViewGrid: mdiViewGrid,
mdiViewGridOutline: mdiViewGridOutline,
mdiViewGridPlus: mdiViewGridPlus,
mdiViewGridPlusOutline: mdiViewGridPlusOutline,
mdiViewHeadline: mdiViewHeadline,
mdiViewList: mdiViewList,
mdiViewListOutline: mdiViewListOutline,
mdiViewModule: mdiViewModule,
mdiViewModuleOutline: mdiViewModuleOutline,
mdiViewParallel: mdiViewParallel,
mdiViewParallelOutline: mdiViewParallelOutline,
mdiViewQuilt: mdiViewQuilt,
mdiViewQuiltOutline: mdiViewQuiltOutline,
mdiViewSequential: mdiViewSequential,
mdiViewSequentialOutline: mdiViewSequentialOutline,
mdiViewSplitHorizontal: mdiViewSplitHorizontal,
mdiViewSplitVertical: mdiViewSplitVertical,
mdiViewStream: mdiViewStream,
mdiViewStreamOutline: mdiViewStreamOutline,
mdiViewWeek: mdiViewWeek,
mdiViewWeekOutline: mdiViewWeekOutline,
mdiVimeo: mdiVimeo,
mdiViolin: mdiViolin,
mdiVirtualReality: mdiVirtualReality,
mdiVirus: mdiVirus,
mdiVirusOff: mdiVirusOff,
mdiVirusOffOutline: mdiVirusOffOutline,
mdiVirusOutline: mdiVirusOutline,
mdiVlc: mdiVlc,
mdiVoicemail: mdiVoicemail,
mdiVolcano: mdiVolcano,
mdiVolcanoOutline: mdiVolcanoOutline,
mdiVolleyball: mdiVolleyball,
mdiVolumeEqual: mdiVolumeEqual,
mdiVolumeHigh: mdiVolumeHigh,
mdiVolumeLow: mdiVolumeLow,
mdiVolumeMedium: mdiVolumeMedium,
mdiVolumeMinus: mdiVolumeMinus,
mdiVolumeMute: mdiVolumeMute,
mdiVolumeOff: mdiVolumeOff,
mdiVolumePlus: mdiVolumePlus,
mdiVolumeSource: mdiVolumeSource,
mdiVolumeVariantOff: mdiVolumeVariantOff,
mdiVolumeVibrate: mdiVolumeVibrate,
mdiVote: mdiVote,
mdiVoteOutline: mdiVoteOutline,
mdiVpn: mdiVpn,
mdiVuejs: mdiVuejs,
mdiVuetify: mdiVuetify,
mdiWalk: mdiWalk,
mdiWall: mdiWall,
mdiWallFire: mdiWallFire,
mdiWallSconce: mdiWallSconce,
mdiWallSconceFlat: mdiWallSconceFlat,
mdiWallSconceFlatOutline: mdiWallSconceFlatOutline,
mdiWallSconceFlatVariant: mdiWallSconceFlatVariant,
mdiWallSconceFlatVariantOutline: mdiWallSconceFlatVariantOutline,
mdiWallSconceOutline: mdiWallSconceOutline,
mdiWallSconceRound: mdiWallSconceRound,
mdiWallSconceRoundOutline: mdiWallSconceRoundOutline,
mdiWallSconceRoundVariant: mdiWallSconceRoundVariant,
mdiWallSconceRoundVariantOutline: mdiWallSconceRoundVariantOutline,
mdiWallet: mdiWallet,
mdiWalletGiftcard: mdiWalletGiftcard,
mdiWalletMembership: mdiWalletMembership,
mdiWalletOutline: mdiWalletOutline,
mdiWalletPlus: mdiWalletPlus,
mdiWalletPlusOutline: mdiWalletPlusOutline,
mdiWalletTravel: mdiWalletTravel,
mdiWallpaper: mdiWallpaper,
mdiWan: mdiWan,
mdiWardrobe: mdiWardrobe,
mdiWardrobeOutline: mdiWardrobeOutline,
mdiWarehouse: mdiWarehouse,
mdiWashingMachine: mdiWashingMachine,
mdiWashingMachineAlert: mdiWashingMachineAlert,
mdiWashingMachineOff: mdiWashingMachineOff,
mdiWatch: mdiWatch,
mdiWatc: mdiWatch,
// mdiWatchstring: mdiWatchstring,
mdiWatchImportVariant: mdiWatchImportVariant,
mdiWatchVariant: mdiWatchVariant,
mdiWatchVibrate: mdiWatchVibrate,
mdiWatchVibrateOff: mdiWatchVibrateOff,
mdiWater: mdiWater,
mdiWaterAlert: mdiWaterAlert,
mdiWaterAlertOutline: mdiWaterAlertOutline,
mdiWaterBoiler: mdiWaterBoiler,
mdiWaterBoilerAlert: mdiWaterBoilerAlert,
mdiWaterBoilerAuto: mdiWaterBoilerAuto,
mdiWaterBoilerOff: mdiWaterBoilerOff,
mdiWaterCheck: mdiWaterCheck,
mdiWaterCheckOutline: mdiWaterCheckOutline,
mdiWaterCircle: mdiWaterCircle,
mdiWaterMinus: mdiWaterMinus,
mdiWaterMinusOutline: mdiWaterMinusOutline,
mdiWaterOff: mdiWaterOff,
mdiWaterOffOutline: mdiWaterOffOutline,
mdiWaterOpacity: mdiWaterOpacity,
mdiWaterOutline: mdiWaterOutline,
mdiWaterPercent: mdiWaterPercent,
mdiWaterPercentAlert: mdiWaterPercentAlert,
mdiWaterPlus: mdiWaterPlus,
mdiWaterPlusOutline: mdiWaterPlusOutline,
mdiWaterPolo: mdiWaterPolo,
mdiWaterPump: mdiWaterPump,
mdiWaterPumpOff: mdiWaterPumpOff,
mdiWaterRemove: mdiWaterRemove,
mdiWaterRemoveOutline: mdiWaterRemoveOutline,
mdiWaterSync: mdiWaterSync,
mdiWaterThermometer: mdiWaterThermometer,
mdiWaterThermometerOutline: mdiWaterThermometerOutline,
mdiWaterWell: mdiWaterWell,
mdiWaterWellOutline: mdiWaterWellOutline,
mdiWaterfall: mdiWaterfall,
mdiWateringCan: mdiWateringCan,
mdiWateringCanOutline: mdiWateringCanOutline,
mdiWatermark: mdiWatermark,
mdiWave: mdiWave,
mdiWaveform: mdiWaveform,
mdiWaves: mdiWaves,
mdiWavesArrowLeft: mdiWavesArrowLeft,
mdiWavesArrowRight: mdiWavesArrowRight,
mdiWavesArrowUp: mdiWavesArrowUp,
mdiWaze: mdiWaze,
mdiWeatherCloudy: mdiWeatherCloudy,
mdiWeatherCloudyAlert: mdiWeatherCloudyAlert,
mdiWeatherCloudyArrowRight: mdiWeatherCloudyArrowRight,
mdiWeatherCloudyClock: mdiWeatherCloudyClock,
mdiWeatherDust: mdiWeatherDust,
mdiWeatherFog: mdiWeatherFog,
mdiWeatherHail: mdiWeatherHail,
mdiWeatherHazy: mdiWeatherHazy,
mdiWeatherHurricane: mdiWeatherHurricane,
mdiWeatherLightning: mdiWeatherLightning,
mdiWeatherLightningRainy: mdiWeatherLightningRainy,
mdiWeatherNight: mdiWeatherNight,
mdiWeatherNightPartlyCloudy: mdiWeatherNightPartlyCloudy,
mdiWeatherPartlyCloudy: mdiWeatherPartlyCloudy,
mdiWeatherPartlyLightning: mdiWeatherPartlyLightning,
mdiWeatherPartlyRainy: mdiWeatherPartlyRainy,
mdiWeatherPartlySnowy: mdiWeatherPartlySnowy,
mdiWeatherPartlySnowyRainy: mdiWeatherPartlySnowyRainy,
mdiWeatherPouring: mdiWeatherPouring,
mdiWeatherRainy: mdiWeatherRainy,
mdiWeatherSnowy: mdiWeatherSnowy,
mdiWeatherSnowyHeavy: mdiWeatherSnowyHeavy,
mdiWeatherSnowyRainy: mdiWeatherSnowyRainy,
mdiWeatherSunny: mdiWeatherSunny,
mdiWeatherSunnyAlert: mdiWeatherSunnyAlert,
mdiWeatherSunnyOff: mdiWeatherSunnyOff,
mdiWeatherSunset: mdiWeatherSunset,
mdiWeatherSunsetDown: mdiWeatherSunsetDown,
mdiWeatherSunsetUp: mdiWeatherSunsetUp,
mdiWeatherTornado: mdiWeatherTornado,
mdiWeatherWindy: mdiWeatherWindy,
mdiWeatherWindyVariant: mdiWeatherWindyVariant,
mdiWeb: mdiWeb,
mdiWebBox: mdiWebBox,
mdiWebCancel: mdiWebCancel,
mdiWebCheck: mdiWebCheck,
mdiWebClock: mdiWebClock,
mdiWebMinus: mdiWebMinus,
mdiWebOff: mdiWebOff,
mdiWebPlus: mdiWebPlus,
mdiWebRefresh: mdiWebRefresh,
mdiWebRemove: mdiWebRemove,
mdiWebSync: mdiWebSync,
mdiWebcam: mdiWebcam,
mdiWebcamOff: mdiWebcamOff,
mdiWebhook: mdiWebhook,
mdiWebpack: mdiWebpack,
mdiWebrtc: mdiWebrtc,
mdiWechat: mdiWechat,
mdiWeight: mdiWeight,
mdiWeightGram: mdiWeightGram,
mdiWeightKilogram: mdiWeightKilogram,
mdiWeightLifter: mdiWeightLifter,
mdiWeightPound: mdiWeightPound,
mdiWhatsapp: mdiWhatsapp,
mdiWheelBarrow: mdiWheelBarrow,
mdiWheelchair: mdiWheelchair,
mdiWheelchairAccessibility: mdiWheelchairAccessibility,
mdiWhistle: mdiWhistle,
mdiWhistleOutline: mdiWhistleOutline,
mdiWhiteBalanceAuto: mdiWhiteBalanceAuto,
mdiWhiteBalanceIncandescent: mdiWhiteBalanceIncandescent,
mdiWhiteBalanceIridescent: mdiWhiteBalanceIridescent,
mdiWhiteBalanceSunny: mdiWhiteBalanceSunny,
mdiWidgets: mdiWidgets,
mdiWidgetsOutline: mdiWidgetsOutline,
mdiWifi: mdiWifi,
mdiWifiAlert: mdiWifiAlert,
mdiWifiArrowDown: mdiWifiArrowDown,
mdiWifiArrowLeft: mdiWifiArrowLeft,
mdiWifiArrowLeftRight: mdiWifiArrowLeftRight,
mdiWifiArrowRight: mdiWifiArrowRight,
mdiWifiArrowUp: mdiWifiArrowUp,
mdiWifiArrowUpDown: mdiWifiArrowUpDown,
mdiWifiCancel: mdiWifiCancel,
mdiWifiCheck: mdiWifiCheck,
mdiWifiCog: mdiWifiCog,
mdiWifiLock: mdiWifiLock,
mdiWifiLockOpen: mdiWifiLockOpen,
mdiWifiMarker: mdiWifiMarker,
mdiWifiMinus: mdiWifiMinus,
mdiWifiOff: mdiWifiOff,
mdiWifiPlus: mdiWifiPlus,
mdiWifiRefresh: mdiWifiRefresh,
mdiWifiRemove: mdiWifiRemove,
mdiWifiSettings: mdiWifiSettings,
mdiWifiStar: mdiWifiStar,
mdiWifiStrength1: mdiWifiStrength1,
mdiWifiStrength1Alert: mdiWifiStrength1Alert,
mdiWifiStrength1Lock: mdiWifiStrength1Lock,
mdiWifiStrength1LockOpen: mdiWifiStrength1LockOpen,
mdiWifiStrength2: mdiWifiStrength2,
mdiWifiStrength2Alert: mdiWifiStrength2Alert,
mdiWifiStrength2Lock: mdiWifiStrength2Lock,
mdiWifiStrength2LockOpen: mdiWifiStrength2LockOpen,
mdiWifiStrength3: mdiWifiStrength3,
mdiWifiStrength3Alert: mdiWifiStrength3Alert,
mdiWifiStrength3Lock: mdiWifiStrength3Lock,
mdiWifiStrength3LockOpen: mdiWifiStrength3LockOpen,
mdiWifiStrength4: mdiWifiStrength4,
mdiWifiStrength4Alert: mdiWifiStrength4Alert,
mdiWifiStrength4Lock: mdiWifiStrength4Lock,
mdiWifiStrength4LockOpen: mdiWifiStrength4LockOpen,
mdiWifiStrengthAlertOutline: mdiWifiStrengthAlertOutline,
mdiWifiStrengthLockOpenOutline: mdiWifiStrengthLockOpenOutline,
mdiWifiStrengthLockOutline: mdiWifiStrengthLockOutline,
mdiWifiStrengthOff: mdiWifiStrengthOff,
mdiWifiStrengthOffOutline: mdiWifiStrengthOffOutline,
mdiWifiStrengthOutline: mdiWifiStrengthOutline,
mdiWifiSync: mdiWifiSync,
mdiWikipedia: mdiWikipedia,
mdiWindPower: mdiWindPower,
mdiWindPowerOutline: mdiWindPowerOutline,
mdiWindTurbine: mdiWindTurbine,
mdiWindTurbineAlert: mdiWindTurbineAlert,
mdiWindTurbineCheck: mdiWindTurbineCheck,
mdiWindowClose: mdiWindowClose,
mdiWindowClosed: mdiWindowClosed,
mdiWindowClosedVariant: mdiWindowClosedVariant,
mdiWindowMaximize: mdiWindowMaximize,
mdiWindowMinimize: mdiWindowMinimize,
mdiWindowOpen: mdiWindowOpen,
mdiWindowOpenVariant: mdiWindowOpenVariant,
mdiWindowRestore: mdiWindowRestore,
mdiWindowShutter: mdiWindowShutter,
mdiWindowShutterAlert: mdiWindowShutterAlert,
mdiWindowShutterAuto: mdiWindowShutterAuto,
mdiWindowShutterCog: mdiWindowShutterCog,
mdiWindowShutterOpen: mdiWindowShutterOpen,
mdiWindowShutterSettings: mdiWindowShutterSettings,
mdiWindsock: mdiWindsock,
mdiWiper: mdiWiper,
mdiWiperWash: mdiWiperWash,
mdiWiperWashAlert: mdiWiperWashAlert,
mdiWizardHat: mdiWizardHat,
mdiWordpress: mdiWordpress,
mdiWrap: mdiWrap,
mdiWrapDisabled: mdiWrapDisabled,
mdiWrench: mdiWrench,
mdiWrenchCheck: mdiWrenchCheck,
mdiWrenchCheckOutline: mdiWrenchCheckOutline,
mdiWrenchClock: mdiWrenchClock,
mdiWrenchClockOutline: mdiWrenchClockOutline,
mdiWrenchCog: mdiWrenchCog,
mdiWrenchCogOutline: mdiWrenchCogOutline,
mdiWrenchOutline: mdiWrenchOutline,
mdiXamarin: mdiXamarin,
mdiXml: mdiXml,
mdiXmpp: mdiXmpp,
mdiYahoo: mdiYahoo,
mdiYeast: mdiYeast,
mdiYinYang: mdiYinYang,
mdiYoga: mdiYoga,
mdiYoutube: mdiYoutube,
mdiYoutubeGaming: mdiYoutubeGaming,
mdiYoutubeStudio: mdiYoutubeStudio,
mdiYoutubeSubscription: mdiYoutubeSubscription,
mdiYoutubeTv: mdiYoutubeTv,
mdiYurt: mdiYurt,
mdiZWave: mdiZWave,
mdiZend: mdiZend,
mdiZigbee: mdiZigbee,
mdiZipBox: mdiZipBox,
mdiZipBoxOutline: mdiZipBoxOutline,
mdiZipDisk: mdiZipDisk,
mdiZodiacAquarius: mdiZodiacAquarius,
mdiZodiacAries: mdiZodiacAries,
mdiZodiacCancer: mdiZodiacCancer,
mdiZodiacCapricorn: mdiZodiacCapricorn,
mdiZodiacGemini: mdiZodiacGemini,
mdiZodiacLeo: mdiZodiacLeo,
mdiZodiacLibra: mdiZodiacLibra,
mdiZodiacPisces: mdiZodiacPisces,
mdiZodiacSagittarius: mdiZodiacSagittarius,
mdiZodiacScorpio: mdiZodiacScorpio,
mdiZodiacTaurus: mdiZodiacTaurus,
mdiZodiacVirgo: mdiZodiacVirgo
}

const IconApp = ({icon, size = 0.7}) => {
    const name = 'mdi' + icon.charAt(0).toUpperCase() +  icon.slice(1).replace(/-(.)/g, function($1) { return $1.toUpperCase(); }).replace(/-/g, '').replace(/^(.)/, function($1) { return $1.toLowerCase(); })
    return ( icon && icon?.length > 0 ? 
        <Icon 
        path={iconos[name]} 
            size={size}
            
            />
            :null
    )
}

export default IconApp